// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/active_icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/shape-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/shape-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/select_down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/search_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/date_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/Radio.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/checkbox_tick.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/active_icon_right.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 0.1. Body / Typography
   ========================================================================== */
body {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #71748d;
  padding: 0px !important;
  background-color: #eeeeee;
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #479573;
  margin: 0px 0px 15px 0px;
  font-family: "Inter", sans-serif;
}

h1 {
  font-size: 34px;
}

h2 {
  font-size: 28px;
  line-height: 30px;
}

h3 {
  font-size: 20px;
}

h4 {
  font-size: 16px;
  line-height: 26px;
}

h5 {
  font-weight: 700 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  text-transform: uppercase !important;
}

h5 span {
  color: #ffb31f !important;
}

h6 {
  font-size: 12px;
}

p {
  margin: 0px 0px 20px 0px;
  font-family: "Inter", sans-serif;
}

p:last-child {
  margin: 0px;
}

a {
  color: #71748d;
}

img {
  max-width: 100%;
}

::placeholder {
  color: #000;
  font-weight: 400;
}

::-moz-placeholder {
  color: #000;
  font-weight: 400;
}

::-webkit-input-placeholder {
  color: #000;
  font-weight: 400;
}

a:hover {
  color: #ff407b;
  text-decoration: none;
}

a:active,
a:hover {
  outline: 0;
  text-decoration: none;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
  color: #3d3f5d;
}

/*--------------------
 Form
---------------------*/
label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-size: 15px;
  color: #71748d;
}

.form-control {
  display: block;
  width: 100%;
  font-size: 14px;
  line-height: 1.42857143;
  color: #000;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d2d2e4;
  border-radius: 2px;
}

.form-control:focus {
  color: #000000;
  background-color: #fff;
  border-color: transparent;
  outline: 0;
  box-shadow: none;
}

input[type=file] {
  color: #71748d;
  background-color: #fff;
  border-color: #a7a7f0;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(214, 214, 255, 0.75);
}

.col-form-label {
  font-size: 15px;
}

button:focus {
  outline: 0;
}

select.form-control {
  color: #71748d;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-position: 99% 52%;
  background-size: auto;
  background-repeat: no-repeat;
  padding-right: 15px;
  border: 1px solid #d2d2e4;
  border-radius: 2px;
}

textarea.form-control {
  height: auto;
  color: #71748d;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d2d2e4;
  border-radius: 2px;
  padding: 12px 16px;
}

input::-webkit-input-placeholder {
  color: #71748d !important;
}

input:focus::-webkit-input-placeholder {
  color: #71748d !important;
}

textarea::-webkit-input-placeholder {
  color: #71748d !important;
}

textarea:focus::-webkit-input-placeholder {
  color: #71748d !important;
}

.form-group {
  margin-bottom: 12px;
}

.form-control-lg {
  padding: 12px;
}

/* Custom-Chekbox
-------------------------------------------------------------- */
.custom-control {
  position: relative;
  min-height: 1.5rem;
  padding-left: 1.5rem;
}

.custom-control-input:checked ~ input[type=checkbox] {
  background: #3d404e;
  border: #7f83a2 1px solid;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-control-label {
  margin-bottom: 0;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #5969ff;
  border-color: #5969ff;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background-color: #5969ff;
}

.custom-control-label::after {
  position: absolute;
  top: 7px;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-control-label::before {
  position: absolute;
  top: 7px;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  user-select: none;
  background-color: #ffffff;
  border: 2px solid #d2d2e4;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #5969ff;
  border-color: #5969ff;
}

.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #efeff6;
}

.custom-select-font-size {
  font-size: 14px;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}

.custom-valid.custom-control-input.is-valid:checked ~ .custom-control-label::before,
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before {
  background-color: #34ce57;
  border-color: #34ce57;
}

.custom-control-input.is-invalid ~ .custom-control-label::before,
.was-validated .custom-control-input:invalid ~ .custom-control-label::before {
  background-color: #ffdadd;
  border-color: #efa2a9;
}

.custom-control-input:disabled ~ .custom-control-label {
  color: #9295b0;
}

.custom-control-input.is-valid ~ .custom-control-label::before,
.was-validated .custom-control-input:valid ~ .custom-control-label::before {
  background-color: #c6ffd3;
  border: 2px solid #68df83;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #75748d;
  text-align: center;
  white-space: nowrap;
  background-color: #efeff6;
  border: 1px solid #d2d2e4;
  border-radius: 4px;
}

.section-block {
  margin: 16px 0px;
}

.section-title {
  font-weight: 500;
  margin-bottom: 5px;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #3e9479 !important;
  border-color: #3e9479 !important;
}

/*--------------------
 Padding / Margin
---------------------*/
.nopadding {
  padding: 0px;
}

.p-r-0 {
  padding-right: 0px;
}

.p-r-10 {
  padding-right: 10px;
}

.p-r-15 {
  padding-right: 15px;
}

.p-r-20 {
  padding-right: 20px;
}

.p-r-25 {
  padding-right: 25px;
}

.p-l-0 {
  padding-left: 0px;
}

.p-l-10 {
  padding-left: 10px;
}

.p-l-15 {
  padding-left: 15px;
}

.p-l-20 {
  padding-left: 20px;
}

.p-l-25 {
  padding-left: 25px;
}

.p-l-40 {
  padding-left: 40px;
}

.p-t-0 {
  padding-top: 0px;
}

.p-t-10 {
  padding-top: 10px;
}

.p-t-20 {
  padding-top: 20px;
}

.p-t-30 {
  padding-top: 30px;
}

.p-t-40 {
  padding-top: 40px;
}

.p-t-60 {
  padding-top: 60px;
}

.p-t-80 {
  padding-top: 80px;
}

.p-t-100 {
  padding-top: 100px;
}

.p-t-120 {
  padding-top: 120px;
}

.p-t-140 {
  padding-top: 140px;
}

.p-b-0 {
  padding-bottom: 0px;
}

.p-b-10 {
  padding-bottom: 10px;
}

.p-b-20 {
  padding-bottom: 20px;
}

.p-b-30 {
  padding-bottom: 30px;
}

.p-b-40 {
  padding-bottom: 40px;
}

.p-b-60 {
  padding-bottom: 60px;
}

.p-b-80 {
  padding-bottom: 80px;
}

.p-b-100 {
  padding-bottom: 100px;
}

.p-b-120 {
  padding-bottom: 120px;
}

.p-b-140 {
  padding-bottom: 140px;
}

.m-r-0 {
  margin-right: 0px;
}

.m-r-10 {
  margin-right: 10px;
}

.m-r-15 {
  margin-right: 15px;
}

.m-r-20 {
  margin-right: 20px;
}

.m-r-25 {
  margin-right: 25px;
}

.m-l-0 {
  margin-left: 0px;
}

.m-l-10 {
  margin-left: 10px;
}

.m-l-15 {
  margin-left: 15px;
}

.m-l-20 {
  margin-left: 20px;
}

.m-l-25 {
  margin-left: 25px;
}

.m-t-0 {
  margin-top: 0px;
}

.m-t-10 {
  margin-top: 10px;
}

.m-t-20 {
  margin-top: 20px;
}

.m-t-30 {
  margin-top: 30px;
}

.m-t-40 {
  margin-top: 40px;
}

.m-t-60 {
  margin-top: 60px;
}

.m-t-80 {
  margin-top: 80px;
}

.m-t-100 {
  margin-top: 100px;
}

.m-t-120 {
  margin-top: 120px;
}

.m-b-0 {
  margin-bottom: 0px;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-b-20 {
  margin-bottom: 20px;
}

.m-b-30 {
  margin-bottom: 30px;
}

.m-b-40 {
  margin-bottom: 40px;
}

.m-b-60 {
  margin-bottom: 60px;
}

.m-b-80 {
  margin-bottom: 80px;
}

.m-b-100 {
  margin-bottom: 100px;
}

.m-b-120 {
  margin-bottom: 120px;
}

/*--------------------
 Font Weight
---------------------*/
html body .font-bold {
  font-weight: 800;
}

html body .font-normal {
  font-weight: 400;
}

html body .font-light {
  font-weight: 300;
}

html body .font-medium {
  font-weight: 600;
}

html body .font-16 {
  font-size: 16px;
}

html body .font-12 {
  font-size: 12px;
}

html body .font-14 {
  font-size: 14px;
}

html body .font-10 {
  font-size: 10px;
}

html body .font-18 {
  font-size: 18px;
}

html body .font-20 {
  font-size: 20px;
}

html body .font-22 {
  font-size: 22px;
}

html body .font-24 {
  font-size: 24px;
}

html body .display-5 {
  font-size: 3rem;
}

html body .display-6 {
  font-size: 2.5rem;
}

html body .display-7 {
  font-size: 2rem;
}

/*--------------------
 Arrow  List
---------------------*/
.arrow {
  position: relative;
}

.arrow li {
  padding-left: 20px;
  line-height: 30px;
}

.arrow li:before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  display: inline-block;
  position: absolute;
  left: 0;
  font-size: 14px;
  color: #ff407b;
  content: "\\f058";
  font-style: initial;
}

.bullet-check {
  position: relative;
}

.bullet-check li {
  padding-left: 25px;
  line-height: 30px;
}

.bullet-check li:before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  display: inline-block;
  position: absolute;
  left: 0;
  font-size: 14px;
  color: #22ce77;
  content: "\\f00c";
  font-style: initial;
}

/*-----------------------
Background Color / Color
-------------------------*/
.bg-primary {
  background-color: #5969ff !important;
  color: #fff !important;
}

.bg-brand {
  background-color: #ffc750 !important;
}

.bg-secondary {
  background-color: #ff407b !important;
  color: #fff !important;
}

.bg-success {
  background-color: #2ec551 !important;
}

.bg-danger {
  background-color: #ef172c !important;
}

.bg-warning {
  background-color: #ffc108 !important;
}

.bg-info {
  background-color: #25d5f2 !important;
}

.bg-light {
  background-color: #f9f9ff !important;
}

.bg-dark {
  background-color: #2e2f39 !important;
}

.bg-primary-light {
  background-color: #dbdeff !important;
  color: #fff !important;
}

.bg-info-light {
  background-color: #dffaff !important;
  color: #fff;
}

.bg-secondary-light {
  background-color: #ffdbe6 !important;
}

.bg-danger-light {
  background-color: #fbd3d5 !important;
}

.bg-brand-light {
  background-color: #fff2d5 !important;
}

.bg-success-light {
  background-color: #c5fad3 !important;
}

/*-----------------------
Borders
-------------------------*/
.border-boxes span {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #fbfbfd;
}

.border {
  border: 1px solid #e6e6f2 !important;
}

.border-top {
  border-top: 1px solid #e6e6f2 !important;
}

.border-bottom {
  border-bottom: 1px solid #e6e6f2 !important;
}

.border-left {
  border-left: 1px solid #e6e6f2 !important;
}

.border-right {
  border-right: 1px solid #e6e6f2 !important;
}

/*-----------------------
 Color
-------------------------*/
.text-primary {
  color: #5969ff !important;
}

.text-brand {
  color: #ffc750 !important;
}

.text-secondary {
  color: #ff407b !important;
}

.text-success {
  color: #2ec551 !important;
}

.text-danger {
  color: #ef172c !important;
}

.text-warning {
  color: #ffc108 !important;
}

.text-info {
  color: #25d5f2 !important;
}

.text-light {
  color: #f0f0f8 !important;
}

.text-dark {
  color: #3d405c !important;
}

.text-gray {
  color: #868aa5 !important;
}

.text-muted {
  color: #7171a6 !important;
}

.rating-color {
  color: #ffa811;
}

/*-----------------------
Borders
-------------------------*/
.border-top-primary {
  border-top-color: #5969ff !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-secondary {
  border-color: #ff407b !important;
}

.border-brand {
  border-color: #ffc750 !important;
}

.border-info {
  border-color: #25d5f2 !important;
}

/*-----------------------
Fontawesome size
-------------------------*/
.fa-sm {
  font-size: 24px !important;
}

.fa-xs {
  font-size: 11px !important;
}

/*-----------------------
Social Color
-------------------------*/
.facebook-color {
  color: #3c73df;
}

.twitter-color {
  color: #1ea2f2;
}

.instagram-color {
  color: #9361fa;
}

.rss-color {
  color: #ee802f;
}

.pinterest-color {
  color: #c8232c;
}

.youtube-color {
  color: #ff0000;
}

.medium-color {
  color: #00ab6c;
}

.googleplus-color {
  color: #d34836;
}

.snapchat-color {
  color: #fffb00;
}

/*-----------------------
Social bg Color
-------------------------*/
.facebook-bgcolor {
  background-color: #3b5898;
  color: #fff;
}

.twitter-bgcolor {
  background-color: #1ea2f2;
  color: #fff;
}

.instagram-bgcolor {
  background-color: #9361fa;
  color: #fff;
}

.rss-bgcolor {
  background-color: #ee802f;
  color: #fff;
}

.pinterest-bgcolor {
  background-color: #c8232c;
  color: #fff;
}

.youtube-bgcolor {
  background-color: #ff0000;
  color: #fff;
}

.googleplus-bgcolor {
  background-color: #d34836;
  color: #fff;
}

/*-----------------------
Progress bar
-------------------------*/
.progress-bar {
  background-color: #5969ff;
}

.primary-progress-bar {
  background-color: #5969ff;
}

.progress-sm {
  height: 5px;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 15px;
}

.f-icon,
.if-icon,
.m-icon,
.sl-icon,
.t-icon,
.w-icon {
  cursor: pointer;
  padding: 13px 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.m-icon {
  width: 33%;
  display: inline-block;
}

.f-icon:hover,
.if-icon:hover,
.m-icon:hover,
.sl-icon:hover,
.t-icon:hover,
.w-icon:hover {
  background-color: #f8f9fa;
}

/*-----------------------
Legends
-------------------------*/
.legend-item {
  font-size: 14px;
}

/* ==========================================================================
   0.2. Type Elements
   ========================================================================== */
/* ==========================================================================
   0.3.  Header
   ========================================================================== */
/*-----------------------
Top Header
-------------------------*/
.header_mobile_view_button {
  background-color: transparent;
  outline: none;
  border: 0px;
  color: #fff;
}

.main-header .navbar {
  padding: 0px;
  box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);
  transition: all 0.3s ease;
  min-height: 60px;
  background-color: #3e9479;
}

.navbar-brand {
  display: inline-block;
  margin-right: 1rem;
  line-height: inherit;
  white-space: nowrap;
  font-size: 30px;
  text-transform: uppercase;
  font-weight: 700;
  color: #007bff;
}

.navbar-brand:hover {
  color: #007bff;
}

.navbar-brand img {
  max-width: 150px;
  width: 100%;
}

.main-header .navbar-nav li.nav-item {
  padding: 0px 12px;
}

.navbar-right-top .nav-item:first-child {
  border-right: 1px solid #e6e6f2;
}

.navbar-right-top .nav-item:last-child {
  border: none;
}

.navbar-right-top .nav-item .nav-link {
  padding: 13px 20px;
  font-size: 16px;
  line-height: 2;
  color: #82849f;
}

.navbar-light .navbar-toggler {
  color: rgba(255, 255, 255, 0);
  border-color: rgba(0, 0, 0, 0);
  padding: 0px;
}

/* ------  top-search-bar --------  */
.top-search-bar {
  padding-top: 12px;
  padding-right: 24px;
}

/* ------  Notification Dropdown --------  */
.notification-dropdown {
  min-width: 320px;
}

.notification-dropdown,
.connection-dropdown,
.nav-user-dropdown {
  padding: 0px;
  margin: 0px;
}

.notification-title {
  font-size: 14px;
  color: #3d405c;
  text-align: center;
  padding: 8px 0px;
  border-bottom: 1px solid #e3e3e3;
  line-height: 1.5;
  background-color: #fffffe;
}

.notification-list .list-group-item {
  border-radius: 0px;
  padding: 12px;
  margin-top: -1px;
  border-left: transparent;
  border-right: transparent;
}

.notification-list .list-group-item.active {
  z-index: 2;
  color: #3d405c;
  background-color: #f7f7fb;
  border-color: #e1e1e7;
}

.notification-list .list-group-item-action:focus,
.list-group-item-action:hover {
  color: #404040;
  text-decoration: none;
  background-color: #f7f7fb;
}

.notification-info .notification-date {
  display: block;
  font-size: 11px;
  margin-top: 4px;
  text-transform: uppercase;
  color: #71748d;
}

.notification .dropdown-toggle::after,
.connection .dropdown-toggle::after,
.nav-user .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border: none;
}

.notification-list-user-img {
  float: left;
}

.notification-list-user-block {
  padding-left: 50px;
  font-size: 14px;
  line-height: 21px;
}

.notification-list-user-name {
  color: #5969ff;
  font-size: 14px;
  margin-right: 8px;
}

.list-footer,
.conntection-footer {
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 10px 0px;
  line-height: 1.5;
  font-weight: 700;
  background-color: #5969ff;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.list-footer a,
.conntection-footer a {
  color: #fff;
}

.list-footer a:hover,
.conntection-footer a:hover {
  color: #fff;
}

.indicator {
  content: "";
  position: absolute;
  top: 16px;
  right: 23px;
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  background-color: #ef172c;
  animation: 0.9s infinite beatHeart;
  transform-origin: center;
}

@keyframes beatHeart {
  0% {
    transform: scale(0.9);
  }
  25% {
    transform: scale(1.1);
  }
  40% {
    transform: scale(0.9);
  }
  60% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
/* ------  Connection --------  */
.connection-list {
  width: 300px;
  padding: 20px;
}

.connection-item {
  border-radius: 3px;
  line-height: 32px;
  text-align: center;
  padding: 12px 7px 4px;
  display: block;
  border: 1px solid transparent;
  color: #3d405c;
  font-size: 12px;
}

.connection-item img {
  width: 32px;
}

.connection-item:hover {
  background-color: #fff;
  border: 1px solid #e6e6f2;
}

.connection-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ----- User Nav Dropdown -----*/
.nav-user-dropdown {
  padding: 0px;
  min-width: 230px;
  margin: 0px;
}

.nav-user-info {
  background-color: #5969ff;
  line-height: 1.4;
  padding: 12px;
  color: #fff;
  font-size: 13px;
  border-radius: 2px 2px 0 0;
}

.nav-user-info .status {
  float: left;
  top: 7px;
  left: 0px;
}

.nav-user-dropdown .dropdown-item {
  display: block;
  width: 100%;
  padding: 12px 22px 15px;
  clear: both;
  font-weight: 400;
  color: #686972;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  font-size: 13px;
  line-height: 0.4;
}

.nav-user-dropdown .dropdown-item:hover {
  background-color: #f7f7fb;
}

/* ------  Top Header User Info --------  */
/* -------------------- 0.4. Sidebar ----------------------- */
.navigation-horizontal {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* background-color: #fff;
    -webkit-box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);
    box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);
    -webkit-transition: all 0.3s ease;*/
}

.navigation-horizontal .nav-link[data-toggle=collapse] {
  position: relative;
  display: flex;
  align-items: center;
}

.navigation-horizontal .nav-link[data-toggle=collapse]::after {
  display: inline-block;
  width: 0;
  height: 0;
  position: absolute;
  right: 8px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.navigation-horizontal .nav-link[data-toggle=collapse][aria-expanded=false]:after {
  transform: rotate(-90deg);
}

.navigation-horizontal .nav-link[data-toggle=collapse]:after {
  transition: transform 0.35s ease, opacity 0.35s ease;
  opacity: 0.5;
}

.navigation-horizontal .navbar-nav {
  width: 100%;
}

.navigation-horizontal .navbar {
  position: relative;
  padding: 0px;
}

.navigation-horizontal .navbar-nav .nav-link {
  font-size: 13px;
  padding: 9px 30px 9px 20px;
  margin-bottom: 2px;
  color: #71789e;
  transition: 0.3s;
  margin: 6px 1px;
}

.navigation-horizontal .nav-link i {
  font-size: 14px;
  margin-right: 9px;
  text-align: center;
  vertical-align: middle;
  line-height: 16px;
}

.nav-divider {
  padding: 10px 14px;
  line-height: 30px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}

.navigation-horizontal .submenu {
  background-color: #e2e2eb;
  margin-top: -6px;
  margin-right: 1px;
  margin-left: 1px;
}

.navigation-horizontal .submenu .nav .nav-item .nav-link {
  font-size: 12px;
  padding: 0px 12px;
  transition: 0.3s;
  line-height: 1;
}

.navigation-horizontal .navbar-nav .nav-link:focus,
.navigation-horizontal .navbar-nav .nav-link.active {
  background-color: #e2e2eb;
  color: #3d405c;
  border-radius: 2px;
}

.navigation-horizontal .navbar-nav .nav-link:focus,
.navigation-horizontal .navbar-nav .nav-link:hover {
  background-color: #e2e2eb;
  color: #3d405c;
  border-radius: 2px;
}

.navigation-horizontal .submenu .nav .nav-item .nav-link:hover {
  color: #3d405c;
  border-radius: 2px;
  background-color: transparent;
}

/* -----------------------
Left Navigation Sidebar
------------------------- */
.nav-left-sidebar {
  position: fixed;
  width: 73px;
  height: 100%;
  z-index: 9;
  top: 60px;
  overflow: initial;
  background-color: #fff;
  box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}

.nav-left-sidebar .nav-link[data-toggle=collapse] {
  position: relative;
  display: flex;
  align-items: center;
}

.nav-left-sidebar .nav-link[data-toggle=collapse]::after {
  display: inline-block;
  width: 0;
  height: 0;
  position: absolute;
  right: 20px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.nav-left-sidebar .nav-link[data-toggle=collapse][aria-expanded=false]:after {
  transform: rotate(-90deg);
}

.nav-left-sidebar .nav-link[data-toggle=collapse]:after {
  transition: transform 0.35s ease, opacity 0.35s ease;
  opacity: 0.5;
}

.nav-left-sidebar .navbar-nav {
  width: 100%;
  row-gap: 20px;
}

.nav-left-sidebar .navbar {
  position: relative;
  padding: 20px 0px;
}

.nav-left-sidebar .navbar-nav .nav-link {
  font-size: 14px;
  padding: 10px 0px;
  width: 50px;
  color: #71789e;
  transition: 0.3s;
}

.nav-left-sidebar .nav-link i {
  font-size: 14px;
  display: inline;
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 16px;
}

.nav-divider {
  padding: 10px 14px;
  line-height: 30px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}

.nav-left-sidebar .submenu {
  padding-left: 12px;
  padding-right: 12px;
  /* margin-top: 5px; */
  background: #96cc9f;
  position: absolute;
  top: 0px;
  left: 73px;
  width: auto;
  z-index: 999;
  padding: 10px;
  row-gap: 10px;
}

.sidebar-dark.nav-left-sidebar .navbar-nav .submenu .nav-item .nav-link {
  background-color: #3e9479;
}

.sidebar-dark.nav-left-sidebar .navbar-nav .submenu .nav-link {
  width: 100%;
  border-radius: 8px;
}

.nav-left-sidebar .submenu .nav .nav-item .nav-link {
  font-size: 14px;
  padding: 6px 12px;
  transition: 0.3s;
}

.nav-left-sidebar .navbar-nav .nav-link:focus,
.nav-left-sidebar .navbar-nav .nav-link.active {
  background-color: #e2e2eb;
  color: #3d405c;
  border-radius: 2px;
}

.nav-left-sidebar .navbar-nav .nav-link:focus,
.nav-left-sidebar .navbar-nav .nav-link:hover {
  background-color: #e2e2eb;
  color: #3d405c;
  border-radius: 2px;
}

.nav-left-sidebar .submenu .nav .nav-item .nav-link:hover {
  color: #3d405c;
  border-radius: 2px;
  background-color: transparent;
}

.nav-left-sidebar .navbar-toggler {
  background-color: #fff;
}

.navbar-toggler {
  padding: 0.25rem 0.5rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

/* -----------------------
Leftsidebar - Primary
------------------------- */
.sidebar-primary {
  background-color: #414da7;
}

.sidebar-primary .nav-divider {
  color: #ddddff;
}

.sidebar-primary.nav-left-sidebar .nav-link i {
  color: #8991d4;
}

.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link {
  color: #8991d4;
}

.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link:focus,
.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link:hover {
  color: #fff;
  background-color: #5761c2;
  border-radius: 2px;
}

.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link:focus,
.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link.active {
  background-color: #5761c2;
  color: #fff;
  border-radius: 2px;
}

.sidebar-primary.nav-left-sidebar .submenu .nav .nav-item .nav-link:hover {
  color: #fff;
  border-radius: 2px;
  background-color: transparent;
}

/* -----------------------
Leftsidebar - dark
------------------------- */
.sidebar-dark {
  background: #3e9479;
  background: -moz-linear-gradient(270deg, #1e4438 -17.61%, #3a957d 95.49%);
  background-color: #3e9479;
  box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);
  -webkit-transition: all 0.3s ease;
}

.sidebar-dark .nav-divider {
  color: #a4aadb;
  font-size: 12px;
  letter-spacing: 1px;
}

.sidebar-dark.nav-left-sidebar .nav-link i {
  color: #fff;
  margin-bottom: 7px;
  font-size: 16px;
}

.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link.active i {
  color: #fdf41f;
}

.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {
  color: #ffffff;
  padding: 10px;
  text-align: center;
  border: 1px solid transparent;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 9px;
  border-radius: 18px;
  text-transform: uppercase;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus,
.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:hover {
  color: #fdf41f;
  background-color: #39675a;
  border: 1px solid rgba(253, 255, 136, 0.5);
}

.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus i,
.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:hover i {
  color: #fdf41f;
}

.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus,
.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link.active {
  background-color: #39675a;
  color: #fdf41f;
  border: 1px solid rgba(253, 255, 136, 0.5);
}

.sidebar-dark.nav-left-sidebar .submenu .nav .nav-item .nav-link:hover {
  color: #fdf41f;
  background-color: #39675a;
  border: 1px solid rgba(253, 255, 136, 0.5);
}

.sidebar-dark.nav-left-sidebar .navbar-nav .nav-item .badge {
  position: absolute;
  right: 40px;
  display: none;
}

.nav-left-sidebar .container-fluid {
  padding: 0px 0px;
}

/*-----navigation dark ---*/
/*-----------------------
Sidebar Page Navigations
-------------------------*/
.sidebar-nav-fixed {
  position: sticky;
  top: 5rem;
}

.sidebar-nav-fixed ul li a {
  font-size: 14px;
  color: #71728e;
  display: block;
  padding: 5px 15px;
  background: transparent;
  border-radius: 4px;
  line-height: 1.8;
}

.sidebar-nav-fixed ul li a:hover {
  color: #5969ff;
}

.sidebar-nav-fixed ul li a.active {
  display: block;
  color: #5969ff;
  background: #e0e0fd;
}

/*--- Bootstrap Dropdown ----*/
.dropdown-menu {
  background: #fff;
  font-size: 14px;
  color: #3d405c;
  border: 1px solid #e6e6f2;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #3d405c;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover {
  color: #5969ff;
  background: #efeff6;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #5969ff;
}

/* -------------------- 0.5.Container / Wrapper ----------------------- */
/*-----------------------
Container / Wrapper
-------------------------*/
.master-main-wrapper {
  min-height: 100%;
  padding-top: 60px;
  position: relative;
}

.main-content-wrapper {
  position: relative;
  left: 0;
  margin-left: 73px;
}

.master-main-wrapper ul.navbar-nav li span::before,
.master-main-wrapper .navbar-nav li button::before {
  display: none;
}

.master-main-wrapper .navbar-nav li button {
  color: #3e9479;
  min-width: auto;
}

.main-content-wrapper-inner {
  padding: 20px 20px 0px;
}

.main-content-wrapper-inner.report-content {
  padding: 20px;
  margin-left: 100px !important;
}

.main-content-wrapper-inner.report-content.full-width {
  margin-left: 0px !important;
}

.main-content-wrapper-inner .card-body h5 {
  color: #479573;
}

.main-content-wrapper-inner .card-header h5 {
  color: #479573;
}

.main-header .navbar-nav li.feedback button span {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  text-transform: none;
  text-decoration: none;
}

.main-header .navbar-nav li.log_out button span {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  text-transform: none;
}

.main-header .navbar-nav li.feedback button span:nth-child(2) {
  border-bottom: 1px solid #fff;
}

.main-header .navbar-nav li.feedback button img {
  margin-right: 5px;
}

.main-header .navbar-nav li {
  color: #fff;
  font-size: 10px;
  text-transform: uppercase;
  line-height: initial;
  padding: 0px 6px;
}

.main-header .navbar-nav li span {
  color: #fdf41f;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}

/*-----------------------
Splash Container / Wrapper
-------------------------*/
.splash-container {
  width: 100%;
  max-width: 375px;
  padding: 15px;
  margin: auto;
}

.splash-container .card-header {
  padding: 20px;
}

.splash-description {
  text-align: center;
  display: block;
  line-height: 20px;
  font-size: 1rem;
  margin-top: 5px;
  padding-bottom: 10px;
}

.splash-title {
  text-align: center;
  display: block;
  font-size: 14px;
  font-weight: 300;
}

.splash-container .card-footer-item {
  padding: 12px 28px;
}

/* -------------------- 0.6.Pageheader ----------------------- */
/*-----------------------
Pageheader
-------------------------*/
.page-header {
  margin-bottom: 30px;
}

.page-breadcrumb .breadcrumb-link {
  color: #a6a6b7;
}

.page-breadcrumb .breadcrumb-link:hover {
  color: #5969ff;
}

.page-breadcrumb .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
  margin-bottom: 0px;
  list-style: none;
  background-color: transparent;
  border-radius: 0px;
  border-top: 1px solid #e0e4ef;
  padding-top: 10px;
  font-size: 12px;
}

.page-breadcrumb .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #b1b1c0;
  content: "\\f105";
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
}

.page-breadcrumb .breadcrumb-item.active {
  color: #71728e;
}

.pageheader-title {
  font-size: 24px;
  margin-bottom: 8px;
}

.pageheader-text {
  margin-bottom: 14px;
  display: none;
}

/* -------------------- 0.7.Footer ----------------------- */
/*-----------------------
 Footer
-------------------------*/
.footer {
  border-top: 1px solid rgba(152, 166, 173, 0.2);
  padding: 14px 30px 14px;
  color: #71748d;
  background-color: #fff;
  width: 100%;
  /*position: absolute; bottom: 0;*/
}

.footer .footer-links a {
  color: #71748d;
  margin-left: 1.5rem;
  transition: all 0.4s;
}

/* ==========================================================================
  1. Dashboard Index-sales
   ========================================================================== */
.chart-widget-list {
  margin-top: 60px;
}

.chart-widget-list p {
  border-bottom: 1px solid #e6e6f2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

.sell-ratio {
  margin-bottom: 15px;
}

.sell-ratio .progress-bar {
  background-color: #25d5f2;
}

/* ==========================================================================
  2. Dashboard Index-Finance
   ========================================================================== */
.dashboard-finance .ct-label {
  display: none;
}

/* ==========================================================================
  3. Dashboard Influencer
   ========================================================================== */
.influencer-profile-data .user-avatar {
  margin-right: 40px;
}

.influencer-profile-data .user-avatar-info {
  display: block;
  margin-top: 14px;
}

.influencer-profile-data .user-avatar-name {
  float: left;
  padding-right: 20px;
}

.influencer-profile-data .user-avatar-email {
  text-decoration: underline;
}

.influencer-profile-data .user-social-media {
  padding: 16px 99px;
  text-align: center;
  border-right: 1px solid #e6e6f2;
}

.influencer-profile-data .user-social-media:last-child {
  border-right: transparent;
}

.user-social-box {
  background-color: #f9f9fc;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.dashboard-influence .progress {
  width: 86%;
  background-color: #ededfa;
}

.campaign-table .dropdown-toggle::after {
  display: none;
}

.campaign-card {
  padding-bottom: 25px;
  padding-top: 25px;
}

.campaign-img {
  margin-bottom: 25px;
}

/* ==========================================================================
  3. Influencer Finder
   ========================================================================== */
.influence-finder .user-social-media {
  padding: 16px 68px;
  text-align: center;
  border-right: 1px solid #e6e6f2;
}

.influence-finder .user-social-media:last-child {
  border-right: transparent;
}

.influence-finder .icon-circle {
  height: 40px;
  width: 40px;
  display: inline-block;
  padding: 9px;
  line-height: 1.7;
}

.search-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.influence-finder button.btn {
  height: 47px;
  width: 110px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

/* ==========================================================================
 4. Influencer Profile
========================================================================== */
.rating-star {
  font-size: 12px;
  padding-top: 8px;
  color: #ffa811;
}

.campaign-social-box {
  background-color: #f9f9fc;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.campaign-metrics {
  border-right: 1px solid #dee2e6;
  text-align: center;
  padding: 8px 79px;
}

.campaign-metrics:last-child {
  border-right: transparent;
}

.influence-profile-content.pills-regular .tab-content {
  background-color: transparent;
  padding: 0px;
  border: transparent;
  border-radius: 0px;
  border-top-left-radius: 0px;
}

/* ==========================================================================
  5. Dashboard Ecommerce
   ========================================================================== */
/* -------------- social sales -------------------*/
.social-sales-icon-circle {
  height: 40px;
  width: 40px;
  line-height: 1;
  text-align: center;
  border-radius: 100%;
  padding: 12px 13px;
  display: inline-block;
}

.social-sales-count {
  float: right;
  line-height: 2.9;
}

/* -------------- traffic sales -------------------*/
.traffic-sales-content {
  padding: 20px !important;
}

.traffic-sales-amount {
  float: right;
  color: #3d405c;
}

/* -------------- country sales -------------------*/
.country-sales-content {
  padding: 20px !important;
}

/* ==========================================================================
   Ecommerce Products
   ========================================================================== */
.product-thumbnail {
  border: 1px solid #e6e6f2;
  background-color: #fff;
  margin-bottom: 30px;
}

.product-img {
  text-align: center;
  padding: 35px 0px;
}

.product-img-head {
  position: relative;
}

.ribbons {
  clip-path: polygon(10% 25%, 10% 0, 35% 0%, 65% 0%, 90% 0, 90% 25%, 90% 50%, 91% 100%, 50% 73%, 10% 100%, 10% 50%);
  position: absolute;
  top: 0px;
  background-color: #59b3ff;
  padding: 31px 15px;
  text-align: center;
  left: 10px;
  font-family: "Roboto", sans-serif;
  color: #fff;
}

.ribbons-text {
  transform: rotate(90deg);
  position: absolute;
  top: 11px;
  left: 10px;
  color: #fff;
}

.product-wishlist-btn {
  height: 40px;
  width: 40px;
  border: 2px solid #dfdfec;
  border-radius: 100px;
  font-size: 18px;
  line-height: 2.3;
  color: #dfdfec;
  text-align: center;
  display: block;
  position: absolute;
  right: 15px;
  top: 15px;
}

.product-wishlist-btn:hover {
  border-color: #ff3367;
  color: #ff3367;
  transition: 0.3s ease;
}

.product-wishlist-btn.active {
  border-color: #ff3367;
  color: #ff3367;
  transition: 0.3s ease;
}

.product-content {
  border-top: 1px solid #e6e6f2;
  padding: 23px;
}

.product-content-head {
  position: relative;
  margin-bottom: 25px;
}

.product-title {
  font-size: 16px;
  margin-bottom: 5px;
}

.product-rating {
  font-size: 12px;
  color: #ffa811;
}

.product-price {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 16px;
  color: #3d405c;
  font-family: "Roboto", sans-serif;
  line-height: 1;
}

.product-del {
  font-size: 14px;
  color: #71748d;
}

.product-sidebar {
  background-color: #fff;
  border: 1px solid #e6e6f2;
}

.product-sidebar-widget {
  border-bottom: 1px solid #e6e6f2;
  padding: 10px 20px;
  margin-bottom: 10px;
}

.product-sidebar-widget:last-child {
  border: 0px;
}

.product-sidebar-widget-title {
  font-size: 16px;
  margin-bottom: 10px;
}

.custom-color-red.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #a40000;
  border-color: #a40000;
}

.custom-color-blue.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #0d4197;
  border-color: #0d4197;
}

.custom-color-yellow.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ffdc40;
  border-color: #ffdc40;
}

.custom-color-black.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #111111;
  border-color: #111111;
}

.product-slider {
  background-color: #fff;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 110px;
}

.product-carousel .carousel-indicators {
  position: absolute;
  right: 0;
  bottom: -80px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.product-carousel .carousel-indicators li {
  position: relative;
  flex: 0 1 auto;
  width: 10px;
  height: 10px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  background-color: rgb(224, 224, 231);
  border-radius: 100%;
}

.product-carousel .carousel-indicators li.active {
  background-color: #5969ff;
}

.product-carousel .carousel-control-next,
.carousel-control-prev {
  display: none;
}

.product-details {
  background-color: #fff;
  padding: 30px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  position: relative;
}

.product-colors {
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.product-size {
  padding-bottom: 14px;
  margin-bottom: 10px;
  position: relative;
}

.product-colors input[type=checkbox],
input[type=radio] {
  box-sizing: border-box;
  padding: 0;
  display: none;
}

.product-colors label {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1.6s;
  animation-name: dot-anim;
}

.product-colors .radio:checked + label {
  animation-play-state: paused;
}

.product-colors label:before {
  content: "\\f00c";
  position: absolute;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  padding: 0px;
  margin: 4px 8px;
  color: #fff;
  font-size: 14px;
}

.product-colors .radio:checked + label:after {
  background: transparent;
  transition: all 0.5s;
  transform: scale(1);
}

/**** BLUE Radio button code ****/
#radio-1 + label {
  left: -60vw;
  background: #0a3c93;
  animation-delay: 0s;
}

#radio-1 + label:before {
  transform: scale(0);
}

#radio-1:checked + label:before {
  transform: scale(1);
  transition: all 0.4s;
}

/**** Yellow Radio button code ****/
#radio-2 + label {
  left: -60vw;
  background: #ffdc40;
  animation-delay: 0s;
}

#radio-2 + label:before {
  transform: scale(0);
}

#radio-2:checked + label:before {
  transform: scale(1);
  transition: all 0.4s;
}

/**** Red Radio button code ****/
#radio-3 + label {
  left: -60vw;
  background: #a00000;
  animation-delay: 0s;
}

#radio-3 + label:before {
  transform: scale(0);
}

#radio-3:checked + label:before {
  transform: scale(1);
  transition: all 0.4s;
}

.product-qty {
  position: absolute;
  right: 0;
  top: 0px;
}

.quantity {
  position: relative;
}

.product-qty input[type=number]::-webkit-inner-spin-button,
.product-qty input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.product-qty input[type=number] {
  -moz-appearance: textfield;
}

.quantity input {
  width: 65px;
  height: 41px;
  line-height: 1.65;
  float: left;
  display: block;
  padding: 0;
  margin: 0;
  padding-left: 20px;
  border: 1px solid #eee;
}

.quantity input:focus {
  outline: 0;
}

.quantity-nav {
  float: left;
  position: relative;
  height: 39px;
}

.quantity-button {
  position: relative;
  cursor: pointer;
  border-left: 1px solid #e6e6f2;
  width: 20px;
  text-align: center;
  color: #333;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  line-height: 1.6;
  transform: translateX(-100%);
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  background-color: #efeff6;
}

.quantity-button.quantity-up {
  position: absolute;
  height: 50%;
  top: 0;
  border-bottom: 1px solid #e6e6f2;
}

.quantity-button.quantity-down {
  position: absolute;
  bottom: -1px;
  height: 50%;
}

/* ==========================================================================
  2. UI Elements
  ========================================================================== */
/* -----------------------
2.1  Alerts
-------------------------*/
/* -----------------------
2.2  Buttons
-------------------------*/
.btn {
  font-size: 14px;
  padding: 9px 16px;
  border-radius: 2px;
}

.btn-wishlist {
  background-color: #efeff6;
  border-radius: 100px;
  height: 30px;
  width: 30px;
  padding: 5px 3px;
  display: inline-block;
  font-size: 14px;
  color: #3d405c;
  text-align: center;
  line-height: 1.7;
}

.btn-wishlist:hover {
  background-color: #ff407b;
  color: #fff;
}

/*--- btn default --*/
.btn-brand {
  color: #2e2f39;
  background-color: #ffc750;
  border-color: #ffc750;
}

.btn-brand:hover {
  color: #2e2f39;
  background-color: #efb63e;
  border-color: #efb63e;
}

.btn-brand.focus,
.btn-brand:focus {
  color: #2e2f39;
  background-color: #efb63e;
  border-color: #efb63e;
  box-shadow: none;
}

/*--- btn primary --*/
.btn-primary {
  color: #fff !important;
  background-color: #225ea8 !important;
  border-color: #225ea8 !important;
  border-radius: 5px !important;
}

.btn-primary:hover {
  color: #fff !important;
  background-color: #225ea8 !important;
  border-color: #225ea8 !important;
}

.btn-primary.focus,
.btn-primary:focus {
  color: #fff !important;
  background-color: #225ea7 !important;
  border-color: #225ea7 !important;
  box-shadow: none !important;
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgb(37, 52, 158) !important;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff !important;
  background-color: #4656e9 !important;
  border-color: #4656e9 !important;
}

/*--- btn secondary --*/
/*.btn-secondary {
  color: #fff !important;
  background-color: #ff407b !important;
  border-color: #ff407b !important;
}

.btn-secondary:hover {
  color: #fff !important;
  background-color: #f0346e !important;
  border-color: #f0346e !important;
}

.btn-secondary.focus,
.btn-secondary:focus {
  color: #fff !important;
  background-color: #f0346e !important;
  border-color: #f0346e !important;
  box-shadow: 0 0 0 1px rgb(222, 17, 80) !important;
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff !important;
  background-color: #f0346e !important;
  border-color: #f0346e !important;
} */
/*--- btn success --*/
.btn-success {
  color: #fff;
  background-color: #2ec551;
  border-color: #2ec551;
}

.btn-success:hover {
  color: #fff;
  background-color: #21ae41;
  border-color: #21ae41;
}

.btn-success.focus,
.btn-success:focus {
  color: #fff;
  background-color: #21ae41;
  border-color: #21ae41;
  box-shadow: 0 0 0 1px rgb(18, 158, 50);
}

.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #21ae41;
  border-color: #21ae41;
}

/*--- btn danger --*/
.btn-danger {
  color: #fff;
  background-color: #ef172c;
  border-color: #ef172c;
}

.btn-danger:hover {
  color: #fff;
  background-color: #da0419;
  border-color: #da0419;
}

.btn-danger.focus,
.btn-danger:focus {
  color: #fff;
  background-color: #da0419;
  border-color: #da0419;
  box-shadow: 0 0 0 1px rgb(218, 4, 25);
}

.btn-danger:not(:disabled):not(.disabled).active,
.btn-danger:not(:disabled):not(.disabled):active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #da0419;
  border-color: #da0419;
}

/*--- btn warning --*/
.btn-warning {
  color: #2e2f39;
  background-color: #ffc108;
  border-color: #ffc108;
}

.btn-warning:hover {
  color: #2e2f39;
  background-color: #f3b600;
  border-color: #f3b600;
}

.btn-warning.focus,
.btn-warning:focus {
  color: #2e2f39;
  background-color: #f3b600;
  border-color: #f3b600;
  box-shadow: 0 0 0 1px rgb(238, 182, 0);
}

.btn-warning:not(:disabled):not(.disabled).active,
.btn-warning:not(:disabled):not(.disabled):active,
.show > .btn-warning.dropdown-toggle {
  color: #2e2f39;
  background-color: #f3b600;
  border-color: #f3b600;
}

/*--- btn info --*/
.btn-info {
  color: #fff;
  background-color: #25d5f2;
  border-color: #25d5f2;
}

.btn-info:hover {
  color: #fff;
  background-color: #17c0dc;
  border-color: #17c0dc;
}

.btn-info.focus,
.btn-info:focus {
  color: #fff;
  background-color: #17c0dc;
  border-color: #17c0dc;
  box-shadow: 0 0 0 1px rgb(238, 184, 22);
}

.btn-info:not(:disabled):not(.disabled).active,
.btn-info:not(:disabled):not(.disabled):active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #17c0dc;
  border-color: #17c0dc;
}

/*--- btn light --*/
.btn-light {
  color: #71738d;
  background-color: #f0f0f8;
  border-color: #f0f0f8;
}

.btn-light:hover {
  color: #2e2f39;
  background-color: #d7d7df;
  border-color: #d7d7df;
}

.btn-light.focus,
.btn-light:focus {
  color: #2e2f39;
  background-color: #d7d7df;
  border-color: #d7d7df;
  box-shadow: 0 0 0 1px rgb(215, 215, 223);
}

/*--- btn dark --*/
.btn-dark {
  color: #fff;
  background-color: #2e2f39;
  border-color: #2e2f39;
}

.btn-dark:hover {
  color: #2e2f39;
  background-color: #d7d7df;
  border-color: #d7d7df;
}

.btn-dark.focus,
.btn-dark:focus {
  color: #fff;
  background-color: #d7d7df;
  border-color: #d7d7df;
  box-shadow: 0 0 0 1px rgb(46, 47, 57);
}

/*--- btn outline brand --*/
.btn-outline-brand {
  color: #2e2f39;
  background-color: transparent;
  border-color: #ffc750;
}

.btn-outline-brand:hover {
  color: #2e2f39;
  background-color: #ffc750;
  border-color: #ffc750;
}

.btn-outline-brand.focus,
.btn-outline-brand:focus {
  color: #2e2f39;
  background-color: transparent;
  border-color: #ffc750;
  box-shadow: 0 0 0 1px rgb(255, 195, 89);
}

/*--- btn outline primary --*/
.btn-outline-primary {
  color: #5969ff;
  background-color: transparent;
  border-color: #5969ff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #5969ff;
  border-color: #5969ff;
}

.btn-outline-primary.focus,
.btn-outline-primary:focus {
  color: #fff;
  background-color: #5969ff;
  border-color: #5969ff;
  box-shadow: 0 0 0 1px rgb(65, 77, 167);
}

/*--- btn outline secondary --*/
.btn-outline-secondary {
  color: #ff407b;
  background-color: transparent;
  border-color: #ff407b;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #ff407b;
  border-color: #ff407b;
}

.btn-outline-secondary.focus,
.btn-outline-secondary:focus {
  color: #fff;
  background-color: #ff407b;
  border-color: #ff407b;
  box-shadow: 0 0 0 1px rgb(227, 45, 201);
}

.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #ff407b;
  border-color: #ff407b;
}

/*--- btn outline success --*/
.btn-outline-success {
  color: #2ec551;
  background-color: transparent;
  border-color: #2ec551;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #2ec551;
  border-color: #2ec551;
}

.btn-outline-success.focus,
.btn-outline-success:focus {
  color: #fff;
  background-color: #2ec551;
  border-color: #2ec551;
  box-shadow: 0 0 0 1px rgb(40, 167, 69);
}

/*--- btn outline danger --*/
.btn-outline-danger {
  color: #ef172c;
  background-color: transparent;
  border-color: #ef172c;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #ef172c;
  border-color: #ef172c;
}

.btn-outline-danger.focus,
.btn-outline-danger:focus {
  color: #fff;
  background-color: #ef172c;
  border-color: #ef172c;
  box-shadow: 0 0 0 1px rgb(239, 23, 44);
}

/*--- btn outline warning --*/
.btn-outline-warning {
  color: #2e2f39;
  background-color: transparent;
  border-color: #ffc108;
}

.btn-outline-warning:hover {
  color: #2e2f39;
  background-color: #ffc108;
  border-color: #ffc108;
}

.btn-outline-warning.focus,
.btn-outline-warning:focus {
  color: #2e2f39;
  background-color: #ffc108;
  border-color: #ffc108;
  box-shadow: 0 0 0 1px rgb(255, 193, 8);
}

/*--- btn outline info --*/
.btn-outline-info {
  color: #25d5f2;
  background-color: transparent;
  border-color: #25d5f2;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #25d5f2;
  border-color: #25d5f2;
}

.btn-outline-info.focus,
.btn-outline-info:focus {
  color: #fff;
  background-color: #25d5f2;
  border-color: #0998b0;
  box-shadow: 0 0 0 1px rgb(238, 184, 22);
}

/*--- btn outline light --*/
.btn-outline-light {
  color: #7171a6;
  background-color: transparent;
  border-color: #e6e6f2;
}

.btn-outline-light:hover {
  color: #71748d;
  background-color: #f0f0f8;
  border-color: #cacae0;
}

.btn-outline-light.focus,
.btn-outline-light:focus {
  color: #71748d;
  background-color: #f0f0f8;
  border-color: #cacae0;
  box-shadow: 0 0 0 1px rgb(235, 235, 237);
}

/*--- btn outline-dark --*/
.btn-outline-dark {
  color: #2e2f39;
  background-color: transparent;
  border-color: #2e2f39;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #2e2f39;
  border-color: #2e2f39;
}

.btn-outline-dark.focus,
.btn-outline-dark:focus {
  color: #fff;
  background-color: #2e2f39;
  border-color: #2e2f39;
  box-shadow: 0 0 0 1px rgb(46, 47, 57);
}

/*--- btn size --*/
.btn-xs {
  padding: 5px !important;
  font-size: 9px !important;
  font-weight: 700 !important;
}

.btn-sm {
  padding: 5px 12px !important;
  font-size: 14px !important;
}

.btn-lg {
  padding: 11px 20px !important;
  font-size: 15px !important;
}

/*--- btn social --*/
.btn-facebook {
  color: #fff;
  background-color: #3c73df;
  border-color: #3c73df;
}

.btn-google-plus {
  color: #fff;
  background-color: #eb5e4c;
  border-color: #eb5e4c;
}

.btn-twitter {
  color: #fff;
  background-color: #2caeff;
  border-color: #2caeff;
}

.btn-instagram {
  color: #fff;
  background-color: #9361fa;
  border-color: #9361fa;
}

.btn-pinterest {
  color: #fff;
  background-color: #c8232c;
  border-color: #c8232c;
}

/*--- cropper document btn --*/
.btn-rounded {
  border-radius: 100px;
}

/*--- cropper document btn --*/
.docs-buttons .btn,
.docs-data .input-group {
  margin-bottom: 5px;
}

/*-----------------------
btn-link
-------------------------*/
.btn-link {
  color: #5969ff;
}

.btn-link:hover {
  text-decoration: none;
}

.btn-primary-link {
  color: #5969ff !important;
}

.btn-brand-link {
  color: #ffc750 !important;
}

.btn-secondary-link {
  color: #ff407b !important;
}

/* -----------------------
2.3  Cards
-------------------------*/
.card {
  border: none;
  box-shadow: 0px 4px 94px rgba(0, 0, 0, 0.03);
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6f2;
}

.card-subtitle {
  font-size: 14px;
}

.card-body {
  border-radius: 12px;
  height: 100%;
}

.card-footer {
  border-top: 0px;
  background: #ffffff;
}

.toolbar {
  font-size: 18px;
}

.card-header-title {
  margin: 0;
  line-height: 2;
}

.card-toolbar-tabs .nav.nav-pills .nav-item .nav-link {
  font-size: 14px;
  padding: 6px 10px;
}

.card-toolbar-tabs .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #5969ff;
  background-color: transparent;
}

/*------------------------- Card Varience --------------------------*/
.card-figure {
  position: relative;
  padding: 10px;
  border-radius: 2px;
}

.card-figure .figure {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.card-figure .figure-caption {
  display: block;
  margin-top: 10px;
  font-size: 0.875rem;
  color: inherit;
}

.figure-title {
  margin: 0 0 0.125rem;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-figure.has-hoverable {
  transition: transform 0.2s, box-shadow 0.2s;
}

.card-figure.has-hoverable:focus,
.card-figure.has-hoverable:hover {
  transform: translate3d(0, -0.25rem, 0);
  box-shadow: 0 5px 15px 0 rgba(61, 70, 79, 0.15);
}

.figure-img {
  position: relative;
  margin-bottom: 0;
  overflow: hidden;
}

.figure-img .img-link {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: hsla(0, 0%, 100%, 0.96);
  opacity: 0;
  z-index: 2;
  transition: opacity 0.2s ease;
}

.card-figure:hover .img-link {
  opacity: 1;
}

.figure-img .img-link .tile {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1rem;
  margin-left: -1rem;
}

.tile.bg-danger {
  color: #fff;
}

.tile-circle {
  border-radius: 4rem;
}

.figure-action {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  opacity: 0;
  transform: translate3d(0, 100%, 0);
  transition: all 0.3s ease;
}

.card-figure:hover .figure-action {
  opacity: 1;
  transform: translateZ(0);
  z-index: 2;
}

.figure-tools {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  padding: 0.5rem;
  opacity: 0;
  z-index: 2;
  transition: opacity 0.3s ease;
}

.card-figure:hover .figure-tools {
  opacity: 1;
}

.figure-description {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 2.25rem 0.5rem;
  background-color: hsla(0, 0%, 100%, 0.96);
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 1;
}

.card-figure:hover .figure-description {
  opacity: 1;
}

.figure-attachment {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background-color: #f5f5f5;
  overflow: hidden;
}

.btn-reset {
  padding: 0 2px;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  background-color: transparent;
  border: 0;
  cursor: pointer;
}

/*------------------------- Card Navigation --------------------------*/
.pills-regular .card-header-pills.nav.nav-pills .nav-item .nav-link.active {
  background-color: #5969ff;
  color: #fff;
}

/* -----------------------
2.4  General
-------------------------*/
/*---------Tooltips----------*/
/*--------- Popovers ----------------*/
.popover {
  border: 1px solid rgb(230, 230, 242);
}

.bs-popover-auto[x-placement^=right] .arrow::before,
.bs-popover-right .arrow::before {
  left: 0;
  border-right-color: rgb(230, 230, 242);
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: inherit;
  background-color: #f7f7fd;
  border-bottom: 1px solid #efeff6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

/* -----------------------
2.5  Modals
-------------------------*/
.bd-example-row .row > .col,
.bd-example-row .row > [class^=col-] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.2);
}

/* -----------------------
2.6  Notification
-------------------------*/
/* -----------------------
2.7  Icon
-------------------------*/
.icon-circle {
  border-radius: 100%;
}

.icon-circle-small {
  line-height: 1;
  padding: 4px 2px;
  text-align: center;
  font-size: 12px;
  display: inline-block;
  border-radius: 100%;
}

.icon-circle-medium {
  line-height: 1;
  padding: 22px 2px;
  text-align: center;
  font-size: 12px;
  display: inline-block;
  border-radius: 100%;
}

.icon-box-lg {
  height: 68px;
  width: 68px;
}

.icon-box-md {
  height: 32px;
  width: 32px;
}

.icon-box-xs {
  height: 20px;
  width: 20px;
}

/* -----------------------
2.8  Tabs
-------------------------*/
.tab-regular .nav.nav-tabs {
  border-bottom: transparent;
}

.tab-regular .nav.nav-tabs .nav-link {
  display: block;
  padding: 17px 49px;
  color: #71748d;
  background-color: #dddde8;
  margin-right: 5px;
  border-color: #dddde8;
}

.tab-regular .nav-tabs .nav-link.active {
  background-color: #fff;
  border-color: #e6e6f2 #e6e6f2 #fff;
  color: #5969ff;
}

.tab-regular .tab-content {
  background-color: #fff;
  padding: 30px;
  border: 1px solid #e6e6f2;
  border-radius: 4px;
  border-top-left-radius: 0px;
}

/*----- Tabs Vertical CSS ----*/
.tab-vertical .nav.nav-tabs {
  float: left;
  display: block;
  margin-right: 0px;
  border-bottom: 0;
}

.tab-vertical .nav.nav-tabs .nav-item {
  margin-bottom: 6px;
}

.tab-vertical .nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  background: #fff;
  padding: 17px 49px;
  color: #71748d;
  background-color: #dddde8;
  border-radius: 4px 0px 0px 4px;
}

.tab-vertical .nav-tabs .nav-link.active {
  color: #5969ff;
  background-color: #fff !important;
  border-color: transparent !important;
}

.tab-vertical .nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 0px !important;
}

.tab-vertical .tab-content {
  overflow: auto;
  border-radius: 0px 4px 4px 4px;
  background: #fff;
  padding: 30px;
}

/*----- Tabs Outline CSS ----*/
.tab-outline .nav.nav-tabs {
  border-bottom: transparent;
}

.tab-outline .nav.nav-tabs .nav-item .nav-link {
  display: block;
  padding: 17px 49px;
  color: #71748d;
  background-color: #e9e9f2;
  border-color: #c4c4cf #c4c4cf #c4c4cf;
  margin-right: 3px;
}

.tab-outline .nav-tabs .nav-link.active {
  color: #5969ff !important;
  background-color: transparent !important;
  border-color: #c4c4cf #c4c4cf #efeff6 !important;
}

.tab-outline .nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #5969ff !important;
}

.tab-outline .tab-content {
  padding: 30px;
  border: 1px solid #c4c4cf;
  border-radius: 4px;
  border-top-left-radius: 0px;
}

/*----- Tabs Vertical Outline CSS ----*/
.tab-vertical-outline .nav.nav-tabs {
  float: left;
  display: block;
  margin-right: 0px;
  border-bottom: 0;
}

.tab-vertical-outline .nav.nav-tabs .nav-item {
  margin-bottom: 6px;
}

.tab-vertical-outline .nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  background: #fff;
  padding: 17px 49px;
  color: #71748d;
  background-color: #e9e9f2;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #c4c4cf !important;
}

.tab-vertical-outline .nav-tabs .nav-link.active {
  color: #5969ff;
  border: 1px solid #c4c4cf !important;
  background: transparent;
  border-right: 1px solid #efeff6 !important;
}

.tab-vertical-outline .nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 0px !important;
}

.tab-vertical-outline .tab-content {
  overflow: auto;
  border-radius: 0px 4px 4px 4px;
  background: transparent;
  padding: 30px;
  border: 1px solid #c4c4cf;
  left: -1px;
  position: relative;
  z-index: -1;
}

/*--- Simple Card Tabs ----*/
.simple-card {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e9e9f2;
}

.simple-card .nav.nav-tabs {
  border-bottom: 1px solid #e6e6f2;
}

.simple-card .nav.nav-tabs .nav-item .nav-link {
  padding: 17px 49px;
  color: #71748d;
  background: #f8f8fb;
  border-color: #e9e9f2 #e9e9f2 #e9e9f2;
  margin-right: -1px;
  border-radius: 0px;
  border-top: transparent;
}

.simple-card .nav-tabs .nav-link.active {
  color: #5969ff !important;
  background-color: transparent !important;
  border-color: #e9e9f2 #e9e9f2 #fff !important;
}

.simple-card .tab-content {
  padding: 30px;
}

/*--- Simple Card Outline Tabs ----*/
.simple-outline-card {
  border-radius: 4px;
  border: 1px solid #c4c4cf;
}

.simple-outline-card .nav.nav-tabs {
  border-bottom: 1px solid #c4c4cf;
}

.simple-outline-card .nav.nav-tabs .nav-item .nav-link {
  padding: 17px 49px;
  color: #71748d;
  background: #e9e9f2;
  border-color: #c4c4cf #c4c4cf #c4c4cf;
  margin-right: -1px;
  border-radius: 0px;
  border-top: transparent;
}

.simple-outline-card .nav-tabs .nav-link.active {
  color: #5969ff !important;
  background-color: transparent !important;
  border-color: #c4c4cf #c4c4cf #efeff6 !important;
}

.simple-outline-card .tab-content {
  padding: 30px;
}

/* -----------------------
Pills Regular
-------------------------*/
.pills-regular .nav.nav-pills .nav-item .nav-link {
  background-color: #dddde8;
  padding: 14px 26px;
  margin-right: 3px;
  color: #71748d;
  font-size: 16px;
  margin-bottom: 4px;
}

.pills-regular .nav.nav-pills .nav-item .nav-link.active {
  background-color: #fff;
  color: #5969ff;
}

.pills-regular .tab-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 4px;
}

/* -----------------------
Pills Outline
-------------------------*/
.pills-outline .nav.nav-pills .nav-item .nav-link {
  background-color: transparent;
  padding: 16px 52px;
  margin-right: 3px;
  color: #71748d;
  border: 1px solid #c4c4cf;
}

.pills-outline .nav.nav-pills .nav-item .nav-link.active {
  background-color: transparent;
  color: #5969ff;
}

.pills-outline .tab-content {
  background-color: transparent;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid #c4c4cf;
}

/* -----------------------
Pills vertical
-------------------------*/
.pills-vertical .nav.nav-pills .nav-link {
  background-color: #dddde8;
  padding: 16px 52px;
  margin-bottom: 4px;
  color: #71748d;
}

.pills-vertical .nav.nav-pills .nav-link.active {
  background-color: #fff;
  color: #5969ff;
}

.pills-vertical .tab-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 4px;
}

/* -----------------------
2.9  Accordions
-------------------------*/
.accrodion-regular .card {
  margin-bottom: 5px;
}

.accrodion-regular .card-body {
  margin-top: -1px;
}

.accrodion-regular .card .card-header {
  font-size: 16px;
  padding: 10px;
  background-color: transparent;
}

.accrodion-regular .card .card-header:first-child {
  border-radius: 3px 3px 0 0;
}

.accrodion-regular .card .card-header .btn-link {
  color: #3d405c;
  text-decoration: none;
}

.accrodion-regular .card .card-header .btn-link:hover {
  color: #f12357;
  text-decoration: none;
}

.accrodion-outline .card {
  margin-bottom: 5px;
  background-color: transparent;
  border-color: #d9d9e3;
  box-shadow: none;
}

.accrodion-outline .card-body {
  border: 1px solid #d9d9e3;
  margin-top: -1px;
}

.accrodion-outline .card .card-header {
  font-size: 16px;
  padding: 10px;
  border: 1px solid #d9d9e3;
  background-color: transparent;
}

.accrodion-outline .card .card-header:first-child {
  border-radius: 3px 3px 0 0;
}

.accrodion-outline .card .card-header .btn-link {
  color: #3d405c;
  text-decoration: none;
}

.accrodion-outline .card .card-header .btn-link:hover {
  color: #f12357;
  text-decoration: none;
}

/* -----------------------
2.10  Typography
-------------------------*/
/* -----------------------
2.11  Listgroup
-------------------------*/
.list-group-item {
  position: relative;
  display: block;
  padding: 16px 20px;
  margin-bottom: -1px;
  border: 1px solid #e6e6f2;
}

/* -----------------------
2.12  Multiselect
-------------------------*/
/*-----------------------
2.13 Badge
-------------------------*/
.badge {
  display: inline-block;
  padding: 3px 7px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge-primary {
  background-color: #5969ff;
}

.badge-primary[href]:focus,
.badge-primary[href]:hover {
  color: #fff;
  text-decoration: none;
  background-color: #4656e9;
}

.badge-brand {
  background-color: #ffb739;
  color: #2e2f39;
}

.badge-brand[href]:focus,
.badge-brand[href]:hover {
  color: #2e2f39;
  background-color: #efb63e;
  text-decoration: none;
}

.badge-secondary {
  background-color: #ff407b;
}

.badge-secondary[href]:focus,
.badge-secondary[href]:hover {
  color: #fff;
  background-color: #ff407b;
  text-decoration: none;
}

.badge-success {
  background-color: #21ae41;
}

.badge-success[href]:focus,
.badge-success[href]:hover {
  color: #fff;
  background-color: #21ae41;
  text-decoration: none;
}

.badge-danger {
  background-color: #da0419;
}

.badge-danger[href]:focus,
.badge-danger[href]:hover {
  color: #fff;
  background-color: #ef172c;
  text-decoration: none;
}

.badge-warning {
  background-color: #f3b600;
  color: #2e2f39;
}

.badge-warning[href]:focus,
.badge-warning[href]:hover {
  color: #2e2f39;
  background-color: #f3b600;
  text-decoration: none;
}

.badge-info {
  background-color: #0998b0;
}

.badge-info[href]:focus,
.badge-info[href]:hover {
  color: #fff;
  background-color: #17c0dc;
  text-decoration: none;
}

.badge-light {
  background-color: #efeff6;
  color: #757691;
}

.badge-light[href]:focus,
.badge-light[href]:hover {
  color: #2e2f39;
  background-color: #d7d7df;
  text-decoration: none;
}

.badge-dark {
  background-color: #1f202b;
}

.badge-light[href]:focus,
.badge-light[href]:hover {
  color: #2e2f39;
  background-color: #d7d7df;
  text-decoration: none;
}

.badge-dot {
  border-radius: 100%;
  padding: 4px;
  display: inline-block;
  margin-right: 3px;
}

.label {
  padding: 3px 10px;
  line-height: 13px;
  color: #fff;
  font-weight: 400;
  border-radius: 2px;
  font-size: 75%;
}

.label-rounded {
  border-radius: 60px;
}

.label-primary {
  background-color: #5969ff;
}

.label-success {
  background-color: #2ec551;
}

.label-danger {
  background-color: #ef172c;
}

/*-----------------------
2.14 Pagination
-------------------------*/
.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: 0px;
  margin-right: 5px;
  line-height: 1.25;
  color: #71748d;
  background-color: #fff;
  border: 1px solid #e6e6f2;
  border-radius: 3px;
  line-height: 1;
}

.page-link:hover {
  z-index: 2;
  color: #fff;
  text-decoration: none;
  background-color: #5969ff;
  border-color: #5969ff;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #5969ff;
  border-color: #5969ff;
}

/*-----------------------
2.15 Spinner
-------------------------*/
.spinner-xxl {
  width: 150px;
  height: 150px;
}

.spinner-xl {
  width: 120px;
  height: 120px;
}

.spinner-lg {
  width: 100px;
  height: 100px;
}

.spinner-md {
  width: 80px;
  height: 80px;
}

.spinner-sm {
  width: 60px;
  height: 60px;
}

.spinner-xs {
  width: 30px;
  height: 30px;
}

.dashboard-spinner {
  margin: 0px 8px;
  border-radius: 50%;
  background-color: transparent;
  border: 6px solid transparent;
  border-top: 6px solid #5969ff;
  border-left: 6px solid #5969ff;
  animation: 1s spin linear infinite;
  display: inline-block;
}

.spinner-primary {
  border-top-color: #5969ff;
  border-left-color: #5969ff;
}

.spinner-secondary {
  border-top-color: #6c757d;
  border-left-color: #6c757d;
}

.spinner-success {
  border-top-color: #2ec551;
  border-left-color: #2ec551;
}

.spinner-danger {
  border-top-color: #dc3545;
  border-left-color: #dc3545;
}

.spinner-warning {
  border-top-color: #ffc107;
  border-left-color: #ffc107;
}

.spinner-info {
  border-top-color: #17a2b8;
  border-left-color: #17a2b8;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*-----------------------
2.16 Switch Toggle
-------------------------*/
.switch-button.switch-button-xs {
  height: 20px;
  line-height: 16px;
  width: 50px;
}

.switch-button {
  display: inline-block;
  border-radius: 50px;
  background-color: #9e9eaf;
  width: 60px;
  height: 27px;
  padding: 4px;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.switch-button input[type=checkbox] {
  display: none;
}

.switch-button input[type=checkbox]:checked + span label {
  float: right;
  border-color: #2a75f3;
}

.switch-button.switch-button-xs label {
  height: 12px;
  width: 12px;
}

.switch-button input[type=checkbox]:checked + span label:before {
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  z-index: 0;
  content: "ON";
  color: #fff;
  left: 0;
  text-align: left;
  padding-left: 10px;
}

.switch-button.switch-button-xs label:before {
  line-height: 21px;
}

.switch-button label:before {
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  z-index: 0;
  content: "OFF";
  right: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 27px;
  top: 0;
  text-align: right;
  padding-right: 10px;
  color: #fff;
}

.switch-button input[type=checkbox]:checked + span {
  background-color: #5969ff;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 4px;
}

.switch-button.switch-button-sm label {
  height: 16px;
  width: 16px;
}

.switch-button label {
  border-radius: 50%;
  box-shadow: 0 0 1px 1px #fff inset;
  background-color: #fff;
  margin: 0;
  height: 19px;
  width: 19px;
  z-index: 1;
  display: inline-block;
  cursor: pointer;
  background-clip: padding-box;
}

.switch-button.switch-button-sm {
  height: 24px;
  width: 57px;
  line-height: 20px;
}

.switch-button.switch-button-lg {
  height: 30px;
  line-height: 32px;
  width: 64px;
}

.switch-button.switch-button-success input[type=checkbox]:checked + span {
  background-color: #2ec551;
}

.switch-button.switch-button-warning input[type=checkbox]:checked + span {
  background-color: #ffc750;
}

.switch-button.switch-button-danger input[type=checkbox]:checked + span {
  background-color: #ef172c;
}

/* ==========================================================================
  3. Charts
  ========================================================================== */
/*-----------------------
3.1 Chartist.js
-------------------------*/
.ct-line.ct-threshold-above,
.ct-point.ct-threshold-above,
.ct-bar.ct-threshold-above {
  stroke: #f05b4f;
}

.ct-line.ct-threshold-below,
.ct-point.ct-threshold-below,
.ct-bar.ct-threshold-below {
  stroke: #59922b;
}

.ct-area.ct-threshold-above {
  fill: #f05b4f;
}

.ct-area.ct-threshold-below {
  fill: #59922b;
}

/*-----------------------
3.2 Sprkling.js
-------------------------*/
.spark-chart {
  display: inline-block;
}

.spark-chart-info {
  display: inline-block;
  float: right;
}

/*-----------------------
3.3 Charts.js
-------------------------*/
/*-----------------------
3.4 Morris.js
-------------------------*/
/*-----------------------
3.5 C3 Charts.js
-------------------------*/
/* ==========================================================================
  4. Forms
  ========================================================================== */
/*-----------------------
4.1.  Form Elements
------------------*/
/*-----------------------
4.2.  Form Validations
------------------*/
/*-----------------------
4.3.  Multiseelct
-----------------*/
/*-----------------------
4.4.  Wizard
------------------*/
/*-----------------------
4.5.  Summar Note / Text Editor
------------------*/
/*-----------------------
4.6.  Multiupload
--------------------*/
/* ==========================================================================
 5. Table
 ========================================================================== */
/*-----------------------
5.1.  General
--------------------*/
.table {
  margin-bottom: 0px;
}

.table td,
.table th {
  padding: 10px;
  vertical-align: middle;
  border-top: 1px solid #e6e6f2;
  font-weight: normal;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e6e6f2;
}

.table thead th,
.table th {
  color: #3d405c;
  font-family: "Roboto", sans-serif;
}

.table-bordered {
  border: 1px solid #e6e6f2;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #e6e6f2;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(230, 230, 242, 0.5);
}

.table-hover tbody tr:hover {
  background-color: rgba(230, 230, 242, 0.5);
}

/*-----------------------
5.2.  Data Tables
--------------------*/
/*-- row group table */
tr.group,
tr.group:hover {
  background-color: #5969ff !important;
  color: #fff;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
}

/*-----------------------
5.3. Table Filters
--------------------*/
/* ==========================================================================
 6. Pages
 ========================================================================== */
/*-----------------------
6.1 Blank Page
-------------------------*/
/*-----------------------
6.2 Blank Page Header
-------------------------*/
/*-----------------------
6.3 Login
-------------------------*/
/*-----------------------
6.4 Sign up Page
-------------------------*/
/*-----------------------
6.5 Forgot Password
-------------------------*/
/*-----------------------
6.6 Profile
-------------------------*/
/*-----------------------
6.7 Pricing
-------------------------*/
/*-----------------------
6.8 Timeline
-------------------------*/
/* --------------------------------

Patterns - reusable parts of our design

-------------------------------- */
@media only screen and (min-width: 1170px) {
  .cd-is-hidden {
    visibility: hidden;
  }
}
/* --------------------------------

Vertical Timeline - by CodyHouse.co

-------------------------------- */
.cd-timeline {
  overflow: hidden;
  margin: 2em auto;
}

.cd-timeline__container {
  position: relative;
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
  padding: 2em 0;
}

.cd-timeline__container::before {
  /* this is the vertical line */
  content: "";
  position: absolute;
  top: 0;
  left: 18px;
  height: 100%;
  width: 4px;
  background: #dedee9;
}

@media only screen and (min-width: 1170px) {
  .cd-timeline {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .cd-timeline__container::before {
    left: 50%;
    margin-left: -2px;
  }
}
.cd-timeline__block {
  position: relative;
  margin: 2em 0;
}

.cd-timeline__block:after {
  /* clearfix */
  content: "";
  display: table;
  clear: both;
}

.cd-timeline__block:first-child {
  margin-top: 0;
}

.cd-timeline__block:last-child {
  margin-bottom: 0;
}

@media only screen and (min-width: 1170px) {
  .cd-timeline__block {
    margin: 4em 0;
  }
}
.cd-timeline__img {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 0 0 4px white, inset 0 2px 0 rgba(0, 0, 0, 0.08), 0 3px 0 4px rgba(0, 0, 0, 0.05);
}

.cd-timeline__img img {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -12px;
}

.cd-timeline__img.cd-timeline__img--picture {
  background: #2ec551;
}

.cd-timeline__img.cd-timeline__img--movie {
  background: #ef172c;
}

.cd-timeline__img.cd-timeline__img--location {
  background: #ffc108;
}

@media only screen and (min-width: 1170px) {
  .cd-timeline__img {
    width: 60px;
    height: 60px;
    left: 50%;
    margin-left: -30px;
    /* Force Hardware Acceleration */
    transform: translateZ(0);
  }
  .cd-timeline__img.cd-timeline__img--bounce-in {
    visibility: visible;
    animation: cd-bounce-1 0.6s;
  }
}
@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.cd-timeline__content {
  position: relative;
  margin-left: 60px;
  background: white;
  border-radius: 0.25em;
  padding: 1em;
  border: none;
  box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);
}

.cd-timeline__content:after {
  /* clearfix */
  content: "";
  display: table;
  clear: both;
}

.cd-timeline__content::before {
  /* triangle next to content block */
  content: "";
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 7px solid transparent;
  border-right: 7px solid white;
}

.cd-timeline__read-more,
.cd-timeline__date {
  display: inline-block;
}

.cd-timeline__read-more {
  float: right;
  padding: 0.8em 1em;
  background: #acb7c0;
  color: white;
  border-radius: 0.25em;
}

.cd-timeline__read-more:hover {
  background-color: #bac4cb;
}

.cd-timeline__date {
  float: left;
  padding: 0.8em 0;
  opacity: 0.7;
}

@media only screen and (min-width: 1170px) {
  .cd-timeline__content {
    margin-left: 0;
    padding: 1.6em;
    width: 45%;
    /* Force Hardware Acceleration */
    transform: translateZ(0);
  }
  .cd-timeline__content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left-color: white;
  }
  .cd-timeline__read-more {
    float: left;
  }
  .cd-timeline__date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 6px;
    font-size: 18px;
  }
  .cd-timeline__block:nth-child(even) .cd-timeline__content {
    float: right;
  }
  .cd-timeline__block:nth-child(even) .cd-timeline__content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right-color: white;
  }
  .cd-timeline__block:nth-child(even) .cd-timeline__read-more {
    float: right;
  }
  .cd-timeline__block:nth-child(even) .cd-timeline__date {
    left: auto;
    right: 122%;
    text-align: right;
  }
  .cd-timeline__content.cd-timeline__content--bounce-in {
    visibility: visible;
    animation: cd-bounce-2 0.6s;
  }
}
@media only screen and (min-width: 1170px) {
  /* inverse bounce effect on even content blocks */
  .cd-timeline__block:nth-child(even) .cd-timeline__content.cd-timeline__content--bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  60% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  60% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
/*-----------------------
6.9 404 error
-------------------------*/
.error-section {
  padding: 74px 0px;
}

.error-section-content {
  padding-top: 30px;
  color: #3d405c;
  padding-bottom: 30px;
}

/*-----------------------
6.9 Calendar
-------------------------*/
#calendar1 {
  margin: 0 auto;
}

#wrap {
  /* width: 1100px; */
  margin: 0 auto;
}

#external-events {
  float: left;
  width: 270px;
  padding: 0 20px;
  border: 1px solid #e0e4ef;
  background: #f9f9ff;
  text-align: left;
  border-radius: 4px;
}

#external-events h4 {
  font-size: 16px;
  margin-top: 0;
  padding-top: 1em;
}

#external-events .fc-event {
  margin: 10px 0;
  cursor: pointer;
}

#external-events p {
  margin: 1.5em 0;
  font-size: 11px;
  color: #666;
}

#external-events p input {
  margin: 0;
  vertical-align: middle;
}

#calendar {
  float: right;
  width: 1240px;
}

/*-----------------------
6.10 Metrics
-------------------------*/
.metric-row {
  margin-bottom: 1.25rem;
  border-radius: 0.25rem;
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
}

.metric-value {
  margin-bottom: 0;
  line-height: 1;
  white-space: nowrap;
}

.metric-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #686f76;
  white-space: nowrap;
}

.metric-label:last-child {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.metric-value > sub,
.metric-value > sup {
  color: #ffa76a;
  font-size: 0.5em;
}

.card-metric {
  text-align: center;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(61, 70, 79, 0.05), 0 1px 3px 0 rgba(61, 70, 79, 0.15);
}

.metric-row .metric {
  margin: 8px 0;
  min-height: 136px;
}

.metric-bordered {
  border: 1px solid #d4d5d7;
}

.metric-value > sub {
  bottom: 5px;
}

/*-----------------------
6.11 Media Objects
-------------------------*/
.dashboard-media-object .card-footer {
  padding: 0px;
}

.btn-account {
  position: relative;
  display: flex;
  margin: 0;
  border: 0;
  flex-wrap: none;
  align-items: center;
  background: none;
  color: inherit;
  appearance: none;
  cursor: pointer;
  transition: background-color 0.15s;
  outline: 0;
}

.btn-account .account-summary {
  margin-right: 16px;
  margin-left: 8px;
  display: block;
  text-align: left;
  flex: 1 1;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}

.btn-account .account-description,
.btn-account .account-name {
  margin: 0;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  line-height: 16px;
}

.btn-account .account-description {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.7;
}

.user-avatar {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
}

.avatar-badge {
  position: absolute;
  right: 3px;
  bottom: 4px;
  display: block;
  width: 8px;
  height: 8px;
  line-height: 1.6;
  text-align: center;
  font-size: 8px;
  color: #fff;
  background-color: #a9acb0;
  border-radius: 8px;
  box-shadow: 0 0 0 2px #fff;
  z-index: 2;
}

.avatar-badge.online {
  background-color: #00a28a;
}

.avatar-badge.idle {
  background-color: #ec935e;
}

.avatar-badge.busy {
  background-color: #ea6759;
}

.avatar-badge.offline {
  color: #a9acb0;
  background-color: #a9acb0;
}

.avatar-badge.has-indicator {
  width: 10px;
  height: 10px;
}

.avatar-group {
  display: inline-block;
}

.avatar-group .user-avatar img {
  box-shadow: 0 0 0 2px #fff;
}

.avatar-group .user-avatar + .user-avatar {
  display: inline-block;
  margin-left: -10px;
}

.avatar-group .user-avatar:focus,
.avatar-group .user-avatar:hover {
  z-index: 2;
}

.user-avatar-floated {
  margin-top: -50px;
  z-index: 2;
}

.metric {
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  max-width: 100%;
  border-radius: 4px;
  cursor: default;
}

.metric-label:last-child {
  margin-top: 12px;
  margin-bottom: 0;
}

.card-footer-item {
  padding: 12px 35px;
  flex: 1 1;
  text-align: center;
  display: inline-block;
}

.card-footer-item-bordered:not(:last-child) {
  border-right: 1px solid rgb(230, 230, 242);
}

/*-------------------- User icon sizes ---------------------*/
.user-avatar-xxl {
  height: 128px;
  width: 128px;
}

.user-avatar-xl {
  height: 90px;
  width: 90px;
}

.user-avatar-lg {
  height: 48px;
  width: 48px;
}

.user-avatar-md {
  height: 32px;
  width: 32px;
}

.user-avatar-sm {
  height: 24px;
  width: 24px;
}

.user-avatar-xs {
  height: 18px;
  width: 18px;
}

/*-----------------------
6.12 Shortable / Nesetable
-------------------------*/
.drag-handle,
.drag-indicator {
  cursor: move;
  cursor: grab;
}

.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.list-group-bordered .list-group-item {
  border-color: rgba(19, 29, 40, 0.125);
}

/*.list-group-item:first-child {
    border-width: 0 0 1px;
}*/
.drag-indicator {
  display: inline-block;
  margin: 0 0.5em;
  height: 8px;
  width: 6px;
  transform: translate3d(-0.5em, 0, 0);
  -webkit-user-select: none;
  user-select: none;
}

.dashboard-short-list .list-group-item {
  display: flex;
}

.dd {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  max-width: 100%;
  list-style: none;
  font-size: 13px;
  line-height: 20px;
}

.dd-list {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

.dd-list .dd-list {
  padding-left: 30px;
}

.dd-collapsed .dd-list {
  display: none;
}

.dd-item,
.dd-empty,
.dd-placeholder {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
}

.dd-handle {
  margin-bottom: -1px;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid rgba(19, 29, 40, 0.125);
  border-bottom: 1px solid rgba(19, 29, 40, 0.125);
}

.dd-handle:hover {
  color: #5969ff;
  background: #fff;
}

.dd-item > button {
  display: block;
  position: relative;
  cursor: pointer;
  float: left;
  width: 34px;
  height: 20px;
  margin: 18px 0;
  padding: 0;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  border: 0;
  background: transparent;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  font-weight: bold;
}

.dd-item > button:before {
  content: "+";
  display: block;
  position: absolute;
  width: 100%;
  text-align: center;
  text-indent: 0;
  font-size: 14px;
}

.dd-item > button[data-action=collapse]:before {
  content: "-";
}

.dd-placeholder,
.dd-empty {
  margin: 5px 0;
  padding: 0;
  min-height: 30px;
  background: #f5f5f5;
  border: 1px dashed #b6bcbf;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd-empty {
  border: 1px dashed #bbb;
  min-height: 100px;
  background-color: #f5f5f5;
  background-image: linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff), linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);
  background-size: 60px 60px;
  background-position: 0 0, 30px 30px;
}

.dd-dragel {
  position: absolute;
  pointer-events: none;
  z-index: 9999;
}

.dd-dragel > .dd-item .dd-handle {
  margin-top: 0;
}

.dd-dragel .dd-handle {
  box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);
}

/**
* Nestable Extras
*/
.nestable-lists {
  display: block;
  clear: both;
  padding: 30px 0;
  width: 100%;
  border: 0;
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
}

#nestable-menu {
  padding: 0;
  margin: 20px 0;
}

#nestable-output,
#nestable2-output {
  width: 100%;
  height: 7em;
  font-size: 0.75em;
  line-height: 1.333333em;
  font-family: Consolas, monospace;
  padding: 5px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd-hover > .dd-handle {
  background: #5969ff !important;
}

/**
* Nestable Draggable Handles
*/
.dd3-content {
  display: block;
  height: 30px;
  margin: 5px 0;
  padding: 5px 10px 5px 40px;
  color: #333;
  text-decoration: none;
  font-weight: bold;
  border: 1px solid #ccc;
  background: #fafafa;
  background: linear-gradient(to top, #fafafa 0%, #eee 100%);
  border-radius: 3px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd3-content:hover {
  color: #2ea8e5;
  background: #fff;
}

.dd-dragel > .dd3-item > .dd3-content {
  margin: 0;
}

.dd3-item > button {
  margin-left: 30px;
}

.dd3-handle {
  position: absolute;
  margin: 0;
  left: 0;
  top: 0;
  cursor: pointer;
  width: 30px;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  border: 1px solid #aaa;
  background: #ddd;
  background: linear-gradient(to top, #ddd 0%, #bbb 100%);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.dd3-handle:before {
  content: "≡";
  display: block;
  position: absolute;
  left: 0;
  top: 3px;
  width: 100%;
  text-align: center;
  text-indent: 0;
  color: #fff;
  font-size: 20px;
  font-weight: normal;
}

.dd3-handle:hover {
  background: #ddd;
}

/**
* Socialite
*/
.socialite {
  display: block;
  float: left;
  height: 35px;
}

/*-----------------------
6.13 404 Error
-------------------------*/
/*-----------------------
6.14 Comments Widget
-------------------------*/
.comment-widgets {
  position: relative;
  margin-bottom: 10px;
}

.comment-widgets .comment-row {
  border-bottom: 1px solid transparent;
  padding: 14px;
  display: flex;
  margin: 10px 0;
}

.comment-widgets .comment-row:last-child {
  border-bottom: 0px;
}

.comment-widgets .comment-row:hover,
.comment-widgets .comment-row.active {
  background: rgba(0, 0, 0, 0.05);
}

.comment-text {
  padding-left: 15px;
  width: 100%;
}

.comment-text:hover .comment-footer .action-icons,
.comment-text.active .comment-footer .action-icons {
  visibility: visible;
}

.comment-text p {
  max-height: 65px;
  width: 100%;
  overflow: hidden;
}

.comment-footer .action-icons {
  visibility: hidden;
}

.comment-footer .action-icons a {
  padding-left: 7px;
  vertical-align: middle;
  color: #9e9fa7;
}

.comment-footer .action-icons a:hover,
.comment-footer .action-icons a.active {
  color: #5969ff;
}

/*-----------------------
6.14 mail box widget
-------------------------*/
.mailbox .drop-title {
  font-weight: 600;
  padding: 11px 20px 15px;
  border-radius: 2px 2px 0 0;
  position: relative;
}

.mailbox .drop-title:after {
  content: "";
  position: absolute;
  opacity: 0.2;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background-size: cover;
}

.mailbox .nav-link {
  border-top: 1px solid #e9ecef;
  padding-top: 15px;
  color: #3e5569;
}

.mailbox .message-center {
  position: relative;
}

.mailbox .message-center .message-item {
  border-bottom: 1px solid #e9ecef;
  display: block;
  text-decoration: none;
  padding: 9px 15px;
}

.mailbox .message-center .message-item:hover {
  background: #f8f9fa;
}

.mailbox .message-center .message-item .message-title {
  color: #212529;
}

.mailbox .message-center .message-item .user-img {
  width: 40px;
  position: relative;
  display: inline-block;
  margin: 0 0px 15px 0;
}

.mailbox .message-center .message-item .user-img img {
  width: 100%;
}

.mailbox .message-center .message-item .user-img .profile-status {
  border: 2px solid #fff;
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  left: 30px;
  position: absolute;
  top: 1px;
  width: 10px;
}

.mailbox .message-center .message-item .user-img .online {
  background: #36bea6;
}

.mailbox .message-center .message-item .user-img .busy {
  background: #f62d51;
}

.mailbox .message-center .message-item .user-img .away {
  background: #ffbc34;
}

.mailbox .message-center .message-item .user-img .offline {
  background: #ffbc34;
}

.mailbox .message-center .message-item .mail-contnet {
  display: inline-block;
  width: 75%;
  padding-left: 10px;
  vertical-align: middle;
}

.mailbox .message-center .message-item .mail-contnet .message-title {
  margin: 5px 0px 0;
}

.mailbox .message-center .message-item .mail-contnet .mail-desc,
.mailbox .message-center .message-item .mail-contnet .time {
  font-size: 12px;
  display: block;
  margin: 1px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #a1aab2;
  white-space: nowrap;
}

/* ==========================================================================
7. Email Componants
========================================================================== */
/*------------------------
7.1  Inbox
----------------------------*/
.page-aside {
  background: none repeat scroll 0 0 #ffffff;
  width: 280px;
  height: 100%;
  position: fixed;
  top: 0;
  left: 265px;
  border-right: 1px solid #e6e6f2;
  margin-top: 61px;
  padding-bottom: 61px;
  color: #404040;
}

.page-aside .aside-header {
  padding: 20px 22px;
  position: relative;
}

.aside-header .navbar-toggle {
  background: 0 0;
  display: none;
  outline: 0;
  border: 0;
  padding: 0 11px 0 0;
  text-align: right;
  margin: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
}

.aside-header .navbar-toggle .icon {
  font-size: 24px;
  color: #71738d;
}

.aside-nav .nav li .icon {
  font-size: 13px;
  vertical-align: middle;
  text-align: center;
  min-width: 19px;
  margin-right: 6px;
  color: #71748d;
}

.aside-nav .nav li.active a {
  color: #f12257;
  background: #fff0f4;
}

.aside-nav .nav li.active a .icon {
  color: #4285f4;
}

.aside-header .title {
  display: block;
  margin: 10px 0 0;
  font-size: 27px;
  line-height: 27px;
  font-weight: 300;
  color: #3d405c;
}

.aside-header .description {
  color: #71748d;
  margin: 0;
}

.aside-nav.collapse {
  display: block;
}

.aside-nav {
  visibility: visible;
  font-size: 14px;
}

.aside-content .nav {
  display: block;
}

.aside-content .nav li a {
  display: block;
  position: relative;
}

.aside-nav .nav li a {
  color: #71748d;
  padding: 10px 20px;
}

.aside-content .nav li a:hover {
  text-decoration: none;
  background-color: #efeff6;
}

.aside-nav .nav li.active a .icon {
  color: #dd1151;
}

.email-list-item .from {
  display: block;
  font-weight: 400;
  font-size: 1rem;
  margin: 0 0 1px 0;
}

.email-list-item .msg {
  margin: 0;
  color: #71738d;
}

.email-list-item .icon {
  margin-right: 7px;
  font-size: 1.154rem;
  vertical-align: middle;
  color: #3d405c;
}

.aside-nav .nav li .badge {
  float: right;
  font-size: 14px;
  font-weight: 300;
  padding: 3px 6px;
}

.aside-nav .title {
  display: block;
  color: #3d405c;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 20px 0 0;
  padding: 8px 22px 4px;
}

.aside-compose {
  text-align: center;
  padding: 14px 25px;
}

.master-main-wrapper .main-content {
  margin-left: 266px;
  width: auto;
}

.email-inbox-header {
  background-color: #fff;
  padding: 25px 25px;
}

.email-title {
  display: block;
  margin: 3px 0 0;
  font-size: 22px;
  font-weight: 300;
}

.email-title .icon {
  font-size: 22px;
  color: #71738d;
}

.email-title .new-messages {
  font-size: 1rem;
  color: #3d405c;
  margin-left: 3px;
}

.input-search .input-group-btn {
  position: absolute;
  display: block;
  width: auto;
  top: 1px;
  right: 1px;
  z-index: 3;
}

.input-search .input-group-btn .btn {
  padding: 5px 10px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 1px;
  border-top-right-radius: 1px;
}

.email-filters {
  padding: 20px;
  border-bottom: 1px solid #e6e6f2;
  background-color: #fff;
  display: table;
  width: 100%;
  border-top: 1px solid #e6e6f2;
}

.email-filters .be-select-all.custom-checkbox {
  display: inline-block;
  vertical-align: middle;
  padding: 0;
  margin: 0 30px 0 0;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.email-filters input {
  margin-right: 8px;
}

.custom-control-label {
  position: static;
  display: inline-block;
  line-height: 2;
}

.email-filters .email-filters-right {
  text-align: right;
}

.email-filters > div {
  display: table-cell;
  vertical-align: middle;
}

.email-pagination-indicator {
  display: inline-block;
  vertical-align: middle;
  margin-right: 13px;
}

.email-list {
  background: #eee;
}

.email-list-item {
  border-bottom: 1px solid #e6e6f2;
  padding: 10px 20px;
  display: table;
  width: 100%;
  cursor: pointer;
  position: relative;
  background-color: #fcfcff;
  font-size: 14px;
}

.email-list-item--unread {
  background-color: #ffffff;
}

.email-list-item--unread .from,
.email-list-item--unread .msg {
  color: #3d405c;
  font-weight: 800;
  -webkit-font-smoothing: initial;
}

.email-list-item--unread .msg {
  color: #3d405c;
}

.email-list-actions {
  width: 40px;
}

.email-list-actions,
.email-list-detail {
  vertical-align: top;
  display: table-cell;
}

.email-list-actions .favorite {
  display: block;
  padding-top: 5px;
  padding-left: 1px;
  line-height: 15px;
}

.email-list-actions .favorite span {
  font-size: 12px;
  line-height: 10px;
  color: silver;
}

.email-list-actions .favorite:hover span {
  color: #8d8d8d;
}

.email-list-actions .favorite.active span {
  color: #ffc600;
}

.email-list-item:hover {
  background-color: #fff;
}

.email-list-actions .custom-checkbox {
  padding: 0;
  margin-top: -2px;
}

.email-list-actions .custom-checkbox.custom-control {
  margin-bottom: 0;
}

/*-------------------
7.2  Email Details
--------------------*/
.email-head {
  background-color: #fff;
}

.email-head-subject {
  padding: 25px 25px;
  border-bottom: 1px solid #e6e6f2;
}

.email-head-subject .title {
  display: block;
  font-size: 1.769rem;
  font-weight: 300;
  color: #3d405c;
}

.email-head-subject .title > a.active .icon {
  color: #ffc600;
}

.email-head-subject .title > a .icon {
  color: silver;
  font-size: 14px;
  margin-right: 6px;
  vertical-align: middle;
  line-height: 31px;
  position: relative;
  top: -1px;
}

.email-head-subject .icons {
  font-size: 14px;
  float: right;
}

.email-head-subject .icons .icon {
  color: #71738d;
  margin-left: 12px;
  vertical-align: middle;
}

.email-head-sender .avatar {
  float: left;
  margin-right: 10px;
}

.email-head-sender {
  padding: 13px 25px;
  line-height: 40px;
}

.email-head-sender .date {
  float: right;
  font-size: 12px;
}

.email-head-sender .avatar {
  float: left;
  margin-right: 10px;
}

.email-head-sender .sender {
  font-size: 1.15rem;
}

.email-head-sender .sender .actions {
  display: inline-block;
  position: relative;
}

.email-head-sender .sender .icon {
  font-size: 1.538rem;
  line-height: 16px;
  color: #5a5a5a;
  margin-left: 7px;
}

.email-body {
  background-color: #fff;
  border-top: 1px solid #e6e6f2;
  padding: 30px 28px;
}

.email-attachments {
  background-color: #fff;
  padding: 25px 28px;
  border-top: 1px solid #e6e6f2;
}

.email-attachments .title {
  display: block;
  font-weight: 500;
}

.email-attachments .title span {
  font-weight: 400;
}

.email-attachments ul {
  list-style: none;
  margin: 15px 0 0;
  padding: 0;
}

.email-attachments ul > li {
  line-height: 23px;
}

.email-attachments ul > li a {
  color: #404040;
  font-weight: 500;
}

.email-attachments ul > li .icon {
  vertical-align: middle;
  color: #737373;
  margin-right: 2px;
}

.email-attachments ul > li span {
  font-weight: 400;
}

/*-------------------
7.3 Email Compose
----------------------*/
.email-head-title {
  padding: 25px 25px;
  border-bottom: 1px solid #e6e6f2;
  display: block;
  font-weight: 400;
  color: #3d405c;
  font-size: 1.769rem;
}

.email-head-title .icon {
  color: #696969;
  margin-right: 12px;
  vertical-align: middle;
  line-height: 31px;
  position: relative;
  top: -1px;
  float: left;
  font-size: 1.538rem;
}

.email-compose-fields {
  background-color: #fff;
  border-bottom: 1px solid #e6e6f2;
  padding: 30px 30px 20px;
}

.form-group.row {
  margin-bottom: 0;
  padding: 12px 0;
}

.form-group.row label {
  white-space: nowrap;
}

.email-compose-fields label {
  padding-top: 15px;
}

.email.editor {
  background-color: #fff;
}

.email.action-send {
  padding: 20px 0px;
}

.btn-space {
  margin-right: 5px;
  margin-bottom: 5px;
}

.breadcrumb {
  margin: 0;
  background-color: transparent;
}

/*-------------------
7.4  Message Chat Module
----------------------*/
.chat-body {
  overflow: hidden;
}

.chat-module {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: space-between;
}

.chat-module {
  height: calc(100vh - 105px);
}

.master-main-wrapper .content-container > .chat-module {
  /*height: 100%;*/
}

.master-main-wrapper .content-container > .chat-module {
  overflow: hidden;
  padding: 1.5rem;
}

.chat-module .chat-module-body {
  width: 100%;
  position: absolute;
  top: 55px;
  height: calc(100% - 4rem);
  overflow-y: scroll;
  padding-right: 1.5rem;
  -ms-overflow-style: none;
}

.master-main-wrapper .content-container > .chat-module .chat-module-body {
  width: 100%;
  padding-right: 0;
}

.chat-module .chat-module-top {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  max-height: calc(100% - 3.5rem);
  position: relative;
}

.avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  border: 2px solid #f7f9fa;
  background: #f7f9fa;
  color: #fff;
}

.media-attachment {
  padding-left: 0.75rem;
  align-items: center;
  border-left: 4px solid #e9eef2;
}

.chat-item .media-attachment {
  border-color: #dedee4;
}

.chat-item-author {
  color: #333;
}

.media-attachment:not(:first-child) {
  margin-top: 0.75rem;
}

.media-attachment div.avatar {
  border: none;
}

.avatar.bg-primary {
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar.bg-primary i {
  font-size: 14px;
}

.media {
  display: flex;
  align-items: flex-start;
}

.chat-item {
  font-size: 0.875rem;
  line-height: 1.3125rem;
}

.master-main-wrapper .content-container > .chat-module .chat-item {
  padding-bottom: 1.5rem;
}

.master-main-wrapper .content-container > .chat-module .chat-item:not(:last-child) {
  border-bottom: 1px solid #e6e6f2;
}

.master-main-wrapper .content-container > .chat-module .chat-item .media-body {
  background: none;
}

.chat-item > .media-body {
  margin-left: 0.75rem;
  border-radius: 0.5rem;
  padding: 6px 1px;
  background: transparent;
}

.media-body {
  flex: 1 1;
}

.chat-item + .chat-item {
  margin-top: 0.75rem;
}

.chat-item .chat-item-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.375rem;
}

.master-main-wrapper .main-container {
  overflow: hidden;
  flex: 1 1;
}

.master-main-wrapper .content-container {
  display: flex;
  height: calc(100vh - 3.5625rem);
}

.master-main-wrapper .content-container > .chat-module .chat-item .media-body {
  padding: 0;
  background: none;
}

.media-attachment .media-body > a {
  display: block;
}

.media-attachment .media-body {
  margin-left: 0.75rem;
}

.chat-module .chat-module-bottom {
  position: relative;
  padding-top: 1rem;
  border-top: 1px solid #e9eef2;
  background: #efeff6;
}

.chat-form {
  position: relative;
}

.chat-module .chat-module-bottom textarea {
  max-height: 9rem;
}

.chat-form textarea {
  padding-right: 3.375rem;
}

.chat-form-buttons {
  position: absolute;
  top: 6px;
  right: 0.25rem;
  display: flex;
  align-items: center;
}

.chat-form-buttons button {
  padding: 0;
}

.chat-form-buttons .custom-file-naked {
  width: 1.5rem;
  margin-left: 0.375rem;
  top: 5px;
}

.custom-file-naked {
  cursor: pointer;
  width: auto;
  height: auto;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.125rem + 2px);
  margin-bottom: 0;
}

.custom-file-naked .custom-file-input {
  width: auto;
  height: auto;
  cursor: pointer;
}

.custom-file-naked .custom-file-label {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: auto;
  cursor: pointer;
}

.chat-form-buttons i {
  color: #6c757d;
  font-size: 1.25rem;
  cursor: pointer;
}

.custom-file-label::after {
  display: none;
}

.chat-sidebar {
  height: 100%;
  overflow: hidden;
  width: 384px;
  border-left: 1px solid #e6e6f2;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.chat-sidebar-content {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.text-small {
  font-size: 0.875rem;
  line-height: 1.3125rem;
}

.chat-team-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-team-sidebar .chat-team-sidebar-top {
  padding: 1.5rem;
}

.align-items-center {
  align-items: center !important;
}

.chat-team-sidebar .nav {
  margin-top: 1.5rem;
}

.chat-team-sidebar .nav-tabs {
  border-radius: 4px;
  background: #eef2f5;
}

.chat-team-sidebar .nav-tabs .nav-item {
  margin: 0.5rem;
}

.chat-team-sidebar .nav-tabs .nav-link:not(.active) {
  color: rgba(33, 37, 41, 0.5);
}

.chat-team-sidebar .nav-tabs .nav-link {
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  padding: 10px;
  transition: color 0.35s ease-out;
}

.chat-team-sidebar .chat-team-sidebar-bottom,
.chat-team-sidebar .chat-team-sidebar-bottom .tab-content {
  flex: 1 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chat-team-sidebar .chat-team-sidebar-bottom,
.chat-team-sidebar .chat-team-sidebar-bottom .tab-content {
  flex: 1 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chat-team-sidebar .tab-pane {
  overflow-y: none;
  -ms-overflow-style: none;
  height: 100%;
}

.chat-team-sidebar .list .list-group-item {
  width: 100%;
}

.sidebar form.dropzone {
  padding: 0 1.5rem;
}

form.dropzone {
  width: 100%;
  margin-bottom: 1.5rem;
}

.sidebar .dz-message {
  background: #f7f9fa;
  padding: 1rem;
}

.dz-message {
  text-align: center;
  padding: 1.5rem;
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  opacity: 1;
  cursor: pointer;
  border-radius: 0.5rem;
  background: #fff;
  border: 1px dashed #e9eef2;
  transition: all 0.35s ease;
  color: rgba(108, 117, 125, 0.5);
}

.dropzone-previews {
  width: 100%;
}

.dz-file-representation img:not([src]) {
  display: none;
}

.dz-file-representation img {
  position: absolute;
  object-fit: cover;
}

.dz-preview .avatars li:last-child {
  transition: opacity 0.35s ease;
  opacity: 0;
}

.dz-loading {
  opacity: 1;
  transition: opacity 0.35s ease;
  position: absolute;
  left: 1.1875rem;
}

.list-group-activity .avatars {
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
}

.list-group-activity span {
  margin-right: 0.25rem;
}

.list-group-activity .avatars > li:first-child {
  position: relative;
  z-index: 2;
}

.avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  border: 2px solid #f7f9fa;
  background: #f7f9fa;
  color: #fff;
}

.avatars > li {
  display: inline-block;
}

.chat-team-sidebar .list-group-activity .avatar {
  border-color: #fff;
}

.avatars {
  padding-left: 0;
  list-style: none;
  margin: 0;
}

.avatar.bg-primary {
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatars > li + li {
  margin-left: -0.75rem;
}

.btn-options {
  color: #6c757d;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.Insurance_div_main_otr .card.Insurance_div {
  border: 0px;
}

/* ==========================================================================
9. Map
========================================================================== */
/*-------------------------------------------------------------------
Media Query
-------------------------------------------------------------------*/
/*==========  Non-Mobile First Method  ==========*/
/* Large Devices, Wide Screens */
@media only screen and (max-width: 1400px) {
  .product-price {
    position: initial;
  }
  .product-slider {
    background-color: #fff;
    border-top-left-radius: 4px;
    padding: 131px 28px;
  }
  .influencer-profile-data .user-social-media {
    padding: 16px 56px;
    text-align: center;
    border-right: 1px solid #e6e6f2;
  }
}
@media only screen and (max-width: 1200px) {
  .product-price {
    position: initial;
  }
  .product-slider {
    padding: 131px 30px;
  }
  /*--------- dashboard-influence -------- */
  .user-social-media {
    padding: 16px 45px;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #dee2e6;
    border-right: transparent !important;
  }
}
/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  /*--------- dashboard-influence -------- */
  .user-social-media {
    padding: 16px 45px;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #dee2e6;
    border-right: transparent !important;
  }
}
/* Small Devices, Tablets */
@media only screen and (max-width: 991px) {
  .main-header .navbar-toggler svg path {
    fill: #fff;
  }
  .main-header .navbar-collapse {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 60px;
    background: #288366;
  }
  .main-header nav.navbar ul {
    flex-direction: column;
    align-items: flex-start;
    justify-content: left;
    flex-wrap: nowrap;
    padding: 15px 10px;
    row-gap: 5px;
  }
  .main-header .navbar > .container-fluid {
    justify-content: end;
    column-gap: 18px;
    flex-wrap: nowrap;
  }
  .main-header .navbar > .container-fluid .navbar-brand {
    width: 100%;
  }
  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {
    flex-direction: row;
    column-gap: 5px;
  }
  .main-content-wrapper-inner {
    padding: 20px 20px 60px 20px;
  }
  .nav-left-sidebar .navbar a {
    color: #fff;
    font-size: 18px;
    text-decoration: none;
  }
  .nav-left-sidebar .navbar {
    padding: 0px;
  }
  .nav-left-sidebar {
    width: 100%;
    position: relative;
    top: 0px;
    right: 0px;
  }
  .main-content-wrapper {
    margin-left: 0px;
  }
  .dashboard-footer {
    margin-left: 0px;
  }
  .nav-left-sidebar .navbar-toggler {
    background-color: transparent;
    padding: 0px;
  }
  /* infulencer dahboard */
  .dashboard-influence .card-footer-item {
    padding: 11px 54px;
  }
  .influencer-profile .tab-regular .nav.nav-tabs .nav-item .nav-link,
  .influencer-profile .tab-regular .nav.nav-pills .nav-item .nav-link {
    display: block;
    padding: 17px 13px;
  }
  /* Inbox */
  .page-aside {
    background: none repeat scroll 0 0 #ffffff;
    width: 280px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-right: 1px solid #e6e6f2;
    margin-top: 0;
    padding-bottom: 0px;
    color: #404040;
  }
  /*--------- dashboard-product-single -------- */
  .product-slider {
    padding: 131px 30px;
  }
  .product-carousel .carousel-indicators {
    bottom: -30px;
  }
  /*--------- dashboard-influence -------- */
  .user-social-media {
    padding: 16px 45px;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #dee2e6;
    border-right: transparent !important;
  }
}
/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .main-content-wrapper-inner {
    padding: 20px 20px 60px 20px;
  }
  .nav-left-sidebar .navbar a {
    color: #fff;
  }
  .nav-left-sidebar .navbar-toggler {
    background-color: transparent;
  }
  .aside-header .navbar-toggle {
    display: block;
  }
  .nav-left-sidebar {
    width: 100%;
    position: relative;
    top: 0px;
    right: 0px;
  }
  .main-content-wrapper {
    margin-left: 0px;
  }
  .dashboard-footer {
    margin-left: 0px;
  }
  .page-aside {
    background: none repeat scroll 0 0 #fff;
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 0px;
    border-right: transparent;
    margin-top: 0px;
    padding-bottom: 0px;
    color: #404040;
    border-bottom: 1px solid #e6e6f2;
  }
  .aside-nav.collapse {
    display: none;
  }
  .master-main-wrapper .main-content {
    margin-left: 0px;
    width: auto;
  }
  .aside-nav.show {
    display: block;
  }
  /*--------- dashboard-influence -------- */
  .user-social-media {
    padding: 16px 45px;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #dee2e6;
    border-right: transparent !important;
  }
  .user-social-media:last-child {
    border-bottom: transparent;
    border-right: transparent !important;
  }
  .dashboard-influence .progress {
    width: 74%;
  }
  .footer {
    margin-left: 0px;
  }
  .influencer-profile-data .user-avatar {
    float: initial;
  }
  .influencer-profile-data .user-avatar-name {
    float: initial;
  }
  .dashboard-influence .card-footer-item {
    padding: 11px 48px;
  }
  /*--------- dashboard-profile -------- */
  .tab-regular .nav.nav-tabs .nav-item .nav-link,
  .tab-regular .nav.nav-pills .nav-item .nav-link {
    display: block;
    padding: 17px 38px;
  }
  .tab-regular .nav.nav-tabs .nav-item,
  .tab-regular .nav.nav-pills .nav-item {
    margin-bottom: 5px;
  }
  /*--------- dashboard-product-single -------- */
  .product-slider {
    padding: 30px 10px;
  }
  .product-carousel .carousel-indicators {
    bottom: -30px;
  }
  .simple-card .nav.nav-tabs .nav-item .nav-link {
    padding: 17px 29px;
  }
}
/* Custom, iPhone Retina */
/*============ NEW_CSS_START ===============*/
.home_main_card_outer {
  background-color: #96cc9f !important;
  position: relative;
  height: auto;
  width: 32% !important;
  z-index: 999;
  position: relative;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
}

.home_main_card_outer::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  bottom: -16px;
  width: 46px;
  height: 16px;
  opacity: 0;
}

.home_main_card_outer.active::after {
  opacity: 1;
}

.home_main_card_outer:hover {
  background-color: #a3c967 !important;
}

.home_main_card_outer.active {
  background-color: #479573 !important;
}

.home_main_card_outer::before {
  position: absolute;
  content: "";
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0.5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: bottom;
  background-repeat: no-repeat;
  width: 100%;
  z-index: -1;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
}

.home_main_card_outer.two::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.home_main_card_outer :not(.active):hover::before,
.home_main_card_outer:hover::before {
  background-position-y: 140%;
}

.home_main_card_outer .card-body {
  padding-bottom: 15px;
}

.home_main_card_outer .card-body h5 {
  margin-bottom: 15px;
}

.Under_Management {
  column-gap: 25px;
}

.Select_state_outer {
  width: 100%;
}

.Select_state_outer h6 {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  margin: 0px;
}

.Under_Management .Under_Management_content_left p,
.Under_Management .Under_Management_content_right p {
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  padding: 8px;
  cursor: pointer;
}

.Under_Management .Under_Management_content_right h4 span {
  font-size: 30px;
}

.Under_Management .Under_Management_content_right p.active {
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  padding: 8px;
  background-color: #225ea8;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
}

.Under_Management .Under_Management_content_right p:hover {
  padding: 8px;
  background-color: #225ea8;
  border-radius: 10px;
  cursor: pointer;
}

.Under_Management .Under_Management_content_left h4 {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #fff !important;
  margin: 0px;
  line-height: initial;
}

.Under_Management .Under_Management_content_right p {
  font-size: 12px;
  margin-bottom: 5px;
}

.Under_Management .Under_Management_content_right h4 {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #fff !important;
  margin: 0px;
  line-height: initial;
}

.client_contact_recency_inner .Under_Management_content_left p {
  font-size: 12px;
  margin-bottom: 5px;
}

.client_contact_recency_inner .Under_Management_content_right h4 {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #fff !important;
  margin: 0px;
  line-height: initial;
}

.Under_Management .Under_Management_content {
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
}

.Under_Management .Under_Management_image {
  max-width: 90px;
  width: 100%;
}

.Under_Management .Under_Management_image img {
  max-width: 90px;
  width: 90px;
}

.Under_Management .Under_Management_content_right {
  text-align: right;
}

.amounts_main {
  margin-bottom: 30px;
}

.amounts_main_outer {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 5px;
  row-gap: 5px;
  margin-top: 20px;
}

.amounts_main_outer .amount_box {
  background-color: #f7f8fa;
  padding: 13px 9px;
  border-radius: 10px;
  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);
  transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  -moz-transition: 0.3s ease-in-out;
}

.amounts_main_outer .amount_box:hover {
  background-color: #e4f8d9;
  border-radius: 0px;
}

.amounts_main_outer .amount_box:hover p {
  color: #55a080;
}

.amounts_main_outer .amount_box p {
  margin-bottom: 0px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #55a080;
}

.amounts_main_outer .amount_box .amount {
  color: #565656;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  line-height: initial;
  display: flex;
  display: -webkit-flex;
  column-gap: 2px;
  margin-top: 5px;
}

.amounts_main_outer .amount_box .amount span {
  color: #565656;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: initial;
}

.amount_box {
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.amount_content h6 {
  margin: 0px;
  font-weight: 700;
  font-size: 17px;
  font-family: "Roboto", sans-serif;
  color: #565656 !important;
  padding: 4px 5px;
  border-radius: 5px;
  margin-top: 5px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.amount_box .amount_title {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
}

.amount_box .amount_title svg {
  opacity: 0;
  visibility: hidden;
  width: 15px;
  height: 15px;
}

.amount_box:hover .amount_title svg {
  opacity: 1;
  visibility: visible;
}

.amount_box:hover .amount_content h6 {
  background-color: #fff;
}

.market_forecast_box .box_title {
  width: 100%;
  grid-column: 4 span;
}

.market_forecast_box .market_forecast_box_outer {
  grid-column: 4 span;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-row-gap: 5px;
  row-gap: 5px;
  grid-column-gap: 5px;
  column-gap: 5px;
}

.market_forecast_box .box_item {
  padding: 6px 2px 2px;
  background: #f7f8fa;
  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);
  border-radius: 10px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.market_forecast_box .box_item:first-child {
  grid-column: 4 span;
  width: auto;
  max-width: 24.5%;
}

.market_forecast_box .box_item span .edit {
  opacity: 0;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.market_forecast_box .box_item:hover span .edit {
  opacity: 1;
}

.market_forecast_box .box_item p.small_title {
  font-size: 12px;
  font-weight: 700;
  color: #55a080;
  text-transform: uppercase;
  margin-bottom: 2px;
  padding-left: 4px;
}

.market_forecast_box .box_item .value_outer {
  display: grid;
  column-gap: 2px;
  grid-template-columns: 1fr 1fr 1fr;
}

.market_forecast_box .box_item .value_outer .value_outer_box {
  border-radius: 6px;
  padding: 4px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
}

.market_forecast_box .box_item .value_outer .value_outer_box svg {
  width: 15px;
  height: 15px;
}

.market_forecast_box .box_item:hover .value_outer .value_outer_box {
  background-color: #fff;
}

.market_forecast_box .box_item.edit_ret,
.market_forecast_box .box_item:hover {
  background: #c7e9b4;
}

.market_forecast_box .box_item:hover p.small_title {
  color: #55a080;
}

.market_forecast_box .value_outer .value_outer_box span {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  color: #565656;
}

.market_forecast_box .value_outer .value_outer_box span.ret,
.market_forecast_box .value_outer .value_outer_box span.vol,
.market_forecast_box .value_outer .value_outer_box span.div {
  display: flex;
  justify-content: space-between;
}

.market_forecast_box .value_outer .value_outer_box h6 {
  margin: 0px;
  font-weight: 700;
  font-size: 20px;
  font-family: "Roboto", sans-serif;
  color: #565656 !important;
}

.market_forecast_box .value_outer .value_outer_box h6 sup {
  top: -6px;
  font-size: 12px;
  right: 2px;
}

.market_forecast .market_forecast_box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 5px;
  column-gap: 5px;
  grid-row-gap: 5px;
  row-gap: 5px;
}

.Dropdown_main_outer label {
  color: #479573;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
}

.Correlations_main_outer {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  grid-column: 4 span;
}

.Correlations_main_outer .Correlations_item {
  padding: 6px;
  background: #f7f8fa;
  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);
  border-radius: 10px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.Correlations_main_outer .Correlations_item h5 {
  font-size: 12px !important;
}

.Correlations_main_outer .Correlations_item:hover {
  background-color: #e4f8d9;
}

.Correlations_main_outer .Correlations_item h6 {
  margin: 0px;
  font-weight: 700;
  font-size: 17px;
  font-family: "Roboto", sans-serif;
  color: #565656 !important;
}

.Correlations_main_outer .Correlations_item .value_outer {
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 5px;
  justify-content: space-between;
  column-gap: 5px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.Correlations_main_outer .Correlations_item:hover .value_outer {
  background: #fff;
}

.Correlations_main_outer .Correlations_item .value_outer .edit {
  opacity: 0;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  width: 15px;
  height: 15px;
  min-width: 15px;
  max-width: 15px;
  min-height: 15px;
  max-height: 15px;
}

.Correlations_main_outer .Correlations_item:hover .value_outer .edit {
  opacity: 1;
}

.Dropdown_main_outer {
  width: 100%;
  max-width: 100%;
  margin-bottom: 8px;
}

.Correlations_title {
  width: 100%;
  grid-column: 4 span;
}

.client_type_outer {
  padding: 0px 1rem;
  border-right: 1px dashed rgba(0, 0, 0, 0.5);
}

.market_forecast_box .box_item.edit_ret .value_outer {
  display: none;
}

.market_forecast_box .box_item.edit_ret .value_ret_content span {
  color: #565656;
  font-weight: 600;
}

.market_forecast_box .box_item.edit_ret .value_ret_content {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 3px;
  margin-top: 8px;
  padding-left: 4px;
}

.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div {
  display: flex;
  align-items: center;
  padding: 3px 8px 3px 10px;
  background: #fff;
  height: 38px;
}

.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div,
.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div input {
  font-weight: 700;
  color: #565656;
}

.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div .submit img {
  width: 15px;
}

.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div input {
  width: 100%;
  border: 0px;
}

.save_button {
  text-align: right;
}

.responsive_save_button button,
.save_button button,
.common-button {
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 7.5px 15px;
  border: 0px;
  background: #225ea8;
  border-radius: 5px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  text-transform: none;
  margin-left: auto;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
}

.common-button {
  height: 35px;
  padding: 7.5px 20px;
}

.secondary-button {
  background: grey !important;
}

.select_client_outer {
  margin-top: 10px;
  width: 100%;
}

.select_client_outer .client,
.select_client_outer .plan {
  width: 100%;
}

.select_client_outer.select_client_outer_other {
  width: 50%;
  margin: 0px;
}

.select_client_outer select {
  width: auto;
}

.select_client_outer input {
  width: 85px;
  background-image: none;
}

.select_client_outer input .select_client_outer select {
  min-height: 28px;
  border-radius: 8px;
  background-color: #fff;
  max-height: 28px;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: 500;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.select_client_outer select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position-y: center;
  background-size: 14px;
  background-position-x: 95%;
  padding: 0px 26px 0px 12px;
  position: relative;
  background-repeat: no-repeat;
  background-position-y: 50%;
  background-position-x: 98%;
}

.select_client_outer select::before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: contain;
  width: 10px;
}

.select_client_outer .add_client_button_group,
.select_client_outer .select_client_outer_form_row {
  column-gap: 5px;
  opacity: 0.5;
  margin-top: 10px;
}

.select_client_outer .select_client_outer_form_row .date_picker input.form-control {
  background-color: #368156;
}

.select_client_outer .select_client_outer_form_row .date_picker input.form-control {
  color: #fff;
  border: none;
}

.home_main_card_outer.active .select_client_outer .add_client_button_group,
.home_main_card_outer.active .select_client_outer .select_client_outer_form_row {
  opacity: 1;
  margin-top: 10px;
}

.home_main_card_outer.active .select_client_outer .select_client_outer_form_row .date_picker input.form-control {
  background-color: #fff;
}

.home_main_card_outer.active .select_client_outer .select_client_outer_form_row .date_picker input.form-control {
  color: #000;
}

.client_contact_total_outer {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.client_contact_total_outer .client_contact_total p {
  font-size: 10px;
  color: #727272;
}

.client_contact_total_outer .client_contact_total.left p span {
  font-weight: 800;
}

.client_contact_total_outer .client_contact_total.right p span {
  font-weight: 600;
  font-size: 20px;
}

.Insurance_div {
  height: 50vh !important;
  overflow: auto;
}

.comments_notes_outer_inner textarea {
  background: linear-gradient(180deg, #ffffff 0%, #efefef 87.59%);
  border: 1px solid #8d8d8d;
  border-radius: 5px;
  width: 100%;
  padding: 13px;
  resize: none;
  height: 133px;
  font-size: 11px;
  font-weight: 500;
  color: #000;
}

.comments_notes_outer_inner textarea::placeholder {
  color: #000 !important;
  font-size: 11px;
  font-weight: 500;
}

.comments_notes_outer {
  height: 50vh !important;
  overflow: auto;
}

.comments_notes_data {
  row-gap: 7px;
  padding-bottom: 25px;
}

.comments_notes_data .comments_notes_data_box {
  padding: 9px 13px 15px;
  background: #eafbe8;
  border-radius: 9px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.comments_notes_data .comments_notes_data_box h6 {
  margin-bottom: 5px;
}

.comments_notes_data .comments_notes_data_box h6,
.comments_notes_data .comments_notes_data_box p {
  font-weight: 500;
  font-size: 10px;
  color: #4a6664;
}

.comments_notes_data_footer {
  padding: 15px;
}

.comments_notes_search_date .search_outer {
  width: 65%;
}

.comments_notes_search_date .date_outer {
  width: 35%;
}

.comments_notes_search_date .date_outer input {
  background: #ffffff;
  border: 1px solid #727272;
  border-radius: 8px;
  padding: 5px 5px 5px 26px;
  font-weight: 500;
  font-size: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position-y: center;
  background-position-x: 5px;
  background-repeat: no-repeat;
  color: #000000;
  line-height: initial;
  height: 26px;
}

.comments_notes_search_date .search_outer input {
  border: none;
  padding: 5px 5px 5px 2px;
  font-weight: 500;
  font-size: 10px;
  color: #000000;
  line-height: initial;
  height: 26px;
}

.comments_notes_search_date .search_outer .input-group {
  border: 1px solid #727272;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.comments_notes_search_date .search_outer .input-group button.search_icon_button {
  background: transparent;
  border: none;
  padding-left: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: 15px;
  background-position-x: 6px;
  background-position-y: 5px;
  height: 20px;
  width: 20px;
}

.comments_notes_search_date {
  padding: 12px 0px 18px;
  column-gap: 12px;
}

.Expenses_div_main_otr {
  padding-right: 0px;
}

/* REPORTS_TOP_HEADER_CSS_START */
.main-content-wrapper-reports {
  display: flex;
  display: -webkit-flex;
  margin-left: 73px;
}

.main-content-wrapper-reports .reports_pdf_nav_under_tab_devices {
  display: none;
}

.main-content-wrapper-reports .reports_pdf_nav_tab {
  width: 97px;
  display: flex;
  display: -webkit-flex;
  background-color: #fff;
  height: 100vh;
  position: fixed;
  overflow: auto;
  left: 73px;
}

.main-content-wrapper-reports .reports_pdf_nav_tab ul {
  padding: 20px 0px;
  width: 100%;
}

.main-content-wrapper-reports .reports_pdf_nav_tab ul li {
  list-style: none;
  text-align: center;
  padding: 5px 0px;
  margin-bottom: 20px;
  position: relative;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
}

.main-content-wrapper-reports .reports_pdf_nav_tab ul li:hover,
.main-content-wrapper-reports .reports_pdf_nav_tab ul li.active {
  background-color: #80b468;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #d7efd4;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5aa266;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.main-content-wrapper-reports .reports_pdf_nav_tab .hover_icons button {
  background-color: transparent;
  outline: none;
  border: 0px;
  padding: 0px;
}

.main-content-wrapper-reports .reports_pdf_nav_tab .hover_icons button img {
  width: 22px;
  background-color: #fff;
  border-radius: 50px;
}

.main-content-wrapper-reports .reports_pdf_nav_tab .hover_icons {
  position: absolute;
  bottom: -8px;
  left: 50%;
  width: 100%;
  transform: translateX(-50%);
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  opacity: 0;
  visibility: hidden;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li:not(.active):hover .hover_icons {
  opacity: 1;
  visibility: visible;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon {
  position: relative;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon img {
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon img.white {
  position: absolute;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon .color {
  opacity: 1;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon .white {
  opacity: 0;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li:hover .pdf_icon .white,
.main-content-wrapper-reports .reports_pdf_nav_tab li.active .pdf_icon .white {
  opacity: 1;
}

.main-content-wrapper-reports .reports_pdf_nav_tab li:hover .pdf_icon .color,
.main-content-wrapper-reports .reports_pdf_nav_tab li.active .pdf_icon .color {
  opacity: 0;
}

.Reports_top_button_div {
  width: 35%;
}

.report_name_outer {
  width: 20%;
  text-align: center;
}

.reports_top_right_div {
  width: 45%;
}

.Reports_top_button_div ul li {
  list-style: none;
}

.Reports_top_button_div ul {
  display: flex;
  display: -webkit-flex;
  column-gap: 6px;
  padding: 0px;
  margin: 0px;
}

.Reports_top_button_div ul li button {
  font-size: 12px !important;
  font-weight: 700;
  font-family: "Inter", sans-serif;
  text-transform: uppercase;
  height: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 8px;
  padding: 7px 15px !important;
  background: #8f8f8f !important;
  border-color: #8f8f8f !important;
}

.Reports_top_button_div ul li button:hover {
  background: #8f8f8f !important;
  border-color: #8f8f8f !important;
}

.Reports_top_button_div ul li button img {
  width: 15px;
}

.report_name_outer h3 {
  margin: 0px;
  font-size: 20px;
  font-weight: 700;
  opacity: 0.6;
  color: #000;
}

.reports_top_right_div {
  column-gap: 15px;
  justify-content: right;
}

.reports_top_right_div_file_outer button {
  background-color: transparent;
  border: 0px;
  padding: 0px 2px;
  outline: none;
}

.reports_generate_pdf button {
  font-size: 12px !important;
  font-weight: 700;
  font-family: "Inter", sans-serif;
  text-transform: uppercase;
  padding: 9px 11.5px !important;
  background-color: #235da8;
}

.reports_generate_pdf button:hover {
  background-color: #235da8;
}

.reports_pdf_outer {
  background-color: #fff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
}

.reports_pdf_outer .reports_pdf_header_outer {
  background-color: #41b6c4;
  padding: 15px 30px;
}

.reports_pdf_header_outer .reports_pdf_financial_advisors h4 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-top: 5px;
  margin-bottom: 0px;
}

.reports_pdf_outer .reports_pdf_header_outer {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
}

.reports_pdf_outer .reports_pdf_financial_advisors {
  width: 35%;
}

.reports_pdf_outer .reports_client_name_outer {
  width: 30%;
  text-align: center;
}

.reports_pdf_outer .reports_advisor_name_date {
  width: 35%;
  text-align: right;
}

.reports_pdf_outer .reports_client_name_outer h1 {
  color: #fff;
  margin-bottom: 0px;
}

.reports_pdf_outer .reports_client_name_outer p {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
  margin: 0px;
}

.reports_advisor_name_date .report_generated_by_outer {
  font-size: 16px;
  color: #fff;
  margin-bottom: 15px;
}

.reports_advisor_name_date .report_generated_by_outer span {
  font-weight: 600;
}

.reports_advisor_name_date .report_generated_by_date_outer {
  font-size: 16px;
  color: #fff;
}

.reports_advisor_name_date .report_generated_by_date_outer span {
  font-weight: 600;
}

.reports_advisor_comments_title h4 {
  font-size: 20px;
  font-weight: 700;
  color: #479573;
  text-transform: uppercase;
  display: flex;
}

.reports_advisor_comments_title .edit_advisor_comments {
  cursor: pointer;
  margin-left: 10px;
}

.reports_pdf_content_outer {
  padding: 25px;
  margin-bottom: 80px;
  height: 100%;
  min-height: 1530px;
}

.reports_advisor_comments_outer {
  padding: 30px 30px;
}

.reports_advisor_comments_text_editor {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0px 9px 27px rgba(0, 0, 0, 0.07), 0px 3.75998px 11.28px rgba(0, 0, 0, 0.0503198), 0px 2.01027px 6.0308px rgba(0, 0, 0, 0.0417275), 0px 1.12694px 3.38082px rgba(0, 0, 0, 0.035), 0px 0.598509px 1.79553px rgba(0, 0, 0, 0.0282725), 0px 0.249053px 0.747159px rgba(0, 0, 0, 0.0196802);
}

.reports_advisor_comments_text_editor_tool_bar {
  border-bottom: 1px solid rgb(0, 0, 0);
}

.reports_advisor_comments_text_editor_textarea {
  display: flex;
}

.reports_advisor_comments_text_editor_textarea textarea {
  border: 0px;
  width: 100%;
  height: 696px;
  resize: none;
  padding: 13px;
  font-size: 11px;
  font-weight: 500;
  color: #000;
}

.reports_advisor_comments_text_editor_tool_bar ul {
  padding: 16px 30px;
  margin: 0px;
  display: flex;
  display: -webkit-flex;
  column-gap: 25px;
}

.reports_advisor_comments_text_editor_tool_bar ul li {
  list-style: none;
}

.reports_disclaimer_outer h4 {
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  color: #479573;
}

.reports_pdf_footer_outer {
  background: #479573;
  padding: 10px 17px;
}

.reports_pdf_footer_outer {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}

.reports_pdf_footer_outer .current_page_count {
  background-color: #8ad184;
  padding: 9px 13px;
  border-radius: 4px;
  min-width: 34px;
  height: 34px;
}

.reports_pdf_page_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 33px;
}

.reports_pdf_page_count p {
  color: #fff;
  font-size: 11px;
}

.reports_pdf_page_count_inner {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.reports_pdf_page_count .dividers {
  padding: 0px 5px;
}

.Reports_top_button_div .reports_search_button img {
  filter: invert(1);
}

.reports_pdf_content_outer .card {
  border: none;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.25);
}

.reports_pdf_icons button {
  background-color: transparent;
  border: 0px;
}

.reports_pdf_icons button img {
  width: 16px;
}

.reports_recommendations_title {
  font-size: 20px;
  font-weight: 700;
  color: #479573;
  text-transform: uppercase;
  display: flex;
}

.reports_recommendations_title_edit {
  cursor: pointer;
  margin-left: 10px;
}

.common_table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 4px 4px;
}

.common_table table thead {
  background-color: #b6d5b2;
}

.common_table table tr th {
  color: #000;
}

.common_table table tr td {
  color: #555;
}

.common_table table tr th,
.common_table table tr td {
  padding: 12px 8px;
  border-radius: 6px;
}

.common_table table tr:nth-child(odd) td {
  background-color: #edffeb;
}

.common_table table tr:nth-child(even) td {
  background-color: #d5f0d1;
}

.Mobile_user_client_details {
  display: none;
}

.Mobile_user_client_details ul {
  background: #3e9479;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: center;
}

.Mobile_user_client_details ul li {
  list-style: none;
  color: #fff;
  font-size: 10px;
  text-transform: uppercase;
  line-height: initial;
  padding: 6px 0px;
}

.Mobile_user_client_details ul li span {
  color: #fdf41f;
  font-size: 14px;
  font-weight: 500;
}

/* CLIENT_PAGE_CSS_START */
.client_main_right .save_button {
  text-align: left;
}

.client_main_right .save_button button {
  margin: 0px;
  background-color: #225ea8;
  padding: 10.5px 10px;
}

.client_main_right .Simulate_button_group button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 7.5px 15px;
  width: auto;
  border: 0px;
  background: #24948c;
  border-radius: 5px;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  width: 135px;
  text-transform: uppercase;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
  background-color: #225ea8;
}

.client_main_right {
  display: flex;
  display: -webkit-flex;
}

.client_main_right .client_main_right_2 {
  text-align: center;
  background-color: #fff;
  padding: 0px 10px;
  border-radius: 6px;
  width: 100%;
  grid-column: 2;
  grid-row: 2;
}

.client_main_right .client_main_right_left {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  flex-direction: column;
  row-gap: 10px;
  width: 100%;
}

.client_main_right .client_main_right_left .result_scroll_div {
  height: 61vh;
  overflow-y: auto;
}

.client_main_right .client_main_right_left .result_scroll_div.result_scroll_div_custom {
  height: 74vh;
}

.client_main_right .client_main_right_left .plan_results_main_outer {
  margin-bottom: 10px;
}

.client_left .plan_results_main_outer {
  display: none;
}

.plan_results_main_outer .button_meter_outer {
  grid-column: 2;
  grid-row: 1;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}

.plan_results_main_outer .button_meter_outer .client_chart_inner {
  border-radius: 10px;
  margin-bottom: 0px;
}

.plan_results_main_outer .button_meter_outer-alert {
  width: 100%;
  grid-column: 1;
  grid-row: 1/span 2;
}

.plan_results_main_outer .button_meter_outer-alert .client_chart_inner {
  margin-bottom: 0px;
}

.plan_results_main_outer .chart_filter {
  width: 100%;
}

.plan_results_main_outer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: min-content;
  column-gap: 8px;
  row-gap: 8px;
}

.Plan_Results_content h4 {
  margin: 0px;
}

.plan_results_main_outer_right {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 8px;
  flex-direction: row;
}

.Simulate_button_group {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 6px;
  width: 100%;
  margin-top: 10px;
  background-color: #fff;
  padding: 10px 0px;
  border-radius: 5px;
}

.Simulate_button_group button {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: initial;
  gap: 10px;
  padding: 7.5px 15px;
  width: auto;
  border: 0px;
  background: #24948c;
  border-radius: 5px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  justify-content: center;
  text-transform: none;
  transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  -moz-transition: 0.3s ease-in-out;
  -ms-transition: 0.3s ease-in-out;
  background-color: #225ea8;
}

.Simulate_button_group button .disabled {
  background: grey !important;
}

.Simulate_button_group button img {
  height: 18px;
}

.Simulate_button_group button:hover {
  background: #3e9479;
}

.plan_results_main_outer_right h4 {
  color: #225ea8;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
}

.client_main_right_2 p {
  color: #225ea8;
  font-size: 10px;
  margin-bottom: 5px;
}

.cancel_update_btn_group {
  display: flex;
  column-gap: 10px;
  justify-content: flex-end;
  margin-top: 15px;
}

.cancel_update_btn_group button {
  margin: 0px;
}

.automatic_button_group button {
  padding: 7.5px 15px !important;
  align-items: center;
  line-height: normal;
  height: auto;
}

.expenses_warning {
  margin-bottom: 10px;
}

.client_main .client_left {
  width: 100%;
}

.client_main .client_right {
  width: 100%;
}

.client_main_right_2 h5 {
  font-weight: 400;
  margin: 0px;
  padding-top: 10px;
}

.client_main_right_2 h5 span {
  font-weight: 700;
  font-size: 20px;
  color: #24948c;
}

.client_main_right .MuiTabs-root {
  min-height: 39px;
}

.client_main_right .MuiTabs-flexContainer button.MuiButtonBase-root {
  background-color: transparent;
  border: 0px;
  color: #fff;
  font-weight: 300;
  font-size: 12px;
  text-transform: uppercase;
  padding: 10px 10px;
  border-bottom: 2px solid transparent;
  min-height: 39px;
}

.client_main_right .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {
  border-bottom: 3px solid #ffc809;
}

.client_main_right .chrono-tabs-wrapper {
  background: linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  background: -webkit-linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  box-shadow: 0px -36px 44px 0px rgba(0, 0, 0, 0.0901960784) inset;
  overflow: hidden;
  border-radius: 10px;
  margin: 0px;
  width: 100%;
  max-width: 100%;
}

.client_main_right .MuiTabs-root {
  border-bottom: 2px solid #fff;
}

.MuiTabs-root .MuiButtonBase-root .MuiSvgIcon-root path {
  fill: #fff;
}

.client_chart_main_div .client_chart_inner {
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
}

.client_chart_main_div .client_chart_inner table {
  margin-bottom: 10px;
  padding: 10px;
  border: 0px;
  display: block;
}

.client_chart_main_div .client_chart_inner:last-child {
  margin-bottom: 0px;
}

.profile_details_outer {
  margin-bottom: 10px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}

.chart_filter ul {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  margin: 0px;
  padding: 12px;
  flex-direction: row;
  row-gap: 25px;
  background: linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  background: -webkit-linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  box-shadow: 0px -36px 44px 0px rgba(0, 0, 0, 0.0901960784) inset;
  overflow: hidden;
  border-radius: 10px;
}

.chart_filter ul li {
  list-style: none;
  width: auto;
  text-align: center;
}

.chart_filter ul li button {
  background-color: transparent;
  border: 0px;
  width: 100%;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 18px;
  position: relative;
  transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
  min-width: 110px;
}

.chart_filter ul li button::before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
  height: 20px;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
}

.chart_filter ul li.active button {
  background-color: #fff;
  color: #24948c;
  font-weight: 600;
  border-radius: 10px;
  padding-left: 30px;
}

.chart_filter ul li.active button::before {
  opacity: 1;
  visibility: visible;
}

.Plan_Results_content {
  display: flex;
  display: -webkit-flex;
  column-gap: 8px;
  row-gap: 5px;
  padding-top: 0px;
}

.client_left .chart_filter ul {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  padding: 0px;
  margin: 0px 0px 10px;
  background-color: #676767;
  border-radius: 10px;
  padding: 5px;
}

.client_left .chart_filter ul li {
  list-style: none;
}

.client_left .chart_filter ul li button {
  background-color: transparent;
  border: 0px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 18px;
  position: relative;
  transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
}

.client_left .chart_filter ul li button::before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
  height: 20px;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
}

.client_left .chart_filter ul li.active button {
  background-color: #fff;
  color: #24948c;
  font-weight: 600;
  border-radius: 10px;
  padding-left: 30px;
}

.client_left .chart_filter ul li.active button::before {
  opacity: 1;
  visibility: visible;
}

/* PRODUCT_PAGE_CSS_START */
.product_left .MuiTabs-flexContainer button.MuiButtonBase-root {
  background-color: transparent;
  border: 0px;
  color: #fff;
  font-weight: 300;
  font-size: 12px;
  text-transform: uppercase;
  padding: 8px 10px;
  border-bottom: 2px solid transparent;
  min-height: 39px;
}

.product_left .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {
  border-bottom: 3px solid #ffc809;
}

.product_left .chrono-tabs-wrapper {
  background: linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  background: -webkit-linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  box-shadow: 0px -36px 44px 0px rgba(0, 0, 0, 0.0901960784) inset;
  overflow: hidden;
  border-radius: 10px;
}

.product_left .MuiTabs-root {
  border-bottom: 2px solid #fff;
  min-height: 39px;
}

.product_left_content {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}

.Choose_Risk_Appetite_outer {
  column-gap: 15px;
  align-items: center;
}

.product_left_content .title-div {
  color: #71748d;
  text-transform: uppercase;
  font-weight: 700;
}

.Current_Target_main_div table {
  padding: 0px;
  margin: 0px;
  min-width: 32.9%;
}

.Current_Target_main_div table tr {
  list-style: none;
  background-color: #eff9f6;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding: 8px 10px;
  font-weight: 700;
  color: #000;
  font-size: 12px;
  margin-bottom: 8px;
  border-radius: 5px;
}

.Current_Target_main_div table thead tr {
  background-color: #66b192;
}

.Current_Target_main_div table tr td.data-value,
.Current_Target_main_div table tr td.data-label {
  margin: 0px;
  font-weight: 400;
  color: #000;
  font-size: 12px;
}

.Current_Target_main_div table tr td.center {
  font-weight: 400;
}

.Current_Target_main_div table tr td.center-data {
  font-weight: 700;
  opacity: 0.7;
}

.Current_Target_main_div {
  margin-top: 20px;
  margin-bottom: 25px;
  column-gap: 6px;
  display: flex;
  display: -webkit-flex;
}

.Current_Target_main_div ul.small-width-grid {
  min-width: 32.9%;
}

.Current_Target_main_div ul.full-width-grid {
  min-width: 50%;
}

.Current_Target_main_div ul li p.orange_text {
  color: #f58c1e;
}

.Current_Target_main_div ul li p.red_text {
  color: #f9294e;
}

.Current_Target_main_div ul li p.green_text {
  color: #52ba7f;
}

.Select_account_main_outer {
  padding: 0px 0px 8px 0px;
  border-bottom: 1px solid #dbdce2;
}

.Select_account_main_outer .Select_account_title {
  padding-bottom: 10px;
}

.Select_account_dropdown {
  max-width: 100%;
  width: 100%;
}

.Select_account_dropdown button {
  background-color: transparent;
  border: 0px;
  padding: 0px;
}

.Balance_input_div .controls-select label {
  margin: 0px;
}

.product_left_content .Balance_input_div {
  width: 100%;
}

.product_left_content .Balance_input_div input {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 5px 10px;
  max-width: 100%;
  height: 38px;
  width: 100%;
}

.product_left_content input {
  border: 1px solid #e0e0e0;
  height: 39px;
  border-radius: 5px;
  padding: 5px 10px;
  width: 100%;
}

.product_left_content .Balance_input_div .Balance_input_div_inner.label-none label {
  display: none;
}

.select_product_main_outer {
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
}

.select_product_main_outer .select_product_title {
  padding-bottom: 10px;
}

.select_product_dropdown_outer {
  width: 100%;
  margin-top: 10px;
}

.controls-select .select-search__control {
  color: #000;
  background-image: none;
  padding: 0px 10px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #e0e0e0;
  height: 38px;
}

.controls-select .select-search__single-value {
  font-size: 12px;
  color: #000;
  background-image: none;
  font-size: 14px;
  font-weight: 400;
}

.controls-select .select-search__value-container {
  padding: 0px;
  height: 38px;
}

.Remaining_Balance_main_outer {
  margin-top: 30px;
}

.Remaining_Balance_main_outer .Remaining_Balance_box {
  display: flex;
  display: -webkit-flex;
  column-gap: 30px;
  row-gap: 10px;
  margin-top: 15px;
}

.Remaining_Balance_main_outer .Remaining_Balance_box ul {
  padding: 0px;
  margin: 0px;
}

.Remaining_Balance_main_outer .Remaining_Balance_box ul li {
  list-style: none;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  display: -webkit-flex;
  column-gap: 15px;
  margin-bottom: 10px;
  color: #000000;
}

.Remaining_Balance_main_outer .Remaining_Balance_box ul li span {
  font-size: 12px;
  color: #000;
  font-weight: 600;
}

.Remaining_Balance_main_outer .Remaining_Balance_box ul li input {
  width: 100%;
}

.Remaining_Balance_main_outer .Remaining_Balance_box .Remaining_Balance_box_inner:last-child::before {
  border: 0px;
}

.Remaining_Balance_main_outer .Remaining_Balance_box_inner {
  position: relative;
}

.Remaining_Balance_main_outer .Remaining_Balance_box_inner::before {
  position: absolute;
  content: "";
  width: 1px;
  border-right: 1px dashed #9b9b9b;
  height: 100%;
  right: -15px;
}

.client_right .tab-content {
  display: none;
}

.client_right .tab-content.active {
  display: block;
}

.client_chart_inner .Data_grid {
  padding: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
}

.client_chart_inner .Data_grid .Data_grid_item {
  padding: 12px;
  background: #eff9f6;
  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);
  border-radius: 10px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  text-align: center;
}

.client_chart_inner .Data_grid .Data_grid_item h3 {
  font-weight: 700;
  font-size: 28px;
}

.client_chart_inner .Data_grid .Data_grid_item p {
  margin: 0px;
  font-family: "Roboto", sans-serif;
  background: #479573;
  padding: 2px 5px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 15px;
  color: #fff;
}

.client_chart_inner .Table_main_outer {
  column-gap: 15px;
  row-gap: 15px;
  flex-wrap: wrap;
  overflow: auto;
}

.client_chart_inner .Table_main_outer ul {
  padding: 0px;
  margin: 0px;
}

.client_chart_inner .Table_main_outer ul.full-width-table {
  min-width: 65%;
}

.client_chart_inner .Table_main_outer ul.small-width-table {
  min-width: 32.333%;
}

.client_chart_inner .Table_main_outer ul li:last-child {
  margin: 0px;
}

.client_chart_inner .Table_main_outer ul li {
  list-style: none;
  background-color: #eff9f6;
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
  padding: 8px 10px;
  margin-bottom: 4px;
  border-radius: 5px;
}

.client_chart_inner .Table_main_outer ul li p {
  margin: 0;
  font-weight: 400;
  color: #000;
  font-size: 12px;
  word-break: break-all;
}

.client_chart_inner .Table_main_outer ul li:nth-child(odd) {
  background-color: #d5f0d1;
}

.client_chart_inner .Table_main_outer ul li:nth-child(even) {
  background-color: #edfeeb;
}

.client_chart_inner .Table_main_outer ul li:first-child {
  background-color: #66b192;
}

.client_chart_inner .Table_main_outer ul li:first-child p {
  font-weight: 700;
}

.choose_a_product_main_outer {
  margin-top: 20px;
}

.choose_a_product_main_outer h5 {
  color: #000;
  text-transform: none;
}

.choose_a_product_table {
  width: 100%;
  height: auto;
  padding: 13px 26px 13px 26px;
  border-radius: 8px;
  gap: 16px;
  background-color: #eff9f6;
}

.choose_a_product_table table {
  width: 100%;
}

.choose_a_product_table table th {
  font-weight: 400;
  color: #000;
  text-transform: uppercase;
  border-bottom: 1px solid #92c48e;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.choose_a_product_table table tr td {
  padding: 8px 0px;
  color: #000;
}

.choose_a_product_main_outer {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #c7c7c7;
}

.insured_main_outer input {
  width: 100%;
}

.insured_main_outer .custom-input,
.insured_main_outer .labelStyle,
.insured_main_outer .disabled-input {
  margin-bottom: 0px;
}

.error-text {
  color: #d32f2f;
  font-size: 12px;
}

.insured_main_outer .row {
  padding-bottom: 15px;
}

.mobile_responsive_tab {
  display: none;
  margin-bottom: 15px;
}

.mobile_responsive_tab ul {
  padding: 0px;
  display: flex;
  display: -webkit-flex;
  column-gap: 15px;
  padding-right: 10px;
}

.mobile_responsive_tab_inner {
  display: flex;
  display: -webkit-flex;
  background: #235345;
  padding: 10px 10px 0px;
  justify-content: space-between;
}

.mobile_responsive_tab ul li {
  list-style: none;
}

.mobile_responsive_tab ul li button {
  background: #3e9479;
  outline: none;
  border: 0px;
  padding: 12px 20px;
  color: #fff;
  border-bottom: 4px solid #235345;
  border-radius: 10px;
  position: relative;
}

.mobile_responsive_tab ul li button::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fdf41f;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
}

.mobile_responsive_tab ul li.active button::before {
  opacity: 1;
}

.mobile_responsive_tab ul li.active button {
  border-bottom: 4px solid #fdf41f;
}

.mobile_responsive_tab .responsive_save_button button {
  background: #225ea8;
}

.mobile_responsive_tab .responsive_save_button button {
  margin-top: 8px;
}

/* CLIENT_PAGE_CS_START */
.client_left_content {
  background-color: #fff;
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}

.client_main_left .chrono-tabs-wrapper {
  background-color: #fff;
}

/* .client_main_left .chrono-tabs-wrapper .MuiTabs-scroller  {
    border-bottom: 1px solid #fff;
} */
.client_main_left .chrono-tabs-wrapper .MuiTab-root {
  border: 0px;
  text-transform: uppercase;
  font-size: 12px;
  color: #005dcf;
  padding: 6px 15px;
  background: #fff;
}

.client_main_left .chrono-tabs-wrapper .MuiTab-root.Mui-selected {
  border-bottom: 2px solid #ffc809;
  color: #2dac00;
  font-weight: 700;
}

.client_main_left .chrono-tabs-wrapper .chrono-sub-tab .MuiTab-root.Mui-selected {
  color: #225ea8;
}

.client_main_left .chrono-tabs-wrapper .chrono-sub-tab .MuiTab-root.Mui-selected span {
  color: #ed5500;
}

.client_left_content .input_group_main {
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
  align-items: center;
  row-gap: 10px;
}

.client_left_content .input_group_div {
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
  width: 50%;
}

.client_left_content .input_label_div {
  width: 50%;
}

.client_left_content .input_group_main input {
  width: 100%;
  height: 35px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 7px;
  padding: 5px 10px;
}

.Tax_Filing_Main {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 20px;
  column-gap: 10px;
}

.Tax_Filing_Main p,
.input_label_div label {
  font-size: 12px;
  color: #000000;
  margin: 0px;
}

.input_group {
  row-gap: 10px;
}

.Select_account_dropdown.select_client_outer button {
  width: auto;
}

.balance_portfolio_outr .balance_portfolio_radio_group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 30px;
}

/* input_checkbox */
/* Hide the default checkbox */
/* https://codepen.io/schobiwan/pen/jGLpJL */
.Choose_Risk_Appetite_member label {
  /* display: block; */
  margin: 0px 0;
  cursor: pointer;
  font-size: 1.2em;
}

.Choose_Risk_Appetite_member .MuiFormGroup-root {
  display: flex;
  display: -webkit-flex;
  column-gap: 15px;
}

.Choose_Risk_Appetite_member label > input[type=checkbox] {
  display: none;
}

.Choose_Risk_Appetite_member input[type=checkbox] + span:before {
  content: "";
  display: inline-block;
  margin-right: 5px;
  font-family: "FontAwesome";
  font-weight: normal;
  width: 20px;
  height: 20px;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  position: relative;
  top: 4px;
}

/**--- Checked ---**/
.MuiCheckbox-colorPrimary.Mui-checked {
  color: #3e9479 !important;
}

.Choose_Risk_Appetite_member input[type=checkbox]:checked + span:before {
  content: "";
  color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: center;
  background-repeat: no-repeat;
  background-color: #24948c;
  border-color: #24948c;
  animation: pop 180ms ease-in;
}

/**--- Disabled ---**/
.Choose_Risk_Appetite_member input[type=checkbox]:disabled + span {
  color: #999;
}

/* .Choose_Risk_Appetite_member input[type="checkbox"]:disabled + span:before {
    content: "\\f0c8";
    color: #999;
  } */
/**--- Animation ---**/
@keyframes pop {
  0% {
    transform: scale(0);
  }
  90% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
/* Radio_button_css_start */
.MuiIconButton-label {
  width: 100%;
  display: flex;
  align-items: inherit;
  justify-content: inherit;
}

.PrivateRadioButtonIcon-root-7 {
  display: flex;
  position: relative;
}

.MuiSvgIcon-root {
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 1.5rem;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
}

.controls-radiogroup .MuiFormControlLabel-root .MuiSvgIcon-root {
  height: 20px;
  width: 20px;
}

.controls-radiogroup .MuiFormControlLabel-root .MuiSvgIcon-root {
  height: 20px;
  width: 20px;
}

.PrivateRadioButtonIcon-root-7.PrivateRadioButtonIcon-checked-9 .PrivateRadioButtonIcon-layer-8 {
  transform: scale(1);
  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.PrivateRadioButtonIcon-layer-8 {
  left: 0;
  position: absolute;
  transform: scale(0);
  transition: transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;
  color: #fff;
}

.MuiRadio-root {
  color: #24948c;
}

.MuiRadio-colorSecondary.Mui-checked {
  color: #24948c !important;
}

/* .MuiButtonBase-root.Mui-checked .MuiSvgIcon-root {
    border: 10px solid;
    border-radius: 50px;
}
.MuiButtonBase-root.Mui-checked .MuiSvgIcon-root path {
    color: #fff;
} */
.MuiButtonBase-root.Mui-checked .MuiSvgIcon-root.PrivateRadioButtonIcon-layer-8 {
  border: 7px solid #3e9479;
  border-radius: 50px;
}

#image-list .sub-menu {
  list-style: none;
  display: none;
  position: absolute;
  top: 0;
  left: 91px;
  width: 400px;
  padding: 20px;
  height: 500px;
  overflow-y: scroll;
  margin: 0;
  background-color: #fff;
}

#image-list .sub-menu.show-sub-menu {
  display: block;
}

.Choose_Risk_Appetite_outer {
  justify-content: space-between;
}

.Choose_Risk_Appetite_outer .Choose_Risk_Appetite_member {
  padding-top: 10px;
}

.select_product_table_main_outer {
  padding-top: 10px;
  padding-bottom: 15px;
}

.select_product_table_main_outer .select_product_table_inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  column-gap: 20px;
  margin-bottom: 6px;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  column-gap: 6px;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_column:nth-child(2) {
  grid-template-columns: 1fr 1fr 30px;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_content {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 5px;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_content p {
  background-color: #eff9f6;
  padding: 10px 26px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 13px;
  height: 43px;
  width: 100%;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_amount input {
  height: 43px;
  border-radius: 7px;
  border: 1px solid #e0e0e0;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_content p {
  margin: 0px;
  color: #000000;
}

.select_product_table_main_outer .select_product_table_inner .select_product_table_delete button {
  background-color: transparent;
  border: 0px;
}

.select_product_table_main_outer .select_product_table_inner:last-child .select_product_table_content {
  background-color: transparent;
}

.select_product_table_main_outer .select_product_table_inner:last-child .select_product_table_content p {
  font-weight: 700;
  background-color: transparent;
  justify-content: flex-end;
}

.client_main_right_2 svg .highcharts-credits {
  display: none !important;
}

.client_main_right_2 svg .highcharts-label.highcharts-data-label text {
  font-size: 10px !important;
  display: block !important;
  text-align: center !important;
  fill: #479573 !important;
  color: #479573 !important;
  stroke: none !important;
}

.vHidden {
  width: 0;
  height: 0;
  display: none;
}

.controls-radiogroup .MuiFormControlLabel-label label {
  margin: 0px !important;
}

.form_group.select_date_time_outer .MuiInputBase-root.MuiInput-underline::before,
.form_group.select_date_time_outer .MuiInputBase-root.MuiInput-underline::after {
  display: none;
}

.form_group.select_date_time_outer .MuiInputBase-root.MuiInput-underline input {
  height: 28px !important;
}

.form_group.select_time_outer .MuiInputBase-root.MuiOutlinedInput-root input {
  height: 28px !important;
  border: 0px solid #e0e0e0;
  appearance: none;
  -webkit-appearance: none;
}

.form_group.select_time_outer .MuiInputBase-root.MuiOutlinedInput-root fieldset {
  top: 0px;
}

.form_group.select_time_outer .MuiInputBase-root.MuiOutlinedInput-root fieldset legend {
  float: left;
}

.crm_content h5.title-div {
  color: #000;
  padding-bottom: 10px;
}

input:disabled::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #b9b9b9;
}

input:disabled:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #b9b9b9;
}

input:disabled::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b9b9b9;
}

input:disabled:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #b9b9b9;
}

input[disabled] {
  color: #000;
  background-color: #f5f5f5;
  background: linear-gradient(0deg, #f2f2f2, #f2f2f2);
}

.crm_content input {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 5px 10px;
  width: 100%;
}

.crm_content .form_group {
  margin-bottom: 22px;
}

.form_group.new_notes_outer textarea {
  width: 100%;
  height: 150px;
  padding: 5px 10px;
  border: 1px solid #e0e0e0;
}

.form_group.new_notes_outer .Choose_Risk_Appetite_member.checkbox {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
}

.select_report_outer .form_group select,
.crm_content .form_group select {
  border: 1px solid #24948c;
  background-color: transparent;
  height: 30px;
  border-radius: 7px;
  padding: 5px 10px;
  width: 100%;
}

.meeting_history ul {
  padding: 0px;
  width: 100%;
  margin: 0px;
}

.meeting_history ul li {
  list-style: none;
  background-color: #eff9f6;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding: 8px 10px;
  margin-bottom: 4px;
  border-radius: 5px;
}

.meeting_history ul li:nth-child(odd) {
  background-color: #d5f0d1;
}

.meeting_history ul li:first-child {
  background-color: #66b192;
}

.meeting_history ul li p {
  margin: 0px;
}

.crm_content_main_screen {
  display: flex;
  display: -webkit-flex;
  column-gap: 30px;
  row-gap: 30px;
}

.crm_content_main_screen .crm_content {
  width: 100%;
}

.crm_content_main_screen .crm_content .row:first-child {
  align-items: center;
}

.crm_all_notes_outer {
  background: linear-gradient(0deg, #f2f2f2, #f2f2f2);
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.crm_all_notes_outer ul {
  padding: 15px;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  row-gap: 10px;
  margin: 0px;
  max-height: 300px;
  overflow: hidden;
  overflow-y: scroll;
}

.crm_all_notes_outer ul li {
  list-style: none;
  display: block;
  width: 100%;
  color: #000;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.crm_all_notes_outer ul li:last-child {
  border: 0px;
  padding-bottom: 0px;
}

.Select_Report_Outer_Card {
  width: 96%;
}

.select_meeting_edit_outer {
  align-items: center;
}

.select_meeting_edit_outer button {
  background-color: transparent;
  border: 0px;
}

/* Search_dropdown */
.controls-input input {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 183.75%);
  border-radius: 7px;
  border: 1px solid #e0e0e0;
  width: 100%;
  height: 43px;
}

.controls-input .error-text {
  color: #d32f2f;
  font-size: 12px;
}

.controls-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border: 1px solid #00a19a !important;
  box-sizing: border-box;
  border-radius: 5px;
}

.controls-select .MuiSelect-outlined {
  padding: 4px 0 8px;
}

.controls-select .MuiOutlinedInput-notchedOutline {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 183.75%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
}

.controls-select .MuiOutlinedInput-notchedOutline legend {
  display: none;
}

.controls-select .MuiOutlinedInput-input {
  padding-left: 8px;
}

.controls-select .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: 1px solid #00a19a;
  box-sizing: border-box;
  border-radius: 5px;
}

.controls-select .MuiInputLabel-root.Mui-focused {
  color: #555555;
  padding-top: 5px;
}

.controls-select .MuiSvgIcon-root {
  z-index: 1;
  color: #555555;
}

.controls-select .MuiOutlinedInput-root.Mui-focused .MuiSvgIcon-root {
  color: #00a19a;
}

.controls-select .MuiMenuItem-root {
  font-size: 12px;
}

.controls-select .select-search__control--is-disabled {
  background: linear-gradient(0deg, #f2f2f2, #f2f2f2) !important;
}

.controls-select .select-search__control {
  height: 35px;
  border-radius: 5px;
  margin-top: 0px;
  background: #fff;
  border: 1px solid #e0e0e0;
}

.controls-select .select-search__single-value {
  font-size: 14px;
}

.controls-select .select-search__placeholder {
  font-size: 14px;
}

.controls-select .select-search__option {
  font-size: 14px;
}

.controls-datepicker .MuiOutlinedInput-notchedOutline {
  border-radius: 4px;
  border-width: 2px;
  border-color: rgba(0, 0, 0, 0.23);
}

.controls-datepicker .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: rgba(0, 0, 0, 0.23);
}

.controls-datepicker button:focus {
  outline: none;
}

.controls-datepicker .datepicker-label {
  margin-bottom: -8px;
}

.controls-datepicker .MuiTextField-root {
  margin-top: 12px;
}

.controls-datepicker .MuiOutlinedInput-input {
  padding: 5px 0 12px 10px;
}

.controls-radiogroup .MuiFormControlLabel-root .MuiSvgIcon-root {
  height: 18px;
  width: 18px;
}

.controls-radiogroup .MuiFormControlLabel-label {
  font-size: 12px !important;
}

.controls-select .MuiFormControl-root .select-search__control .select-search__indicators svg path {
  fill: #000;
}

/* .controls-select .MuiFormControl-root .select-search__control .select-search__indicator-separator.css-1okebmr-indicatorSeparator {
  display: none;
}
.controls-select .MuiFormControl-root .select-search__control .select-search__indicators svg path {
  fill: #24948C;
} 
.controls-select .MuiFormControl-root .select-search__control .select-search__placeholder {
  color: #24948C;
} */
.Plan_Results_content.select_client_outer .Horizon_div,
.Plan_Results_content.select_client_outer .Display_Client {
  width: 100%;
}

/* POP_up_css_start */
.MuiDialog-scrollPaper .signup-body-container .newplan-form-grid.MuiGrid-spacing-xs-2 {
  width: 100%;
}

.MuiDialog-scrollPaper .signup-body-container .newplan-form-grid {
  margin: 0px;
}

.MuiDialog-scrollPaper .signup-title-container .signup-title-close-icon {
  color: #24948c;
  font-size: 20px;
  cursor: pointer;
}

.MuiDialog-container.MuiDialog-scrollPaper .controls-input input {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0px 15px;
}

.Select_account_dropdown.select_client_outer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}

.MuiSwitch-root .MuiSwitch-track {
  background-color: #3e9479 !important;
}

.MuiSwitch-root .MuiSwitch-switchBase + .MuiSwitch-track {
  background-color: #ddd !important;
}

.MuiSwitch-root .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: #3e9479 !important;
}

.signup-body-container .MuiFormControlLabel-root {
  margin-left: 0px;
}

.signup-body-container .MuiTypography-root {
  font-size: 14px;
  margin-left: 10px;
}

.select_client_outer_form_row .client.client-review-dd {
  display: block;
  column-gap: 10px;
  margin-bottom: 10px;
}

.select_client_outer_form_row .plan.client-review-dd {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 10px;
  margin-bottom: 10px;
}

.select_client_outer_form_row .client-review-dd .controls-select label {
  display: none;
}

.select_client_outer_form_row .client-review-dd button {
  width: 100%;
}

.select_client_outer_form_row.marketandasset_outer .controls-select label {
  display: none;
}

.Table_main_outer table {
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
}

.Table_main_outer table tr td,
.Table_main_outer table tr th {
  padding: 8px 10px;
  font-size: 12px;
  text-align: left;
  border: 1px solid #e0e0e0;
}

.Table_main_outer table tr th {
  background-color: #e3e3e3;
  color: #000;
  font-weight: 700;
}

.Table_main_outer table tr td {
  background-color: #ffffff;
  color: #000;
}

.client_chart_main_div.data .Table_main_outer table tr th {
  border: 1px solid #e3e3e3;
}

.client_chart_main_div.data .center-data {
  text-align: center;
}

.Table_main_outer table.full-width-table {
  min-width: 100%;
  width: 100%;
}

.select_client_outer_form_row.marketandasset_outer {
  margin: 0px;
}

.select_client_outer_form_row.marketandasset_outer p {
  color: #000;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.select_client_outer_form_row.report_select_dd {
  margin: 0px;
  width: 35%;
}

.product_left .acc-list-container .MuiTabs-flexContainer button.MuiButtonBase-root {
  color: #000;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  padding: 10px 10px;
}

.product_left .acc-list-container .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {
  border-bottom: none;
}

.product_left .plaid-container .simulate-buttons button.MuiButtonBase-root.MuiButton-textPrimary {
  color: #fff !important;
}

.inv-list-container {
  overflow: auto;
}
.inv-list-container .MuiFormGroup-root {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.Select_account_main_outer {
  margin-bottom: 15px;
}

.Select_account_main_outer .select_account_dropdown-outer {
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
  margin-top: 15px;
}

.Select_account_main_outer .controls-select-main-outer h5.account_dropdown_label {
  width: -webkit-fill-available;
  display: block;
  margin: 12px 0px;
  max-width: fit-content;
  font-weight: bolder !important;
  color: #71748d;
  font-size: 14px !important;
  text-transform: none !important;
  line-height: 22px !important;
}

.Select_account_main_outer .controls-select-main-outer {
  display: flex;
  column-gap: 60px;
  justify-content: space-between;
  column-gap: 20px;
}

.Select_account_main_outer .controls-select-main-outer .controls-select {
  width: 50%;
}

.Accordion_outer.faq-container-new .insured_main_outer p {
  font-weight: normal;
  font-size: 14px;
  color: #71748d;
  font-family: "Inter", sans-serif;
}

.client_chart_main_div.data .center-data {
  text-align: center;
}

.MuiPaper-root.MuiAccordion-root {
  background-color: #fff;
  box-shadow: unset;
  border-radius: 8px;
  overflow: hidden;
}

.MuiPaper-root.MuiAccordion-root.Mui-expanded {
  background: #fff;
}

.MuiPaper-root.MuiAccordion-root:first-of-type {
  border-radius: 8px;
}

.faq-container .faq-content-items {
  margin-bottom: 4px;
}

.faq-container .faq-content-items .MuiPaper-root {
  box-shadow: 0 0 6px 0 #dfdfdf;
}

.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-content {
  color: #000;
  margin: 0px;
  padding: 0px;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root {
  min-height: 30px;
  flex-direction: row-reverse;
  padding: 6px 10px;
  column-gap: 6px;
}

.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root svg path {
  color: #24948c;
}

.MuiPaper-root.MuiAccordion-root.Mui-expanded .MuiAccordionSummary-content {
  color: #24948c;
  font-weight: 600;
  font-size: 14px;
}

.MuiButtonBase-root .MuiTabScrollButton-root {
  color: #fff !important;
}

.MuiPaper-root.MuiDialog-paper .MuiDialogActions-root {
  padding: 15px 24px 15px;
  box-shadow: 0 0 11px 0 #cdcdcd;
  justify-content: space-between;
}

.popup_button_group p.mandatory_tag {
  color: #666666;
  margin: 0px;
}

.popup_button_group p.mandatory_tag span {
  color: red;
}

.personal_div_first_row {
  justify-content: right;
}

.personal_div_first_row .personal_div_first_content {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  column-gap: 15px;
}

.personal_div_first_row .personal_div_first_content p {
  margin-bottom: 0px;
}

.personal_div_first_row .personal_div_first_content input {
  margin-bottom: 0px;
}

.personal_div_first_row {
  padding: 10px 0px;
}

.planOuter {
  position: relative;
}

.planOuter .select_client_outer_other {
  position: absolute;
  top: 10px;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  width: 30%;
}

.planOuter .select_client_outer_other .client {
  display: inline-flex;
  align-items: center;
  column-gap: 10px;
}

.planOuter .select_client_outer_other .client .controls-select {
  width: 100%;
}

.card.timeline-card .card-header {
  padding: 15px 15px;
}

.MuiDialog-container {
  justify-content: center !important;
  width: 100%;
}

.MuiDialog-container .MuiPaper-root {
  width: 100%;
}

.signup-body-container textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}

.reminder_div {
  display: flex;
  display: -webkit-flex;
  column-gap: 30px;
}

.reminder_div .form_group {
  width: 100%;
}

.save_inline_div {
  display: flex;
  display: -webkit-flex;
  grid-column-gap: 30px;
  column-gap: 10px;
  justify-content: flex-end;
}

.mobile_card {
  display: none;
}

.mobile_card .home_main_card_outer.active::after {
  display: none;
}

.divider_line {
  position: relative;
}

.divider_line::before {
  position: absolute;
  content: "";
  height: 100%;
  width: 2px;
  top: 0px;
  bottom: 0px;
  background-color: #39675a;
}

/* New */
.client_main .client_left {
  position: relative;
}

.client_left.product_left .product_left_content {
  height: calc(90vh - 96px);
  overflow-y: auto;
  overflow-x: hidden;
}

.client_left.product_left.solution_action_height_full .product_left_content,
.client_left.product_left.build_action_height_full .product_left_content {
  height: calc(100vh - 96px);
}

.privacy_policy_outer {
  padding: 30px;
  margin: 20px 0px;
  background: #fff;
}

.privacy_policy_outer h1,
.privacy_policy_outer h2,
.privacy_policy_outer h3,
.privacy_policy_outer h4,
.privacy_policy_outer h5,
.privacy_policy_outer h6 {
  color: #3e9479;
  font-family: "Futura_Bold";
  font-style: normal;
  font-weight: 700;
  margin-top: 20px;
}

.privacy_policy_outer h1 {
  color: #000;
  text-align: center;
  margin-bottom: 35px;
  text-transform: uppercase;
}

.privacy_policy_outer p strong {
  color: #3e9479;
  text-transform: uppercase;
  font-weight: 600;
}

.button-like-link {
  background: none;
  border: none;
  cursor: pointer;
  font-size: "14px";
  text-decoration: underline;
  /* Underline the text to mimic link */
  padding: 0;
  /* Remove default padding */
  font-family: inherit;
  /* Inherit font from parent */
}

.header_right_action_div {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  gap: 10px;
}

.header_right_action_div .user-button {
  padding: 0px;
  width: auto;
  min-width: auto;
}

.header_right_action_div .user-button svg {
  font-size: 25px;
}

.header_right_action_div .user-button svg path {
  fill: #fff;
}

.MuiPopover-root.user-button-menu-options ul {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding: 10px 20px;
}

.MuiPopover-root.user-button-menu-options ul li {
  justify-content: flex-start;
  padding: 5px 0px;
  background: transparent;
  height: auto;
  min-height: auto;
}

.MuiPopover-root.user-button-menu-options .MuiBackdrop-root.MuiBackdrop-invisible.MuiModal-backdrop .MuiPopover-root.user-button-menu-options .MuiBackdrop-root.MuiBackdrop-invisible.MuiModal-backdrop {
  display: none;
}

.MuiPopover-root.user-button-menu-options button {
  padding: 0px;
}

.MuiPopover-root.user-button-menu-options .MuiButton-label {
  padding: 0px;
  min-width: fit-content;
  max-width: fit-content;
  width: auto;
}

.MuiPopover-root.user-button-menu-options .MuiIconButton-label .MuiPopover-root.user-button-menu-options .MuiIconButton-label svg path,
.MuiPopover-root.user-button-menu-options .MuiButton-startIcon svg path {
  fill: #000;
}

.MuiPopover-root.user-button-menu-options button.MuiButton-text {
  color: #555;
  font-size: 12px;
  padding: 0px 0px;
  width: 100%;
  text-align: left;
  justify-content: flex-start;
}

.MuiPopover-root.user-button-menu-options button.MuiButton-text:hover {
  background-color: transparent;
}

.required:after {
  content: " *";
  color: red;
}

.mandatory:before {
  content: "* ";
  color: red;
}

.MuiDialog-container button.MuiButton-root:not(.Mui-disabled) {
  background-color: rgb(34, 94, 168) !important;
}

.solution_expenses_outer {
  margin-bottom: 15px;
}

.plaid_save_button_group {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.plaid_save_button_group button {
  margin-left: 0px;
  width: auto;
}

.solution_action_height_full .product_left_content {
  height: 87vh;
}

.insight_action_height_full .product_left_content,
.goals_action_height_full .product_left_content {
  height: 80vh;
}

.simulate-buttons.cancel_update_btn_group {
  text-align: right;
  max-width: 100%;
  width: 100%;
}

.delete_popup_outer .MuiPaper-root {
  justify-content: center;
  align-items: center;
}

.report_select_dd .controls-select label {
  display: none;
}

.controls-select .custom-input {
  padding: 0px;
  border: 0px;
  height: auto;
}

.radio_button_inline .controls-radiogroup .MuiFormLabel-root {
  display: none;
}

.radio_button_inline .controls-radiogroup .MuiFormGroup-root {
  flex-direction: row;
}

.expenses_grid_main_outer .expenses_grid_outer {
  row-gap: 15px;
}

.simulate-buttons.next_previous_btn_group {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
}

.simulate-buttons.next_previous_btn_group button.next_button {
  margin-left: auto;
}

.residence_taxFiling_outer {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 20px;
  row-gap: 10px;
  align-items: start;
}

.solution_goal_verticaltab_main_outer .MuiTabs-vertical {
  width: 30%;
  background: linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  background: -webkit-linear-gradient(270deg, #666666 -9.03%, #6a6a6a 39.95%, #7e7e7e 59.81%, #7c7c7c 245.14%);
  box-shadow: 0px -36px 44px 0px rgba(0, 0, 0, 0.0901960784) inset;
  overflow: hidden;
  border-radius: 10px;
  height: fit-content;
}

.solution_goal_verticaltab_main_outer .tab_content {
  width: 70%;
}

.solution_goal_verticaltab_main_outer .tab_content .MuiBox-root {
  padding-top: 0px;
  padding-bottom: 0px;
}

.solution_goal_verticaltab_main_outer .MuiFormControlLabel-root {
  margin-left: 0px;
  width: 100%;
  gap: 8px;
  margin-bottom: 0px;
}

.solution_goal_verticaltab_main_outer .tab_content.input_tab .MuiFormControlLabel-root {
  gap: 20px;
  margin-bottom: 15px;
}

.solution_goal_verticaltab_main_outer h5 {
  margin-bottom: 10px;
  text-transform: unset !important;
  font-weight: 400 !important;
  text-align: left;
  font-size: 12px !important;
}

.solution_goal_content .solution_goal_right .solution_goal_right_box .MuiTypography-root {
  font-size: 12px;
}

.solution_goal_content .solution_goal_right .solution_goal_right_box .action-limit-width,
.solution_goal_content .solution_goal_right .solution_goal_right_box .action-limit-width img {
  width: 15px;
  min-width: 15px;
}

.product_left .solution_goal_verticaltab_main_outer .MuiTabs-flexContainer button.MuiButtonBase-root {
  border-bottom: 2px solid #fff;
}

.product_left .solution_goal_verticaltab_main_outer .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {
  border-bottom: 3px solid #ffc809;
}

.solution_goal_verticaltab_main_outer {
  padding: 20px 10px;
}

.solution_goal_content {
  display: flex;
  display: -webkit-flex;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #ddd;
}

.solution_goal_content .solution_goal_title {
  width: 22%;
  border-right: 1px solid #ddd;
}

.solution_goal_content .solution_goal_title h4 {
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
}

.solution_goal_content .solution_goal_right {
  width: 78%;
  padding-left: 10px;
  padding-bottom: 0px;
}

.solution_goal_content .solution_goal_right .solution_goal_right_row button {
  background-color: transparent;
  width: fit-content;
}

.solution_goal_content .solution_goal_right .solution_goal_right_row {
  display: grid;
  grid-template-columns: 130px 1fr 1fr 1fr;
  gap: 15px;
  padding: 10px;
  background: #f9f9f9;
  margin-bottom: 12px;
}

.solution_goal_content .solution_goal_right .solution_goal_right_row .solution_goal_column:first-child h5 {
  padding-left: 25px;
}

.solution_goal_content .solution_goal_right .solution_goal_column .green_color {
  background: #3e9479;
  background-color: #3e9479;
  border-color: #3e9479;
}

.solution_goal_content .solution_goal_right .solution_goal_column .yellow_color {
  background: #ffc809;
  background-color: #ffc809;
  border-color: #ffc809;
}

.solution_goal_content .solution_goal_right .solution_goal_column .red_color {
  background: #f70000;
  background-color: #f70000;
  border-color: #f70000;
}

.solution_goal_content .solution_goal_right .solution_goal_column .orange_color {
  background: #f78900;
  background-color: #f78900;
  border-color: #f78900;
}

.solution_goal_content .solution_goal_right .solution_goal_column .lightgreen_color {
  background: #60ff60;
  background-color: #60ff60;
  border-color: #60ff60;
}

.solution_goal_content .solution_goal_right .solution_goal_column .grey_color {
  background-color: #a1a1a1;
  background: #a1a1a1;
  border-color: #a1a1a1;
}

.solution_goal_content .solution_goal_right .solution_goal_right_row.add_btn_row {
  background: transparent;
  padding: 0px;
}

.solution_goal_content .solution_goal_right .solution_goal_right_row:last-child {
  margin-bottom: 0px;
}

.solution_goal_content .solution_goal_right .justify-content-left {
  column-gap: 10px;
  justify-content: left;
}

.solution_goal_content .solution_goal_right .solution_goal_right_box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 10px;
}

.solution_goal_content .solution_goal_right .solution_goal_right_box label {
  margin: 0px;
  font-size: 12px;
}

.solution_goal_content .solution_goal_right .solution_goal_right_box .Mui-disabled {
  opacity: 1;
  -webkit-text-fill-color: rgb(0, 0, 0);
}

.solution_goal_right .add_button {
  background-color: transparent;
  width: fit-content;
  box-shadow: none;
  padding: 0px;
  width: auto;
  min-width: auto;
  margin-left: 60px;
}

.client_main_right_left .chrono-parent-tab {
  display: grid;
}

.client_main_right_left .chrono-parent-tab .MuiTabs-root {
  position: relative;
  padding: 0px 40px;
  display: grid;
}

.client_main_right_left .chrono-parent-tab .MuiTabs-root .MuiTabScrollButton-root {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.client_main_right_left .chrono-parent-tab .MuiTabs-root .MuiTabScrollButton-root:first-child {
  left: 0px;
}

.client_main_right_left .chrono-parent-tab .MuiTabs-root .MuiTabScrollButton-root:last-child {
  right: 0px;
}

.tab_main_nav {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  margin: 20px 0px 0px;
  padding-bottom: 15px;
}

.tab_main_nav button {
  border: 0px;
  color: #fff;
  font-weight: 400;
  padding: 7px 10px;
  background: #225ea8;
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 5px;
  text-transform: none;
}

.tab_main_nav button:hover {
  background: #3e9479;
}

.tab_main_nav button svg {
  font-size: 18px;
}

.tab_main_nav.full_width_nav {
  grid-column: 2 span;
}

.product_left_content .MuiAlert-standardInfo {
  background-color: #ededed;
}

nav.navbar ul li.nav-item {
  position: relative;
}

.insured_main_outer,
.financial-instn-container,
.Select_account_main_outer,
.marketing_select_member {
  grid-column: 2 span;
}

.markets_grid_full {
  grid-column: 2 span;
}

.marketing_select_member,
.financial-instn-container {
  padding-bottom: 20px;
}

.Select_account_main_outer .action-button {
  width: 25px !important;
}

.asset-mix-input-outer {
  width: 100%;
}

.asset-mix-input {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;
  margin-bottom: 15px;
}

.markets_grid_full .chart_filter {
  margin-top: 30px;
}

.faq-container-new .faq-content-new {
  box-shadow: 0 0 6px 0 #dfdfdf;
  border-radius: 5px;
  border: 1px solid #dfdfdf;
  background-color: #fff;
  background: #fff;
  margin-bottom: 3px;
}

.product_left_content .tab_main_nav {
  display: none !important;
}

.product_left_content .tab_main_nav.block {
  display: flex !important;
}

.planner-input.long-text-input input {
  height: auto !important;
  min-height: 28px !important;
  max-height: 28px !important;
}

.planner-input.long-text-input .MuiInput-underline::before,
.planner-input.long-text-input .MuiInput-underline::after {
  display: none;
}

.plaid-container .chart_filter .tab {
  margin-bottom: 0px;
}

.Select-Update-row {
  padding-bottom: 15px;
}

.markets-radio-buttons [type=radio]:checked,
.markets-radio-buttons [type=radio]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.markets-radio-buttons [type=radio]:checked + label,
.markets-radio-buttons [type=radio]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}

.markets-radio-buttons [type=radio]:checked + label:before,
.markets-radio-buttons [type=radio]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 2px solid #828282;
  border-radius: 100%;
  background: #fff;
}

.markets-radio-buttons [type=radio]:not(:checked) + label:before {
  width: 15px;
  height: 15px;
}

.markets-radio-buttons [type=radio]:checked + label:before {
  border: 7px solid #24948c;
}

.markets-radio-buttons [type=radio]:checked + label:after,
.markets-radio-buttons [type=radio]:not(:checked) + label:after {
  content: "";
  width: 3px;
  height: 3px;
  background: #f87da9;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  transition: all 0.2s ease;
}

.markets-radio-buttons [type=radio]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}

.markets-radio-buttons [type=radio]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}

.markets-radio-buttons {
  display: flex;
  display: -webkit-flex;
  column-gap: 20px;
}

.main_build_nav_item {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  column-gap: 20px;
  background-color: #479573;
  box-shadow: 0 0 7px 1px #c9c9c9;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  z-index: 9;
}

.main_build_nav_item::before {
  position: absolute;
  content: "";
  top: 15px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0.5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: bottom;
  background-repeat: no-repeat;
  width: 100%;
  z-index: -1;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -ms-transition: 0.5s ease-in-out;
  background-size: contain;
}

.main_build_nav_item .main_build_nav_icon img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.Main_Build_nav_outer {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.main_build_nav_item .main_build_nav_title h5 {
  text-transform: uppercase;
  margin-bottom: 0px;
  color: #fff;
}

.Main_Build_nav_main_outer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  position: relative;
  z-index: 0;
}

.main_build_nav_item::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-position: center;
  background-repeat: no-repeat;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  width: 10px;
  height: 25px;
  opacity: 0;
  right: -8px;
  background-size: contain;
}

.main_build_nav_item.active::after {
  opacity: 1;
}

.Main_Build_sub_nav ul {
  padding: 0px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  gap: 10px;
}

.Main_Build_sub_nav ul li {
  padding: 10px;
  border-radius: 5px;
  background-color: #66b192;
  color: #fff;
  list-style: none;
  cursor: pointer;
}

.Main_Build_sub_nav ul li:hover {
  background-color: #479573;
}

.product_left_content-inner {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
}

.locked-text {
  color: red;
  margin-left: 4px;
  font-size: 12px;
}

.insured_main_outer.full-height {
  height: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: column;
}

.client_left .Main_Build_content {
  height: 100%;
}

.insured_radio_group.vacation_date_input .planner-input.long-text-input input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  max-height: 100% !important;
  min-height: auto !important;
}

.product_left_content-inner .breadcrumb ul {
  display: flex;
  display: -webkit-flex;
  padding: 10px;
  gap: 20px;
  background-color: #eeeff1;
  width: 100%;
  border-radius: 8px;
  margin: 0px;
}

.product_left_content-inner .breadcrumb ul li {
  list-style: none;
  position: relative;
  font-size: 16px;
  padding: 0px 10px;
  font-weight: 500;
  color: #71748d;
}

.product_left_content-inner .breadcrumb ul li::before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  border-left: solid 7px #71748d;
  border-bottom: solid 7px transparent;
  border-top: solid 7px transparent;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  right: -15px;
}

.product_left_content-inner .breadcrumb ul li:last-child {
  color: #3e9479;
}

.product_left_content-inner .breadcrumb ul li:last-child::before {
  display: none;
}

.Save_Simulate_button_outer .Simulate_button_group {
  padding: 10px;
}

.Save_Simulate_button_outer .Simulate_button_group button {
  width: 100%;
}

.delete_popup_outer .MuiDialogActions-root {
  width: 100%;
}

.alert_text {
  margin-top: 10px;
}

.financial-instn-container {
  padding-top: 10px;
}

.plan.client-review-dd .controls-select .select-search__control--is-disabled {
  background: #808080 !important;
  color: #fff;
  border: 1px solid #808080 !important;
}

.plan.client-review-dd .controls-select .select-search__control--is-disabled .select-search__indicator svg path {
  fill: #fff;
}

.plan.client-review-dd .controls-select .select-search__control--is-disabled .select-search__placeholder {
  color: #fff;
}

.plan.client-review-dd .controls-select .select-search__placeholder {
  line-height: 16px;
}

.mandatory_div p span {
  color: red;
}

.chrono-charts-container .ant-switch .MuiFormControlLabel-root {
  margin: 0px;
  padding: 10px;
}

.custom_note_inner {
  padding: 20px;
}

.custom_note_inner p {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0px 9px 27px rgba(0, 0, 0, 0.07), 0px 3.75998px 11.28px rgba(0, 0, 0, 0.0503198), 0px 2.01027px 6.0308px rgba(0, 0, 0, 0.0417275), 0px 1.12694px 3.38082px rgba(0, 0, 0, 0.035), 0px 0.598509px 1.79553px rgba(0, 0, 0, 0.0282725), 0px 0.249053px 0.747159px rgba(0, 0, 0, 0.0196802);
  width: 100%;
  padding: 15px;
}

@media (max-width: 991px) {
  .mobile_card {
    display: block;
  }
  .desktop_card {
    column-gap: 20px;
  }
  .desktop_card .Under_Management_content {
    display: none !important;
  }
  .desktop_card .home_main_card_outer .card-body {
    text-align: center;
    padding: 10px;
  }
  .desktop_card .Under_Management {
    justify-content: center;
  }
  .desktop_card .select_client_outer {
    display: none;
  }
  .desktop_card .Under_Management .Under_Management_image img {
    max-width: 45px;
    width: 45px;
  }
  .desktop_card .Under_Management .Under_Management_image {
    margin: 0px auto;
  }
}
/* Just some basic styling for demonstration */
.outer {
  position: relative;
}

.inner {
  flex: 1 1;
  /* Equal width for both columns */
}

.carousel-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 15px;
}

.carousel-itemm {
  width: 50%;
}

/* Styling for arrows */
.arrow {
  display: none;
  /* Hide arrows by default */
}

/* Media query for tablet and mobile devices */
@media only screen and (max-width: 991px) {
  .carousel-itemm {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
  .divider_line {
    display: none;
  }
  .outer {
    flex-direction: column;
    /* Stack columns on top of each other */
  }
  .inner {
    flex: none;
    /* Reset flex property */
    width: auto;
    /* Reset width property */
  }
  .carousel-container {
    display: flex;
    /* Display carousel */
    overflow-x: hidden;
    /* Add horizontal scroll for overflow */
    width: 100%;
    gap: 0px;
  }
  .arrow {
    display: block;
    /* Display arrows */
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background-color: rgba(62, 148, 121, 0.65);
    color: white;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
  }
  .arrow.left {
    left: 0;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  .arrow.right {
    right: 0;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/newUIV5.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;+EAAA;AAMA;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,mCAAA;AAFF;;AAKA;;;;;;EAME,cAAA;EACA,wBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,wBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;EACA,qBAAA;AAFF;;AAKA;;EAEE,UAAA;EACA,qBAAA;AAFF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AARF;;AAWA;;sBAAA;AAIA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AATF;;AAYA;EACE,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;AATF;;AAYA;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,kDAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAgBA;EACE,UAAA;AAbF;;AAgBA;EACE,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,4BAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAyBA;EACE,mBAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;gEAAA;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;AAvBF;;AA0BA;EACE,mBAAA;EACA,yBAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAvBF;;AA0BA;EACE,gBAAA;AAvBF;;AA0BA;EACE,yBAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,yBAAA;AAvBF;;AA4BA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EAGA,iBAAA;EACA,yBAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,yBAAA;EACA,qBAAA;AAzBF;;AA4BA;EACE,yBAAA;AAzBF;;AA4BA;EACE,eAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;;EAEE,yBAAA;EACA,qBAAA;AAzBF;;AA4BA;;EAEE,yBAAA;EACA,qBAAA;AAzBF;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;;EAEE,yBAAA;EACA,yBAAA;AAzBF;;AA4BA;EAEE,aAAA;EAEA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,gBAAA;EACA,kBAAA;AAzBF;;AA4BA;;;EAGE,WAAA;EACA,oCAAA;EACA,gCAAA;AAzBF;;AA4BA;;sBAAA;AAIA;EACE,YAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,qBAAA;AA1BF;;AA6BA;EACE,qBAAA;AA1BF;;AA6BA;EACE,qBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,eAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;EACE,oBAAA;AA1BF;;AA6BA;;sBAAA;AAIA;EACE,gBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,iBAAA;AA3BF;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;;sBAAA;AAIA;EACE,kBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,kBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA5BF;;AA+BA;;0BAAA;AAIA;EACE,oCAAA;EACA,sBAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;EACA,sBAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;EACA,sBAAA;AA7BF;;AAgCA;EACE,oCAAA;EACA,WAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;EACE,oCAAA;AA7BF;;AAgCA;;0BAAA;AAIA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AA9BF;;AAiCA;EACE,oCAAA;AA9BF;;AAiCA;EACE,wCAAA;AA9BF;;AAiCA;EACE,2CAAA;AA9BF;;AAiCA;EACE,yCAAA;AA9BF;;AAiCA;EACE,0CAAA;AA9BF;;AAiCA;;0BAAA;AAIA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,yBAAA;AA/BF;;AAkCA;EACE,cAAA;AA/BF;;AAkCA;;0BAAA;AAIA;EACE,oCAAA;AAhCF;;AAmCA;EACE,4BAAA;AAhCF;;AAmCA;EACE,gCAAA;AAhCF;;AAmCA;EACE,gCAAA;AAhCF;;AAmCA;EACE,gCAAA;AAhCF;;AAmCA;;0BAAA;AAUA;EACE,0BAAA;AAvCF;;AA0CA;EACE,0BAAA;AAvCF;;AA0CA;;0BAAA;AAIA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;;AA2CA;;0BAAA;AAIA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,yBAAA;EACA,WAAA;AAzCF;;AA4CA;;0BAAA;AAIA;EACE,yBAAA;AA1CF;;AA6CA;EACE,yBAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,WAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;EACE,YAAA;AA1CF;;AA6CA;;;;;;EAME,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1CF;;AA6CA;EACE,UAAA;EACA,qBAAA;AA1CF;;AA6CA;;;;;;EAME,yBAAA;AA1CF;;AA6CA;;0BAAA;AAIA;EACE,eAAA;AA3CF;;AAkDA;;+EAAA;AAIA;;+EAAA;AAIA;;0BAAA;AAGA;EACE,6BAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AAjDF;;AAsDA;EACE,YAAA;EAEA,oDAAA;EAEA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAnDF;;AAsDA;EACE,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AAnDF;;AAsDA;EACE,cAAA;AAnDF;;AAsDA;EACE,gBAAA;EACA,WAAA;AAnDF;;AAwDA;EACE,iBAAA;AArDF;;AAwDA;EACE,+BAAA;AArDF;;AAwDA;EACE,YAAA;AArDF;;AAwDA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AArDF;;AAwDA;EACE,6BAAA;EACA,8BAAA;EACA,YAAA;AArDF;;AAwDA,qCAAA;AAEA;EACE,iBAAA;EACA,mBAAA;AAtDF;;AAyDA,4CAAA;AAIA;EACE,gBAAA;AAzDF;;AA4DA;;;EAGE,YAAA;EACA,WAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBAAA;AAzDF;;AA8DA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;AA3DF;;AA8DA;EACE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AA3DF;;AA8DA;;EAEE,cAAA;EACA,qBAAA;EACA,yBAAA;AA3DF;;AAkEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AA/DF;;AAkEA;;;EAGE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,WAAA;AA/DF;;AAkEA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AA/DF;;AAkEA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AA/DF;;AAkEA;;EAEE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;AA/DF;;AAkEA;;EAEE,WAAA;AA/DF;;AAkEA;;EAEE,WAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCAAA;EACA,wBAAA;AA/DF;;AAkEA;EACE;IACE,qBAAA;EA/DF;EAkEA;IACE,qBAAA;EAhEF;EAmEA;IACE,qBAAA;EAjEF;EAoEA;IACE,qBAAA;EAlEF;EAqEA;IACE,qBAAA;EAnEF;AACF;AAsEA,iCAAA;AAMA;EACE,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;AAzEF;;AA4EA;EACE,sBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzEF;;AA4EA,iCAAA;AAIA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AA5EF;;AAiFA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,QAAA;EACA,SAAA;AA9EF;;AAmFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAhFF;;AAmFA;EACE,yBAAA;AAhFF;;AAmFA,2CAAA;AAEA,8DAAA;AAEA;EACE,WAAA;EACA,YAAA;EAEA,cAAA;EACA;;;uCAAA;AAhFF;;AAsFA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAnFF;;AAsFA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AAnFF;;AAsFA;EACE,yBAAA;AAnFF;;AAsFA;EACE,oDAAA;EACA,YAAA;AAnFF;;AAsFA;EACE,WAAA;AAnFF;;AAsFA;EACE,kBAAA;EACA,YAAA;AAnFF;;AAwFA;EACE,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AArFF;;AAwFA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AArFF;;AAwFA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AArFF;;AAwFA;EACE,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AArFF;;AAwFA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AArFF;;AAwFA;;EAEE,yBAAA;EACA,cAAA;EACA,kBAAA;AArFF;;AAwFA;;EAEE,yBAAA;EACA,cAAA;EACA,kBAAA;AArFF;;AAwFA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;AArFF;;AAwFA;;2BAAA;AAIA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EAEA,oDAAA;EACA,yBAAA;EACA,iCAAA;AAtFF;;AAyFA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAtFF;;AAyFA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AAtFF;;AAyFA;EACE,yBAAA;AAtFF;;AAyFA;EACE,oDAAA;EACA,YAAA;AAtFF;;AAyFA;EACE,WAAA;EACA,aAAA;AAtFF;;AAyFA;EACE,kBAAA;EACA,iBAAA;AAtFF;;AA2FA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAxFF;;AA2FA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EAEA,iBAAA;AAzFF;;AA4FA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAzFF;;AA4FA;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AAzFF;;AA4FA;EACE,yBAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,kBAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAzFF;;AA4FA;;EAEE,yBAAA;EACA,cAAA;EACA,kBAAA;AAzFF;;AA4FA;;EAEE,yBAAA;EACA,cAAA;EACA,kBAAA;AAzFF;;AA4FA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;AAzFF;;AA4FA;EACE,sBAAA;AAzFF;;AA4FA;EACE,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;AAzFF;;AA4FA;;2BAAA;AAIA;EACE,yBAAA;AA1FF;;AA6FA;EACE,cAAA;AA1FF;;AA6FA;EACE,cAAA;AA1FF;;AA+FA;EACE,cAAA;AA5FF;;AA+FA;;EAEE,WAAA;EACA,yBAAA;EACA,kBAAA;AA5FF;;AA+FA;;EAEE,yBAAA;EACA,WAAA;EACA,kBAAA;AA5FF;;AA+FA;EACE,WAAA;EACA,kBAAA;EACA,6BAAA;AA5FF;;AA+FA;;2BAAA;AAIA;EAEE,mBAAA;EAEA,yEAAA;EACA,yBAAA;EAEA,oDAAA;EACA,iCAAA;AA9FF;;AAiGA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AA9FF;;AAiGA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AA9FF;;AAiGA;EACE,cAAA;AA9FF;;AAmGA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAhGF;;AAmGA;;EAEE,cAAA;EACA,yBAAA;EACA,0CAAA;AAhGF;;AAmGA;;EAEE,cAAA;AAhGF;;AAmGA;;EAEE,yBAAA;EACA,cAAA;EACA,0CAAA;AAhGF;;AAmGA;EACE,cAAA;EACA,yBAAA;EACA,0CAAA;AAhGF;;AAmGA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AAhGF;;AAmGA;EACE,gBAAA;AAhGF;;AAmGA,2BAAA;AAEA;;0BAAA;AAIA;EACE,gBAAA;EACA,SAAA;AAlGF;;AAyGA;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAtGF;;AAyGA;EACE,cAAA;AAtGF;;AAyGA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;AAtGF;;AAyGA,8BAAA;AAEA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAvGF;;AA0GA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AAvGF;;AA0GA;EACE,cAAA;EACA,mBAAA;AAvGF;;AA4GA;;EAEE,WAAA;EACA,qBAAA;EACA,yBAAA;AAzGF;;AA4GA,yEAAA;AAEA;;0BAAA;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AA3GF;;AA8GA;EACE,kBAAA;EACA,OAAA;EACA,iBAAA;AA3GF;;AA8GA;;EAEE,aAAA;AA3GF;;AA8GA;EACE,cAAA;EACA,eAAA;AA3GF;;AA8GA;EACE,sBAAA;AA3GF;;AA8GA;EACE,aAAA;EACA,6BAAA;AA3GF;;AA8GA;EACE,2BAAA;AA3GF;;AA8GA;EACE,cAAA;AA3GF;;AA8GA;EACE,cAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA3GF;;AA8GA;EACE,6BAAA;AA3GF;;AA8GA;EACE,iBAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AA3GF;;AA8GA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AA3GF;;AA8GA;;0BAAA;AAIA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AA5GF;;AA+GA;EACE,aAAA;AA5GF;;AA+GA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AA5GF;;AA+GA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA5GF;;AA+GA;EACE,kBAAA;AA5GF;;AA+GA,gEAAA;AAEA;;0BAAA;AAIA;EACE,mBAAA;AA9GF;;AAuHA;EACE,cAAA;AApHF;;AAuHA;EACE,cAAA;AApHF;;AAuHA;EACE,aAAA;EAEA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AApHF;;AAuHA;EACE,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AApHF;;AAuHA;EACE,cAAA;AApHF;;AAuHA;EACE,eAAA;EACA,kBAAA;AApHF;;AAuHA;EACE,mBAAA;EACA,aAAA;AApHF;;AAuHA,4DAAA;AAEA;;0BAAA;AAIA;EACE,8CAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,iCAAA;AAtHF;;AA2HA;EACE,cAAA;EACA,mBAAA;EAEA,oBAAA;AAxHF;;AA2HA;;+EAAA;AAIA;EACE,gBAAA;AAzHF;;AA4HA;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;AAzHF;;AA4HA;EACE,mBAAA;AAzHF;;AA4HA;EACE,yBAAA;AAzHF;;AA4HA;;+EAAA;AAMA;EACE,aAAA;AA5HF;;AA+HA;;+EAAA;AAQA;EACE,kBAAA;AAjIF;;AAoIA;EACE,cAAA;EACA,gBAAA;AAjIF;;AAoIA;EACE,WAAA;EACA,mBAAA;AAjIF;;AAwIA;EACE,0BAAA;AArIF;;AAwIA;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;AArIF;;AAwIA;EACE,yBAAA;AArIF;;AAwIA;EACE,yBAAA;EACA,kCAAA;EACA,mCAAA;AArIF;;AAwIA;EACE,UAAA;EACA,yBAAA;AArIF;;AA0IA;EACE,aAAA;AAvIF;;AA0IA;EACE,oBAAA;EACA,iBAAA;AAvIF;;AA0IA;EACE,mBAAA;AAvIF;;AA4IA;;+EAAA;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;AA5IF;;AA+IA;EACE,yBAAA;AA5IF;;AA+IA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AA5IF;;AA+IA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AA5IF;;AA+IA;EACE,YAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;AA5IF;;AA+IA;;4EAAA;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA/IF;;AAkJA;EACE,yBAAA;EACA,kCAAA;EACA,mCAAA;AA/IF;;AAkJA;EACE,+BAAA;EACA,kBAAA;EACA,iBAAA;AA/IF;;AAkJA;EACE,yBAAA;AA/IF;;AAkJA;EACE,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AA/IF;;AAsJA;;+EAAA;AAMA,mDAAA;AAIA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAzJF;;AAgKA;EACE,YAAA;EACA,gBAAA;AA7JF;;AAgKA,oDAAA;AAIA;EACE,wBAAA;AAhKF;;AAqKA;EACE,YAAA;EACA,cAAA;AAlKF;;AAqKA,oDAAA;AAIA;EACE,wBAAA;AArKF;;AAwKA;;+EAAA;AAIA;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;AAtKF;;AAyKA;EACE,kBAAA;EACA,iBAAA;AAtKF;;AAyKA;EACE,kBAAA;AAtKF;;AAyKA;EAYE,iHAAA;EAYA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,WAAA;AA3LF;;AA8LA;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AA3LF;;AA8LA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA3LF;;AA8LA;EACE,qBAAA;EACA,cAAA;EACA,qBAAA;AA3LF;;AA8LA;EACE,qBAAA;EACA,cAAA;EACA,qBAAA;AA3LF;;AA8LA;EACE,6BAAA;EACA,aAAA;AA3LF;;AA8LA;EACE,kBAAA;EACA,mBAAA;AA3LF;;AA8LA;EACE,eAAA;EACA,kBAAA;AA3LF;;AA8LA;EACE,eAAA;EAEA,cAAA;AA5LF;;AA+LA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,iCAAA;EACA,cAAA;AA5LF;;AAiMA;EACE,eAAA;EACA,cAAA;AA9LF;;AAiMA;EACE,sBAAA;EACA,yBAAA;AA9LF;;AAiMA;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;AA9LF;;AAiMA;EACE,WAAA;AA9LF;;AAiMA;EACE,eAAA;EACA,mBAAA;AA9LF;;AAiMA;EACE,yBAAA;EACA,qBAAA;AA9LF;;AAiMA;EACE,yBAAA;EACA,qBAAA;AA9LF;;AAiMA;EACE,yBAAA;EACA,qBAAA;AA9LF;;AAiMA;EACE,yBAAA;EACA,qBAAA;AA9LF;;AAiMA;EACE,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,cAAA;AA9LF;;AAmMA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EAEA,aAAA;EAEA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAhMF;;AAmMA;EACE,kBAAA;EAEA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;AAhMF;;AAmMA;EACE,yBAAA;AAhMF;;AAmMA;;EAEE,aAAA;AAhMF;;AAmMA;EACE,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,+BAAA;EACA,kBAAA;AAhMF;;AAmMA;EACE,oBAAA;EACA,mBAAA;AAhMF;;AAmMA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;AAhMF;;AAmMA;;EAEE,sBAAA;EACA,UAAA;EACA,aAAA;AAhMF;;AAqMA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,sCAAA;EACA,mCAAA;EACA,wBAAA;EACA,wBAAA;AAlMF;;AAqMA;EACE,4BAAA;AAlMF;;AAqMA;EACE,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAlMF;;AAqMA;EACE,uBAAA;EACA,oBAAA;EACA,mBAAA;AAlMF;;AAqMA,iCAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;AAlMF;;AAqMA;EACE,mBAAA;AAlMF;;AAqMA;EACE,mBAAA;EACA,oBAAA;AAlMF;;AAqMA,mCAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;AAlMF;;AAqMA;EACE,mBAAA;AAlMF;;AAqMA;EACE,mBAAA;EACA,oBAAA;AAlMF;;AAqMA,gCAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;AAlMF;;AAqMA;EACE,mBAAA;AAlMF;;AAqMA;EACE,mBAAA;EACA,oBAAA;AAlMF;;AAqMA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;AAlMF;;AAqMA;EACE,kBAAA;AAlMF;;AAqMA;;EAEE,wBAAA;EACA,SAAA;AAlMF;;AAqMA;EACE,0BAAA;AAlMF;;AAqMA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;AAlMF;;AAqMA;EACE,UAAA;AAlMF;;AAqMA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AAlMF;;AAqMA;EACE,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EAEA,gBAAA;EAEA,4BAAA;EACA,yBAAA;EAGA,oBAAA;EACA,iBAAA;EACA,yBAAA;AAnMF;;AAsMA;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,gCAAA;AAnMF;;AAsMA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAnMF;;AAsMA;;8EAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAtMF;;AAyMA;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAtMF;;AAyMA;EACE,yBAAA;EACA,WAAA;AAtMF;;AAyMA,qBAAA;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAvMF;;AA0MA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAvMF;;AA0MA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAvMF;;AA0MA,qBAAA;AAEA;EACE,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,6BAAA;AAxMF;;AA2MA;EACE,sBAAA;EACA,oCAAA;EACA,gCAAA;AAxMF;;AA2MA;;EAEE,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,2BAAA;AAxMF;;AA2MA;;;EAGE,oDAAA;AAxMF;;AA2MA;;;EAGE,sBAAA;EACA,oCAAA;EACA,gCAAA;AAxMF;;AA2MA,uBAAA;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AA4BA,qBAAA;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3MF;;AA8MA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3MF;;AA8MA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sCAAA;AA3MF;;AA8MA;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3MF;;AA8MA,oBAAA;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA5MF;;AA+MA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA5MF;;AA+MA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,qCAAA;AA5MF;;AA+MA;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AA5MF;;AA+MA,qBAAA;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AA7MF;;AAgNA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AA7MF;;AAgNA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,sCAAA;AA7MF;;AAgNA;;;EAGE,cAAA;EACA,yBAAA;EACA,qBAAA;AA7MF;;AAgNA,kBAAA;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA9MF;;AAiNA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA9MF;;AAiNA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,uCAAA;AA9MF;;AAiNA;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AA9MF;;AAiNA,mBAAA;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AA/MF;;AAkNA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AA/MF;;AAkNA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,wCAAA;AA/MF;;AAkNA,kBAAA;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAhNF;;AAmNA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAhNF;;AAmNA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,qCAAA;AAhNF;;AAmNA,2BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAjNF;;AAoNA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAjNF;;AAoNA;;EAEE,cAAA;EACA,6BAAA;EACA,qBAAA;EACA,uCAAA;AAjNF;;AAoNA,6BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAlNF;;AAqNA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAlNF;;AAqNA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sCAAA;AAlNF;;AAqNA,+BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAnNF;;AAsNA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAnNF;;AAsNA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,uCAAA;AAnNF;;AAsNA;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AAnNF;;AAsNA,6BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AApNF;;AAuNA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AApNF;;AAuNA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sCAAA;AApNF;;AAuNA,4BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AArNF;;AAwNA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AArNF;;AAwNA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sCAAA;AArNF;;AAwNA,6BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAtNF;;AAyNA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAtNF;;AAyNA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,sCAAA;AAtNF;;AAyNA,0BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAvNF;;AA0NA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAvNF;;AA0NA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,uCAAA;AAvNF;;AA0NA,2BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAxNF;;AA2NA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAxNF;;AA2NA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,wCAAA;AAxNF;;AA2NA,0BAAA;AAEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;AAzNF;;AA4NA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAzNF;;AA4NA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,qCAAA;AAzNF;;AA4NA,kBAAA;AAEA;EACE,uBAAA;EACA,yBAAA;EACA,2BAAA;AA1NF;;AA6NA;EACE,4BAAA;EACA,0BAAA;AA1NF;;AA6NA;EACE,6BAAA;EACA,0BAAA;AA1NF;;AA6NA,oBAAA;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3NF;;AA8NA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3NF;;AA8NA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3NF;;AA8NA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3NF;;AA8NA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AA3NF;;AA8NA,8BAAA;AAEA;EACE,oBAAA;AA5NF;;AA+NA,8BAAA;AAEA;;EAEE,kBAAA;AA7NF;;AAgOA;;0BAAA;AAIA;EACE,cAAA;AA9NF;;AAiOA;EACE,qBAAA;AA9NF;;AAiOA;EACE,yBAAA;AA9NF;;AAiOA;EACE,yBAAA;AA9NF;;AAiOA;EACE,yBAAA;AA9NF;;AAiOA;;0BAAA;AAIA;EACE,YAAA;EAGA,4CAAA;AA/NF;;AAkOA;EACE,sBAAA;EACA,gCAAA;AA/NF;;AAoOA;EACE,eAAA;AAjOF;;AAoOA;EACE,mBAAA;EACA,YAAA;AAjOF;;AAsOA;EACE,eAAA;EACA,mBAAA;AAnOF;;AAwOA;EACE,eAAA;AArOF;;AAwOA;EACE,SAAA;EACA,cAAA;AArOF;;AA8OA;EACE,eAAA;EACA,iBAAA;AA3OF;;AA8OA;;EAEE,cAAA;EACA,6BAAA;AA3OF;;AA8OA,qEAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;AA5OF;;AA+OA;EAGE,aAAA;EAIA,sBAAA;EACA,gBAAA;AA5OF;;AA+OA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA5OF;;AA+OA;EACE,oBAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5OF;;AA+OA;EAGE,2CAAA;AA3OF;;AAgPA;;EAGE,sCAAA;EAEA,+CAAA;AA7OF;;AAgPA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AA7OF;;AAgPA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,yCAAA;EACA,UAAA;EACA,UAAA;EAEA,6BAAA;AA7OF;;AAgPA;EACE,UAAA;AA7OF;;AAgPA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AA7OF;;AAgPA;EACE,WAAA;AA7OF;;AAgPA;EACE,mBAAA;AA7OF;;AAgPA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EAEA,kCAAA;EAEA,yBAAA;AA7OF;;AAgPA;EACE,UAAA;EAEA,wBAAA;EACA,UAAA;AA7OF;;AAgPA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EAGA,aAAA;EAGA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EAEA,6BAAA;AA7OF;;AAgPA;EACE,UAAA;AA7OF;;AAgPA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,yCAAA;EACA,UAAA;EAEA,yBAAA;EACA,UAAA;AA7OF;;AAgPA;EACE,UAAA;AA7OF;;AAgPA;EACE,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AA7OF;;AAgPA;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;AA7OF;;AAgPA,uEAAA;AAMA;EACE,yBAAA;EACA,WAAA;AAlPF;;AAqPA;;0BAAA;AAIA,8BAAA;AAEA,sCAAA;AAEA;EACE,oCAAA;AArPF;;AAwPA;;EAEE,OAAA;EACA,sCAAA;AArPF;;AAwPA;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,gCAAA;EACA,0CAAA;EACA,2CAAA;AArPF;;AAwPA;;0BAAA;AAIA;;EAEE,oBAAA;EACA,uBAAA;EACA,yCAAA;EACA,wCAAA;AAtPF;;AAyPA;;0BAAA;AAIA;;0BAAA;AAIA;EACE,mBAAA;AAxPF;;AA2PA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AAxPF;;AA2PA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AAxPF;;AAiQA;EACE,YAAA;EACA,WAAA;AA9PF;;AAiQA;EACE,YAAA;EACA,WAAA;AA9PF;;AAmQA;EACE,YAAA;EACA,WAAA;AAhQF;;AAmQA;;0BAAA;AAMA;EACE,0BAAA;AAnQF;;AAwQA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;AArQF;;AA2QA;EACE,sBAAA;EACA,kCAAA;EACA,cAAA;AAxQF;;AA2QA;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AAxQF;;AA2QA,+BAAA;AAIA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA3QF;;AA8QA;EACE,kBAAA;AA3QF;;AA8QA;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EAGA,8BAAA;AA3QF;;AA8QA;EACE,cAAA;EACA,iCAAA;EACA,oCAAA;AA3QF;;AA8QA;EACE,6BAAA;EACA,sCAAA;EACA,uCAAA;AA3QF;;AA8QA;EACE,cAAA;EAGA,8BAAA;EACA,gBAAA;EACA,aAAA;AA3QF;;AA8QA,8BAAA;AAIA;EACE,0BAAA;AA9QF;;AAiRA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,qCAAA;EACA,iBAAA;AA9QF;;AAmRA;EACE,yBAAA;EACA,wCAAA;EACA,gDAAA;AAhRF;;AAmRA;;EAEE,yBAAA;EACA,yBAAA;AAhRF;;AAmRA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AAhRF;;AAmRA,uCAAA;AAIA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAnRF;;AAsRA;EACE,kBAAA;AAnRF;;AAsRA;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EAGA,8BAAA;EACA,oCAAA;AAnRF;;AAsRA;EACE,cAAA;EACA,oCAAA;EACA,uBAAA;EACA,0CAAA;AAnRF;;AAsRA;EACE,6BAAA;EACA,sCAAA;EACA,uCAAA;AAnRF;;AAsRA;EACE,cAAA;EAGA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AAnRF;;AAsRA,4BAAA;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,yBAAA;AApRF;;AAuRA;EACE,gCAAA;AApRF;;AAyRA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAtRF;;AAyRA;EACE,yBAAA;EACA,wCAAA;EACA,6CAAA;AAtRF;;AAyRA;EACE,aAAA;AAtRF;;AAyRA,oCAAA;AAEA;EACE,kBAAA;EACA,yBAAA;AAvRF;;AA0RA;EACE,gCAAA;AAvRF;;AA4RA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAzRF;;AA4RA;EACE,yBAAA;EACA,wCAAA;EACA,gDAAA;AAzRF;;AA4RA;EACE,aAAA;AAzRF;;AA4RA;;0BAAA;AAUA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAhSF;;AAmSA;EACE,sBAAA;EACA,cAAA;AAhSF;;AAmSA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;AAhSF;;AAmSA;;0BAAA;AAUA;EACE,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AAvSF;;AA0SA;EACE,6BAAA;EACA,cAAA;AAvSF;;AA0SA;EACE,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAvSF;;AA0SA;;0BAAA;AAQA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AA5SF;;AA+SA;EACE,sBAAA;EACA,cAAA;AA5SF;;AA+SA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;AA5SF;;AA+SA;;0BAAA;AAMA;EACE,kBAAA;AA/SF;;AAkTA;EACE,gBAAA;AA/SF;;AAkTA;EACE,eAAA;EACA,aAAA;EACA,6BAAA;AA/SF;;AAkTA;EACE,0BAAA;AA/SF;;AAkTA;EACE,cAAA;EACA,qBAAA;AA/SF;;AAkTA;EACE,cAAA;EACA,qBAAA;AA/SF;;AAoTA;EACE,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AAjTF;;AAoTA;EACE,yBAAA;EACA,gBAAA;AAjTF;;AAoTA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;AAjTF;;AAoTA;EACE,0BAAA;AAjTF;;AAoTA;EACE,cAAA;EACA,qBAAA;AAjTF;;AAoTA;EACE,cAAA;EACA,qBAAA;AAjTF;;AAoTA;;0BAAA;AAIA;;0BAAA;AAIA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAnTF;;AAsTA;;0BAAA;AAIA;;0BAAA;AAIA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;AArTF;;AAwTA;EACE,yBAAA;AArTF;;AAwTA;;EAEE,WAAA;EACA,qBAAA;EACA,yBAAA;AArTF;;AAwTA;EACE,yBAAA;EACA,cAAA;AArTF;;AAwTA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;AArTF;;AAwTA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;AArTF;;AAwTA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;AArTF;;AAwTA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;EACA,cAAA;AArTF;;AAwTA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;AArTF;;AAwTA;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;EACA,cAAA;AArTF;;AAwTA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AAwTA;EACE,yBAAA;AArTF;;AAwTA;;EAEE,cAAA;EACA,yBAAA;EACA,qBAAA;AArTF;;AA0TA;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAvTF;;AA0TA;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAvTF;;AA0TA;EACE,mBAAA;AAvTF;;AA0TA;EACE,yBAAA;AAvTF;;AA0TA;EACE,yBAAA;AAvTF;;AA0TA;EACE,yBAAA;AAvTF;;AA0TA;;0BAAA;AAIA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAxTF;;AA2TA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAxTF;;AA2TA;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAxTF;;AA2TA;;0BAAA;AAIA;EACE,YAAA;EACA,aAAA;AAzTF;;AA4TA;EACE,YAAA;EACA,aAAA;AAzTF;;AA4TA;EACE,YAAA;EACA,aAAA;AAzTF;;AA4TA;EACE,WAAA;EACA,YAAA;AAzTF;;AA4TA;EACE,WAAA;EACA,YAAA;AAzTF;;AA4TA;EACE,WAAA;EACA,YAAA;AAzTF;;AA4TA;EACE,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EAEA,kCAAA;EACA,qBAAA;AAzTF;;AA4TA;EACE,yBAAA;EACA,0BAAA;AAzTF;;AA4TA;EACE,yBAAA;EACA,0BAAA;AAzTF;;AA4TA;EACE,yBAAA;EACA,0BAAA;AAzTF;;AA4TA;EACE,yBAAA;EACA,0BAAA;AAzTF;;AA4TA;EACE,yBAAA;EACA,0BAAA;AAzTF;;AA4TA;EACE,yBAAA;EACA,0BAAA;AAzTF;AAwUA;EACE;IAEE,uBAAA;EA3TF;EA8TA;IAEE,yBAAA;EA5TF;AACF;AA+TA;;0BAAA;AAIA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AA9TF;;AAiUA;EACE,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AA9TF;;AAiUA;EACE,aAAA;AA9TF;;AAiUA;EACE,YAAA;EACA,qBAAA;AA9TF;;AAiUA;EACE,YAAA;EACA,WAAA;AA9TF;;AAiUA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;AA9TF;;AAiUA;EACE,iBAAA;AA9TF;;AAiUA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,MAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AA9TF;;AAiUA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA9TF;;AAiUA;EACE,YAAA;EACA,WAAA;AA9TF;;AAiUA;EACE,kBAAA;EACA,kCAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;AA9TF;;AAiUA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AA9TF;;AAiUA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AA9TF;;AAiUA;EACE,yBAAA;AA9TF;;AAiUA;EACE,yBAAA;AA9TF;;AAiUA;EACE,yBAAA;AA9TF;;AAiUA;;8EAAA;AAIA;;0BAAA;AAIA;;;EAGE,eAAA;AAhUF;;AAmUA;;;EAGE,eAAA;AAhUF;;AAmUA;EACE,aAAA;AAhUF;;AAmUA;EACE,aAAA;AAhUF;;AAmUA;;0BAAA;AAIA;EACE,qBAAA;AAjUF;;AAoUA;EACE,qBAAA;EACA,YAAA;AAjUF;;AAoUA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;8EAAA;AAIA;;mBAAA;AAIA;;mBAAA;AAIA;;kBAAA;AAIA;;mBAAA;AAIA;;mBAAA;AAIA;;qBAAA;AAIA;;6EAAA;AAIA;;qBAAA;AAIA;EACE,kBAAA;AA7UF;;AAgVA;;EAEE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AA7UF;;AAgVA;EACE,sBAAA;EACA,gCAAA;AA7UF;;AAgVA;;EAEE,cAAA;EACA,iCAAA;AA7UF;;AAgVA;EACE,yBAAA;AA7UF;;AAgVA;;EAEE,yBAAA;AA7UF;;AAgVA;EACE,0CAAA;AA7UF;;AAgVA;EACE,0CAAA;AA7UF;;AAgVA;;qBAAA;AAIA,sBAAA;AAEA;;EAEE,oCAAA;EACA,WAAA;EACA,iCAAA;EACA,eAAA;AA/UF;;AAkVA;;qBAAA;AAIA;;6EAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;0BAAA;AAIA;;;;kCAAA;AAMA;EACE;IACE,kBAAA;EA1VF;AACF;AA6VA;;;;kCAAA;AAMA;EACE,gBAAA;EACA,gBAAA;AA5VF;;AA+VA;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AA5VF;;AA+VA;EACE,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AA5VF;;AA+VA;EACE;IACE,eAAA;IACA,kBAAA;EA5VF;EA+VA;IACE,SAAA;IACA,iBAAA;EA7VF;AACF;AAgWA;EACE,kBAAA;EACA,aAAA;AA9VF;;AAiWA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;AA9VF;;AAiWA;EACE,aAAA;AA9VF;;AAiWA;EACE,gBAAA;AA9VF;;AAiWA;EACE;IACE,aAAA;EA9VF;AACF;AAiWA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,+FAAA;AAhWF;;AAoWA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAjWF;;AAoWA;EACE,mBAAA;AAjWF;;AAoWA;EACE,mBAAA;AAjWF;;AAoWA;EACE,mBAAA;AAjWF;;AAoWA;EACE;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,gCAAA;IAEA,wBAAA;EAjWF;EAoWA;IACE,mBAAA;IAEA,2BAAA;EAlWF;AACF;AAwXA;EACE;IACE,UAAA;IAEA,qBAAA;EAtWF;EAyWA;IACE,UAAA;IAEA,qBAAA;EAvWF;EA0WA;IAEE,mBAAA;EAxWF;AACF;AA2WA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EAGA,qDAAA;AAzWF;;AA4WA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;AAzWF;;AA4WA;EACE,mCAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,6BAAA;AAzWF;;AAoXA;;EAEE,qBAAA;AAjXF;;AAoXA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAjXF;;AAoXA;EACE,yBAAA;AAjXF;;AAoXA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAjXF;;AA6XA;EACE;IACE,cAAA;IACA,cAAA;IACA,UAAA;IACA,gCAAA;IAEA,wBAAA;EA1XF;EA6XA;IACE,SAAA;IACA,UAAA;IACA,yBAAA;IACA,wBAAA;EA3XF;EA8XA;IACE,WAAA;EA5XF;EA+XA;IACE,kBAAA;IACA,WAAA;IACA,UAAA;IACA,QAAA;IACA,eAAA;EA7XF;EAgYA;IACE,YAAA;EA9XF;EAiYA;IACE,SAAA;IACA,UAAA;IACA,WAAA;IACA,yBAAA;IACA,yBAAA;EA/XF;EAkYA;IACE,YAAA;EAhYF;EAmYA;IACE,UAAA;IACA,WAAA;IACA,iBAAA;EAjYF;EAoYA;IACE,mBAAA;IAEA,2BAAA;EAlYF;AACF;AAqYA;EAEE,iDAAA;EACA;IAEE,mCAAA;EApYF;AACF;AA0ZA;EACE;IACE,UAAA;IAEA,6BAAA;EAxYF;EA2YA;IACE,UAAA;IAEA,2BAAA;EAzYF;EA4YA;IAEE,wBAAA;EA1YF;AACF;AAgaA;EACE;IACE,UAAA;IAEA,4BAAA;EA9YF;EAiZA;IACE,UAAA;IAEA,4BAAA;EA/YF;EAkZA;IAEE,wBAAA;EAhZF;AACF;AAmZA;;0BAAA;AAIA;EACE,iBAAA;AAlZF;;AAqZA;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;AAlZF;;AAqZA;;0BAAA;AAIA;EACE,cAAA;AAnZF;;AAsZA;EACE,mBAAA;EACA,cAAA;AAnZF;;AAsZA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAnZF;;AAsZA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;AAnZF;;AAsZA;EACE,cAAA;EACA,eAAA;AAnZF;;AAsZA;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAnZF;;AAsZA;EACE,SAAA;EACA,sBAAA;AAnZF;;AAsZA;EACE,YAAA;EACA,aAAA;AAnZF;;AAsZA;;0BAAA;AAIA;EACE,sBAAA;EACA,sBAAA;EAGA,oBAAA;EAGA,aAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;AApZF;;AAuZA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AApZF;;AAuZA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AApZF;;AAuZA;EACE,kBAAA;EACA,gBAAA;AApZF;;AAuZA;;EAEE,cAAA;EACA,gBAAA;AApZF;;AAuZA;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EAGA,gFAAA;AArZF;;AAyZA;EACE,aAAA;EACA,iBAAA;AAtZF;;AAyZA;EACE,yBAAA;AAtZF;;AAyZA;EACE,WAAA;AAtZF;;AAyZA;;0BAAA;AAIA;EACE,YAAA;AAvZF;;AA0ZA;EACE,kBAAA;EAGA,aAAA;EACA,SAAA;EACA,SAAA;EAEA,eAAA;EAGA,mBAAA;EACA,gBAAA;EACA,cAAA;EAGA,gBAAA;EACA,eAAA;EAEA,kCAAA;EACA,UAAA;AAvZF;;AA0ZA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EAGA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAvZF;;AA0ZA;;EAEE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAvZF;;AA0ZA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AAvZF;;AA0ZA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAvZF;;AA0ZA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EAEA,0BAAA;EACA,UAAA;AAvZF;;AA0ZA;EACE,yBAAA;AAvZF;;AA0ZA;EACE,yBAAA;AAvZF;;AA0ZA;EACE,yBAAA;AAvZF;;AA0ZA;EACE,cAAA;EACA,yBAAA;AAvZF;;AA0ZA;EACE,WAAA;EACA,YAAA;AAvZF;;AA0ZA;EACE,qBAAA;AAvZF;;AA0ZA;EAEE,0BAAA;AAvZF;;AA0ZA;EACE,qBAAA;EACA,kBAAA;AAvZF;;AA0ZA;;EAEE,UAAA;AAvZF;;AA0ZA;EACE,iBAAA;EACA,UAAA;AAvZF;;AA0ZA;EACE,kBAAA;EACA,aAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,uBAAA;EAGA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAvZF;;AA0ZA;EACE,gBAAA;EACA,gBAAA;AAvZF;;AA0ZA;EACE,kBAAA;EAGA,SAAA;EACA,kBAAA;EACA,qBAAA;AAvZF;;AA0ZA;EACE,0CAAA;AAvZF;;AA0ZA,6DAAA;AAEA;EACE,aAAA;EACA,YAAA;AAxZF;;AA2ZA;EACE,YAAA;EACA,WAAA;AAxZF;;AA2ZA;EACE,YAAA;EACA,WAAA;AAxZF;;AA2ZA;EACE,YAAA;EACA,WAAA;AAxZF;;AA2ZA;EACE,YAAA;EACA,WAAA;AAxZF;;AA2ZA;EACE,YAAA;EACA,WAAA;AAxZF;;AA2ZA;;0BAAA;AAMA;;EAEE,YAAA;EAEA,YAAA;AA3ZF;;AA8ZA;EACE,aAAA;AA3ZF;;AA8ZA;EACE,qCAAA;AA3ZF;;AA8ZA;;EAAA;AAIA;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EAGA,oCAAA;EACA,yBAAA;EAGA,iBAAA;AA7ZF;;AAgaA;EACE,aAAA;AA7ZF;;AAgaA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7ZF;;AAgaA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AA7ZF;;AAgaA;EACE,kBAAA;AA7ZF;;AAgaA;EACE,aAAA;AA7ZF;;AAgaA;;;EAGE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7ZF;;AAgaA;EACE,mBAAA;EACA,qBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,sBAAA;EACA,6CAAA;EACA,gDAAA;AA7ZF;;AAgaA;EACE,cAAA;EACA,gBAAA;AA7ZF;;AAgaA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AA7ZF;;AAgaA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA7ZF;;AAgaA;EACE,YAAA;AA7ZF;;AAgaA;;EAEE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;AA7ZF;;AAgaA;EACE,uBAAA;EACA,iBAAA;EACA,yBAAA;EAeA,wLAAA;EAYA,0BAAA;EACA,mCAAA;AApbF;;AAubA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;AApbF;;AAubA;EACE,aAAA;AApbF;;AAubA;EAEE,4CAAA;AApbF;;AAubA;;CAAA;AAIA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,6BAAA;AArbF;;AAwbA;EACE,UAAA;EACA,cAAA;AArbF;;AAwbA;;EAEE,WAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;AArbF;;AA8bA;EACE,8BAAA;AA3bF;;AA8bA;;CAAA;AAIA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EAGA,0DAAA;EAEA,kBAAA;EACA,sBAAA;EACA,2BAAA;AA5bF;;AA+bA;EACE,cAAA;EACA,gBAAA;AA5bF;;AA+bA;EACE,SAAA;AA5bF;;AA+bA;EACE,iBAAA;AA5bF;;AA+bA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EAGA,uDAAA;EACA,0BAAA;EACA,6BAAA;AA5bF;;AA+bA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AA5bF;;AA+bA;EACE,gBAAA;AA5bF;;AA+bA;;CAAA;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA7bF;;AAgcA;;0BAAA;AAIA;;0BAAA;AAIA;EACE,kBAAA;EACA,mBAAA;AA/bF;;AAkcA;EACE,oCAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;AA/bF;;AAkcA;EACE,kBAAA;AA/bF;;AAkcA;;EAEE,+BAAA;AA/bF;;AAkcA;EACE,kBAAA;EACA,WAAA;AA/bF;;AAkcA;;EAEE,mBAAA;AA/bF;;AAkcA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AA/bF;;AAkcA;EACE,kBAAA;AA/bF;;AAkcA;EACE,iBAAA;EACA,sBAAA;EACA,cAAA;AA/bF;;AAkcA;;EAEE,cAAA;AA/bF;;AAkcA;;0BAAA;AAIA;EACE,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;AAhcF;;AAmcA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAhcF;;AAmcA;EACE,6BAAA;EACA,iBAAA;EACA,cAAA;AAhcF;;AAmcA;EACE,kBAAA;AAhcF;;AAmcA;EACE,gCAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAhcF;;AAmcA;EACE,mBAAA;AAhcF;;AAmcA;EACE,cAAA;AAhcF;;AAmcA;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AAhcF;;AAmcA;EACE,WAAA;AAhcF;;AAmcA;EACE,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAhcF;;AAmcA;EACE,mBAAA;AAhcF;;AAmcA;EACE,mBAAA;AAhcF;;AAmcA;EACE,mBAAA;AAhcF;;AAmcA;EACE,mBAAA;AAhcF;;AAmcA;EACE,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;AAhcF;;AAmcA;EACE,iBAAA;AAhcF;;AAmcA;;EAEE,eAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhcF;;AAmcA;;4EAAA;AAIA;;6BAAA;AAIA;EACE,0CAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAlcF;;AAqcA;EACE,kBAAA;EACA,kBAAA;AAlcF;;AAucA;EACE,eAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;AApcF;;AAucA;EACE,eAAA;EACA,cAAA;AApcF;;AAucA;EACE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApcF;;AAucA;EACE,cAAA;EACA,mBAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AApcF;;AAucA;EACE,cAAA;EACA,SAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,mBAAA;EACA,eAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,cAAA;EACA,kBAAA;AApcF;;AAucA;EACE,cAAA;EACA,kBAAA;AApcF;;AAucA;EACE,qBAAA;EACA,yBAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AApcF;;AAucA;EACE,SAAA;EACA,cAAA;AApcF;;AAucA;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AApcF;;AAucA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AApcF;;AAucA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;AApcF;;AAucA;EACE,kBAAA;EACA,kBAAA;AApcF;;AAucA;EACE,kBAAA;EACA,WAAA;AApcF;;AAucA;EACE,sBAAA;EACA,kBAAA;AApcF;;AAucA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AApcF;;AAucA;EACE,eAAA;EACA,cAAA;AApcF;;AAucA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AApcF;;AAucA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AApcF;;AAucA;EACE,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,4BAAA;AApcF;;AAucA;EACE,aAAA;EACA,gCAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;AApcF;;AAucA;EACE,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AApcF;;AAucA;;EAEE,kBAAA;EAGA,oBAAA;EACA,sBAAA;AApcF;;AAucA;EACE,iBAAA;AApcF;;AAucA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AApcF;;AAucA;EACE,iBAAA;AApcF;;AAucA;EACE,mBAAA;EACA,sBAAA;AApcF;;AAucA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AApcF;;AAucA;EACE,gBAAA;AApcF;;AAucA;EACE,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AApcF;;AAucA;EACE,yBAAA;AApcF;;AAucA;;EAEE,cAAA;EACA,gBAAA;EACA,+BAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,WAAA;AApcF;;AAucA;;EAEE,mBAAA;EACA,mBAAA;AApcF;;AAucA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AApcF;;AAucA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,cAAA;AApcF;;AAucA;EACE,sBAAA;AApcF;;AAucA;EACE,UAAA;EACA,gBAAA;AApcF;;AAucA;EACE,gBAAA;AApcF;;AAucA;;qBAAA;AAIA;EACE,sBAAA;AArcF;;AAwcA;EACE,kBAAA;EACA,gCAAA;AArcF;;AAwcA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AArcF;;AAwcA;EACE,cAAA;AArcF;;AAwcA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AArcF;;AAwcA;EACE,eAAA;EACA,YAAA;AArcF;;AAwcA;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AArcF;;AAwcA;EACE,WAAA;EACA,kBAAA;AArcF;;AAwcA;EACE,kBAAA;EACA,iBAAA;AArcF;;AAwcA;EACE,YAAA;EACA,eAAA;AArcF;;AAwcA;EACE,WAAA;EACA,kBAAA;AArcF;;AAwcA;EACE,kBAAA;AArcF;;AAwcA;EACE,qBAAA;EACA,kBAAA;AArcF;;AAwcA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AArcF;;AAwcA;EACE,sBAAA;EACA,6BAAA;EACA,kBAAA;AArcF;;AAwcA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;AArcF;;AAwcA;EACE,cAAA;EACA,gBAAA;AArcF;;AAwcA;EACE,gBAAA;AArcF;;AAwcA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AArcF;;AAwcA;EACE,iBAAA;AArcF;;AAwcA;EACE,cAAA;EACA,gBAAA;AArcF;;AAwcA;EACE,sBAAA;EACA,cAAA;EACA,iBAAA;AArcF;;AAwcA;EACE,gBAAA;AArcF;;AAwcA;;uBAAA;AAIA;EACE,kBAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAtcF;;AAycA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAtcF;;AAycA;EACE,sBAAA;EACA,gCAAA;EACA,uBAAA;AAtcF;;AAycA;EACE,gBAAA;EACA,eAAA;AAtcF;;AAycA;EACE,mBAAA;AAtcF;;AAycA;EACE,iBAAA;AAtcF;;AAycA;EACE,sBAAA;AAtcF;;AAycA;EACE,iBAAA;AAtcF;;AAycA;EACE,iBAAA;EACA,kBAAA;AAtcF;;AAycA;EACE,SAAA;EACA,6BAAA;AAtcF;;AAycA;;uBAAA;AAIA;EACE,gBAAA;AAvcF;;AA0cA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAAA;AAvcF;;AA0cA;EACE,2BAAA;AAvcF;;AA0cA;EACE,gBAAA;AAvcF;;AA0cA;EACE,gBAAA;EACA,eAAA;AAvcF;;AA0cA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;AAvcF;;AA0cA;EACE,WAAA;EACA,gBAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;AAvcF;;AA0cA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAvcF;;AA0cA;EACE,qBAAA;EACA,mBAAA;EACA,8BAAA;AAvcF;;AA0cA;EACE,qBAAA;AAvcF;;AA0cA;EACE,WAAA;AAvcF;;AA0cA;EACE,mBAAA;AAvcF;;AA0cA;EACE,YAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAvcF;;AA0cA;EACE,eAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,uBAAA;AAvcF;;AA0cA;EACE,mBAAA;EACA,sBAAA;AAvcF;;AA0cA;EACE,sBAAA;AAvcF;;AA0cA;EACE,gCAAA;AAvcF;;AA0cA;EACE,gBAAA;AAvcF;;AA0cA;EACE,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AAvcF;;AA0cA;EACE,SAAA;AAvcF;;AA0cA;EACE,mBAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAvcF;;AA0cA;EACE,gBAAA;EACA,SAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,+BAAA;AAvcF;;AA0cA;EACE,UAAA;EACA,gBAAA;AAvcF;;AA0cA;EACE,cAAA;AAvcF;;AA0cA;EACE,oBAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;AAvcF;;AA0cA;EACE,kBAAA;AAvcF;;AA0cA;EACE,gBAAA;AAvcF;;AA0cA;EACE,uBAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAvcF;;AA0cA;EACE,UAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAvcF;;AA0cA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;AAvcF;;AA0cA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAvcF;;AA0cA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAvcF;;AA0cA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAvcF;;AA0cA;EACE,aAAA;AAvcF;;AA0cA;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAvcF;;AA0cA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvcF;;AA0cA;EACE,mBAAA;EACA,sBAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAvcF;;AA0cA;EACE,eAAA;AAvcF;;AA0cA;EACE,8BAAA;AAvcF;;AA0cA;EACE,kBAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,mBAAA;AAvcF;;AA0cA;EACE,cAAA;AAvcF;;AA0cA;EACE,4BAAA;AAvcF;;AA0cA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,gCAAA;AAvcF;;AA0cA;;EAEE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAvcF;;AA0cA;;EAEE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAvcF;;AA0cA;EACE,gBAAA;EACA,wBAAA;EACA,YAAA;AAvcF;;AA0cA;EACE,WAAA;AAvcF;;AA0cA;EACE,iBAAA;AAvcF;;AA0cA;EACE,WAAA;EACA,qBAAA;AAvcF;;AA0cA;EACE,mBAAA;EACA,aAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;AAvcF;;AA0cA;EACE,WAAA;AAvcF;;AA0cA;EACE,aAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,iBAAA;AAvcF;;AA0cA;EACE,8BAAA;EACA,UAAA;AAvcF;;AA0cA;EACE,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAvcF;;AA0cA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;AAvcF;;AA0cA;EACE,qBAAA;AAvcF;;AA0cA;EACE,kBAAA;EACA,UAAA;AAvcF;;AA0cA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAvcF;;AA0cA;EACE,qBAAA;AAvcF;;AA0cA;EACE,kBAAA;AAvcF;;AA0cA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAvcF;;AA0cA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAvcF;;AA0cA;EACE,qBAAA;AAvcF;;AA0cA;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAvcF;;AA0cA;EACE,WAAA;AAvcF;;AA0cA;;4EAAA;AAIA;;oEAAA;AAIA,kDAAA;AAEA,gCAAA;AAEA;EACE;IACE,iBAAA;EA3cF;EA8cA;IACE,sBAAA;IACA,2BAAA;IACA,mBAAA;EA5cF;EA+cA;IACE,kBAAA;IACA,kBAAA;IACA,+BAAA;EA7cF;AACF;AAgdA;EACE;IACE,iBAAA;EA9cF;EAidA;IACE,mBAAA;EA/cF;EAkdA,0CAAA;EACA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;IACA,gCAAA;IACA,oCAAA;EAhdF;AACF;AAmdA,6BAAA;AAEA;EAEE,0CAAA;EACA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;IACA,gCAAA;IACA,oCAAA;EAndF;AACF;AAsdA,2BAAA;AAEA;EASE;IACE,UAAA;EA7dF;EAgeA;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,mBAAA;EA9dF;EAieA;IACE,sBAAA;IACA,uBAAA;IACA,qBAAA;IACA,iBAAA;IACA,kBAAA;IACA,YAAA;EA/dF;EAkeA;IACE,oBAAA;IACA,gBAAA;IACA,iBAAA;EAheF;EAmeA;IACE,WAAA;EAjeF;EAoeA;IACE,mBAAA;IACA,eAAA;EAleF;EAqeA;IACE,4BAAA;EAneF;EAseA;IACE,WAAA;IACA,eAAA;IACA,qBAAA;EApeF;EAueA;IACE,YAAA;EAreF;EAweA;IACE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;EAteF;EAyeA;IACE,gBAAA;EAveF;EA0eA;IACE,gBAAA;EAxeF;EA2eA;IACE,6BAAA;IACA,YAAA;EAzeF;EA4eA,wBAAA;EACA;IACE,kBAAA;EA1eF;EA6eA;;IAEE,cAAA;IACA,kBAAA;EA3eF;EA8eA,UAAA;EACA;IACE,0CAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,+BAAA;IACA,aAAA;IACA,mBAAA;IACA,cAAA;EA5eF;EA+eA,+CAAA;EACA;IACE,mBAAA;EA7eF;EAgfA;IACE,aAAA;EA9eF;EAifA,0CAAA;EACA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;IACA,gCAAA;IACA,oCAAA;EA/eF;AACF;AAkfA,gCAAA;AAEA;EACE;IACE,4BAAA;EAjfF;EAofA;IACE,WAAA;EAlfF;EAqfA;IACE,6BAAA;EAnfF;EAsfA;IACE,cAAA;EApfF;EAufA;IACE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;EArfF;EAwfA;IACE,gBAAA;EAtfF;EAyfA;IACE,gBAAA;EAvfF;EA0fA;IACE,uCAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,MAAA;IACA,SAAA;IACA,yBAAA;IACA,eAAA;IACA,mBAAA;IACA,cAAA;IACA,gCAAA;EAxfF;EA2fA;IACE,aAAA;EAzfF;EA4fA;IACE,gBAAA;IACA,WAAA;EA1fF;EA6fA;IACE,cAAA;EA3fF;EA8fA,0CAAA;EACA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;IACA,gCAAA;IACA,oCAAA;EA5fF;EA+fA;IACE,0BAAA;IACA,oCAAA;EA7fF;EAggBA;IACE,UAAA;EA9fF;EAigBA;IACE,gBAAA;EA/fF;EAkgBA;IACE,cAAA;EAhgBF;EAmgBA;IACE,cAAA;EAjgBF;EAogBA;IACE,kBAAA;EAlgBF;EAqgBA,wCAAA;EACA;;IAEE,cAAA;IACA,kBAAA;EAngBF;EAsgBA;;IAEE,kBAAA;EApgBF;EAugBA,+CAAA;EACA;IACE,kBAAA;EArgBF;EAwgBA;IACE,aAAA;EAtgBF;EAygBA;IACE,kBAAA;EAvgBF;AACF;AA0gBA,0BAAA;AAGA,6CAAA;AAEA;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;AA3gBF;;AA8gBA;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA3gBF;;AA8gBA;EACE,UAAA;AA3gBF;;AA8gBA;EACE,oCAAA;AA3gBF;;AA8gBA;EACE,oCAAA;AA3gBF;;AA8gBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;AA3gBF;;AA8gBA;EACE,yDAAA;AA3gBF;;AA8gBA;;EAEE,2BAAA;AA3gBF;;AA8gBA;EACE,oBAAA;AA3gBF;;AA8gBA;EACE,mBAAA;AA3gBF;;AA8gBA;EACE,gBAAA;AA3gBF;;AA8gBA;EACE,WAAA;AA3gBF;;AA8gBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AA3gBF;;AA8gBA;;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA3gBF;;AA8gBA;EACE,eAAA;AA3gBF;;AA8gBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA3gBF;;AA8gBA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AA3gBF;;AA8gBA;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AA3gBF;;AA8gBA;EACE,eAAA;EACA,kBAAA;AA3gBF;;AA8gBA;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AA3gBF;;AA8gBA;EACE,eAAA;EACA,kBAAA;AA3gBF;;AA8gBA;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,8BAAA;EACA,eAAA;AA3gBF;;AA8gBA;EACE,eAAA;EACA,WAAA;AA3gBF;;AA8gBA;EACE,eAAA;EACA,WAAA;AA3gBF;;AA8gBA;EACE,iBAAA;AA3gBF;;AA8gBA;EACE,mBAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,kCAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA3gBF;;AA8gBA;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qDAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,yBAAA;EACA,kBAAA;AA3gBF;;AA8gBA;EACE,cAAA;AA3gBF;;AA8gBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AA3gBF;;AA8gBA;EACE,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AA3gBF;;AA8gBA;EACE,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA3gBF;;AA8gBA;EACE,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AA3gBF;;AA8gBA;EACE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AA3gBF;;AA8gBA;EACE,UAAA;EACA,mBAAA;AA3gBF;;AA8gBA;EACE,sBAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,mBAAA;AA3gBF;;AA8gBA;EACE,mBAAA;EACA,aAAA;EACA,sCAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AA3gBF;;AA8gBA;EACE,oBAAA;EACA,mBAAA;EACA,qDAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AA3gBF;;AA8gBA;EACE,UAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,UAAA;AA3gBF;;AA8gBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,eAAA;EACA,kCAAA;AA3gBF;;AA8gBA;EACE,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,YAAA;AA3gBF;;AA8gBA;EACE,sBAAA;AA3gBF;;AA8gBA;;EAEE,mBAAA;AA3gBF;;AA8gBA;EACE,cAAA;AA3gBF;;AA8gBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,cAAA;AA3gBF;;AA8gBA;;;EAGE,aAAA;EACA,8BAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,yBAAA;AA3gBF;;AA8gBA;EACE,SAAA;EACA,eAAA;EACA,UAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,sCAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AA3gBF;;AA8gBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,QAAA;EACA,mBAAA;AA3gBF;;AA8gBA;EACE,YAAA;EACA,mBAAA;EACA,qDAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,0BAAA;AA3gBF;;AA8gBA;EACE,yBAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,yBAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AA3gBF;;AA8gBA;EACE,gBAAA;AA3gBF;;AA8gBA;EACE,UAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA3gBF;;AA8gBA;EACE,UAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,mBAAA;AA3gBF;;AA8gBA;EACE,iBAAA;EACA,2CAAA;AA3gBF;;AA8gBA;EACE,aAAA;AA3gBF;;AA8gBA;EACE,cAAA;EACA,gBAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AA3gBF;;AA8gBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;AA3gBF;;AA8gBA;;EAEE,gBAAA;EACA,cAAA;AA3gBF;;AA8gBA;EACE,WAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,WAAA;AA3gBF;;AA8gBA;EACE,iBAAA;AA3gBF;;AA8gBA;;;EAGE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;AA3gBF;;AA8gBA;EACE,YAAA;EACA,mBAAA;AA3gBF;;AA8gBA;EACE,2BAAA;AA3gBF;;AA8gBA;EACE,gBAAA;EACA,WAAA;AA3gBF;;AA8gBA;;EAEE,WAAA;AA3gBF;;AA8gBA;EACE,UAAA;EACA,WAAA;AA3gBF;;AA8gBA;EACE,WAAA;AA3gBF;;AA8gBA;EACE,WAAA;EACA,sBAAA;AA3gBF;;AA8gBA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AA3gBF;;AA8gBA;EACE,yDAAA;EACA,6BAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;EACA,kBAAA;EAEA,4BAAA;EACA,0BAAA;EACA,0BAAA;AA5gBF;;AA+gBA;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,WAAA;AA5gBF;;AA+gBA;;EAEE,eAAA;EACA,YAAA;EACA,gBAAA;AA5gBF;;AA+gBA;EACE,yBAAA;AA5gBF;;AA+gBA;EACE,WAAA;EACA,YAAA;AA5gBF;;AA+gBA;;EAEE,UAAA;EACA,gBAAA;AA5gBF;;AA+gBA;EACE,sBAAA;AA5gBF;;AA+gBA;EACE,WAAA;AA5gBF;;AA+gBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,cAAA;AA5gBF;;AA+gBA;EACE,gBAAA;AA5gBF;;AA+gBA;EACE,gBAAA;EACA,eAAA;AA5gBF;;AA+gBA;EACE,uBAAA;EACA,cAAA;AA5gBF;;AA+gBA;EACE,+DAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AA5gBF;;AA+gBA;EACE,uBAAA;EACA,cAAA;AA5gBF;;AA+gBA;EACE,YAAA;EACA,oBAAA;AA5gBF;;AA+gBA;EACE,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AA5gBF;;AA+gBA;EACE,kBAAA;AA5gBF;;AA+gBA;;EAEE,gBAAA;EACA,eAAA;EACA,cAAA;AA5gBF;;AA+gBA;EACE,aAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,yDAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;AA5gBF;;AA+gBA;EACE,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;AA5gBF;;AA+gBA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA5gBF;;AA+gBA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,sBAAA;EACA,gBAAA;AA5gBF;;AA+gBA;EACE,kBAAA;AA5gBF;;AA+gBA,iCAAA;AACA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;AA5gBF;;AA+gBA;EACE,aAAA;AA5gBF;;AA+gBA;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AA5gBF;;AA+gBA;EACE,iBAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,oCAAA;AA5gBF;;AA+gBA;;EAEE,yBAAA;AA5gBF;;AA+gBA,UAAA;AACA;EACE,UAAA;EACA,WAAA;AA5gBF;;AA+gBA,UAAA;AACA;EACE,mBAAA;EACA,mBAAA;AA5gBF;;AA+gBA,WAAA;AACA;EACE,mBAAA;EACA,mBAAA;AA5gBF;;AA+gBA,oBAAA;AACA;EACE,gBAAA;AA5gBF;;AA+gBA;EACE,6BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AA5gBF;;AA+gBA;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;AA5gBF;;AA+gBA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,UAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,UAAA;EACA,mBAAA;AA5gBF;;AA+gBA;EACE,kBAAA;AA5gBF;;AA+gBA;EACE,4BAAA;EACA,oCAAA;AA5gBF;;AA+gBA;EACE,kBAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;;EAEE,UAAA;AA5gBF;;AA+gBA;;EAEE,UAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;EACE,UAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;EACE,gBAAA;AA5gBF;;AA+gBA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,0BAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,8BAAA;EACA,gCAAA;AA5gBF;;AA+gBA;EACE,8BAAA;EACA,gCAAA;AA5gBF;;AA+gBA;EACE,WAAA;AA5gBF;;AA+gBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,gBAAA;EACA,sBAAA;AA5gBF;;AA+gBA;EACE,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AA5gBF;;AA+gBA;EACE,0BAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBAAA;AA5gBF;;AA+gBA;EACE,yBAAA;AA5gBF;;AA+gBA;EACE,sBAAA;EACA,4CAAA;EACA,oDAAA;AA5gBF;;AA+gBA;EACE,yBAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AA5gBF;;AA+gBA;EACE,UAAA;AA5gBF;;AA+gBA;EACE,UAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,UAAA;EACA,iBAAA;AA5gBF;;AA+gBA;EACE,WAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA5gBF;;AA+gBA;EACE,gBAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,WAAA;AA5gBF;;AA+gBA;EACE,gBAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;AA5gBF;;AA+gBA;EACE,eAAA;EACA,iBAAA;AA5gBF;;AA+gBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA5gBF;;AA+gBA;EACE,kBAAA;AA5gBF;;AA+gBA;EACE,mBAAA;EACA,oCAAA;EACA,kSAAA;AA5gBF;;AAohBA;EACE,qCAAA;AAjhBF;;AAohBA;EACE,aAAA;AAjhBF;;AAohBA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAjhBF;;AAohBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AAjhBF;;AAohBA;EACE,gBAAA;AAjhBF;;AAwhBA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AArhBF;;AAwhBA;EACE,mBAAA;EACA,kBAAA;AArhBF;;AAwhBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AArhBF;;AAwhBA;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AArhBF;;AAwhBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AArhBF;;AAwhBA;EACE,WAAA;EACA,eAAA;AArhBF;;AAwhBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AArhBF;;AAwhBA;EACE,gBAAA;AArhBF;;AAwhBA;EACE,iBAAA;AArhBF;;AAwhBA;EACE,YAAA;EAGA,2CAAA;AArhBF;;AAwhBA;EACE,6BAAA;EACA,WAAA;AArhBF;;AAwhBA;EACE,WAAA;AArhBF;;AAwhBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;AArhBF;;AAwhBA;EACE,eAAA;EACA,iBAAA;AArhBF;;AAwhBA;EACE,WAAA;EACA,yBAAA;EACA,uBAAA;AArhBF;;AAwhBA;EACE,yBAAA;AArhBF;;AAwhBA;EACE,WAAA;AArhBF;;AAwhBA;EACE,WAAA;AArhBF;;AAwhBA;;EAEE,iBAAA;EACA,kBAAA;AArhBF;;AAwhBA;EACE,yBAAA;AArhBF;;AAwhBA;EACE,yBAAA;AArhBF;;AAwhBA;EACE,aAAA;AArhBF;;AAwhBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AArhBF;;AAwhBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AArhBF;;AAwhBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArhBF;;AAwhBA,0BAAA;AAEA;EACE,gBAAA;AAthBF;;AAyhBA;EACE,WAAA;EACA,yBAAA;EACA,oBAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,yBAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,qBAAA;AAthBF;;AAyhBA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AAthBF;;AAyhBA;EACE,YAAA;EACA,gBAAA;AAthBF;;AAyhBA;EACE,YAAA;AAthBF;;AAyhBA;EACE,mBAAA;AAthBF;;AAyhBA;EACE,aAAA;AAthBF;;AAyhBA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAthBF;;AAyhBA;EACE,mBAAA;EACA,kBAAA;AAthBF;;AAyhBA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AAthBF;;AAyhBA;EACE,kBAAA;AAthBF;;AAyhBA;EACE,WAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,8BAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;AAthBF;;AAyhBA;EACE,WAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,yBAAA;AAthBF;;AAyhBA;EACE,2BAAA;AAthBF;;AAyhBA;EACE,YAAA;AAthBF;;AAyhBA;EACE,mBAAA;AAthBF;;AAyhBA;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAthBF;;AAyhBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAthBF;;AAyhBA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAthBF;;AAyhBA;EACE,WAAA;AAthBF;;AAyhBA;EACE,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAthBF;;AAyhBA;EACE,mBAAA;AAthBF;;AAyiBA;EACE,WAAA;AAtiBF;;AAyiBA;EACE,WAAA;AAtiBF;;AAyiBA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAtiBF;;AAyiBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAtiBF;;AAyiBA;EACE,gBAAA;AAtiBF;;AAyiBA;EACE,6BAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AAtiBF;;AAyiBA;EACE,gCAAA;AAtiBF;;AAyiBA;EACE,oGAAA;EAKA,4GAAA;EAKA,gEAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AA9iBF;;AAijBA;EACE,6BAAA;AA9iBF;;AAijBA;EACE,UAAA;AA9iBF;;AAijBA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;AA9iBF;;AAmjBA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AAhjBF;;AAmjBA;EACE,kBAAA;AAhjBF;;AAmjBA;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AAhjBF;;AAmjBA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,oGAAA;EAKA,4GAAA;EAKA,gEAAA;EACA,gBAAA;EACA,mBAAA;AAzjBF;;AA4jBA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAzjBF;;AA4jBA;EACE,6BAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;EACA,gCAAA;EAEA,gBAAA;AA1jBF;;AA6jBA;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,UAAA;EACA,kBAAA;AA1jBF;;AA6jBA;EACE,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA1jBF;;AA6jBA;EACE,UAAA;EACA,mBAAA;AA1jBF;;AA6jBA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA1jBF;;AA6jBA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AA1jBF;;AA6jBA;EACE,gBAAA;AA1jBF;;AA6jBA;EACE,6BAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;EACA,gCAAA;AA1jBF;;AA6jBA;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,UAAA;EACA,kBAAA;AA1jBF;;AA6jBA;EACE,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA1jBF;;AA6jBA;EACE,UAAA;EACA,mBAAA;AA1jBF;;AA+jBA,2BAAA;AAEA;EACE,6BAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,oCAAA;EACA,gBAAA;AA7jBF;;AAgkBA;EACE,gCAAA;AA7jBF;;AAgkBA;EACE,oGAAA;EAKA,4GAAA;EAKA,gEAAA;EACA,gBAAA;EACA,mBAAA;AArkBF;;AAwkBA;EACE,6BAAA;EACA,gBAAA;AArkBF;;AAwkBA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;AArkBF;;AAwkBA;EACE,gBAAA;EACA,mBAAA;AArkBF;;AAwkBA;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;AArkBF;;AAwkBA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AArkBF;;AAwkBA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AArkBF;;AAwkBA;EACE,yBAAA;AArkBF;;AAwkBA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArkBF;;AAwkBA;EACE,gBAAA;AArkBF;;AAwkBA;EACE,gBAAA;EACA,YAAA;AArkBF;;AAwkBA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;AArkBF;;AAwkBA;EACE,gBAAA;AArkBF;;AAwkBA;EACE,cAAA;AArkBF;;AAwkBA;EACE,cAAA;AArkBF;;AAwkBA;EACE,cAAA;AArkBF;;AAwkBA;EACE,cAAA;AArkBF;;AAwkBA;EACE,wBAAA;EACA,gCAAA;AArkBF;;AAwkBA;EACE,oBAAA;AArkBF;;AAwkBA;EAGE,eAAA;EACA,WAAA;AAvkBF;;AA0kBA;EACE,6BAAA;EACA,WAAA;EACA,YAAA;AAvkBF;;AAykBA;EACE,WAAA;AAtkBF;;AAykBA;EACE,WAAA;AAtkBF;;AAykBA;EAEE,yBAAA;EAGA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAzkBF;;AA4kBA;EAEE,yBAAA;EAEA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AA3kBF;;AA8kBA;EACE,aAAA;AA3kBF;;AA8kBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AA3kBF;;AA8kBA;EACE,oBAAA;AA3kBF;;AA8kBA;EACE,WAAA;EACA,gBAAA;AA3kBF;;AA8kBA;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AA3kBF;;AA8kBA;EACE,eAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA3kBF;;AA8kBA;EACE,YAAA;EACA,YAAA;AA3kBF;;AA8kBA;EACE,gBAAA;AA3kBF;;AA8kBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AA3kBF;;AA8kBA;EACE,YAAA;EACA,WAAA;AA3kBF;;AA8kBA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA3kBF;;AA8kBA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AA3kBF;;AA8kBA;EACE,WAAA;AA3kBF;;AA8kBA;EACE,WAAA;AA3kBF;;AA8kBA;EACE,kBAAA;AA3kBF;;AA8kBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;AA3kBF;;AA8kBA;EACE,aAAA;AA3kBF;;AA8kBA;EACE,cAAA;AA3kBF;;AA8kBA;EACE,aAAA;EACA,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;AA3kBF;;AA8kBA;EACE,aAAA;EACA,mBAAA;EACA,qDAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;AA3kBF;;AA8kBA;EACE,gBAAA;EACA,eAAA;AA3kBF;;AA8kBA;EACE,WAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA3kBF;;AA8kBA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AA3kBF;;AA8kBA;EACE,YAAA;EACA,WAAA;AA3kBF;;AA8kBA;EACE,cAAA;AA3kBF;;AA8kBA;EACE,kBAAA;AA3kBF;;AA8kBA;EACE,WAAA;AA3kBF;;AA8kBA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA3kBF;;AA8kBA;EACE,SAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AA3kBF;;AA8kBA;EACE,yBAAA;AA3kBF;;AA8kBA;EACE,yBAAA;AA3kBF;;AA8kBA;EACE,yBAAA;AA3kBF;;AA8kBA;EACE,gBAAA;AA3kBF;;AA8kBA;EACE,gBAAA;AA3kBF;;AA8kBA;EACE,WAAA;EACA,oBAAA;AA3kBF;;AA8kBA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;AA3kBF;;AA8kBA;EACE,WAAA;AA3kBF;;AA8kBA;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AA3kBF;;AA8kBA;EACE,gBAAA;EACA,WAAA;AA3kBF;;AA8kBA;EACE,oBAAA;EACA,mBAAA;EACA,iCAAA;AA3kBF;;AA8kBA;EACE,WAAA;AA3kBF;;AA8kBA;;;EAGE,kBAAA;AA3kBF;;AA8kBA;EACE,cAAA;EACA,eAAA;AA3kBF;;AA8kBA;EACE,oBAAA;AA3kBF;;AA8kBA;EACE,aAAA;EACA,mBAAA;AA3kBF;;AA8kBA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AA3kBF;;AA8kBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;AA3kBF;;AA8kBA;EACE,gBAAA;AA3kBF;;AA8kBA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AA3kBF;;AA8kBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AA3kBF;;AA8kBA;EACE,UAAA;AA3kBF;;AA8kBA;EACE,gCAAA;AA3kBF;;AA8kBA;EACE,mBAAA;AA3kBF;;AA8kBA;EACE,eAAA;AA3kBF;;AA8kBA,yBAAA;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AA5kBF;;AA+kBA;EACE,sBAAA;AA5kBF;;AA+kBA;;GAAA;AAGA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA5kBF;;AA+kBA;EACE,gCAAA;EACA,cAAA;EACA,gBAAA;AA5kBF;;AA+kBA;EACE,cAAA;AA5kBF;;AA+kBA;EACE,cAAA;AA5kBF;;AAilBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AA9kBF;;AAilBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;AA9kBF;;AAilBA;EACE,UAAA;AA9kBF;;AAilBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA9kBF;;AAilBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA9kBF;;AAilBA;;EAEE,eAAA;EACA,cAAA;EACA,WAAA;AA9kBF;;AAilBA;EACE,aAAA;AA9kBF;;AAilBA;EACE,WAAA;AA9kBF;;AAilBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA9kBF;;AAilBA,mBAAA;AAEA,8BAAA;AAEA,4CAAA;AAEA;EACE,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAjlBF;;AAolBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAjlBF;;AAolBA;EACE,aAAA;AAjlBF;;AAolBA;EACE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAjlBF;;AAolBA,oBAAA;AACA;EACE,yBAAA;AAjlBF;;AAolBA;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;AAjlBF;;AAolBA,qBAAA;AAEA;EACE,WAAA;AAllBF;;AAqlBA;;;KAAA;AAKA,sBAAA;AAEA;EACE;IACE,mBAAA;EAplBF;EAulBA;IACE,qBAAA;EArlBF;EAwlBA;IACE,mBAAA;EAtlBF;AACF;AAylBA,2BAAA;AAEA;EACE,WAAA;EACA,aAAA;EACA,oBAAA;EACA,wBAAA;AAxlBF;;AA2lBA;EACE,aAAA;EACA,kBAAA;AAxlBF;;AA2lBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,uDAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AAxlBF;;AA2lBA;EACE,YAAA;EACA,WAAA;AAxlBF;;AA2lBA;EACE,YAAA;EACA,WAAA;AAxlBF;;AA2lBA;EACE,mBAAA;EACA,0DAAA;AAxlBF;;AA2lBA;EACE,OAAA;EACA,kBAAA;EACA,mBAAA;EACA,0DAAA;EACA,WAAA;AAxlBF;;AA2lBA;EACE,cAAA;AAxlBF;;AA2lBA;EACE,yBAAA;AAxlBF;;AA2lBA;;;;;;GAAA;AAQA;EACE,yBAAA;EACA,mBAAA;AAzlBF;;AA4lBA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;AAzlBF;;AA4lBA;EACE,cAAA;AAzlBF;;AA4lBA;EACE,8BAAA;AAzlBF;;AA4lBA;EACE,iBAAA;AAzlBF;;AA4lBA;EACE,iBAAA;EACA,oBAAA;AAzlBF;;AA4lBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAzlBF;;AA4lBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAzlBF;;AA4lBA;EACE,mCAAA;AAzlBF;;AA4lBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EAEA,eAAA;AA1lBF;;AA6lBA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AA1lBF;;AAwmBA;EAEE,YAAA;EACA,kBAAA;EACA,yBAAA;AAtmBF;;AA+mBA;EACE,WAAA;EACA,cAAA;AA5mBF;;AA+mBA;EACE,6BAAA;EACA,WAAA;AA5mBF;;AA+mBA;EACE,6BAAA;AA5mBF;;AA+mBA;EACE,gBAAA;EACA,6BAAA;EACA,yBAAA;AA5mBF;;AA+mBA;EACE,wBAAA;AA5mBF;;AA+mBA;EACE,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;AA5mBF;;AA+mBA;EACE,QAAA;EACA,SAAA;EACA,aAAA;AA5mBF;;AA+mBA;EACE,sBAAA;AA5mBF;;AA+mBA;;EAEE,aAAA;AA5mBF;;AA+mBA;EACE,uBAAA;AA5mBF;;AA+mBA;EACE,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,wBAAA;AA5mBF;;AA+mBA;EACE,QAAA;AA5mBF;;AA+mBA;EACE,WAAA;AA5mBF;;AA+mBA;EACE,WAAA;EACA,oBAAA;AA5mBF;;AA+mBA;EACE,oBAAA;EACA,cAAA;AA5mBF;;AA+mBA;EACE,4BAAA;EACA,cAAA;AA5mBF;;AA+mBA;EACE,wBAAA;EACA,cAAA;AA5mBF;;AA+mBA;EACE,0BAAA;EACA,cAAA;AA5mBF;;AA+mBA;EACE,WAAA;EACA,yBAAA;EACA,mDAAA;AA5mBF;;AA+mBA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AA5mBF;;AA+mBA;EACE,mBAAA;AA5mBF;;AA+mBA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;AA5mBF;;AA+mBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AA5mBF;;AA+mBA;;EAEE,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AA5mBF;;AA+mBA;EACE,YAAA;EACA,WAAA;EACA,WAAA;AA5mBF;;AA+mBA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA5mBF;;AA+mBA;EACE,yBAAA;AA5mBF;;AA+mBA;EACE,yBAAA;AA5mBF;;AA+mBA;EACE,WAAA;AA5mBF;;AA+mBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AA5mBF;;AA+mBA;EACE,WAAA;AA5mBF;;AA+mBA;EACE,mBAAA;AA5mBF;;AA+mBA;EACE,mDAAA;EACA,yBAAA;EACA,yBAAA;AA5mBF;;AA+mBA;EACE,aAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA5mBF;;AA+mBA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;AA5mBF;;AA+mBA;EACE,WAAA;EACA,mBAAA;AA5mBF;;AA+mBA;EACE,UAAA;AA5mBF;;AA+mBA;EACE,mBAAA;AA5mBF;;AA+mBA;EACE,6BAAA;EACA,WAAA;AA5mBF;;AA+mBA,oBAAA;AAEA;EACE,+EAAA;EAGA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AA/mBF;;AAknBA;EACE,cAAA;EACA,eAAA;AA/mBF;;AAunBA;EACE,oCAAA;EACA,sBAAA;EACA,kBAAA;AApnBF;;AAunBA;EACE,kBAAA;AApnBF;;AAunBA;EACE,+EAAA;EAGA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAtnBF;;AAynBA;EACE,aAAA;AAtnBF;;AAynBA;EACE,iBAAA;AAtnBF;;AAynBA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;AAtnBF;;AAynBA;EACE,cAAA;EACA,gBAAA;AAtnBF;;AAynBA;EACE,UAAA;EACA,cAAA;AAtnBF;;AAynBA;EACE,cAAA;AAtnBF;;AAynBA;EACE,eAAA;AAtnBF;;AAynBA;EACE,8DAAA;AAtnBF;;AAwnBA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AArnBF;;AAwnBA;EACE,eAAA;AArnBF;;AAwnBA;EACE,eAAA;AArnBF;;AAwnBA;EACE,eAAA;AArnBF;;AAwnBA;EACE,kBAAA;EACA,iBAAA;EACA,iCAAA;AArnBF;;AAwnBA;EACE,iCAAA;AArnBF;;AAwnBA;EACE,aAAA;AArnBF;;AAwnBA;EACE,mBAAA;AArnBF;;AAwnBA;EACE,gBAAA;AArnBF;;AAwnBA;EACE,wBAAA;AArnBF;;AAwnBA;EACE,YAAA;EACA,WAAA;AArnBF;;AAwnBA;EACE,0BAAA;AArnBF;;AAwnBA;EACE,UAAA;AArnBF;;AAwnBA;;;;;;;;GAAA;AAUA;;EAEE,WAAA;AAtnBF;;AAynBA,qBAAA;AAEA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAvnBF;;AA0nBA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;AAvnBF;;AA0nBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAvnBF;;AA0nBA;EACE,oCAAA;AAvnBF;;AA0nBA;EACE,iCAAA;AAvnBF;;AA0nBA;EACE,oCAAA;AAvnBF;;AA0nBA;EACE,gBAAA;AAvnBF;;AA0nBA;EACE,eAAA;EACA,iBAAA;AAvnBF;;AA0nBA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAvnBF;;AA0nBA;EACE,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;AAvnBF;;AA0nBA;EACE,aAAA;AAvnBF;;AA0nBA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,aAAA;AAvnBF;;AA0nBA;EACE,yBAAA;EACA,yBAAA;AAvnBF;;AA0nBA;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAvnBF;;AA0nBA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AAvnBF;;AA0nBA;EACE,yBAAA;EACA,WAAA;AAvnBF;;AA0nBA;EACE,yBAAA;AAvnBF;;AA0nBA;EACE,kBAAA;AAvnBF;;AA0nBA;EACE,eAAA;EACA,WAAA;AAvnBF;;AA0nBA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAvnBF;;AA0nBA;EACE,WAAA;EACA,UAAA;AAvnBF;;AA0nBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAvnBF;;AA0nBA;EACE,mBAAA;AAvnBF;;AA0nBA;EACE,sBAAA;AAvnBF;;AA0nBA;EACE,cAAA;AAvnBF;AAynBE;EACE,aAAA;EACA,qCAAA;AAvnBJ;;AA2nBA;EACE,mBAAA;AAxnBF;;AA2nBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAxnBF;;AA2nBA;EACE,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;AAxnBF;;AA2nBA;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;AAxnBF;;AA2nBA;EACE,UAAA;AAxnBF;;AA2nBA;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AAxnBF;;AA2nBA;EACE,kBAAA;AAxnBF;;AA6nBA;EACE,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA1nBF;;AA6nBA;EACE,gBAAA;AA1nBF;;AA6nBA;EACE,kBAAA;AA1nBF;;AA6nBA;EACE,kBAAA;AA1nBF;;AA6nBA;EACE,6BAAA;AA1nBF;;AA6nBA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA1nBF;;AA6nBA;EACE,gBAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AA1nBF;;AA6nBA;EACE,cAAA;AA1nBF;;AA6nBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA1nBF;;AA6nBA;EACE,sBAAA;AA1nBF;;AA6nBA;EACE,uBAAA;EACA,8BAAA;EACA,8BAAA;AA1nBF;;AA4nBA;EACE,cAAA;EACA,WAAA;AAznBF;;AA2nBA;EACE,UAAA;AAxnBF;;AA0nBA;EACE,sBAAA;AAvnBF;;AA0nBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAvnBF;;AA0nBA;EACE,kBAAA;AAvnBF;;AA0nBA;EACE,kBAAA;AAvnBF;;AA0nBA;EACE,iBAAA;AAvnBF;;AA0nBA;EACE,kBAAA;AAvnBF;;AA0nBA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AAvnBF;;AA0nBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AAvnBF;;AA0nBA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,kBAAA;AAvnBF;;AA0nBA;EACE,kCAAA;EACA,WAAA;AAvnBF;;AA0nBA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;AAvnBF;;AA0nBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAvnBF;;AA0nBA;EACE,WAAA;AAvnBF;;AA0nBA;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AAvnBF;;AA8nBA;EACE,aAAA;AA3nBF;;AA8nBA;EACE,aAAA;AA3nBF;;AA8nBA;EACE,kBAAA;AA3nBF;;AA8nBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;AA3nBF;;AA8nBA,QAAA;AAEA;EACE,kBAAA;AA5nBF;;AAooBA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;AAjoBF;;AAqoBA;;EAEE,0BAAA;AAloBF;;AAqoBA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AAloBF;;AAqoBA;;;;;;EAME,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAloBF;;AAqoBA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAloBF;;AAqoBA;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;AAloBF;;AAqoBA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,qCAAA;EACA,UAAA;EACA,2BAAA;EACA,oBAAA;EACA,6BAAA;AAloBF;;AAqoBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;AAloBF;;AAqoBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAloBF;;AAqoBA;EACE,eAAA;AAloBF;;AAqoBA;EACE,UAAA;AAloBF;;AAqoBA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AAloBF;;AAqoBA;EACE,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAloBF;;AAqoBA;EACE,aAAA;AAloBF;;AA+oBA;EACE,YAAA;AA5oBF;;AA+oBA;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;AA5oBF;;AA+oBA;;EAEE,UAAA;AA5oBF;;AA+oBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AA5oBF;;AA+oBA;EACE,6BAAA;AA5oBF;;AA+oBA;EACE,aAAA;EACA,UAAA;AA5oBF;;AA+oBA;EACE,aAAA;EACA,UAAA;AA5oBF;;AA+oBA;EACE,6CAAA;AA5oBF;;AA+oBA;EACE,mBAAA;AA5oBF;;AA+oBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA5oBF;;AA+oBA;EACE,gBAAA;EACA,WAAA;AA5oBF;;AA+oBA;EACE,YAAA;AA5oBF;;AA+oBA;;EAEE,YAAA;AA5oBF;;AA+oBA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AA5oBF;;AA+oBA;EACE,uBAAA;EACA,mBAAA;AA5oBF;;AA+oBA;EACE,aAAA;AA5oBF;;AA8oBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;AA3oBF;;AA6oBA;EACE,aAAA;AA1oBF;;AA6oBA;EACE,mBAAA;AA1oBF;;AA6oBA;EACE,aAAA;AA1oBF;;AA6oBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AA1oBF;;AA6oBA;EACE,iBAAA;AA1oBF;;AA6oBA;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AA1oBF;;AA6oBA;EACE,UAAA;EACA,oGAAA;EAKA,4GAAA;EAKA,gEAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAlpBF;;AAqpBA;EACE,UAAA;AAlpBF;;AAqpBA;EACE,gBAAA;EACA,mBAAA;AAlpBF;;AAqpBA;EACE,gBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;AAlpBF;;AAqpBA;EACE,SAAA;EACA,mBAAA;AAlpBF;;AAqpBA;EACE,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;AAlpBF;;AAqpBA;EACE,eAAA;AAlpBF;;AAqpBA;;EAEE,WAAA;EACA,eAAA;AAlpBF;;AAwpBA;EACE,6BAAA;AArpBF;;AAwpBA;EACE,gCAAA;AArpBF;;AAwpBA;EACE,kBAAA;AArpBF;;AAwpBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;AArpBF;;AAwpBA;EACE,UAAA;EACA,4BAAA;AArpBF;;AAwpBA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AArpBF;;AAwpBA;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;AArpBF;;AAwpBA;EACE,6BAAA;EACA,kBAAA;AArpBF;;AAwpBA;EACE,aAAA;EACA,wCAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AArpBF;;AAwpBA;EACE,kBAAA;AArpBF;;AAwpBA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,yBAAA;EACA,mBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,uBAAA;EACA,YAAA;AArpBF;;AAwpBA;EACE,kBAAA;AArpBF;;AAwpBA;EACE,gBAAA;EACA,qBAAA;AArpBF;;AAwpBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AArpBF;;AAwpBA;EACE,WAAA;EACA,eAAA;AArpBF;;AAwpBA;EACE,UAAA;EACA,qCAAA;AArpBF;;AAwpBA;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AArpBF;;AAwpBA;EACE,aAAA;AArpBF;;AAwpBA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;AArpBF;;AAwpBA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;AArpBF;;AAwpBA;EACE,SAAA;AArpBF;;AAwpBA;EACE,UAAA;AArpBF;;AAypBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;AAtpBF;;AAypBA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAtpBF;;AAypBA;EACE,mBAAA;AAtpBF;;AAypBA;EACE,eAAA;AAtpBF;;AAypBA;EACE,mBAAA;AAtpBF;;AAypBA;EACE,yBAAA;AAtpBF;;AAypBA;EACE,kBAAA;AAtpBF;;AAypBA;;;;EAIE,mBAAA;AAtpBF;;AAypBA;EACE,mBAAA;AAtpBF;;AAypBA;;EAEE,oBAAA;AAtpBF;;AAypBA;EACE,sBAAA;AAtpBF;;AAypBA;EACE,WAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;AAtpBF;;AAypBA;EACE,gBAAA;AAtpBF;;AAypBA;EACE,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAtpBF;;AAypBA;EACE,wBAAA;AAtpBF;;AAypBA;EACE,wBAAA;AAtpBF;;AAypBA;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;AAtpBF;;AAypBA;;EAEE,aAAA;AAtpBF;;AAypBA;EACE,kBAAA;AAtpBF;;AAypBA;EACE,oBAAA;AAtpBF;;AAypBA;;EAEE,kBAAA;EACA,aAAA;AAtpBF;;AAypBA;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAtpBF;;AAypBA;;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAtpBF;;AAypBA;EACE,WAAA;EACA,YAAA;AAtpBF;;AAypBA;EACE,yBAAA;AAtpBF;;AAypBA;;EAEE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;AAtpBF;;AAypBA;EACE,UAAA;EAEA,mBAAA;AAtpBF;;AAypBA;EACE,UAAA;EAEA,mBAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAtpBF;;AAypBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,wBAAA;AAtpBF;;AAypBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtpBF;;AAypBA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAtpBF;;AAypBA;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AAtpBF;;AAypBA;EACE,UAAA;AAtpBF;;AAypBA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAtpBF;;AAypBA;EACE,yBAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;AAtpBF;;AAypBA;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AAtpBF;;AAypBA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;AAtpBF;;AAypBA;EACE,YAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,2BAAA;AAtpBF;;AAypBA;EACE,aAAA;EACA,qBAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAtpBF;;AAypBA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAtpBF;;AAypBA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,oCAAA;EACA,iCAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,YAAA;AAtpBF;;AAypBA;EACE,cAAA;AAtpBF;;AAypBA;EACE,aAAA;AAtpBF;;AAypBA;EACE,aAAA;AAtpBF;;AAwpBA;EACE,WAAA;AArpBF;;AAupBA;EACE,WAAA;AAppBF;;AAupBA;EACE,gBAAA;AAppBF;;AAupBA;EACE,iBAAA;AAppBF;;AAspBA;EACE,8BAAA;EACA,WAAA;EACA,oCAAA;AAnpBF;;AAqpBA;EACE,UAAA;AAlpBF;;AAopBA;EACE,WAAA;AAjpBF;;AAmpBA;EACE,iBAAA;AAhpBF;;AAkpBA;EACE,UAAA;AA/oBF;;AAipBA;EACE,WAAA;EACA,aAAA;AA9oBF;;AAgpBA;EACE,aAAA;AA7oBF;;AA+oBA;EACE,mBAAA;EACA,oCAAA;EACA,kSAAA;EACA,WAAA;EACA,aAAA;AA5oBF;;AAgpBA;EACE;IACE,cAAA;EA7oBF;EAgpBA;IACE,gBAAA;EA9oBF;EAipBA;IACE,wBAAA;EA/oBF;EAkpBA;IACE,kBAAA;IACA,aAAA;EAhpBF;EAmpBA;IACE,uBAAA;EAjpBF;EAopBA;IACE,aAAA;EAlpBF;EAqpBA;IACE,eAAA;IACA,WAAA;EAnpBF;EAspBA;IACE,gBAAA;EAppBF;AACF;AA2pBA,8CAAA;AACA;EACE,kBAAA;AAzpBF;;AA+pBA;EACE,SAAA;EACA,iCAAA;AA5pBF;;AA+pBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;AA5pBF;;AA+pBA;EAEE,UAAA;AA7pBF;;AAgqBA,uBAAA;AACA;EACE,aAAA;EACA,2BAAA;AA7pBF;;AAgqBA,8CAAA;AACA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;EA7pBF;EAgqBA;IACE,aAAA;EA9pBF;EAiqBA;IACE,sBAAA;IACA,uCAAA;EA/pBF;EAkqBA;IACE,UAAA;IACA,wBAAA;IACA,WAAA;IACA,yBAAA;EAhqBF;EAmqBA;IACE,aAAA;IACA,qBAAA;IACA,kBAAA;IACA,uCAAA;IACA,WAAA;IACA,QAAA;EAjqBF;EAoqBA;IACE,cAAA;IACA,mBAAA;IACA,kBAAA;IACA,QAAA;IACA,2BAAA;IACA,WAAA;IACA,YAAA;IACA,0CAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,eAAA;EAlqBF;EAqqBA;IACE,OAAA;IACA,6BAAA;IACA,gCAAA;EAnqBF;EAsqBA;IACE,QAAA;IACA,4BAAA;IACA,+BAAA;EApqBF;AACF","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/* 0.1. Body / Typography\r\n   ========================================================================== */\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\r\n\r\nbody {\r\n  font-family: 'Inter', sans-serif;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n  color: #71748d;\r\n  padding: 0px !important;\r\n  background-color: #eeeeee;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  color: #479573;\r\n  margin: 0px 0px 15px 0px;\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\nh1 {\r\n  font-size: 34px;\r\n}\r\n\r\nh2 {\r\n  font-size: 28px;\r\n  line-height: 30px;\r\n}\r\n\r\nh3 {\r\n  font-size: 20px;\r\n}\r\n\r\nh4 {\r\n  font-size: 16px;\r\n  line-height: 26px;\r\n}\r\n\r\nh5 {\r\n  font-weight: 700 !important;\r\n  font-size: 14px !important;\r\n  line-height: 17px !important;\r\n  text-transform: uppercase !important;\r\n}\r\n\r\nh5 span {\r\n  color: #ffb31f !important;\r\n}\r\n\r\nh6 {\r\n  font-size: 12px;\r\n}\r\n\r\np {\r\n  margin: 0px 0px 20px 0px;\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\np:last-child {\r\n  margin: 0px;\r\n}\r\n\r\na {\r\n  color: #71748d;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n}\r\n\r\n::placeholder {\r\n  color: #000;\r\n  font-weight: 400;\r\n}\r\n\r\n::-moz-placeholder {\r\n  color: #000;\r\n  font-weight: 400;\r\n}\r\n\r\n::-webkit-input-placeholder {\r\n  color: #000;\r\n  font-weight: 400;\r\n}\r\n\r\na:hover {\r\n  color: #ff407b;\r\n  text-decoration: none;\r\n}\r\n\r\na:active,\r\na:hover {\r\n  outline: 0;\r\n  text-decoration: none;\r\n}\r\n\r\nol,\r\nul {}\r\n\r\nol li,\r\nul li {}\r\n\r\n.lead {\r\n  font-size: 1.25rem;\r\n  font-weight: 300;\r\n  color: #3d3f5d;\r\n}\r\n\r\n/*--------------------\r\n Form\r\n---------------------*/\r\n\r\nlabel {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  margin-bottom: 5px;\r\n  font-size: 15px;\r\n  color: #71748d;\r\n}\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  font-size: 14px;\r\n  line-height: 1.42857143;\r\n  color: #000;\r\n  background-color: #fff;\r\n  background-image: none;\r\n  border: 1px solid #d2d2e4;\r\n  border-radius: 2px;\r\n}\r\n\r\n.form-control:focus {\r\n  color: #000000;\r\n  background-color: #fff;\r\n  border-color: transparent;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\ninput[type='file'] {\r\n  color: #71748d;\r\n  background-color: #fff;\r\n  border-color: #a7a7f0;\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(214, 214, 255, 0.75);\r\n}\r\n\r\n.col-form-label {\r\n  font-size: 15px;\r\n}\r\n\r\ninput {}\r\n\r\nbutton {}\r\n\r\nbutton:focus {\r\n  outline: 0;\r\n}\r\n\r\nselect.form-control {\r\n  color: #71748d;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  background-position: 99% 52%;\r\n  background-size: auto;\r\n  background-repeat: no-repeat;\r\n  //background-image: url(../images/down-arrow.png);\r\n  padding-right: 15px;\r\n  border: 1px solid #d2d2e4;\r\n  border-radius: 2px;\r\n}\r\n\r\ntextarea.form-control {\r\n  height: auto;\r\n  color: #71748d;\r\n  background-color: #fff;\r\n  background-image: none;\r\n  border: 1px solid #d2d2e4;\r\n  border-radius: 2px;\r\n  padding: 12px 16px;\r\n}\r\n\r\ninput::-webkit-input-placeholder {\r\n  color: #71748d !important;\r\n}\r\n\r\ninput:focus::-webkit-input-placeholder {\r\n  color: #71748d !important;\r\n}\r\n\r\ntextarea::-webkit-input-placeholder {\r\n  color: #71748d !important;\r\n}\r\n\r\ntextarea:focus::-webkit-input-placeholder {\r\n  color: #71748d !important;\r\n}\r\n\r\nbutton.btn {}\r\n\r\nbutton.btn-default {}\r\n\r\nbutton.btn-primary {}\r\n\r\naddress {}\r\n\r\n.form-group {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.form-control-lg {\r\n  padding: 12px;\r\n}\r\n\r\n/* Custom-Chekbox\r\n-------------------------------------------------------------- */\r\n\r\n.custom-control {\r\n  position: relative;\r\n  min-height: 1.5rem;\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.custom-control-input:checked~input[type='checkbox'] {\r\n  background: #3d404e;\r\n  border: #7f83a2 1px solid;\r\n}\r\n\r\n.custom-control-input {\r\n  position: absolute;\r\n  z-index: -1;\r\n  opacity: 0;\r\n}\r\n\r\n.custom-control-label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::before {\r\n  background-color: #5969ff;\r\n  border-color: #5969ff;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n  color: #fff;\r\n  background-color: #5969ff;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {}\r\n\r\n.custom-control-label::after {\r\n  position: absolute;\r\n  top: 7px;\r\n  left: 0;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  content: '';\r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  background-size: 50% 50%;\r\n}\r\n\r\n.custom-control-label::before {\r\n  position: absolute;\r\n  top: 7px;\r\n  left: 0;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  pointer-events: none;\r\n  content: '';\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  background-color: #ffffff;\r\n  border: 2px solid #d2d2e4;\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n  background-color: #5969ff;\r\n  border-color: #5969ff;\r\n}\r\n\r\n.custom-control-input:disabled~.custom-control-label::before {\r\n  background-color: #efeff6;\r\n}\r\n\r\n.custom-select-font-size {\r\n  font-size: 14px;\r\n}\r\n\r\n.custom-control-input:focus~.custom-control-label::before {\r\n  box-shadow: none;\r\n}\r\n\r\n.custom-valid.custom-control-input.is-valid:checked~.custom-control-label::before,\r\n.was-validated .custom-control-input:valid:checked~.custom-control-label::before {\r\n  background-color: #34ce57;\r\n  border-color: #34ce57;\r\n}\r\n\r\n.custom-control-input.is-invalid~.custom-control-label::before,\r\n.was-validated .custom-control-input:invalid~.custom-control-label::before {\r\n  background-color: #ffdadd;\r\n  border-color: #efa2a9;\r\n}\r\n\r\n.custom-control-input:disabled~.custom-control-label {\r\n  color: #9295b0;\r\n}\r\n\r\n.custom-control-input.is-valid~.custom-control-label::before,\r\n.was-validated .custom-control-input:valid~.custom-control-label::before {\r\n  background-color: #c6ffd3;\r\n  border: 2px solid #68df83;\r\n}\r\n\r\n.input-group-text {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  padding: 10px;\r\n  margin-bottom: 0;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #75748d;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: #efeff6;\r\n  border: 1px solid #d2d2e4;\r\n  border-radius: 4px;\r\n}\r\n\r\n.section-block {\r\n  margin: 16px 0px;\r\n}\r\n\r\n.section-title {\r\n  font-weight: 500;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled).active,\r\n.btn-primary:not(:disabled):not(.disabled):active,\r\n.show>.btn-primary.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #3e9479 !important;\r\n  border-color: #3e9479 !important;\r\n}\r\n\r\n/*--------------------\r\n Padding / Margin\r\n---------------------*/\r\n\r\n.nopadding {\r\n  padding: 0px;\r\n}\r\n\r\n.p-r-0 {\r\n  padding-right: 0px;\r\n}\r\n\r\n.p-r-10 {\r\n  padding-right: 10px;\r\n}\r\n\r\n.p-r-15 {\r\n  padding-right: 15px;\r\n}\r\n\r\n.p-r-20 {\r\n  padding-right: 20px;\r\n}\r\n\r\n.p-r-25 {\r\n  padding-right: 25px;\r\n}\r\n\r\n.p-l-0 {\r\n  padding-left: 0px;\r\n}\r\n\r\n.p-l-10 {\r\n  padding-left: 10px;\r\n}\r\n\r\n.p-l-15 {\r\n  padding-left: 15px;\r\n}\r\n\r\n.p-l-20 {\r\n  padding-left: 20px;\r\n}\r\n\r\n.p-l-25 {\r\n  padding-left: 25px;\r\n}\r\n\r\n.p-l-40 {\r\n  padding-left: 40px;\r\n}\r\n\r\n.p-t-0 {\r\n  padding-top: 0px;\r\n}\r\n\r\n.p-t-10 {\r\n  padding-top: 10px;\r\n}\r\n\r\n.p-t-20 {\r\n  padding-top: 20px;\r\n}\r\n\r\n.p-t-30 {\r\n  padding-top: 30px;\r\n}\r\n\r\n.p-t-40 {\r\n  padding-top: 40px;\r\n}\r\n\r\n.p-t-60 {\r\n  padding-top: 60px;\r\n}\r\n\r\n.p-t-80 {\r\n  padding-top: 80px;\r\n}\r\n\r\n.p-t-100 {\r\n  padding-top: 100px;\r\n}\r\n\r\n.p-t-120 {\r\n  padding-top: 120px;\r\n}\r\n\r\n.p-t-140 {\r\n  padding-top: 140px;\r\n}\r\n\r\n.p-b-0 {\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.p-b-10 {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.p-b-20 {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.p-b-30 {\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.p-b-40 {\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.p-b-60 {\r\n  padding-bottom: 60px;\r\n}\r\n\r\n.p-b-80 {\r\n  padding-bottom: 80px;\r\n}\r\n\r\n.p-b-100 {\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.p-b-120 {\r\n  padding-bottom: 120px;\r\n}\r\n\r\n.p-b-140 {\r\n  padding-bottom: 140px;\r\n}\r\n\r\n.m-r-0 {\r\n  margin-right: 0px;\r\n}\r\n\r\n.m-r-10 {\r\n  margin-right: 10px;\r\n}\r\n\r\n.m-r-15 {\r\n  margin-right: 15px;\r\n}\r\n\r\n.m-r-20 {\r\n  margin-right: 20px;\r\n}\r\n\r\n.m-r-25 {\r\n  margin-right: 25px;\r\n}\r\n\r\n.m-l-0 {\r\n  margin-left: 0px;\r\n}\r\n\r\n.m-l-10 {\r\n  margin-left: 10px;\r\n}\r\n\r\n.m-l-15 {\r\n  margin-left: 15px;\r\n}\r\n\r\n.m-l-20 {\r\n  margin-left: 20px;\r\n}\r\n\r\n.m-l-25 {\r\n  margin-left: 25px;\r\n}\r\n\r\n.m-t-0 {\r\n  margin-top: 0px;\r\n}\r\n\r\n.m-t-10 {\r\n  margin-top: 10px;\r\n}\r\n\r\n.m-t-20 {\r\n  margin-top: 20px;\r\n}\r\n\r\n.m-t-30 {\r\n  margin-top: 30px;\r\n}\r\n\r\n.m-t-40 {\r\n  margin-top: 40px;\r\n}\r\n\r\n.m-t-60 {\r\n  margin-top: 60px;\r\n}\r\n\r\n.m-t-80 {\r\n  margin-top: 80px;\r\n}\r\n\r\n.m-t-100 {\r\n  margin-top: 100px;\r\n}\r\n\r\n.m-t-120 {\r\n  margin-top: 120px;\r\n}\r\n\r\n.m-b-0 {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.m-b-10 {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.m-b-20 {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.m-b-30 {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.m-b-40 {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.m-b-60 {\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.m-b-80 {\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.m-b-100 {\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.m-b-120 {\r\n  margin-bottom: 120px;\r\n}\r\n\r\n/*--------------------\r\n Font Weight\r\n---------------------*/\r\n\r\nhtml body .font-bold {\r\n  font-weight: 800;\r\n}\r\n\r\nhtml body .font-normal {\r\n  font-weight: 400;\r\n}\r\n\r\nhtml body .font-light {\r\n  font-weight: 300;\r\n}\r\n\r\nhtml body .font-medium {\r\n  font-weight: 600;\r\n}\r\n\r\nhtml body .font-16 {\r\n  font-size: 16px;\r\n}\r\n\r\nhtml body .font-12 {\r\n  font-size: 12px;\r\n}\r\n\r\nhtml body .font-14 {\r\n  font-size: 14px;\r\n}\r\n\r\nhtml body .font-10 {\r\n  font-size: 10px;\r\n}\r\n\r\nhtml body .font-18 {\r\n  font-size: 18px;\r\n}\r\n\r\nhtml body .font-20 {\r\n  font-size: 20px;\r\n}\r\n\r\nhtml body .font-22 {\r\n  font-size: 22px;\r\n}\r\n\r\nhtml body .font-24 {\r\n  font-size: 24px;\r\n}\r\n\r\nhtml body .display-5 {\r\n  font-size: 3rem;\r\n}\r\n\r\nhtml body .display-6 {\r\n  font-size: 2.5rem;\r\n}\r\n\r\nhtml body .display-7 {\r\n  font-size: 2rem;\r\n}\r\n\r\n/*--------------------\r\n Arrow  List\r\n---------------------*/\r\n\r\n.arrow {\r\n  position: relative;\r\n}\r\n\r\n.arrow li {\r\n  padding-left: 20px;\r\n  line-height: 30px;\r\n}\r\n\r\n.arrow li:before {\r\n  font-family: 'Font Awesome\\ 5 Free';\r\n  font-weight: 900;\r\n  display: inline-block;\r\n  position: absolute;\r\n  left: 0;\r\n  font-size: 14px;\r\n  color: #ff407b;\r\n  content: '\\f058';\r\n  font-style: initial;\r\n}\r\n\r\n.bullet-check {\r\n  position: relative;\r\n}\r\n\r\n.bullet-check li {\r\n  padding-left: 25px;\r\n  line-height: 30px;\r\n}\r\n\r\n.bullet-check li:before {\r\n  font-family: 'Font Awesome\\ 5 Free';\r\n  font-weight: 900;\r\n  display: inline-block;\r\n  position: absolute;\r\n  left: 0;\r\n  font-size: 14px;\r\n  color: #22ce77;\r\n  content: '\\f00c';\r\n  font-style: initial;\r\n}\r\n\r\n/*-----------------------\r\nBackground Color / Color\r\n-------------------------*/\r\n\r\n.bg-primary {\r\n  background-color: #5969ff !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.bg-brand {\r\n  background-color: #ffc750 !important;\r\n}\r\n\r\n.bg-secondary {\r\n  background-color: #ff407b !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.bg-success {\r\n  background-color: #2ec551 !important;\r\n}\r\n\r\n.bg-danger {\r\n  background-color: #ef172c !important;\r\n}\r\n\r\n.bg-warning {\r\n  background-color: #ffc108 !important;\r\n}\r\n\r\n.bg-info {\r\n  background-color: #25d5f2 !important;\r\n}\r\n\r\n.bg-light {\r\n  background-color: #f9f9ff !important;\r\n}\r\n\r\n.bg-dark {\r\n  background-color: #2e2f39 !important;\r\n}\r\n\r\n.bg-primary-light {\r\n  background-color: #dbdeff !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.bg-info-light {\r\n  background-color: #dffaff !important;\r\n  color: #fff;\r\n}\r\n\r\n.bg-secondary-light {\r\n  background-color: #ffdbe6 !important;\r\n}\r\n\r\n.bg-danger-light {\r\n  background-color: #fbd3d5 !important;\r\n}\r\n\r\n.bg-brand-light {\r\n  background-color: #fff2d5 !important;\r\n}\r\n\r\n.bg-success-light {\r\n  background-color: #c5fad3 !important;\r\n}\r\n\r\n/*-----------------------\r\nBorders\r\n-------------------------*/\r\n\r\n.border-boxes span {\r\n  display: inline-block;\r\n  width: 5rem;\r\n  height: 5rem;\r\n  margin: 0.25rem;\r\n  background-color: #fbfbfd;\r\n}\r\n\r\n.border {\r\n  border: 1px solid #e6e6f2 !important;\r\n}\r\n\r\n.border-top {\r\n  border-top: 1px solid #e6e6f2 !important;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: 1px solid #e6e6f2 !important;\r\n}\r\n\r\n.border-left {\r\n  border-left: 1px solid #e6e6f2 !important;\r\n}\r\n\r\n.border-right {\r\n  border-right: 1px solid #e6e6f2 !important;\r\n}\r\n\r\n/*-----------------------\r\n Color\r\n-------------------------*/\r\n\r\n.text-primary {\r\n  color: #5969ff !important;\r\n}\r\n\r\n.text-brand {\r\n  color: #ffc750 !important;\r\n}\r\n\r\n.text-secondary {\r\n  color: #ff407b !important;\r\n}\r\n\r\n.text-success {\r\n  color: #2ec551 !important;\r\n}\r\n\r\n.text-danger {\r\n  color: #ef172c !important;\r\n}\r\n\r\n.text-warning {\r\n  color: #ffc108 !important;\r\n}\r\n\r\n.text-info {\r\n  color: #25d5f2 !important;\r\n}\r\n\r\n.text-light {\r\n  color: #f0f0f8 !important;\r\n}\r\n\r\n.text-dark {\r\n  color: #3d405c !important;\r\n}\r\n\r\n.text-gray {\r\n  color: #868aa5 !important;\r\n}\r\n\r\n.text-muted {\r\n  color: #7171a6 !important;\r\n}\r\n\r\n.rating-color {\r\n  color: #ffa811;\r\n}\r\n\r\n/*-----------------------\r\nBorders\r\n-------------------------*/\r\n\r\n.border-top-primary {\r\n  border-top-color: #5969ff !important;\r\n}\r\n\r\n.border-3 {\r\n  border-width: 3px !important;\r\n}\r\n\r\n.border-secondary {\r\n  border-color: #ff407b !important;\r\n}\r\n\r\n.border-brand {\r\n  border-color: #ffc750 !important;\r\n}\r\n\r\n.border-info {\r\n  border-color: #25d5f2 !important;\r\n}\r\n\r\n/*-----------------------\r\nFontawesome size\r\n-------------------------*/\r\n\r\n.fa-xl {}\r\n\r\n.fa-lg {}\r\n\r\n.fa-md {}\r\n\r\n.fa-sm {\r\n  font-size: 24px !important;\r\n}\r\n\r\n.fa-xs {\r\n  font-size: 11px !important;\r\n}\r\n\r\n/*-----------------------\r\nSocial Color\r\n-------------------------*/\r\n\r\n.facebook-color {\r\n  color: #3c73df;\r\n}\r\n\r\n.twitter-color {\r\n  color: #1ea2f2;\r\n}\r\n\r\n.instagram-color {\r\n  color: #9361fa;\r\n}\r\n\r\n.rss-color {\r\n  color: #ee802f;\r\n}\r\n\r\n.pinterest-color {\r\n  color: #c8232c;\r\n}\r\n\r\n.youtube-color {\r\n  color: #ff0000;\r\n}\r\n\r\n.medium-color {\r\n  color: #00ab6c;\r\n}\r\n\r\n.googleplus-color {\r\n  color: #d34836;\r\n}\r\n\r\n.snapchat-color {\r\n  color: #fffb00;\r\n}\r\n\r\n/*-----------------------\r\nSocial bg Color\r\n-------------------------*/\r\n\r\n.facebook-bgcolor {\r\n  background-color: #3b5898;\r\n  color: #fff;\r\n}\r\n\r\n.twitter-bgcolor {\r\n  background-color: #1ea2f2;\r\n  color: #fff;\r\n}\r\n\r\n.instagram-bgcolor {\r\n  background-color: #9361fa;\r\n  color: #fff;\r\n}\r\n\r\n.rss-bgcolor {\r\n  background-color: #ee802f;\r\n  color: #fff;\r\n}\r\n\r\n.pinterest-bgcolor {\r\n  background-color: #c8232c;\r\n  color: #fff;\r\n}\r\n\r\n.youtube-bgcolor {\r\n  background-color: #ff0000;\r\n  color: #fff;\r\n}\r\n\r\n.googleplus-bgcolor {\r\n  background-color: #d34836;\r\n  color: #fff;\r\n}\r\n\r\n/*-----------------------\r\nProgress bar\r\n-------------------------*/\r\n\r\n.progress-bar {\r\n  background-color: #5969ff;\r\n}\r\n\r\n.primary-progress-bar {\r\n  background-color: #5969ff;\r\n}\r\n\r\n.progress-sm {\r\n  height: 5px;\r\n}\r\n\r\n.progress-sm {\r\n  height: 5px;\r\n}\r\n\r\n.progress-md {\r\n  height: 8px;\r\n}\r\n\r\n.progress-lg {\r\n  height: 12px;\r\n}\r\n\r\n.progress-xl {\r\n  height: 15px;\r\n}\r\n\r\n.f-icon,\r\n.if-icon,\r\n.m-icon,\r\n.sl-icon,\r\n.t-icon,\r\n.w-icon {\r\n  cursor: pointer;\r\n  padding: 13px 15px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.m-icon {\r\n  width: 33%;\r\n  display: inline-block;\r\n}\r\n\r\n.f-icon:hover,\r\n.if-icon:hover,\r\n.m-icon:hover,\r\n.sl-icon:hover,\r\n.t-icon:hover,\r\n.w-icon:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n/*-----------------------\r\nLegends\r\n-------------------------*/\r\n\r\n.legend-item {\r\n  font-size: 14px;\r\n}\r\n\r\n.legend-title {}\r\n\r\n.legend-text {}\r\n\r\n/* ==========================================================================\r\n   0.2. Type Elements\r\n   ========================================================================== */\r\n\r\n/* ==========================================================================\r\n   0.3.  Header\r\n   ========================================================================== */\r\n\r\n/*-----------------------\r\nTop Header\r\n-------------------------*/\r\n.header_mobile_view_button {\r\n  background-color: transparent;\r\n  outline: none;\r\n  border: 0px;\r\n  color: #fff;\r\n}\r\n\r\n.main-header {}\r\n\r\n.main-header .navbar {\r\n  padding: 0px;\r\n  -webkit-box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n  box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n  -webkit-transition: all 0.3s ease;\r\n  transition: all 0.3s ease;\r\n  min-height: 60px;\r\n  background-color: #3e9479;\r\n}\r\n\r\n.navbar-brand {\r\n  display: inline-block;\r\n  margin-right: 1rem;\r\n  line-height: inherit;\r\n  white-space: nowrap;\r\n  font-size: 30px;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n  color: #007bff;\r\n}\r\n\r\n.navbar-brand:hover {\r\n  color: #007bff;\r\n}\r\n\r\n.navbar-brand img {\r\n  max-width: 150px;\r\n  width: 100%;\r\n}\r\n\r\n.navbar-right-top {}\r\n\r\n.main-header .navbar-nav li.nav-item {\r\n  padding: 0px 12px;\r\n}\r\n\r\n.navbar-right-top .nav-item:first-child {\r\n  border-right: 1px solid #e6e6f2;\r\n}\r\n\r\n.navbar-right-top .nav-item:last-child {\r\n  border: none;\r\n}\r\n\r\n.navbar-right-top .nav-item .nav-link {\r\n  padding: 13px 20px;\r\n  font-size: 16px;\r\n  line-height: 2;\r\n  color: #82849f;\r\n}\r\n\r\n.navbar-light .navbar-toggler {\r\n  color: rgb(255 255 255 / 0%);\r\n  border-color: rgb(0 0 0 / 0%);\r\n  padding: 0px;\r\n}\r\n\r\n/* ------  top-search-bar --------  */\r\n\r\n.top-search-bar {\r\n  padding-top: 12px;\r\n  padding-right: 24px;\r\n}\r\n\r\n/* ------  Notification Dropdown --------  */\r\n\r\n.notification {}\r\n\r\n.notification-dropdown {\r\n  min-width: 320px;\r\n}\r\n\r\n.notification-dropdown,\r\n.connection-dropdown,\r\n.nav-user-dropdown {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.notification-title {\r\n  font-size: 14px;\r\n  color: #3d405c;\r\n  text-align: center;\r\n  padding: 8px 0px;\r\n  border-bottom: 1px solid #e3e3e3;\r\n  line-height: 1.5;\r\n  background-color: #fffffe;\r\n}\r\n\r\n.notification-list {}\r\n\r\n.notification-list .list-group-item {\r\n  border-radius: 0px;\r\n  padding: 12px;\r\n  margin-top: -1px;\r\n  border-left: transparent;\r\n  border-right: transparent;\r\n}\r\n\r\n.notification-list .list-group-item.active {\r\n  z-index: 2;\r\n  color: #3d405c;\r\n  background-color: #f7f7fb;\r\n  border-color: #e1e1e7;\r\n}\r\n\r\n.notification-list .list-group-item-action:focus,\r\n.list-group-item-action:hover {\r\n  color: #404040;\r\n  text-decoration: none;\r\n  background-color: #f7f7fb;\r\n}\r\n\r\n.notification-list .list-group-item:last-child {}\r\n\r\n.notification-info {}\r\n\r\n.notification-info .notification-date {\r\n  display: block;\r\n  font-size: 11px;\r\n  margin-top: 4px;\r\n  text-transform: uppercase;\r\n  color: #71748d;\r\n}\r\n\r\n.notification .dropdown-toggle::after,\r\n.connection .dropdown-toggle::after,\r\n.nav-user .dropdown-toggle::after {\r\n  display: inline-block;\r\n  width: 0;\r\n  height: 0;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: '';\r\n  border: none;\r\n}\r\n\r\n.notification-list-user-img {\r\n  float: left;\r\n}\r\n\r\n.notification-list-user-block {\r\n  padding-left: 50px;\r\n  font-size: 14px;\r\n  line-height: 21px;\r\n}\r\n\r\n.notification-list-user-name {\r\n  color: #5969ff;\r\n  font-size: 14px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.list-footer,\r\n.conntection-footer {\r\n  font-size: 14px;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 10px 0px;\r\n  line-height: 1.5;\r\n  font-weight: 700;\r\n  background-color: #5969ff;\r\n  border-bottom-left-radius: 3px;\r\n  border-bottom-right-radius: 3px;\r\n}\r\n\r\n.list-footer a,\r\n.conntection-footer a {\r\n  color: #fff;\r\n}\r\n\r\n.list-footer a:hover,\r\n.conntection-footer a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.indicator {\r\n  content: '';\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 23px;\r\n  display: inline-block;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 100%;\r\n  background-color: #ef172c;\r\n  animation: 0.9s infinite beatHeart;\r\n  transform-origin: center;\r\n}\r\n\r\n@keyframes beatHeart {\r\n  0% {\r\n    transform: scale(0.9);\r\n  }\r\n\r\n  25% {\r\n    transform: scale(1.1);\r\n  }\r\n\r\n  40% {\r\n    transform: scale(0.9);\r\n  }\r\n\r\n  60% {\r\n    transform: scale(1.1);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(0.9);\r\n  }\r\n}\r\n\r\n/* ------  Connection --------  */\r\n\r\n.connection {}\r\n\r\n.connection-dropdown {}\r\n\r\n.connection-list {\r\n  width: 300px;\r\n  padding: 20px;\r\n}\r\n\r\n.connection-item {\r\n  border-radius: 3px;\r\n  line-height: 32px;\r\n  text-align: center;\r\n  padding: 12px 7px 4px;\r\n  display: block;\r\n  border: 1px solid transparent;\r\n  color: #3d405c;\r\n  font-size: 12px;\r\n}\r\n\r\n.connection-item img {\r\n  width: 32px;\r\n}\r\n\r\n.connection-item:hover {\r\n  background-color: #fff;\r\n  border: 1px solid #e6e6f2;\r\n}\r\n\r\n.connection-item span {\r\n  display: block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ----- User Nav Dropdown -----*/\r\n\r\n.nav-user {}\r\n\r\n.nav-user-dropdown {\r\n  padding: 0px;\r\n  min-width: 230px;\r\n  margin: 0px;\r\n}\r\n\r\n.nav-user-name {}\r\n\r\n.nav-user-info {\r\n  background-color: #5969ff;\r\n  line-height: 1.4;\r\n  padding: 12px;\r\n  color: #fff;\r\n  font-size: 13px;\r\n  border-radius: 2px 2px 0 0;\r\n}\r\n\r\n.nav-user-info .status {\r\n  float: left;\r\n  top: 7px;\r\n  left: 0px;\r\n}\r\n\r\n.nav-user-dropdown {}\r\n\r\n.nav-user-dropdown .dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 12px 22px 15px;\r\n  clear: both;\r\n  font-weight: 400;\r\n  color: #686972;\r\n  text-align: inherit;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: 0;\r\n  font-size: 13px;\r\n  line-height: 0.4;\r\n}\r\n\r\n.nav-user-dropdown .dropdown-item:hover {\r\n  background-color: #f7f7fb;\r\n}\r\n\r\n/* ------  Top Header User Info --------  */\r\n\r\n/* -------------------- 0.4. Sidebar ----------------------- */\r\n\r\n.navigation-horizontal {\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  overflow: auto;\r\n  /* background-color: #fff;\r\n    -webkit-box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n    box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n    -webkit-transition: all 0.3s ease;*/\r\n}\r\n\r\n.navigation-horizontal .nav-link[data-toggle='collapse'] {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.navigation-horizontal .nav-link[data-toggle='collapse']::after {\r\n  display: inline-block;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  right: 8px;\r\n  vertical-align: 0.255em;\r\n  content: '';\r\n  border-top: 0.3em solid;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.3em solid transparent;\r\n}\r\n\r\n.navigation-horizontal .nav-link[data-toggle='collapse'][aria-expanded='false']:after {\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.navigation-horizontal .nav-link[data-toggle='collapse']:after {\r\n  transition: transform 0.35s ease, opacity 0.35s ease;\r\n  opacity: 0.5;\r\n}\r\n\r\n.navigation-horizontal .navbar-nav {\r\n  width: 100%;\r\n}\r\n\r\n.navigation-horizontal .navbar {\r\n  position: relative;\r\n  padding: 0px;\r\n}\r\n\r\n.navigation-horizontal .navbar-nav .nav-item {}\r\n\r\n.navigation-horizontal .navbar-nav .nav-link {\r\n  font-size: 13px;\r\n  padding: 9px 30px 9px 20px;\r\n  margin-bottom: 2px;\r\n  color: #71789e;\r\n  transition: 0.3s;\r\n  margin: 6px 1px;\r\n}\r\n\r\n.navigation-horizontal .nav-link i {\r\n  font-size: 14px;\r\n  margin-right: 9px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  line-height: 16px;\r\n}\r\n\r\n.nav-divider {\r\n  padding: 10px 14px;\r\n  line-height: 30px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  font-size: 12px;\r\n}\r\n\r\n.navigation-horizontal .submenu {\r\n  background-color: #e2e2eb;\r\n  margin-top: -6px;\r\n  margin-right: 1px;\r\n  margin-left: 1px;\r\n}\r\n\r\n.navigation-horizontal .submenu .nav .nav-item .nav-link {\r\n  font-size: 12px;\r\n  padding: 0px 12px;\r\n  transition: 0.3s;\r\n  line-height: 1;\r\n}\r\n\r\n.navigation-horizontal .navbar-nav .nav-link:focus,\r\n.navigation-horizontal .navbar-nav .nav-link.active {\r\n  background-color: #e2e2eb;\r\n  color: #3d405c;\r\n  border-radius: 2px;\r\n}\r\n\r\n.navigation-horizontal .navbar-nav .nav-link:focus,\r\n.navigation-horizontal .navbar-nav .nav-link:hover {\r\n  background-color: #e2e2eb;\r\n  color: #3d405c;\r\n  border-radius: 2px;\r\n}\r\n\r\n.navigation-horizontal .submenu .nav .nav-item .nav-link:hover {\r\n  color: #3d405c;\r\n  border-radius: 2px;\r\n  background-color: transparent;\r\n}\r\n\r\n/* -----------------------\r\nLeft Navigation Sidebar\r\n------------------------- */\r\n\r\n.nav-left-sidebar {\r\n  position: fixed;\r\n  width: 73px;\r\n  height: 100%;\r\n  z-index: 9;\r\n  top: 60px;\r\n  overflow: initial;\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n  box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n  transition: all 0.3s ease;\r\n  -webkit-transition: all 0.3s ease;\r\n}\r\n\r\n.nav-left-sidebar .nav-link[data-toggle='collapse'] {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.nav-left-sidebar .nav-link[data-toggle='collapse']::after {\r\n  display: inline-block;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  right: 20px;\r\n  vertical-align: 0.255em;\r\n  content: '';\r\n  border-top: 0.3em solid;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.3em solid transparent;\r\n}\r\n\r\n.nav-left-sidebar .nav-link[data-toggle='collapse'][aria-expanded='false']:after {\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.nav-left-sidebar .nav-link[data-toggle='collapse']:after {\r\n  transition: transform 0.35s ease, opacity 0.35s ease;\r\n  opacity: 0.5;\r\n}\r\n\r\n.nav-left-sidebar .navbar-nav {\r\n  width: 100%;\r\n  row-gap: 20px;\r\n}\r\n\r\n.nav-left-sidebar .navbar {\r\n  position: relative;\r\n  padding: 20px 0px;\r\n}\r\n\r\n.nav-left-sidebar .navbar-nav .nav-item {}\r\n\r\n.nav-left-sidebar .navbar-nav .nav-link {\r\n  font-size: 14px;\r\n  padding: 10px 0px;\r\n  width: 50px;\r\n  color: #71789e;\r\n  transition: 0.3s;\r\n}\r\n\r\n.nav-left-sidebar .nav-link i {\r\n  font-size: 14px;\r\n  display: inline;\r\n  display: block;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  // vertical-align: middle;\r\n  line-height: 16px;\r\n}\r\n\r\n.nav-divider {\r\n  padding: 10px 14px;\r\n  line-height: 30px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  font-size: 12px;\r\n}\r\n\r\n.nav-left-sidebar .submenu {\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n  /* margin-top: 5px; */\r\n  background: #96cc9f;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 73px;\r\n  width: auto;\r\n  z-index: 999;\r\n  padding: 10px;\r\n  row-gap: 10px;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .submenu .nav-item .nav-link {\r\n  background-color: #3e9479;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .submenu .nav-link {\r\n  width: 100%;\r\n  border-radius: 8px;\r\n}\r\n\r\n.nav-left-sidebar .submenu .nav .nav-item .nav-link {\r\n  font-size: 14px;\r\n  padding: 6px 12px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.nav-left-sidebar .navbar-nav .nav-link:focus,\r\n.nav-left-sidebar .navbar-nav .nav-link.active {\r\n  background-color: #e2e2eb;\r\n  color: #3d405c;\r\n  border-radius: 2px;\r\n}\r\n\r\n.nav-left-sidebar .navbar-nav .nav-link:focus,\r\n.nav-left-sidebar .navbar-nav .nav-link:hover {\r\n  background-color: #e2e2eb;\r\n  color: #3d405c;\r\n  border-radius: 2px;\r\n}\r\n\r\n.nav-left-sidebar .submenu .nav .nav-item .nav-link:hover {\r\n  color: #3d405c;\r\n  border-radius: 2px;\r\n  background-color: transparent;\r\n}\r\n\r\n.nav-left-sidebar .navbar-toggler {\r\n  background-color: #fff;\r\n}\r\n\r\n.navbar-toggler {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n/* -----------------------\r\nLeftsidebar - Primary\r\n------------------------- */\r\n\r\n.sidebar-primary {\r\n  background-color: #414da7;\r\n}\r\n\r\n.sidebar-primary .nav-divider {\r\n  color: #ddddff;\r\n}\r\n\r\n.sidebar-primary.nav-left-sidebar .nav-link i {\r\n  color: #8991d4;\r\n}\r\n\r\n.sidebar-primary.nav-left-sidebar .navbar-nav .nav-item {}\r\n\r\n.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link {\r\n  color: #8991d4;\r\n}\r\n\r\n.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link:focus,\r\n.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link:hover {\r\n  color: #fff;\r\n  background-color: #5761c2;\r\n  border-radius: 2px;\r\n}\r\n\r\n.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link:focus,\r\n.sidebar-primary.nav-left-sidebar .navbar-nav .nav-link.active {\r\n  background-color: #5761c2;\r\n  color: #fff;\r\n  border-radius: 2px;\r\n}\r\n\r\n.sidebar-primary.nav-left-sidebar .submenu .nav .nav-item .nav-link:hover {\r\n  color: #fff;\r\n  border-radius: 2px;\r\n  background-color: transparent;\r\n}\r\n\r\n/* -----------------------\r\nLeftsidebar - dark\r\n------------------------- */\r\n\r\n.sidebar-dark {\r\n  // background: linear-gradient(270deg, #1e4438 -17.61%, #3a957d 95.49%);\r\n  background: #3e9479;\r\n  background: -webkit-linear-gradient(270deg, #1e4438 -17.61%, #3a957d 95.49%);\r\n  background: -moz-linear-gradient(270deg, #1e4438 -17.61%, #3a957d 95.49%);\r\n  background-color: #3e9479;\r\n  -webkit-box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n  box-shadow: 0px 0px 28px 0px rgba(82, 63, 105, 0.13);\r\n  -webkit-transition: all 0.3s ease;\r\n}\r\n\r\n.sidebar-dark .nav-divider {\r\n  color: #a4aadb;\r\n  font-size: 12px;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .nav-link i {\r\n  color: #fff;\r\n  margin-bottom: 7px;\r\n  font-size: 16px;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link.active i {\r\n  color: #fdf41f;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-item {}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  text-align: center;\r\n  border: 1px solid transparent;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  font-size: 9px;\r\n  border-radius: 18px;\r\n  text-transform: uppercase;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus,\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:hover {\r\n  color: #fdf41f;\r\n  background-color: #39675a;\r\n  border: 1px solid rgb(253, 255, 136, 0.5);\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus i,\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:hover i {\r\n  color: #fdf41f;\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link:focus,\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-link.active {\r\n  background-color: #39675a;\r\n  color: #fdf41f;\r\n  border: 1px solid rgb(253, 255, 136, 0.5);\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .submenu .nav .nav-item .nav-link:hover {\r\n  color: #fdf41f;\r\n  background-color: #39675a;\r\n  border: 1px solid rgb(253, 255, 136, 0.5);\r\n}\r\n\r\n.sidebar-dark.nav-left-sidebar .navbar-nav .nav-item .badge {\r\n  position: absolute;\r\n  right: 40px;\r\n  display: none;\r\n}\r\n\r\n.nav-left-sidebar .container-fluid {\r\n  padding: 0px 0px;\r\n}\r\n\r\n/*-----navigation dark ---*/\r\n\r\n/*-----------------------\r\nSidebar Page Navigations\r\n-------------------------*/\r\n\r\n.sidebar-nav-fixed {\r\n  position: sticky;\r\n  top: 5rem;\r\n}\r\n\r\n.sidebar-nav-fixed ul {}\r\n\r\n.sidebar-nav-fixed ul li {}\r\n\r\n.sidebar-nav-fixed ul li a {\r\n  font-size: 14px;\r\n  color: #71728e;\r\n  display: block;\r\n  padding: 5px 15px;\r\n  background: transparent;\r\n  border-radius: 4px;\r\n  line-height: 1.8;\r\n}\r\n\r\n.sidebar-nav-fixed ul li a:hover {\r\n  color: #5969ff;\r\n}\r\n\r\n.sidebar-nav-fixed ul li a.active {\r\n  display: block;\r\n  color: #5969ff;\r\n  background: #e0e0fd;\r\n}\r\n\r\n/*--- Bootstrap Dropdown ----*/\r\n\r\n.dropdown-menu {\r\n  background: #fff;\r\n  font-size: 14px;\r\n  color: #3d405c;\r\n  border: 1px solid #e6e6f2;\r\n}\r\n\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.25rem 1.5rem;\r\n  clear: both;\r\n  font-weight: 400;\r\n  color: #3d405c;\r\n  text-align: inherit;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.dropdown-item:hover {\r\n  color: #5969ff;\r\n  background: #efeff6;\r\n}\r\n\r\n.page-section {}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #5969ff;\r\n}\r\n\r\n/* -------------------- 0.5.Container / Wrapper ----------------------- */\r\n\r\n/*-----------------------\r\nContainer / Wrapper\r\n-------------------------*/\r\n\r\n.master-main-wrapper {\r\n  min-height: 100%;\r\n  padding-top: 60px;\r\n  position: relative;\r\n}\r\n\r\n.main-content-wrapper {\r\n  position: relative;\r\n  left: 0;\r\n  margin-left: 73px;\r\n}\r\n\r\n.master-main-wrapper ul.navbar-nav li span::before,\r\n.master-main-wrapper .navbar-nav li button::before {\r\n  display: none;\r\n}\r\n\r\n.master-main-wrapper .navbar-nav li button {\r\n  color: #3e9479;\r\n  min-width: auto;\r\n}\r\n\r\n.main-content-wrapper-inner {\r\n  padding: 20px 20px 0px;\r\n}\r\n\r\n.main-content-wrapper-inner.report-content {\r\n  padding: 20px;\r\n  margin-left: 100px !important;\r\n}\r\n\r\n.main-content-wrapper-inner.report-content.full-width {\r\n  margin-left: 0px !important;\r\n}\r\n\r\n.main-content-wrapper-inner .card-body h5 {\r\n  color: #479573;\r\n}\r\n\r\n.main-content-wrapper-inner .card-header h5 {\r\n  color: #479573;\r\n}\r\n\r\n.main-header .navbar-nav li.feedback button span {\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  text-transform: none;\r\n  text-decoration: none;\r\n}\r\n\r\n.main-header .navbar-nav li.log_out button span {\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  text-transform: none;\r\n}\r\n\r\n.main-header .navbar-nav li.feedback button span:nth-child(2) {\r\n  border-bottom: 1px solid #fff;\r\n}\r\n\r\n.main-header .navbar-nav li.feedback button img {\r\n  margin-right: 5px;\r\n}\r\n\r\n.main-header .navbar-nav li {\r\n  color: #fff;\r\n  font-size: 10px;\r\n  text-transform: uppercase;\r\n  line-height: initial;\r\n  padding: 0px 6px;\r\n}\r\n\r\n.main-header .navbar-nav li span {\r\n  color: #fdf41f;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n}\r\n\r\n/*-----------------------\r\nSplash Container / Wrapper\r\n-------------------------*/\r\n\r\n.splash-container {\r\n  width: 100%;\r\n  max-width: 375px;\r\n  padding: 15px;\r\n  margin: auto;\r\n}\r\n\r\n.splash-container .card-header {\r\n  padding: 20px;\r\n}\r\n\r\n.splash-description {\r\n  text-align: center;\r\n  display: block;\r\n  line-height: 20px;\r\n  font-size: 1rem;\r\n  margin-top: 5px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.splash-title {\r\n  text-align: center;\r\n  display: block;\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n}\r\n\r\n.splash-container .card-footer-item {\r\n  padding: 12px 28px;\r\n}\r\n\r\n/* -------------------- 0.6.Pageheader ----------------------- */\r\n\r\n/*-----------------------\r\nPageheader\r\n-------------------------*/\r\n\r\n.page-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.page-breadcrumb {}\r\n\r\n.page-breadcrumb .breadcrumb {}\r\n\r\n.page-breadcrumb .breadcrumb-item {}\r\n\r\n.page-breadcrumb .breadcrumb-link {\r\n  color: #a6a6b7;\r\n}\r\n\r\n.page-breadcrumb .breadcrumb-link:hover {\r\n  color: #5969ff;\r\n}\r\n\r\n.page-breadcrumb .breadcrumb {\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  padding: 0px;\r\n  margin-bottom: 0px;\r\n  list-style: none;\r\n  background-color: transparent;\r\n  border-radius: 0px;\r\n  border-top: 1px solid #e0e4ef;\r\n  padding-top: 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.page-breadcrumb .breadcrumb .breadcrumb-item+.breadcrumb-item::before {\r\n  display: inline-block;\r\n  padding-right: 0.5rem;\r\n  color: #b1b1c0;\r\n  content: '\\f105';\r\n  font-family: 'Font Awesome\\ 5 Free';\r\n  font-weight: 600;\r\n}\r\n\r\n.page-breadcrumb .breadcrumb-item.active {\r\n  color: #71728e;\r\n}\r\n\r\n.pageheader-title {\r\n  font-size: 24px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.pageheader-text {\r\n  margin-bottom: 14px;\r\n  display: none;\r\n}\r\n\r\n/* -------------------- 0.7.Footer ----------------------- */\r\n\r\n/*-----------------------\r\n Footer\r\n-------------------------*/\r\n\r\n.footer {\r\n  border-top: 1px solid rgba(152, 166, 173, 0.2);\r\n  padding: 14px 30px 14px;\r\n  color: #71748d;\r\n  background-color: #fff;\r\n  width: 100%;\r\n  /*position: absolute; bottom: 0;*/\r\n}\r\n\r\n.footer-links {}\r\n\r\n.footer .footer-links a {\r\n  color: #71748d;\r\n  margin-left: 1.5rem;\r\n  -webkit-transition: all 0.4s;\r\n  transition: all 0.4s;\r\n}\r\n\r\n/* ==========================================================================\r\n  1. Dashboard Index-sales\r\n   ========================================================================== */\r\n\r\n.chart-widget-list {\r\n  margin-top: 60px;\r\n}\r\n\r\n.chart-widget-list p {\r\n  border-bottom: 1px solid #e6e6f2;\r\n  margin-bottom: 8px;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.sell-ratio {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.sell-ratio .progress-bar {\r\n  background-color: #25d5f2;\r\n}\r\n\r\n/* ==========================================================================\r\n  2. Dashboard Index-Finance\r\n   ========================================================================== */\r\n\r\n.dashboard-finance {}\r\n\r\n.dashboard-finance .ct-label {\r\n  display: none;\r\n}\r\n\r\n/* ==========================================================================\r\n  3. Dashboard Influencer\r\n   ========================================================================== */\r\n\r\n.dashboard-influence {}\r\n\r\n.influencer-profile-data {}\r\n\r\n.influencer-profile-data .user-avatar {\r\n  margin-right: 40px;\r\n}\r\n\r\n.influencer-profile-data .user-avatar-info {\r\n  display: block;\r\n  margin-top: 14px;\r\n}\r\n\r\n.influencer-profile-data .user-avatar-name {\r\n  float: left;\r\n  padding-right: 20px;\r\n}\r\n\r\n.user-avatar-address {}\r\n\r\n.influencer-profile-data .user-avatar-address {}\r\n\r\n.influencer-profile-data .user-avatar-email {\r\n  text-decoration: underline;\r\n}\r\n\r\n.influencer-profile-data .user-social-media {\r\n  padding: 16px 99px;\r\n  text-align: center;\r\n  border-right: 1px solid #e6e6f2;\r\n}\r\n\r\n.influencer-profile-data .user-social-media:last-child {\r\n  border-right: transparent;\r\n}\r\n\r\n.user-social-box {\r\n  background-color: #f9f9fc;\r\n  border-bottom-left-radius: 0.25rem;\r\n  border-bottom-right-radius: 0.25rem;\r\n}\r\n\r\n.dashboard-influence .progress {\r\n  width: 86%;\r\n  background-color: #ededfa;\r\n}\r\n\r\n.campaign-table {}\r\n\r\n.campaign-table .dropdown-toggle::after {\r\n  display: none;\r\n}\r\n\r\n.campaign-card {\r\n  padding-bottom: 25px;\r\n  padding-top: 25px;\r\n}\r\n\r\n.campaign-img {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.campaign-info {}\r\n\r\n/* ==========================================================================\r\n  3. Influencer Finder\r\n   ========================================================================== */\r\n\r\n.influence-finder {}\r\n\r\n.influence-finder .user-social-media {\r\n  padding: 16px 68px;\r\n  text-align: center;\r\n  border-right: 1px solid #e6e6f2;\r\n}\r\n\r\n.influence-finder .user-social-media:last-child {\r\n  border-right: transparent;\r\n}\r\n\r\n.influence-finder .icon-circle {\r\n  height: 40px;\r\n  width: 40px;\r\n  display: inline-block;\r\n  padding: 9px;\r\n  line-height: 1.7;\r\n}\r\n\r\n.search-btn {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 20px;\r\n}\r\n\r\n.influence-finder button.btn {\r\n  height: 47px;\r\n  width: 110px;\r\n  border-top-left-radius: 0px;\r\n  border-bottom-left-radius: 0px;\r\n}\r\n\r\n/* ==========================================================================\r\n 4. Influencer Profile\r\n========================================================================== */\r\n\r\n.influence-profile {}\r\n\r\n.rating-star {\r\n  font-size: 12px;\r\n  padding-top: 8px;\r\n  color: #ffa811;\r\n}\r\n\r\n.campaign-social-box {\r\n  background-color: #f9f9fc;\r\n  border-bottom-left-radius: 0.25rem;\r\n  border-bottom-right-radius: 0.25rem;\r\n}\r\n\r\n.campaign-metrics {\r\n  border-right: 1px solid #dee2e6;\r\n  text-align: center;\r\n  padding: 8px 79px;\r\n}\r\n\r\n.campaign-metrics:last-child {\r\n  border-right: transparent;\r\n}\r\n\r\n.influence-profile-content.pills-regular .tab-content {\r\n  background-color: transparent;\r\n  padding: 0px;\r\n  border: transparent;\r\n  border-radius: 0px;\r\n  border-top-left-radius: 0px;\r\n}\r\n\r\n.review-block {}\r\n\r\n.review-text {}\r\n\r\n/* ==========================================================================\r\n  5. Dashboard Ecommerce\r\n   ========================================================================== */\r\n\r\n.dashboard-ecommerce {}\r\n\r\n/* -------------- social sales -------------------*/\r\n\r\n.social-sales {}\r\n\r\n.social-sales-icon-circle {\r\n  height: 40px;\r\n  width: 40px;\r\n  line-height: 1;\r\n  text-align: center;\r\n  border-radius: 100%;\r\n  padding: 12px 13px;\r\n  display: inline-block;\r\n}\r\n\r\n.social-sales-content {}\r\n\r\n.social-sales-name {}\r\n\r\n.social-sales-count {\r\n  float: right;\r\n  line-height: 2.9;\r\n}\r\n\r\n/* -------------- traffic sales -------------------*/\r\n\r\n.traffic-sales {}\r\n\r\n.traffic-sales-content {\r\n  padding: 20px !important;\r\n}\r\n\r\n.traffic-sales-name {}\r\n\r\n.traffic-sales-amount {\r\n  float: right;\r\n  color: #3d405c;\r\n}\r\n\r\n/* -------------- country sales -------------------*/\r\n\r\n.country-sales {}\r\n\r\n.country-sales-content {\r\n  padding: 20px !important;\r\n}\r\n\r\n/* ==========================================================================\r\n   Ecommerce Products\r\n   ========================================================================== */\r\n\r\n.product-thumbnail {\r\n  border: 1px solid #e6e6f2;\r\n  background-color: #fff;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.product-img {\r\n  text-align: center;\r\n  padding: 35px 0px;\r\n}\r\n\r\n.product-img-head {\r\n  position: relative;\r\n}\r\n\r\n.ribbons {\r\n  -webkit-clip-path: polygon(10% 25%,\r\n      10% 0,\r\n      35% 0%,\r\n      65% 0%,\r\n      90% 0,\r\n      90% 25%,\r\n      90% 50%,\r\n      91% 100%,\r\n      50% 73%,\r\n      10% 100%,\r\n      10% 50%);\r\n  clip-path: polygon(10% 25%,\r\n      10% 0,\r\n      35% 0%,\r\n      65% 0%,\r\n      90% 0,\r\n      90% 25%,\r\n      90% 50%,\r\n      91% 100%,\r\n      50% 73%,\r\n      10% 100%,\r\n      10% 50%);\r\n\r\n  position: absolute;\r\n  top: 0px;\r\n  background-color: #59b3ff;\r\n  padding: 31px 15px;\r\n  text-align: center;\r\n  left: 10px;\r\n  font-family: 'Roboto', sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.ribbons-text {\r\n  transform: rotate(90deg);\r\n  position: absolute;\r\n  top: 11px;\r\n  left: 10px;\r\n  color: #fff;\r\n}\r\n\r\n.product-wishlist-btn {\r\n  height: 40px;\r\n  width: 40px;\r\n  border: 2px solid #dfdfec;\r\n  border-radius: 100px;\r\n  font-size: 18px;\r\n  line-height: 2.3;\r\n  color: #dfdfec;\r\n  text-align: center;\r\n  display: block;\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 15px;\r\n}\r\n\r\n.product-wishlist-btn:hover {\r\n  border-color: #ff3367;\r\n  color: #ff3367;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.product-wishlist-btn.active {\r\n  border-color: #ff3367;\r\n  color: #ff3367;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.product-content {\r\n  border-top: 1px solid #e6e6f2;\r\n  padding: 23px;\r\n}\r\n\r\n.product-content-head {\r\n  position: relative;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.product-title {\r\n  font-size: 16px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.product-rating {\r\n  font-size: 12px;\r\n\r\n  color: #ffa811;\r\n}\r\n\r\n.product-price {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  font-size: 16px;\r\n  color: #3d405c;\r\n  font-family: 'Roboto', sans-serif;\r\n  line-height: 1;\r\n}\r\n\r\n.product-btn {}\r\n\r\n.product-del {\r\n  font-size: 14px;\r\n  color: #71748d;\r\n}\r\n\r\n.product-sidebar {\r\n  background-color: #fff;\r\n  border: 1px solid #e6e6f2;\r\n}\r\n\r\n.product-sidebar-widget {\r\n  border-bottom: 1px solid #e6e6f2;\r\n  padding: 10px 20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.product-sidebar-widget:last-child {\r\n  border: 0px;\r\n}\r\n\r\n.product-sidebar-widget-title {\r\n  font-size: 16px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.custom-color-red.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n  background-color: #a40000;\r\n  border-color: #a40000;\r\n}\r\n\r\n.custom-color-blue.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n  background-color: #0d4197;\r\n  border-color: #0d4197;\r\n}\r\n\r\n.custom-color-yellow.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n  background-color: #ffdc40;\r\n  border-color: #ffdc40;\r\n}\r\n\r\n.custom-color-black.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n  background-color: #111111;\r\n  border-color: #111111;\r\n}\r\n\r\n.product-slider {\r\n  background-color: #fff;\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n  padding: 110px;\r\n}\r\n\r\n.product-carousel {}\r\n\r\n.product-carousel .carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: -80px;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  padding-left: 0;\r\n  margin-right: 15%;\r\n  margin-left: 15%;\r\n  list-style: none;\r\n}\r\n\r\n.product-carousel .carousel-indicators li {\r\n  position: relative;\r\n  -ms-flex: 0 1 auto;\r\n  flex: 0 1 auto;\r\n  width: 10px;\r\n  height: 10px;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  background-color: rgb(224, 224, 231);\r\n  border-radius: 100%;\r\n}\r\n\r\n.product-carousel .carousel-indicators li.active {\r\n  background-color: #5969ff;\r\n}\r\n\r\n.product-carousel .carousel-control-next,\r\n.carousel-control-prev {\r\n  display: none;\r\n}\r\n\r\n.product-details {\r\n  background-color: #fff;\r\n  padding: 30px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\n.product-colors {\r\n  padding-bottom: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.product-size {\r\n  padding-bottom: 14px;\r\n  margin-bottom: 10px;\r\n  position: relative;\r\n}\r\n\r\n.product-colors input[type='checkbox'],\r\ninput[type='radio'] {\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  display: none;\r\n}\r\n\r\n.product-description {}\r\n\r\n.product-colors label {\r\n  display: inline-block;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  transition: all 0.2s ease-in-out;\r\n  animation-timing-function: ease-in-out;\r\n  animation-iteration-count: infinite;\r\n  animation-duration: 1.6s;\r\n  animation-name: dot-anim;\r\n}\r\n\r\n.product-colors .radio:checked+label {\r\n  animation-play-state: paused;\r\n}\r\n\r\n.product-colors label:before {\r\n  content: '\\f00c';\r\n  position: absolute;\r\n  font-family: 'Font Awesome\\ 5 Free';\r\n  font-weight: 900;\r\n  padding: 0px;\r\n  margin: 4px 8px;\r\n  color: #fff;\r\n  font-size: 14px;\r\n}\r\n\r\n.product-colors .radio:checked+label:after {\r\n  background: transparent;\r\n  transition: all 0.5s;\r\n  transform: scale(1);\r\n}\r\n\r\n/**** BLUE Radio button code ****/\r\n#radio-1+label {\r\n  left: -60vw;\r\n  background: #0a3c93;\r\n  animation-delay: 0s;\r\n}\r\n\r\n#radio-1+label:before {\r\n  transform: scale(0);\r\n}\r\n\r\n#radio-1:checked+label:before {\r\n  transform: scale(1);\r\n  transition: all 0.4s;\r\n}\r\n\r\n/**** Yellow Radio button code ****/\r\n#radio-2+label {\r\n  left: -60vw;\r\n  background: #ffdc40;\r\n  animation-delay: 0s;\r\n}\r\n\r\n#radio-2+label:before {\r\n  transform: scale(0);\r\n}\r\n\r\n#radio-2:checked+label:before {\r\n  transform: scale(1);\r\n  transition: all 0.4s;\r\n}\r\n\r\n/**** Red Radio button code ****/\r\n#radio-3+label {\r\n  left: -60vw;\r\n  background: #a00000;\r\n  animation-delay: 0s;\r\n}\r\n\r\n#radio-3+label:before {\r\n  transform: scale(0);\r\n}\r\n\r\n#radio-3:checked+label:before {\r\n  transform: scale(1);\r\n  transition: all 0.4s;\r\n}\r\n\r\n.product-qty {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0px;\r\n}\r\n\r\n.quantity {\r\n  position: relative;\r\n}\r\n\r\n.product-qty input[type='number']::-webkit-inner-spin-button,\r\n.product-qty input[type='number']::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.product-qty input[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n.quantity input {\r\n  width: 65px;\r\n  height: 41px;\r\n  line-height: 1.65;\r\n  float: left;\r\n  display: block;\r\n  padding: 0;\r\n  margin: 0;\r\n  padding-left: 20px;\r\n  border: 1px solid #eee;\r\n}\r\n\r\n.quantity input:focus {\r\n  outline: 0;\r\n}\r\n\r\n.quantity-nav {\r\n  float: left;\r\n  position: relative;\r\n  height: 39px;\r\n}\r\n\r\n.quantity-button {\r\n  position: relative;\r\n  cursor: pointer;\r\n  border-left: 1px solid #e6e6f2;\r\n  width: 20px;\r\n  text-align: center;\r\n  color: #333;\r\n  font-size: 13px;\r\n  font-family: 'Roboto', sans-serif;\r\n\r\n  line-height: 1.6;\r\n  -webkit-transform: translateX(-100%);\r\n  transform: translateX(-100%);\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  -o-user-select: none;\r\n  user-select: none;\r\n  background-color: #efeff6;\r\n}\r\n\r\n.quantity-button.quantity-up {\r\n  position: absolute;\r\n  height: 50%;\r\n  top: 0;\r\n  border-bottom: 1px solid #e6e6f2;\r\n}\r\n\r\n.quantity-button.quantity-down {\r\n  position: absolute;\r\n  bottom: -1px;\r\n  height: 50%;\r\n}\r\n\r\n/* ==========================================================================\r\n  2. UI Elements\r\n  ========================================================================== */\r\n\r\n/* -----------------------\r\n2.1  Alerts\r\n-------------------------*/\r\n\r\n/* -----------------------\r\n2.2  Buttons\r\n-------------------------*/\r\n\r\n.btn {\r\n  font-size: 14px;\r\n  padding: 9px 16px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.btn-wishlist {\r\n  background-color: #efeff6;\r\n  border-radius: 100px;\r\n  height: 30px;\r\n  width: 30px;\r\n  padding: 5px 3px;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n  color: #3d405c;\r\n  text-align: center;\r\n  line-height: 1.7;\r\n}\r\n\r\n.btn-wishlist:hover {\r\n  background-color: #ff407b;\r\n  color: #fff;\r\n}\r\n\r\n/*--- btn default --*/\r\n\r\n.btn-brand {\r\n  color: #2e2f39;\r\n  background-color: #ffc750;\r\n  border-color: #ffc750;\r\n}\r\n\r\n.btn-brand:hover {\r\n  color: #2e2f39;\r\n  background-color: #efb63e;\r\n  border-color: #efb63e;\r\n}\r\n\r\n.btn-brand.focus,\r\n.btn-brand:focus {\r\n  color: #2e2f39;\r\n  background-color: #efb63e;\r\n  border-color: #efb63e;\r\n  box-shadow: none;\r\n}\r\n\r\n/*--- btn primary --*/\r\n\r\n.btn-primary {\r\n  color: #fff !important;\r\n  background-color: #225ea8 !important;\r\n  border-color: #225ea8 !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\n.btn-primary:hover {\r\n  color: #fff !important;\r\n  background-color: #225ea8 !important;\r\n  border-color: #225ea8 !important;\r\n}\r\n\r\n.btn-primary.focus,\r\n.btn-primary:focus {\r\n  color: #fff !important;\r\n  background-color: #225ea7 !important;\r\n  border-color: #225ea7 !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled).active:focus,\r\n.btn-primary:not(:disabled):not(.disabled):active:focus,\r\n.show>.btn-primary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgb(37, 52, 158) !important;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled).active,\r\n.btn-primary:not(:disabled):not(.disabled):active,\r\n.show>.btn-primary.dropdown-toggle {\r\n  color: #fff !important;\r\n  background-color: #4656e9 !important;\r\n  border-color: #4656e9 !important;\r\n}\r\n\r\n/*--- btn secondary --*/\r\n\r\n/*.btn-secondary {\r\n  color: #fff !important;\r\n  background-color: #ff407b !important;\r\n  border-color: #ff407b !important;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  color: #fff !important;\r\n  background-color: #f0346e !important;\r\n  border-color: #f0346e !important;\r\n}\r\n\r\n.btn-secondary.focus,\r\n.btn-secondary:focus {\r\n  color: #fff !important;\r\n  background-color: #f0346e !important;\r\n  border-color: #f0346e !important;\r\n  box-shadow: 0 0 0 1px rgb(222, 17, 80) !important;\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled).active,\r\n.btn-secondary:not(:disabled):not(.disabled):active,\r\n.show > .btn-secondary.dropdown-toggle {\r\n  color: #fff !important;\r\n  background-color: #f0346e !important;\r\n  border-color: #f0346e !important;\r\n} */\r\n\r\n/*--- btn success --*/\r\n\r\n.btn-success {\r\n  color: #fff;\r\n  background-color: #2ec551;\r\n  border-color: #2ec551;\r\n}\r\n\r\n.btn-success:hover {\r\n  color: #fff;\r\n  background-color: #21ae41;\r\n  border-color: #21ae41;\r\n}\r\n\r\n.btn-success.focus,\r\n.btn-success:focus {\r\n  color: #fff;\r\n  background-color: #21ae41;\r\n  border-color: #21ae41;\r\n  box-shadow: 0 0 0 1px rgb(18, 158, 50);\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled).active,\r\n.btn-success:not(:disabled):not(.disabled):active,\r\n.show>.btn-success.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #21ae41;\r\n  border-color: #21ae41;\r\n}\r\n\r\n/*--- btn danger --*/\r\n\r\n.btn-danger {\r\n  color: #fff;\r\n  background-color: #ef172c;\r\n  border-color: #ef172c;\r\n}\r\n\r\n.btn-danger:hover {\r\n  color: #fff;\r\n  background-color: #da0419;\r\n  border-color: #da0419;\r\n}\r\n\r\n.btn-danger.focus,\r\n.btn-danger:focus {\r\n  color: #fff;\r\n  background-color: #da0419;\r\n  border-color: #da0419;\r\n  box-shadow: 0 0 0 1px rgb(218, 4, 25);\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled).active,\r\n.btn-danger:not(:disabled):not(.disabled):active,\r\n.show>.btn-danger.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #da0419;\r\n  border-color: #da0419;\r\n}\r\n\r\n/*--- btn warning --*/\r\n\r\n.btn-warning {\r\n  color: #2e2f39;\r\n  background-color: #ffc108;\r\n  border-color: #ffc108;\r\n}\r\n\r\n.btn-warning:hover {\r\n  color: #2e2f39;\r\n  background-color: #f3b600;\r\n  border-color: #f3b600;\r\n}\r\n\r\n.btn-warning.focus,\r\n.btn-warning:focus {\r\n  color: #2e2f39;\r\n  background-color: #f3b600;\r\n  border-color: #f3b600;\r\n  box-shadow: 0 0 0 1px rgb(238, 182, 0);\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled).active,\r\n.btn-warning:not(:disabled):not(.disabled):active,\r\n.show>.btn-warning.dropdown-toggle {\r\n  color: #2e2f39;\r\n  background-color: #f3b600;\r\n  border-color: #f3b600;\r\n}\r\n\r\n/*--- btn info --*/\r\n\r\n.btn-info {\r\n  color: #fff;\r\n  background-color: #25d5f2;\r\n  border-color: #25d5f2;\r\n}\r\n\r\n.btn-info:hover {\r\n  color: #fff;\r\n  background-color: #17c0dc;\r\n  border-color: #17c0dc;\r\n}\r\n\r\n.btn-info.focus,\r\n.btn-info:focus {\r\n  color: #fff;\r\n  background-color: #17c0dc;\r\n  border-color: #17c0dc;\r\n  box-shadow: 0 0 0 1px rgb(238, 184, 22);\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled).active,\r\n.btn-info:not(:disabled):not(.disabled):active,\r\n.show>.btn-info.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #17c0dc;\r\n  border-color: #17c0dc;\r\n}\r\n\r\n/*--- btn light --*/\r\n\r\n.btn-light {\r\n  color: #71738d;\r\n  background-color: #f0f0f8;\r\n  border-color: #f0f0f8;\r\n}\r\n\r\n.btn-light:hover {\r\n  color: #2e2f39;\r\n  background-color: #d7d7df;\r\n  border-color: #d7d7df;\r\n}\r\n\r\n.btn-light.focus,\r\n.btn-light:focus {\r\n  color: #2e2f39;\r\n  background-color: #d7d7df;\r\n  border-color: #d7d7df;\r\n  box-shadow: 0 0 0 1px rgb(215, 215, 223);\r\n}\r\n\r\n/*--- btn dark --*/\r\n\r\n.btn-dark {\r\n  color: #fff;\r\n  background-color: #2e2f39;\r\n  border-color: #2e2f39;\r\n}\r\n\r\n.btn-dark:hover {\r\n  color: #2e2f39;\r\n  background-color: #d7d7df;\r\n  border-color: #d7d7df;\r\n}\r\n\r\n.btn-dark.focus,\r\n.btn-dark:focus {\r\n  color: #fff;\r\n  background-color: #d7d7df;\r\n  border-color: #d7d7df;\r\n  box-shadow: 0 0 0 1px rgb(46, 47, 57);\r\n}\r\n\r\n/*--- btn outline brand --*/\r\n\r\n.btn-outline-brand {\r\n  color: #2e2f39;\r\n  background-color: transparent;\r\n  border-color: #ffc750;\r\n}\r\n\r\n.btn-outline-brand:hover {\r\n  color: #2e2f39;\r\n  background-color: #ffc750;\r\n  border-color: #ffc750;\r\n}\r\n\r\n.btn-outline-brand.focus,\r\n.btn-outline-brand:focus {\r\n  color: #2e2f39;\r\n  background-color: transparent;\r\n  border-color: #ffc750;\r\n  box-shadow: 0 0 0 1px rgb(255, 195, 89);\r\n}\r\n\r\n/*--- btn outline primary --*/\r\n\r\n.btn-outline-primary {\r\n  color: #5969ff;\r\n  background-color: transparent;\r\n  border-color: #5969ff;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n  color: #fff;\r\n  background-color: #5969ff;\r\n  border-color: #5969ff;\r\n}\r\n\r\n.btn-outline-primary.focus,\r\n.btn-outline-primary:focus {\r\n  color: #fff;\r\n  background-color: #5969ff;\r\n  border-color: #5969ff;\r\n  box-shadow: 0 0 0 1px rgb(65, 77, 167);\r\n}\r\n\r\n/*--- btn outline secondary --*/\r\n\r\n.btn-outline-secondary {\r\n  color: #ff407b;\r\n  background-color: transparent;\r\n  border-color: #ff407b;\r\n}\r\n\r\n.btn-outline-secondary:hover {\r\n  color: #fff;\r\n  background-color: #ff407b;\r\n  border-color: #ff407b;\r\n}\r\n\r\n.btn-outline-secondary.focus,\r\n.btn-outline-secondary:focus {\r\n  color: #fff;\r\n  background-color: #ff407b;\r\n  border-color: #ff407b;\r\n  box-shadow: 0 0 0 1px rgb(227, 45, 201);\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\r\n.show>.btn-outline-secondary.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #ff407b;\r\n  border-color: #ff407b;\r\n}\r\n\r\n/*--- btn outline success --*/\r\n\r\n.btn-outline-success {\r\n  color: #2ec551;\r\n  background-color: transparent;\r\n  border-color: #2ec551;\r\n}\r\n\r\n.btn-outline-success:hover {\r\n  color: #fff;\r\n  background-color: #2ec551;\r\n  border-color: #2ec551;\r\n}\r\n\r\n.btn-outline-success.focus,\r\n.btn-outline-success:focus {\r\n  color: #fff;\r\n  background-color: #2ec551;\r\n  border-color: #2ec551;\r\n  box-shadow: 0 0 0 1px rgb(40, 167, 69);\r\n}\r\n\r\n/*--- btn outline danger --*/\r\n\r\n.btn-outline-danger {\r\n  color: #ef172c;\r\n  background-color: transparent;\r\n  border-color: #ef172c;\r\n}\r\n\r\n.btn-outline-danger:hover {\r\n  color: #fff;\r\n  background-color: #ef172c;\r\n  border-color: #ef172c;\r\n}\r\n\r\n.btn-outline-danger.focus,\r\n.btn-outline-danger:focus {\r\n  color: #fff;\r\n  background-color: #ef172c;\r\n  border-color: #ef172c;\r\n  box-shadow: 0 0 0 1px rgb(239, 23, 44);\r\n}\r\n\r\n/*--- btn outline warning --*/\r\n\r\n.btn-outline-warning {\r\n  color: #2e2f39;\r\n  background-color: transparent;\r\n  border-color: #ffc108;\r\n}\r\n\r\n.btn-outline-warning:hover {\r\n  color: #2e2f39;\r\n  background-color: #ffc108;\r\n  border-color: #ffc108;\r\n}\r\n\r\n.btn-outline-warning.focus,\r\n.btn-outline-warning:focus {\r\n  color: #2e2f39;\r\n  background-color: #ffc108;\r\n  border-color: #ffc108;\r\n  box-shadow: 0 0 0 1px rgb(255, 193, 8);\r\n}\r\n\r\n/*--- btn outline info --*/\r\n\r\n.btn-outline-info {\r\n  color: #25d5f2;\r\n  background-color: transparent;\r\n  border-color: #25d5f2;\r\n}\r\n\r\n.btn-outline-info:hover {\r\n  color: #fff;\r\n  background-color: #25d5f2;\r\n  border-color: #25d5f2;\r\n}\r\n\r\n.btn-outline-info.focus,\r\n.btn-outline-info:focus {\r\n  color: #fff;\r\n  background-color: #25d5f2;\r\n  border-color: #0998b0;\r\n  box-shadow: 0 0 0 1px rgb(238, 184, 22);\r\n}\r\n\r\n/*--- btn outline light --*/\r\n\r\n.btn-outline-light {\r\n  color: #7171a6;\r\n  background-color: transparent;\r\n  border-color: #e6e6f2;\r\n}\r\n\r\n.btn-outline-light:hover {\r\n  color: #71748d;\r\n  background-color: #f0f0f8;\r\n  border-color: #cacae0;\r\n}\r\n\r\n.btn-outline-light.focus,\r\n.btn-outline-light:focus {\r\n  color: #71748d;\r\n  background-color: #f0f0f8;\r\n  border-color: #cacae0;\r\n  box-shadow: 0 0 0 1px rgb(235, 235, 237);\r\n}\r\n\r\n/*--- btn outline-dark --*/\r\n\r\n.btn-outline-dark {\r\n  color: #2e2f39;\r\n  background-color: transparent;\r\n  border-color: #2e2f39;\r\n}\r\n\r\n.btn-outline-dark:hover {\r\n  color: #fff;\r\n  background-color: #2e2f39;\r\n  border-color: #2e2f39;\r\n}\r\n\r\n.btn-outline-dark.focus,\r\n.btn-outline-dark:focus {\r\n  color: #fff;\r\n  background-color: #2e2f39;\r\n  border-color: #2e2f39;\r\n  box-shadow: 0 0 0 1px rgb(46, 47, 57);\r\n}\r\n\r\n/*--- btn size --*/\r\n\r\n.btn-xs {\r\n  padding: 5px !important;\r\n  font-size: 9px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.btn-sm {\r\n  padding: 5px 12px !important;\r\n  font-size: 14px !important;\r\n}\r\n\r\n.btn-lg {\r\n  padding: 11px 20px !important;\r\n  font-size: 15px !important;\r\n}\r\n\r\n/*--- btn social --*/\r\n\r\n.btn-facebook {\r\n  color: #fff;\r\n  background-color: #3c73df;\r\n  border-color: #3c73df;\r\n}\r\n\r\n.btn-google-plus {\r\n  color: #fff;\r\n  background-color: #eb5e4c;\r\n  border-color: #eb5e4c;\r\n}\r\n\r\n.btn-twitter {\r\n  color: #fff;\r\n  background-color: #2caeff;\r\n  border-color: #2caeff;\r\n}\r\n\r\n.btn-instagram {\r\n  color: #fff;\r\n  background-color: #9361fa;\r\n  border-color: #9361fa;\r\n}\r\n\r\n.btn-pinterest {\r\n  color: #fff;\r\n  background-color: #c8232c;\r\n  border-color: #c8232c;\r\n}\r\n\r\n/*--- cropper document btn --*/\r\n\r\n.btn-rounded {\r\n  border-radius: 100px;\r\n}\r\n\r\n/*--- cropper document btn --*/\r\n\r\n.docs-buttons .btn,\r\n.docs-data .input-group {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n/*-----------------------\r\nbtn-link\r\n-------------------------*/\r\n\r\n.btn-link {\r\n  color: #5969ff;\r\n}\r\n\r\n.btn-link:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.btn-primary-link {\r\n  color: #5969ff !important;\r\n}\r\n\r\n.btn-brand-link {\r\n  color: #ffc750 !important;\r\n}\r\n\r\n.btn-secondary-link {\r\n  color: #ff407b !important;\r\n}\r\n\r\n/* -----------------------\r\n2.3  Cards\r\n-------------------------*/\r\n\r\n.card {\r\n  border: none;\r\n  -webkit-box-shadow: 0px 4px 94px rgba(0, 0, 0, 0.03);\r\n  -moz-box-shadow: 0px 4px 94px rgba(0, 0, 0, 0.03);\r\n  box-shadow: 0px 4px 94px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.card-header {\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #e6e6f2;\r\n}\r\n\r\n.card-title {}\r\n\r\n.card-subtitle {\r\n  font-size: 14px;\r\n}\r\n\r\n.card-body {\r\n  border-radius: 12px;\r\n  height: 100%;\r\n}\r\n\r\n.card-text {}\r\n\r\n.card-footer {\r\n  border-top: 0px;\r\n  background: #ffffff;\r\n}\r\n\r\n.card-link {}\r\n\r\n.toolbar {\r\n  font-size: 18px;\r\n}\r\n\r\n.card-header-title {\r\n  margin: 0;\r\n  line-height: 2;\r\n}\r\n\r\n.card-toolbar-tabs {}\r\n\r\n.card-toolbar-tabs .nav.nav-pills {}\r\n\r\n.card-toolbar-tabs .nav.nav-pills .nav-item {}\r\n\r\n.card-toolbar-tabs .nav.nav-pills .nav-item .nav-link {\r\n  font-size: 14px;\r\n  padding: 6px 10px;\r\n}\r\n\r\n.card-toolbar-tabs .nav-pills .nav-link.active,\r\n.nav-pills .show>.nav-link {\r\n  color: #5969ff;\r\n  background-color: transparent;\r\n}\r\n\r\n/*------------------------- Card Varience --------------------------*/\r\n\r\n.card-figure {\r\n  position: relative;\r\n  padding: 10px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.card-figure .figure {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-figure .figure-caption {\r\n  display: block;\r\n  margin-top: 10px;\r\n  font-size: 0.875rem;\r\n  color: inherit;\r\n}\r\n\r\n.figure-title {\r\n  margin: 0 0 0.125rem;\r\n  text-transform: capitalize;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.card-figure.has-hoverable {\r\n  -webkit-transition: -webkit-transform 0.2s, -webkit-box-shadow 0.2s;\r\n  transition: -webkit-transform 0.2s, -webkit-box-shadow 0.2s;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  transition: transform 0.2s, box-shadow 0.2s, -webkit-transform 0.2s,\r\n    -webkit-box-shadow 0.2s;\r\n}\r\n\r\n.card-figure.has-hoverable:focus,\r\n.card-figure.has-hoverable:hover {\r\n  -webkit-transform: translate3d(0, -0.25rem, 0);\r\n  transform: translate3d(0, -0.25rem, 0);\r\n  -webkit-box-shadow: 0 5px 15px 0 rgba(61, 70, 79, 0.15);\r\n  box-shadow: 0 5px 15px 0 rgba(61, 70, 79, 0.15);\r\n}\r\n\r\n.figure-img {\r\n  position: relative;\r\n  margin-bottom: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.figure-img .img-link {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  background-color: hsla(0, 0%, 100%, 0.96);\r\n  opacity: 0;\r\n  z-index: 2;\r\n  -webkit-transition: opacity 0.2s ease;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.card-figure:hover .img-link {\r\n  opacity: 1;\r\n}\r\n\r\n.figure-img .img-link .tile {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -1rem;\r\n  margin-left: -1rem;\r\n}\r\n\r\n.tile.bg-danger {\r\n  color: #fff;\r\n}\r\n\r\n.tile-circle {\r\n  border-radius: 4rem;\r\n}\r\n\r\n.figure-action {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: block;\r\n  opacity: 0;\r\n  -webkit-transform: translate3d(0, 100%, 0);\r\n  transform: translate3d(0, 100%, 0);\r\n  -webkit-transition: all 0.3s ease;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.card-figure:hover .figure-action {\r\n  opacity: 1;\r\n  -webkit-transform: translateZ(0);\r\n  transform: translateZ(0);\r\n  z-index: 2;\r\n}\r\n\r\n.figure-tools {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n  padding: 0.5rem;\r\n  opacity: 0;\r\n  z-index: 2;\r\n  -webkit-transition: opacity 0.3s ease;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.card-figure:hover .figure-tools {\r\n  opacity: 1;\r\n}\r\n\r\n.figure-description {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 2.25rem 0.5rem;\r\n  background-color: hsla(0, 0%, 100%, 0.96);\r\n  opacity: 0;\r\n  -webkit-transition: all 0.3s ease;\r\n  transition: all 0.3s ease;\r\n  z-index: 1;\r\n}\r\n\r\n.card-figure:hover .figure-description {\r\n  opacity: 1;\r\n}\r\n\r\n.figure-attachment {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  min-height: 200px;\r\n  background-color: #f5f5f5;\r\n  overflow: hidden;\r\n}\r\n\r\n.btn-reset {\r\n  padding: 0 2px;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n  color: inherit;\r\n  background-color: transparent;\r\n  border: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n/*------------------------- Card Navigation --------------------------*/\r\n\r\n.card-header-tabs {}\r\n\r\n.card-header-pills {}\r\n\r\n.pills-regular .card-header-pills.nav.nav-pills .nav-item .nav-link.active {\r\n  background-color: #5969ff;\r\n  color: #fff;\r\n}\r\n\r\n/* -----------------------\r\n2.4  General\r\n-------------------------*/\r\n\r\n/*---------Tooltips----------*/\r\n\r\n/*--------- Popovers ----------------*/\r\n\r\n.popover {\r\n  border: 1px solid rgb(230, 230, 242);\r\n}\r\n\r\n.bs-popover-auto[x-placement^='right'] .arrow::before,\r\n.bs-popover-right .arrow::before {\r\n  left: 0;\r\n  border-right-color: rgb(230, 230, 242);\r\n}\r\n\r\n.popover-header {\r\n  padding: 0.5rem 0.75rem;\r\n  margin-bottom: 0;\r\n  font-size: 1rem;\r\n  color: inherit;\r\n  background-color: #f7f7fd;\r\n  border-bottom: 1px solid #efeff6;\r\n  border-top-left-radius: calc(0.3rem - 1px);\r\n  border-top-right-radius: calc(0.3rem - 1px);\r\n}\r\n\r\n/* -----------------------\r\n2.5  Modals\r\n-------------------------*/\r\n\r\n.bd-example-row .row>.col,\r\n.bd-example-row .row>[class^='col-'] {\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  background-color: rgba(86, 61, 124, 0.15);\r\n  border: 1px solid rgba(86, 61, 124, 0.2);\r\n}\r\n\r\n/* -----------------------\r\n2.6  Notification\r\n-------------------------*/\r\n\r\n/* -----------------------\r\n2.7  Icon\r\n-------------------------*/\r\n\r\n.icon-circle {\r\n  border-radius: 100%;\r\n}\r\n\r\n.icon-circle-small {\r\n  line-height: 1;\r\n  padding: 4px 2px;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  display: inline-block;\r\n  border-radius: 100%;\r\n}\r\n\r\n.icon-circle-medium {\r\n  line-height: 1;\r\n  padding: 22px 2px;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  display: inline-block;\r\n  border-radius: 100%;\r\n}\r\n\r\n.icon-box {}\r\n\r\n.icon-box-xxl {}\r\n\r\n.icon-box-xl {}\r\n\r\n.icon-box-lg {\r\n  height: 68px;\r\n  width: 68px;\r\n}\r\n\r\n.icon-box-md {\r\n  height: 32px;\r\n  width: 32px;\r\n}\r\n\r\n.icon-box-sm {}\r\n\r\n.icon-box-xs {\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n/* -----------------------\r\n2.8  Tabs\r\n-------------------------*/\r\n\r\n.tab-regular {}\r\n\r\n.tab-regular .nav.nav-tabs {\r\n  border-bottom: transparent;\r\n}\r\n\r\n.tab-regular .nav.nav-tabs .nav-item {}\r\n\r\n.tab-regular .nav.nav-tabs .nav-link {\r\n  display: block;\r\n  padding: 17px 49px;\r\n  color: #71748d;\r\n  background-color: #dddde8;\r\n  margin-right: 5px;\r\n  border-color: #dddde8;\r\n}\r\n\r\n.tab-regular .nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {}\r\n\r\n.tab-regular .nav-tabs .nav-link.active {\r\n  background-color: #fff;\r\n  border-color: #e6e6f2 #e6e6f2 #fff;\r\n  color: #5969ff;\r\n}\r\n\r\n.tab-regular .tab-content {\r\n  background-color: #fff;\r\n  padding: 30px;\r\n  border: 1px solid #e6e6f2;\r\n  border-radius: 4px;\r\n  border-top-left-radius: 0px;\r\n}\r\n\r\n/*----- Tabs Vertical CSS ----*/\r\n\r\n.tab-vertical {}\r\n\r\n.tab-vertical .nav.nav-tabs {\r\n  float: left;\r\n  display: block;\r\n  margin-right: 0px;\r\n  border-bottom: 0;\r\n}\r\n\r\n.tab-vertical .nav.nav-tabs .nav-item {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.tab-vertical .nav-tabs .nav-link {\r\n  border: 1px solid transparent;\r\n  border-top-left-radius: 0.25rem;\r\n  border-top-right-radius: 0.25rem;\r\n  background: #fff;\r\n  padding: 17px 49px;\r\n  color: #71748d;\r\n  background-color: #dddde8;\r\n  -webkit-border-radius: 4px 0px 0px 4px;\r\n  -moz-border-radius: 4px 0px 0px 4px;\r\n  border-radius: 4px 0px 0px 4px;\r\n}\r\n\r\n.tab-vertical .nav-tabs .nav-link.active {\r\n  color: #5969ff;\r\n  background-color: #fff !important;\r\n  border-color: transparent !important;\r\n}\r\n\r\n.tab-vertical .nav-tabs .nav-link {\r\n  border: 1px solid transparent;\r\n  border-top-left-radius: 4px !important;\r\n  border-top-right-radius: 0px !important;\r\n}\r\n\r\n.tab-vertical .tab-content {\r\n  overflow: auto;\r\n  -webkit-border-radius: 0px 4px 4px 4px;\r\n  -moz-border-radius: 0px 4px 4px 4px;\r\n  border-radius: 0px 4px 4px 4px;\r\n  background: #fff;\r\n  padding: 30px;\r\n}\r\n\r\n/*----- Tabs Outline CSS ----*/\r\n\r\n.tab-outline {}\r\n\r\n.tab-outline .nav.nav-tabs {\r\n  border-bottom: transparent;\r\n}\r\n\r\n.tab-outline .nav.nav-tabs .nav-item .nav-link {\r\n  display: block;\r\n  padding: 17px 49px;\r\n  color: #71748d;\r\n  background-color: #e9e9f2;\r\n  border-color: #c4c4cf #c4c4cf #c4c4cf;\r\n  margin-right: 3px;\r\n}\r\n\r\n.tab-outline .nav.nav-tabs .nav-item {}\r\n\r\n.tab-outline .nav-tabs .nav-link.active {\r\n  color: #5969ff !important;\r\n  background-color: transparent !important;\r\n  border-color: #c4c4cf #c4c4cf #efeff6 !important;\r\n}\r\n\r\n.tab-outline .nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {\r\n  border-color: transparent;\r\n  color: #5969ff !important;\r\n}\r\n\r\n.tab-outline .tab-content {\r\n  padding: 30px;\r\n  border: 1px solid #c4c4cf;\r\n  border-radius: 4px;\r\n  border-top-left-radius: 0px;\r\n}\r\n\r\n/*----- Tabs Vertical Outline CSS ----*/\r\n\r\n.tab-vertical-outline {}\r\n\r\n.tab-vertical-outline .nav.nav-tabs {\r\n  float: left;\r\n  display: block;\r\n  margin-right: 0px;\r\n  border-bottom: 0;\r\n}\r\n\r\n.tab-vertical-outline .nav.nav-tabs .nav-item {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.tab-vertical-outline .nav-tabs .nav-link {\r\n  border: 1px solid transparent;\r\n  border-top-left-radius: 0.25rem;\r\n  border-top-right-radius: 0.25rem;\r\n  background: #fff;\r\n  padding: 17px 49px;\r\n  color: #71748d;\r\n  background-color: #e9e9f2;\r\n  -webkit-border-radius: 4px 0px 0px 4px;\r\n  -moz-border-radius: 4px 0px 0px 4px;\r\n  border-radius: 4px 0px 0px 4px;\r\n  border: 1px solid #c4c4cf !important;\r\n}\r\n\r\n.tab-vertical-outline .nav-tabs .nav-link.active {\r\n  color: #5969ff;\r\n  border: 1px solid #c4c4cf !important;\r\n  background: transparent;\r\n  border-right: 1px solid #efeff6 !important;\r\n}\r\n\r\n.tab-vertical-outline .nav-tabs .nav-link {\r\n  border: 1px solid transparent;\r\n  border-top-left-radius: 4px !important;\r\n  border-top-right-radius: 0px !important;\r\n}\r\n\r\n.tab-vertical-outline .tab-content {\r\n  overflow: auto;\r\n  -webkit-border-radius: 0px 4px 4px 4px;\r\n  -moz-border-radius: 0px 4px 4px 4px;\r\n  border-radius: 0px 4px 4px 4px;\r\n  background: transparent;\r\n  padding: 30px;\r\n  border: 1px solid #c4c4cf;\r\n  left: -1px;\r\n  position: relative;\r\n  z-index: -1;\r\n}\r\n\r\n/*--- Simple Card Tabs ----*/\r\n\r\n.simple-card {\r\n  background-color: #fff;\r\n  border-radius: 4px;\r\n  border: 1px solid #e9e9f2;\r\n}\r\n\r\n.simple-card .nav.nav-tabs {\r\n  border-bottom: 1px solid #e6e6f2;\r\n}\r\n\r\n.simple-card .nav.nav-tabs .nav-item {}\r\n\r\n.simple-card .nav.nav-tabs .nav-item .nav-link {\r\n  padding: 17px 49px;\r\n  color: #71748d;\r\n  background: #f8f8fb;\r\n  border-color: #e9e9f2 #e9e9f2 #e9e9f2;\r\n  margin-right: -1px;\r\n  border-radius: 0px;\r\n  border-top: transparent;\r\n}\r\n\r\n.simple-card .nav-tabs .nav-link.active {\r\n  color: #5969ff !important;\r\n  background-color: transparent !important;\r\n  border-color: #e9e9f2 #e9e9f2 #fff !important;\r\n}\r\n\r\n.simple-card .tab-content {\r\n  padding: 30px;\r\n}\r\n\r\n/*--- Simple Card Outline Tabs ----*/\r\n\r\n.simple-outline-card {\r\n  border-radius: 4px;\r\n  border: 1px solid #c4c4cf;\r\n}\r\n\r\n.simple-outline-card .nav.nav-tabs {\r\n  border-bottom: 1px solid #c4c4cf;\r\n}\r\n\r\n.simple-outline-card .nav.nav-tabs .nav-item {}\r\n\r\n.simple-outline-card .nav.nav-tabs .nav-item .nav-link {\r\n  padding: 17px 49px;\r\n  color: #71748d;\r\n  background: #e9e9f2;\r\n  border-color: #c4c4cf #c4c4cf #c4c4cf;\r\n  margin-right: -1px;\r\n  border-radius: 0px;\r\n  border-top: transparent;\r\n}\r\n\r\n.simple-outline-card .nav-tabs .nav-link.active {\r\n  color: #5969ff !important;\r\n  background-color: transparent !important;\r\n  border-color: #c4c4cf #c4c4cf #efeff6 !important;\r\n}\r\n\r\n.simple-outline-card .tab-content {\r\n  padding: 30px;\r\n}\r\n\r\n/* -----------------------\r\nPills Regular\r\n-------------------------*/\r\n\r\n.pills-regular {}\r\n\r\n.pills-regular .nav.nav-pills {}\r\n\r\n.pills-regular .nav.nav-pills .nav-item {}\r\n\r\n.pills-regular .nav.nav-pills .nav-item .nav-link {\r\n  background-color: #dddde8;\r\n  padding: 14px 26px;\r\n  margin-right: 3px;\r\n  color: #71748d;\r\n  font-size: 16px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.pills-regular .nav.nav-pills .nav-item .nav-link.active {\r\n  background-color: #fff;\r\n  color: #5969ff;\r\n}\r\n\r\n.pills-regular .tab-content {\r\n  background-color: #fff;\r\n  padding: 30px;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* -----------------------\r\nPills Outline\r\n-------------------------*/\r\n\r\n.pills-outline {}\r\n\r\n.pills-outline .nav.nav-pills {}\r\n\r\n.pills-outline .nav.nav-pills .nav-item {}\r\n\r\n.pills-outline .nav.nav-pills .nav-item .nav-link {\r\n  background-color: transparent;\r\n  padding: 16px 52px;\r\n  margin-right: 3px;\r\n  color: #71748d;\r\n  border: 1px solid #c4c4cf;\r\n}\r\n\r\n.pills-outline .nav.nav-pills .nav-item .nav-link.active {\r\n  background-color: transparent;\r\n  color: #5969ff;\r\n}\r\n\r\n.pills-outline .tab-content {\r\n  background-color: transparent;\r\n  padding: 30px;\r\n  border-radius: 4px;\r\n  border: 1px solid #c4c4cf;\r\n}\r\n\r\n/* -----------------------\r\nPills vertical\r\n-------------------------*/\r\n\r\n.pills-vertical {}\r\n\r\n.pills-vertical .nav.nav-pills {}\r\n\r\n.pills-vertical .nav.nav-pills .nav-link {\r\n  background-color: #dddde8;\r\n  padding: 16px 52px;\r\n  margin-bottom: 4px;\r\n  color: #71748d;\r\n}\r\n\r\n.pills-vertical .nav.nav-pills .nav-link.active {\r\n  background-color: #fff;\r\n  color: #5969ff;\r\n}\r\n\r\n.pills-vertical .tab-content {\r\n  background-color: #fff;\r\n  padding: 30px;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* -----------------------\r\n2.9  Accordions\r\n-------------------------*/\r\n\r\n.accrodion-regular {}\r\n\r\n.accrodion-regular .card {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.accrodion-regular .card-body {\r\n  margin-top: -1px;\r\n}\r\n\r\n.accrodion-regular .card .card-header {\r\n  font-size: 16px;\r\n  padding: 10px;\r\n  background-color: transparent;\r\n}\r\n\r\n.accrodion-regular .card .card-header:first-child {\r\n  border-radius: calc(4px - 1px) calc(4px - 1px) 0 0;\r\n}\r\n\r\n.accrodion-regular .card .card-header .btn-link {\r\n  color: #3d405c;\r\n  text-decoration: none;\r\n}\r\n\r\n.accrodion-regular .card .card-header .btn-link:hover {\r\n  color: #f12357;\r\n  text-decoration: none;\r\n}\r\n\r\n.accrodion-outline {}\r\n\r\n.accrodion-outline .card {\r\n  margin-bottom: 5px;\r\n  background-color: transparent;\r\n  border-color: #d9d9e3;\r\n  box-shadow: none;\r\n}\r\n\r\n.accrodion-outline .card-body {\r\n  border: 1px solid #d9d9e3;\r\n  margin-top: -1px;\r\n}\r\n\r\n.accrodion-outline .card .card-header {\r\n  font-size: 16px;\r\n  padding: 10px;\r\n  border: 1px solid #d9d9e3;\r\n  background-color: transparent;\r\n}\r\n\r\n.accrodion-outline .card .card-header:first-child {\r\n  border-radius: calc(4px - 1px) calc(4px - 1px) 0 0;\r\n}\r\n\r\n.accrodion-outline .card .card-header .btn-link {\r\n  color: #3d405c;\r\n  text-decoration: none;\r\n}\r\n\r\n.accrodion-outline .card .card-header .btn-link:hover {\r\n  color: #f12357;\r\n  text-decoration: none;\r\n}\r\n\r\n/* -----------------------\r\n2.10  Typography\r\n-------------------------*/\r\n\r\n/* -----------------------\r\n2.11  Listgroup\r\n-------------------------*/\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: 16px 20px;\r\n  margin-bottom: -1px;\r\n  border: 1px solid #e6e6f2;\r\n}\r\n\r\n/* -----------------------\r\n2.12  Multiselect\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n2.13 Badge\r\n-------------------------*/\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: 3px 7px;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 1;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.badge-primary {\r\n  background-color: #5969ff;\r\n}\r\n\r\n.badge-primary[href]:focus,\r\n.badge-primary[href]:hover {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #4656e9;\r\n}\r\n\r\n.badge-brand {\r\n  background-color: #ffb739;\r\n  color: #2e2f39;\r\n}\r\n\r\n.badge-brand[href]:focus,\r\n.badge-brand[href]:hover {\r\n  color: #2e2f39;\r\n  background-color: #efb63e;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-secondary {\r\n  background-color: #ff407b;\r\n}\r\n\r\n.badge-secondary[href]:focus,\r\n.badge-secondary[href]:hover {\r\n  color: #fff;\r\n  background-color: #ff407b;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-success {\r\n  background-color: #21ae41;\r\n}\r\n\r\n.badge-success[href]:focus,\r\n.badge-success[href]:hover {\r\n  color: #fff;\r\n  background-color: #21ae41;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-danger {\r\n  background-color: #da0419;\r\n}\r\n\r\n.badge-danger[href]:focus,\r\n.badge-danger[href]:hover {\r\n  color: #fff;\r\n  background-color: #ef172c;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-warning {\r\n  background-color: #f3b600;\r\n  color: #2e2f39;\r\n}\r\n\r\n.badge-warning[href]:focus,\r\n.badge-warning[href]:hover {\r\n  color: #2e2f39;\r\n  background-color: #f3b600;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-info {\r\n  background-color: #0998b0;\r\n}\r\n\r\n.badge-info[href]:focus,\r\n.badge-info[href]:hover {\r\n  color: #fff;\r\n  background-color: #17c0dc;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-light {\r\n  background-color: #efeff6;\r\n  color: #757691;\r\n}\r\n\r\n.badge-light[href]:focus,\r\n.badge-light[href]:hover {\r\n  color: #2e2f39;\r\n  background-color: #d7d7df;\r\n  text-decoration: none;\r\n}\r\n\r\n.badge-dark {\r\n  background-color: #1f202b;\r\n}\r\n\r\n.badge-light[href]:focus,\r\n.badge-light[href]:hover {\r\n  color: #2e2f39;\r\n  background-color: #d7d7df;\r\n  text-decoration: none;\r\n}\r\n\r\n.dashboard-badges {}\r\n\r\n.badge-dot {\r\n  border-radius: 100%;\r\n  padding: 4px;\r\n  display: inline-block;\r\n  margin-right: 3px;\r\n}\r\n\r\n.label {\r\n  padding: 3px 10px;\r\n  line-height: 13px;\r\n  color: #fff;\r\n  font-weight: 400;\r\n  border-radius: 2px;\r\n  font-size: 75%;\r\n}\r\n\r\n.label-rounded {\r\n  border-radius: 60px;\r\n}\r\n\r\n.label-primary {\r\n  background-color: #5969ff;\r\n}\r\n\r\n.label-success {\r\n  background-color: #2ec551;\r\n}\r\n\r\n.label-danger {\r\n  background-color: #ef172c;\r\n}\r\n\r\n/*-----------------------\r\n2.14 Pagination\r\n-------------------------*/\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: 0.5rem 0.75rem;\r\n  margin-left: 0px;\r\n  margin-right: 5px;\r\n  line-height: 1.25;\r\n  color: #71748d;\r\n  background-color: #fff;\r\n  border: 1px solid #e6e6f2;\r\n  border-radius: 3px;\r\n  line-height: 1;\r\n}\r\n\r\n.page-link:hover {\r\n  z-index: 2;\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #5969ff;\r\n  border-color: #5969ff;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  z-index: 1;\r\n  color: #fff;\r\n  background-color: #5969ff;\r\n  border-color: #5969ff;\r\n}\r\n\r\n/*-----------------------\r\n2.15 Spinner\r\n-------------------------*/\r\n\r\n.spinner-xxl {\r\n  width: 150px;\r\n  height: 150px;\r\n}\r\n\r\n.spinner-xl {\r\n  width: 120px;\r\n  height: 120px;\r\n}\r\n\r\n.spinner-lg {\r\n  width: 100px;\r\n  height: 100px;\r\n}\r\n\r\n.spinner-md {\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n\r\n.spinner-sm {\r\n  width: 60px;\r\n  height: 60px;\r\n}\r\n\r\n.spinner-xs {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.dashboard-spinner {\r\n  margin: 0px 8px;\r\n  border-radius: 50%;\r\n  background-color: transparent;\r\n  border: 6px solid transparent;\r\n  border-top: 6px solid #5969ff;\r\n  border-left: 6px solid #5969ff;\r\n  -webkit-animation: 1s spin linear infinite;\r\n  animation: 1s spin linear infinite;\r\n  display: inline-block;\r\n}\r\n\r\n.spinner-primary {\r\n  border-top-color: #5969ff;\r\n  border-left-color: #5969ff;\r\n}\r\n\r\n.spinner-secondary {\r\n  border-top-color: #6c757d;\r\n  border-left-color: #6c757d;\r\n}\r\n\r\n.spinner-success {\r\n  border-top-color: #2ec551;\r\n  border-left-color: #2ec551;\r\n}\r\n\r\n.spinner-danger {\r\n  border-top-color: #dc3545;\r\n  border-left-color: #dc3545;\r\n}\r\n\r\n.spinner-warning {\r\n  border-top-color: #ffc107;\r\n  border-left-color: #ffc107;\r\n}\r\n\r\n.spinner-info {\r\n  border-top-color: #17a2b8;\r\n  border-left-color: #17a2b8;\r\n}\r\n\r\n@-webkit-keyframes spin {\r\n  from {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/*-----------------------\r\n2.16 Switch Toggle\r\n-------------------------*/\r\n\r\n.switch-button.switch-button-xs {\r\n  height: 20px;\r\n  line-height: 16px;\r\n  width: 50px;\r\n}\r\n\r\n.switch-button {\r\n  display: inline-block;\r\n  border-radius: 50px;\r\n  background-color: #9e9eaf;\r\n  width: 60px;\r\n  height: 27px;\r\n  padding: 4px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n\r\n.switch-button input[type='checkbox'] {\r\n  display: none;\r\n}\r\n\r\n.switch-button input[type='checkbox']:checked+span label {\r\n  float: right;\r\n  border-color: #2a75f3;\r\n}\r\n\r\n.switch-button.switch-button-xs label {\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n\r\n.switch-button input[type='checkbox']:checked+span label:before {\r\n  position: absolute;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  z-index: 0;\r\n  content: 'ON';\r\n  color: #fff;\r\n  left: 0;\r\n  text-align: left;\r\n  padding-left: 10px;\r\n}\r\n\r\n.switch-button.switch-button-xs label:before {\r\n  line-height: 21px;\r\n}\r\n\r\n.switch-button label:before {\r\n  position: absolute;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  z-index: 0;\r\n  content: 'OFF';\r\n  right: 0;\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  line-height: 27px;\r\n  top: 0;\r\n  text-align: right;\r\n  padding-right: 10px;\r\n  color: #fff;\r\n}\r\n\r\n.switch-button input[type='checkbox']:checked+span {\r\n  background-color: #5969ff;\r\n  display: block;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 4px;\r\n}\r\n\r\n.switch-button.switch-button-sm label {\r\n  height: 16px;\r\n  width: 16px;\r\n}\r\n\r\n.switch-button label {\r\n  border-radius: 50%;\r\n  box-shadow: 0 0 1px 1px #fff inset;\r\n  background-color: #fff;\r\n  margin: 0;\r\n  height: 19px;\r\n  width: 19px;\r\n  z-index: 1;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.switch-button.switch-button-sm {\r\n  height: 24px;\r\n  width: 57px;\r\n  line-height: 20px;\r\n}\r\n\r\n.switch-button.switch-button-lg {\r\n  height: 30px;\r\n  line-height: 32px;\r\n  width: 64px;\r\n}\r\n\r\n.switch-button.switch-button-success input[type='checkbox']:checked+span {\r\n  background-color: #2ec551;\r\n}\r\n\r\n.switch-button.switch-button-warning input[type='checkbox']:checked+span {\r\n  background-color: #ffc750;\r\n}\r\n\r\n.switch-button.switch-button-danger input[type='checkbox']:checked+span {\r\n  background-color: #ef172c;\r\n}\r\n\r\n/* ==========================================================================\r\n  3. Charts\r\n  ========================================================================== */\r\n\r\n/*-----------------------\r\n3.1 Chartist.js\r\n-------------------------*/\r\n\r\n.ct-line.ct-threshold-above,\r\n.ct-point.ct-threshold-above,\r\n.ct-bar.ct-threshold-above {\r\n  stroke: #f05b4f;\r\n}\r\n\r\n.ct-line.ct-threshold-below,\r\n.ct-point.ct-threshold-below,\r\n.ct-bar.ct-threshold-below {\r\n  stroke: #59922b;\r\n}\r\n\r\n.ct-area.ct-threshold-above {\r\n  fill: #f05b4f;\r\n}\r\n\r\n.ct-area.ct-threshold-below {\r\n  fill: #59922b;\r\n}\r\n\r\n/*-----------------------\r\n3.2 Sprkling.js\r\n-------------------------*/\r\n\r\n.spark-chart {\r\n  display: inline-block;\r\n}\r\n\r\n.spark-chart-info {\r\n  display: inline-block;\r\n  float: right;\r\n}\r\n\r\n/*-----------------------\r\n3.3 Charts.js\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n3.4 Morris.js\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n3.5 C3 Charts.js\r\n-------------------------*/\r\n\r\n/* ==========================================================================\r\n  4. Forms\r\n  ========================================================================== */\r\n\r\n/*-----------------------\r\n4.1.  Form Elements\r\n------------------*/\r\n\r\n/*-----------------------\r\n4.2.  Form Validations\r\n------------------*/\r\n\r\n/*-----------------------\r\n4.3.  Multiseelct\r\n-----------------*/\r\n\r\n/*-----------------------\r\n4.4.  Wizard\r\n------------------*/\r\n\r\n/*-----------------------\r\n4.5.  Summar Note / Text Editor\r\n------------------*/\r\n\r\n/*-----------------------\r\n4.6.  Multiupload\r\n--------------------*/\r\n\r\n/* ==========================================================================\r\n 5. Table\r\n ========================================================================== */\r\n\r\n/*-----------------------\r\n5.1.  General\r\n--------------------*/\r\n\r\n.table {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.table td,\r\n.table th {\r\n  padding: 10px;\r\n  vertical-align: middle;\r\n  border-top: 1px solid #e6e6f2;\r\n  font-weight: normal;\r\n}\r\n\r\n.table thead th {\r\n  vertical-align: bottom;\r\n  border-bottom: 2px solid #e6e6f2;\r\n}\r\n\r\n.table thead th,\r\n.table th {\r\n  color: #3d405c;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.table-bordered {\r\n  border: 1px solid #e6e6f2;\r\n}\r\n\r\n.table-bordered td,\r\n.table-bordered th {\r\n  border: 1px solid #e6e6f2;\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n  background-color: rgba(230, 230, 242, 0.5);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: rgba(230, 230, 242, 0.5);\r\n}\r\n\r\n/*-----------------------\r\n5.2.  Data Tables\r\n--------------------*/\r\n\r\n/*-- row group table */\r\n\r\ntr.group,\r\ntr.group:hover {\r\n  background-color: #5969ff !important;\r\n  color: #fff;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 18px;\r\n}\r\n\r\n/*-----------------------\r\n5.3. Table Filters\r\n--------------------*/\r\n\r\n/* ==========================================================================\r\n 6. Pages\r\n ========================================================================== */\r\n\r\n/*-----------------------\r\n6.1 Blank Page\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.2 Blank Page Header\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.3 Login\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.4 Sign up Page\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.5 Forgot Password\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.6 Profile\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.7 Pricing\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.8 Timeline\r\n-------------------------*/\r\n\r\n/* --------------------------------\r\n\r\nPatterns - reusable parts of our design\r\n\r\n-------------------------------- */\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .cd-is-hidden {\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n/* --------------------------------\r\n\r\nVertical Timeline - by CodyHouse.co\r\n\r\n-------------------------------- */\r\n\r\n.cd-timeline {\r\n  overflow: hidden;\r\n  margin: 2em auto;\r\n}\r\n\r\n.cd-timeline__container {\r\n  position: relative;\r\n  width: 90%;\r\n  max-width: 1170px;\r\n  margin: 0 auto;\r\n  padding: 2em 0;\r\n}\r\n\r\n.cd-timeline__container::before {\r\n  /* this is the vertical line */\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 18px;\r\n  height: 100%;\r\n  width: 4px;\r\n  background: #dedee9;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .cd-timeline {\r\n    margin-top: 3em;\r\n    margin-bottom: 3em;\r\n  }\r\n\r\n  .cd-timeline__container::before {\r\n    left: 50%;\r\n    margin-left: -2px;\r\n  }\r\n}\r\n\r\n.cd-timeline__block {\r\n  position: relative;\r\n  margin: 2em 0;\r\n}\r\n\r\n.cd-timeline__block:after {\r\n  /* clearfix */\r\n  content: '';\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.cd-timeline__block:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.cd-timeline__block:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .cd-timeline__block {\r\n    margin: 4em 0;\r\n  }\r\n}\r\n\r\n.cd-timeline__img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  -webkit-box-shadow: 0 0 0 4px white, inset 0 2px 0 rgba(0, 0, 0, 0.08),\r\n    0 3px 0 4px rgba(0, 0, 0, 0.05);\r\n  box-shadow: 0 0 0 4px white, inset 0 2px 0 rgba(0, 0, 0, 0.08),\r\n    0 3px 0 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.cd-timeline__img img {\r\n  display: block;\r\n  width: 24px;\r\n  height: 24px;\r\n  position: relative;\r\n  left: 50%;\r\n  top: 50%;\r\n  margin-left: -12px;\r\n  margin-top: -12px;\r\n}\r\n\r\n.cd-timeline__img.cd-timeline__img--picture {\r\n  background: #2ec551;\r\n}\r\n\r\n.cd-timeline__img.cd-timeline__img--movie {\r\n  background: #ef172c;\r\n}\r\n\r\n.cd-timeline__img.cd-timeline__img--location {\r\n  background: #ffc108;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .cd-timeline__img {\r\n    width: 60px;\r\n    height: 60px;\r\n    left: 50%;\r\n    margin-left: -30px;\r\n    /* Force Hardware Acceleration */\r\n    -webkit-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n  }\r\n\r\n  .cd-timeline__img.cd-timeline__img--bounce-in {\r\n    visibility: visible;\r\n    -webkit-animation: cd-bounce-1 0.6s;\r\n    animation: cd-bounce-1 0.6s;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0.5);\r\n    transform: scale(0.5);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1.2);\r\n    transform: scale(1.2);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0.5);\r\n    transform: scale(0.5);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1.2);\r\n    transform: scale(1.2);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.cd-timeline__content {\r\n  position: relative;\r\n  margin-left: 60px;\r\n  background: white;\r\n  border-radius: 0.25em;\r\n  padding: 1em;\r\n  border: none;\r\n  -webkit-box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);\r\n  -moz-box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);\r\n  box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);\r\n}\r\n\r\n.cd-timeline__content:after {\r\n  /* clearfix */\r\n  content: '';\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.cd-timeline__content::before {\r\n  /* triangle next to content block */\r\n  content: '';\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 100%;\r\n  height: 0;\r\n  width: 0;\r\n  border: 7px solid transparent;\r\n  border-right: 7px solid white;\r\n}\r\n\r\n.cd-timeline__content h2 {}\r\n\r\n.cd-timeline__content p,\r\n.cd-timeline__read-more,\r\n.cd-timeline__date {}\r\n\r\n.cd-timeline__content p {}\r\n\r\n.cd-timeline__read-more,\r\n.cd-timeline__date {\r\n  display: inline-block;\r\n}\r\n\r\n.cd-timeline__read-more {\r\n  float: right;\r\n  padding: 0.8em 1em;\r\n  background: #acb7c0;\r\n  color: white;\r\n  border-radius: 0.25em;\r\n}\r\n\r\n.cd-timeline__read-more:hover {\r\n  background-color: #bac4cb;\r\n}\r\n\r\n.cd-timeline__date {\r\n  float: left;\r\n  padding: 0.8em 0;\r\n  opacity: 0.7;\r\n}\r\n\r\n@media only screen and (min-width: 768px) {\r\n  .cd-timeline__content h2 {}\r\n\r\n  .cd-timeline__content p {}\r\n\r\n  .cd-timeline__read-more,\r\n  .cd-timeline__date {}\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .cd-timeline__content {\r\n    margin-left: 0;\r\n    padding: 1.6em;\r\n    width: 45%;\r\n    /* Force Hardware Acceleration */\r\n    -webkit-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n  }\r\n\r\n  .cd-timeline__content::before {\r\n    top: 24px;\r\n    left: 100%;\r\n    border-color: transparent;\r\n    border-left-color: white;\r\n  }\r\n\r\n  .cd-timeline__read-more {\r\n    float: left;\r\n  }\r\n\r\n  .cd-timeline__date {\r\n    position: absolute;\r\n    width: 100%;\r\n    left: 122%;\r\n    top: 6px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .cd-timeline__block:nth-child(even) .cd-timeline__content {\r\n    float: right;\r\n  }\r\n\r\n  .cd-timeline__block:nth-child(even) .cd-timeline__content::before {\r\n    top: 24px;\r\n    left: auto;\r\n    right: 100%;\r\n    border-color: transparent;\r\n    border-right-color: white;\r\n  }\r\n\r\n  .cd-timeline__block:nth-child(even) .cd-timeline__read-more {\r\n    float: right;\r\n  }\r\n\r\n  .cd-timeline__block:nth-child(even) .cd-timeline__date {\r\n    left: auto;\r\n    right: 122%;\r\n    text-align: right;\r\n  }\r\n\r\n  .cd-timeline__content.cd-timeline__content--bounce-in {\r\n    visibility: visible;\r\n    -webkit-animation: cd-bounce-2 0.6s;\r\n    animation: cd-bounce-2 0.6s;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n\r\n  /* inverse bounce effect on even content blocks */\r\n  .cd-timeline__block:nth-child(even) .cd-timeline__content.cd-timeline__content--bounce-in {\r\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\r\n    animation: cd-bounce-2-inverse 0.6s;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(-100px);\r\n    transform: translateX(-100px);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(-100px);\r\n    transform: translateX(-100px);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(100px);\r\n    transform: translateX(100px);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(-20px);\r\n    transform: translateX(-20px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(100px);\r\n    transform: translateX(100px);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(-20px);\r\n    transform: translateX(-20px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n/*-----------------------\r\n6.9 404 error\r\n-------------------------*/\r\n\r\n.error-section {\r\n  padding: 74px 0px;\r\n}\r\n\r\n.error-section-content {\r\n  padding-top: 30px;\r\n  color: #3d405c;\r\n  padding-bottom: 30px;\r\n}\r\n\r\n/*-----------------------\r\n6.9 Calendar\r\n-------------------------*/\r\n\r\n#calendar1 {\r\n  margin: 0 auto;\r\n}\r\n\r\n#wrap {\r\n  /* width: 1100px; */\r\n  margin: 0 auto;\r\n}\r\n\r\n#external-events {\r\n  float: left;\r\n  width: 270px;\r\n  padding: 0 20px;\r\n  border: 1px solid #e0e4ef;\r\n  background: #f9f9ff;\r\n  text-align: left;\r\n  border-radius: 4px;\r\n}\r\n\r\n#external-events h4 {\r\n  font-size: 16px;\r\n  margin-top: 0;\r\n  padding-top: 1em;\r\n}\r\n\r\n#external-events .fc-event {\r\n  margin: 10px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n#external-events p {\r\n  margin: 1.5em 0;\r\n  font-size: 11px;\r\n  color: #666;\r\n}\r\n\r\n#external-events p input {\r\n  margin: 0;\r\n  vertical-align: middle;\r\n}\r\n\r\n#calendar {\r\n  float: right;\r\n  width: 1240px;\r\n}\r\n\r\n/*-----------------------\r\n6.10 Metrics\r\n-------------------------*/\r\n\r\n.metric-row {\r\n  margin-bottom: 1.25rem;\r\n  border-radius: 0.25rem;\r\n  -webkit-box-align: stretch;\r\n  -ms-flex-align: stretch;\r\n  align-items: stretch;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  margin-right: -10px;\r\n  margin-left: -10px;\r\n}\r\n\r\n.metric-value {\r\n  margin-bottom: 0;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n}\r\n\r\n.metric-label {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #686f76;\r\n  white-space: nowrap;\r\n}\r\n\r\n.metric-label:last-child {\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.metric-value>sub,\r\n.metric-value>sup {\r\n  color: #ffa76a;\r\n  font-size: 0.5em;\r\n}\r\n\r\n.card-metric {\r\n  text-align: center;\r\n  background-color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  -webkit-box-shadow: 0 0 0 1px rgba(61, 70, 79, 0.05),\r\n    0 1px 3px 0 rgba(61, 70, 79, 0.15);\r\n  box-shadow: 0 0 0 1px rgba(61, 70, 79, 0.05),\r\n    0 1px 3px 0 rgba(61, 70, 79, 0.15);\r\n}\r\n\r\n.metric-row .metric {\r\n  margin: 8px 0;\r\n  min-height: 136px;\r\n}\r\n\r\n.metric-bordered {\r\n  border: 1px solid #d4d5d7;\r\n}\r\n\r\n.metric-value>sub {\r\n  bottom: 5px;\r\n}\r\n\r\n/*-----------------------\r\n6.11 Media Objects\r\n-------------------------*/\r\n\r\n.dashboard-media-object .card-footer {\r\n  padding: 0px;\r\n}\r\n\r\n.btn-account {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin: 0;\r\n  border: 0;\r\n  -ms-flex-wrap: none;\r\n  flex-wrap: none;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  background: none;\r\n  color: inherit;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  cursor: pointer;\r\n  -webkit-transition: background-color 0.15s;\r\n  transition: background-color 0.15s;\r\n  outline: 0;\r\n}\r\n\r\n.btn-account .account-summary {\r\n  margin-right: 16px;\r\n  margin-left: 8px;\r\n  display: block;\r\n  text-align: left;\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: clip;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn-account .account-description,\r\n.btn-account .account-name {\r\n  margin: 0;\r\n  display: block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 500;\r\n  line-height: 16px;\r\n}\r\n\r\n.btn-account .account-description {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  opacity: 0.7;\r\n}\r\n\r\n.user-avatar {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.avatar-badge {\r\n  position: absolute;\r\n  right: 3px;\r\n  bottom: 4px;\r\n  display: block;\r\n  width: 8px;\r\n  height: 8px;\r\n  line-height: 1.6;\r\n  text-align: center;\r\n  font-size: 8px;\r\n  color: #fff;\r\n  background-color: #a9acb0;\r\n  border-radius: 8px;\r\n  -webkit-box-shadow: 0 0 0 2px #fff;\r\n  box-shadow: 0 0 0 2px #fff;\r\n  z-index: 2;\r\n}\r\n\r\n.avatar-badge.online {\r\n  background-color: #00a28a;\r\n}\r\n\r\n.avatar-badge.idle {\r\n  background-color: #ec935e;\r\n}\r\n\r\n.avatar-badge.busy {\r\n  background-color: #ea6759;\r\n}\r\n\r\n.avatar-badge.offline {\r\n  color: #a9acb0;\r\n  background-color: #a9acb0;\r\n}\r\n\r\n.avatar-badge.has-indicator {\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n.avatar-group {\r\n  display: inline-block;\r\n}\r\n\r\n.avatar-group .user-avatar img {\r\n  -webkit-box-shadow: 0 0 0 2px #fff;\r\n  box-shadow: 0 0 0 2px #fff;\r\n}\r\n\r\n.avatar-group .user-avatar+.user-avatar {\r\n  display: inline-block;\r\n  margin-left: -10px;\r\n}\r\n\r\n.avatar-group .user-avatar:focus,\r\n.avatar-group .user-avatar:hover {\r\n  z-index: 2;\r\n}\r\n\r\n.user-avatar-floated {\r\n  margin-top: -50px;\r\n  z-index: 2;\r\n}\r\n\r\n.metric {\r\n  position: relative;\r\n  padding: 16px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-flex: 1;\r\n  -ms-flex-positive: 1;\r\n  flex-grow: 1;\r\n  max-width: 100%;\r\n  border-radius: 4px;\r\n  cursor: default;\r\n}\r\n\r\n.metric-label:last-child {\r\n  margin-top: 12px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-footer-item {\r\n  padding: 12px 35px;\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  text-align: center;\r\n  display: inline-block;\r\n}\r\n\r\n.card-footer-item-bordered:not(:last-child) {\r\n  border-right: 1px solid rgb(230, 230, 242);\r\n}\r\n\r\n/*-------------------- User icon sizes ---------------------*/\r\n\r\n.user-avatar-xxl {\r\n  height: 128px;\r\n  width: 128px;\r\n}\r\n\r\n.user-avatar-xl {\r\n  height: 90px;\r\n  width: 90px;\r\n}\r\n\r\n.user-avatar-lg {\r\n  height: 48px;\r\n  width: 48px;\r\n}\r\n\r\n.user-avatar-md {\r\n  height: 32px;\r\n  width: 32px;\r\n}\r\n\r\n.user-avatar-sm {\r\n  height: 24px;\r\n  width: 24px;\r\n}\r\n\r\n.user-avatar-xs {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n\r\n/*-----------------------\r\n6.12 Shortable / Nesetable\r\n-------------------------*/\r\n\r\n.dashboard-short-list {}\r\n\r\n.drag-handle,\r\n.drag-indicator {\r\n  cursor: move;\r\n  cursor: -webkit-grab;\r\n  cursor: grab;\r\n}\r\n\r\n.card-header+.list-group .list-group-item:first-child {\r\n  border-top: 0;\r\n}\r\n\r\n.list-group-bordered .list-group-item {\r\n  border-color: rgba(19, 29, 40, 0.125);\r\n}\r\n\r\n/*.list-group-item:first-child {\r\n    border-width: 0 0 1px;\r\n}*/\r\n\r\n.drag-indicator {\r\n  display: inline-block;\r\n  margin: 0 0.5em;\r\n  height: 8px;\r\n  width: 6px;\r\n  //background-image: url(../images/drag-indicator.png);\r\n  -webkit-transform: translate3d(-0.5em, 0, 0);\r\n  transform: translate3d(-0.5em, 0, 0);\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.dashboard-short-list .list-group-item {\r\n  display: flex;\r\n}\r\n\r\n.dd {\r\n  position: relative;\r\n  display: block;\r\n  margin: 0;\r\n  padding: 0;\r\n  max-width: 100%;\r\n  list-style: none;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n}\r\n\r\n.dd-list {\r\n  display: block;\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  width: 100%;\r\n}\r\n\r\n.dd-list .dd-list {\r\n  padding-left: 30px;\r\n}\r\n\r\n.dd-collapsed .dd-list {\r\n  display: none;\r\n}\r\n\r\n.dd-item,\r\n.dd-empty,\r\n.dd-placeholder {\r\n  display: block;\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n  min-height: 20px;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n}\r\n\r\n.dd-handle {\r\n  margin-bottom: -1px;\r\n  padding: 0.75rem 1rem;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  border-top: 1px solid rgba(19, 29, 40, 0.125);\r\n  border-bottom: 1px solid rgba(19, 29, 40, 0.125);\r\n}\r\n\r\n.dd-handle:hover {\r\n  color: #5969ff;\r\n  background: #fff;\r\n}\r\n\r\n.dd-item>button {\r\n  display: block;\r\n  position: relative;\r\n  cursor: pointer;\r\n  float: left;\r\n  width: 34px;\r\n  height: 20px;\r\n  margin: 18px 0;\r\n  padding: 0;\r\n  text-indent: 100%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  border: 0;\r\n  background: transparent;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.dd-item>button:before {\r\n  content: '+';\r\n  display: block;\r\n  position: absolute;\r\n  width: 100%;\r\n  text-align: center;\r\n  text-indent: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.dd-item>button[data-action='collapse']:before {\r\n  content: '-';\r\n}\r\n\r\n.dd-placeholder,\r\n.dd-empty {\r\n  margin: 5px 0;\r\n  padding: 0;\r\n  min-height: 30px;\r\n  background: #f5f5f5;\r\n  border: 1px dashed #b6bcbf;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n}\r\n\r\n.dd-empty {\r\n  border: 1px dashed #bbb;\r\n  min-height: 100px;\r\n  background-color: #f5f5f5;\r\n  background-image: -webkit-linear-gradient(45deg,\r\n      #fff 25%,\r\n      transparent 25%,\r\n      transparent 75%,\r\n      #fff 75%,\r\n      #fff),\r\n    -webkit-linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);\r\n  background-image: -moz-linear-gradient(45deg,\r\n      #fff 25%,\r\n      transparent 25%,\r\n      transparent 75%,\r\n      #fff 75%,\r\n      #fff),\r\n    -moz-linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%, #fff);\r\n  background-image: linear-gradient(45deg,\r\n      #fff 25%,\r\n      transparent 25%,\r\n      transparent 75%,\r\n      #fff 75%,\r\n      #fff),\r\n    linear-gradient(45deg,\r\n      #fff 25%,\r\n      transparent 25%,\r\n      transparent 75%,\r\n      #fff 75%,\r\n      #fff);\r\n  background-size: 60px 60px;\r\n  background-position: 0 0, 30px 30px;\r\n}\r\n\r\n.dd-dragel {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  z-index: 9999;\r\n}\r\n\r\n.dd-dragel>.dd-item .dd-handle {\r\n  margin-top: 0;\r\n}\r\n\r\n.dd-dragel .dd-handle {\r\n  -webkit-box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);\r\n  box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/**\r\n* Nestable Extras\r\n*/\r\n\r\n.nestable-lists {\r\n  display: block;\r\n  clear: both;\r\n  padding: 30px 0;\r\n  width: 100%;\r\n  border: 0;\r\n  border-top: 2px solid #ddd;\r\n  border-bottom: 2px solid #ddd;\r\n}\r\n\r\n#nestable-menu {\r\n  padding: 0;\r\n  margin: 20px 0;\r\n}\r\n\r\n#nestable-output,\r\n#nestable2-output {\r\n  width: 100%;\r\n  height: 7em;\r\n  font-size: 0.75em;\r\n  line-height: 1.333333em;\r\n  font-family: Consolas, monospace;\r\n  padding: 5px;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n}\r\n\r\n#nestable2 .dd-handle {}\r\n\r\n#nestable2 .dd-handle:hover {}\r\n\r\n#nestable2 .dd-item>button:before {}\r\n\r\n.dd-hover>.dd-handle {\r\n  background: #5969ff !important;\r\n}\r\n\r\n/**\r\n* Nestable Draggable Handles\r\n*/\r\n\r\n.dd3-content {\r\n  display: block;\r\n  height: 30px;\r\n  margin: 5px 0;\r\n  padding: 5px 10px 5px 40px;\r\n  color: #333;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  border: 1px solid #ccc;\r\n  background: #fafafa;\r\n  background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  background: linear-gradient(to top, #fafafa 0%, #eee 100%);\r\n  -webkit-border-radius: 3px;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n}\r\n\r\n.dd3-content:hover {\r\n  color: #2ea8e5;\r\n  background: #fff;\r\n}\r\n\r\n.dd-dragel>.dd3-item>.dd3-content {\r\n  margin: 0;\r\n}\r\n\r\n.dd3-item>button {\r\n  margin-left: 30px;\r\n}\r\n\r\n.dd3-handle {\r\n  position: absolute;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  cursor: pointer;\r\n  width: 30px;\r\n  text-indent: 100%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  border: 1px solid #aaa;\r\n  background: #ddd;\r\n  background: -webkit-linear-gradient(top, #ddd 0%, #bbb 100%);\r\n  background: -moz-linear-gradient(top, #ddd 0%, #bbb 100%);\r\n  background: linear-gradient(to top, #ddd 0%, #bbb 100%);\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.dd3-handle:before {\r\n  content: '≡';\r\n  display: block;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 3px;\r\n  width: 100%;\r\n  text-align: center;\r\n  text-indent: 0;\r\n  color: #fff;\r\n  font-size: 20px;\r\n  font-weight: normal;\r\n}\r\n\r\n.dd3-handle:hover {\r\n  background: #ddd;\r\n}\r\n\r\n/**\r\n* Socialite\r\n*/\r\n\r\n.socialite {\r\n  display: block;\r\n  float: left;\r\n  height: 35px;\r\n}\r\n\r\n/*-----------------------\r\n6.13 404 Error\r\n-------------------------*/\r\n\r\n/*-----------------------\r\n6.14 Comments Widget\r\n-------------------------*/\r\n\r\n.comment-widgets {\r\n  position: relative;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.comment-widgets .comment-row {\r\n  border-bottom: 1px solid transparent;\r\n  padding: 14px;\r\n  display: flex;\r\n  margin: 10px 0;\r\n}\r\n\r\n.comment-widgets .comment-row:last-child {\r\n  border-bottom: 0px;\r\n}\r\n\r\n.comment-widgets .comment-row:hover,\r\n.comment-widgets .comment-row.active {\r\n  background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.comment-text {\r\n  padding-left: 15px;\r\n  width: 100%;\r\n}\r\n\r\n.comment-text:hover .comment-footer .action-icons,\r\n.comment-text.active .comment-footer .action-icons {\r\n  visibility: visible;\r\n}\r\n\r\n.comment-text p {\r\n  max-height: 65px;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.comment-footer .action-icons {\r\n  visibility: hidden;\r\n}\r\n\r\n.comment-footer .action-icons a {\r\n  padding-left: 7px;\r\n  vertical-align: middle;\r\n  color: #9e9fa7;\r\n}\r\n\r\n.comment-footer .action-icons a:hover,\r\n.comment-footer .action-icons a.active {\r\n  color: #5969ff;\r\n}\r\n\r\n/*-----------------------\r\n6.14 mail box widget\r\n-------------------------*/\r\n\r\n.mailbox .drop-title {\r\n  font-weight: 600;\r\n  padding: 11px 20px 15px;\r\n  border-radius: 2px 2px 0 0;\r\n  position: relative;\r\n}\r\n\r\n.mailbox .drop-title:after {\r\n  content: '';\r\n  position: absolute;\r\n  opacity: 0.2;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  background-size: cover;\r\n}\r\n\r\n.mailbox .nav-link {\r\n  border-top: 1px solid #e9ecef;\r\n  padding-top: 15px;\r\n  color: #3e5569;\r\n}\r\n\r\n.mailbox .message-center {\r\n  position: relative;\r\n}\r\n\r\n.mailbox .message-center .message-item {\r\n  border-bottom: 1px solid #e9ecef;\r\n  display: block;\r\n  text-decoration: none;\r\n  padding: 9px 15px;\r\n}\r\n\r\n.mailbox .message-center .message-item:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.mailbox .message-center .message-item .message-title {\r\n  color: #212529;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img {\r\n  width: 40px;\r\n  position: relative;\r\n  display: inline-block;\r\n  margin: 0 0px 15px 0;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img img {\r\n  width: 100%;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img .profile-status {\r\n  border: 2px solid #fff;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  height: 10px;\r\n  left: 30px;\r\n  position: absolute;\r\n  top: 1px;\r\n  width: 10px;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img .online {\r\n  background: #36bea6;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img .busy {\r\n  background: #f62d51;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img .away {\r\n  background: #ffbc34;\r\n}\r\n\r\n.mailbox .message-center .message-item .user-img .offline {\r\n  background: #ffbc34;\r\n}\r\n\r\n.mailbox .message-center .message-item .mail-contnet {\r\n  display: inline-block;\r\n  width: 75%;\r\n  padding-left: 10px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.mailbox .message-center .message-item .mail-contnet .message-title {\r\n  margin: 5px 0px 0;\r\n}\r\n\r\n.mailbox .message-center .message-item .mail-contnet .mail-desc,\r\n.mailbox .message-center .message-item .mail-contnet .time {\r\n  font-size: 12px;\r\n  display: block;\r\n  margin: 1px 0;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  color: #a1aab2;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ==========================================================================\r\n7. Email Componants\r\n========================================================================== */\r\n\r\n/*------------------------\r\n7.1  Inbox\r\n----------------------------*/\r\n\r\n.page-aside {\r\n  background: none repeat scroll 0 0 #ffffff;\r\n  width: 280px;\r\n  height: 100%;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 265px;\r\n  border-right: 1px solid #e6e6f2;\r\n  margin-top: 61px;\r\n  padding-bottom: 61px;\r\n  color: #404040;\r\n}\r\n\r\n.page-aside .aside-header {\r\n  padding: 20px 22px;\r\n  position: relative;\r\n}\r\n\r\n.aside-header {}\r\n\r\n.aside-header .navbar-toggle {\r\n  background: 0 0;\r\n  display: none;\r\n  outline: 0;\r\n  border: 0;\r\n  padding: 0 11px 0 0;\r\n  text-align: right;\r\n  margin: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  position: absolute;\r\n}\r\n\r\n.aside-header .navbar-toggle .icon {\r\n  font-size: 24px;\r\n  color: #71738d;\r\n}\r\n\r\n.aside-nav .nav li .icon {\r\n  font-size: 13px;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  min-width: 19px;\r\n  margin-right: 6px;\r\n  color: #71748d;\r\n}\r\n\r\n.aside-nav .nav li.active a {\r\n  color: #f12257;\r\n  background: #fff0f4;\r\n}\r\n\r\n.aside-nav .nav li.active a .icon {\r\n  color: #4285f4;\r\n}\r\n\r\n.aside-header .title {\r\n  display: block;\r\n  margin: 10px 0 0;\r\n  font-size: 27px;\r\n  line-height: 27px;\r\n  font-weight: 300;\r\n  color: #3d405c;\r\n}\r\n\r\n.aside-header .description {\r\n  color: #71748d;\r\n  margin: 0;\r\n}\r\n\r\n.aside-nav.collapse {\r\n  display: block;\r\n}\r\n\r\n.aside-nav {\r\n  visibility: visible;\r\n  font-size: 14px;\r\n}\r\n\r\n.aside-content .nav {\r\n  display: block;\r\n}\r\n\r\n.aside-content .nav li a {\r\n  display: block;\r\n  position: relative;\r\n}\r\n\r\n.aside-nav .nav li a {\r\n  color: #71748d;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.aside-content .nav li a:hover {\r\n  text-decoration: none;\r\n  background-color: #efeff6;\r\n}\r\n\r\n.aside-nav .nav li.active a .icon {\r\n  color: #dd1151;\r\n}\r\n\r\n.email-list-item .from {\r\n  display: block;\r\n  font-weight: 400;\r\n  font-size: 1rem;\r\n  margin: 0 0 1px 0;\r\n}\r\n\r\n.email-list-item .msg {\r\n  margin: 0;\r\n  color: #71738d;\r\n}\r\n\r\n.email-list-item .icon {\r\n  margin-right: 7px;\r\n  font-size: 1.154rem;\r\n  vertical-align: middle;\r\n  color: #3d405c;\r\n}\r\n\r\n.aside-nav .nav li .badge {\r\n  float: right;\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  padding: 3px 6px;\r\n}\r\n\r\n.aside-nav .title {\r\n  display: block;\r\n  color: #3d405c;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  margin: 20px 0 0;\r\n  padding: 8px 22px 4px;\r\n}\r\n\r\n.aside-compose {\r\n  text-align: center;\r\n  padding: 14px 25px;\r\n}\r\n\r\n.master-main-wrapper .main-content {\r\n  margin-left: 266px;\r\n  width: auto;\r\n}\r\n\r\n.email-inbox-header {\r\n  background-color: #fff;\r\n  padding: 25px 25px;\r\n}\r\n\r\n.email-title {\r\n  display: block;\r\n  margin: 3px 0 0;\r\n  font-size: 22px;\r\n  font-weight: 300;\r\n}\r\n\r\n.email-title .icon {\r\n  font-size: 22px;\r\n  color: #71738d;\r\n}\r\n\r\n.email-title .new-messages {\r\n  font-size: 1rem;\r\n  color: #3d405c;\r\n  margin-left: 3px;\r\n}\r\n\r\n.input-search .input-group-btn {\r\n  position: absolute;\r\n  display: block;\r\n  width: auto;\r\n  top: 1px;\r\n  right: 1px;\r\n  z-index: 3;\r\n}\r\n\r\n.input-search .input-group-btn .btn {\r\n  padding: 5px 10px;\r\n  border-top-left-radius: 0px;\r\n  border-bottom-left-radius: 0px;\r\n  border-bottom-right-radius: 1px;\r\n  border-top-right-radius: 1px;\r\n}\r\n\r\n.email-filters {\r\n  padding: 20px;\r\n  border-bottom: 1px solid #e6e6f2;\r\n  background-color: #fff;\r\n  display: table;\r\n  width: 100%;\r\n  border-top: 1px solid #e6e6f2;\r\n}\r\n\r\n.email-filters .be-select-all.custom-checkbox {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  padding: 0;\r\n  margin: 0 30px 0 0;\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  vertical-align: middle;\r\n}\r\n\r\n.email-filters input {\r\n  margin-right: 8px;\r\n}\r\n\r\n.custom-control-label {\r\n  position: static;\r\n  display: inline-block;\r\n  line-height: 2;\r\n}\r\n\r\n.email-filters .email-filters-right {\r\n  text-align: right;\r\n}\r\n\r\n.email-filters>div {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n}\r\n\r\n.email-pagination-indicator {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-right: 13px;\r\n}\r\n\r\n.email-list {\r\n  background: #eee;\r\n}\r\n\r\n.email-list-item {\r\n  border-bottom: 1px solid #e6e6f2;\r\n  padding: 10px 20px;\r\n  display: table;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  position: relative;\r\n  background-color: #fcfcff;\r\n  font-size: 14px;\r\n}\r\n\r\n.email-list-item--unread {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.email-list-item--unread .from,\r\n.email-list-item--unread .msg {\r\n  color: #3d405c;\r\n  font-weight: 800;\r\n  -webkit-font-smoothing: initial;\r\n}\r\n\r\n.email-list-item--unread .msg {\r\n  color: #3d405c;\r\n}\r\n\r\n.email-list-actions {\r\n  width: 40px;\r\n}\r\n\r\n.email-list-actions,\r\n.email-list-detail {\r\n  vertical-align: top;\r\n  display: table-cell;\r\n}\r\n\r\n.email-list-actions .favorite {\r\n  display: block;\r\n  padding-top: 5px;\r\n  padding-left: 1px;\r\n  line-height: 15px;\r\n}\r\n\r\n.email-list-actions .favorite span {\r\n  font-size: 12px;\r\n  line-height: 10px;\r\n  color: silver;\r\n}\r\n\r\n.email-list-actions .favorite:hover span {\r\n  color: #8d8d8d;\r\n}\r\n\r\n.email-list-actions .favorite.active span {\r\n  color: #ffc600;\r\n}\r\n\r\n.email-list-item:hover {\r\n  background-color: #fff;\r\n}\r\n\r\n.email-list-actions .custom-checkbox {\r\n  padding: 0;\r\n  margin-top: -2px;\r\n}\r\n\r\n.email-list-actions .custom-checkbox.custom-control {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/*-------------------\r\n7.2  Email Details\r\n--------------------*/\r\n\r\n.email-head {\r\n  background-color: #fff;\r\n}\r\n\r\n.email-head-subject {\r\n  padding: 25px 25px;\r\n  border-bottom: 1px solid #e6e6f2;\r\n}\r\n\r\n.email-head-subject .title {\r\n  display: block;\r\n  font-size: 1.769rem;\r\n  font-weight: 300;\r\n  color: #3d405c;\r\n}\r\n\r\n.email-head-subject .title>a.active .icon {\r\n  color: #ffc600;\r\n}\r\n\r\n.email-head-subject .title>a .icon {\r\n  color: silver;\r\n  font-size: 14px;\r\n  margin-right: 6px;\r\n  vertical-align: middle;\r\n  line-height: 31px;\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n.email-head-subject .icons {\r\n  font-size: 14px;\r\n  float: right;\r\n}\r\n\r\n.email-head-subject .icons .icon {\r\n  color: #71738d;\r\n  margin-left: 12px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.email-head-sender .avatar {\r\n  float: left;\r\n  margin-right: 10px;\r\n}\r\n\r\n.email-head-sender {\r\n  padding: 13px 25px;\r\n  line-height: 40px;\r\n}\r\n\r\n.email-head-sender .date {\r\n  float: right;\r\n  font-size: 12px;\r\n}\r\n\r\n.email-head-sender .avatar {\r\n  float: left;\r\n  margin-right: 10px;\r\n}\r\n\r\n.email-head-sender .sender {\r\n  font-size: 1.15rem;\r\n}\r\n\r\n.email-head-sender .sender .actions {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.email-head-sender .sender .icon {\r\n  font-size: 1.538rem;\r\n  line-height: 16px;\r\n  color: #5a5a5a;\r\n  margin-left: 7px;\r\n}\r\n\r\n.email-body {\r\n  background-color: #fff;\r\n  border-top: 1px solid #e6e6f2;\r\n  padding: 30px 28px;\r\n}\r\n\r\n.email-attachments {\r\n  background-color: #fff;\r\n  padding: 25px 28px;\r\n  border-top: 1px solid #e6e6f2;\r\n}\r\n\r\n.email-attachments .title {\r\n  display: block;\r\n  font-weight: 500;\r\n}\r\n\r\n.email-attachments .title span {\r\n  font-weight: 400;\r\n}\r\n\r\n.email-attachments ul {\r\n  list-style: none;\r\n  margin: 15px 0 0;\r\n  padding: 0;\r\n}\r\n\r\n.email-attachments ul>li {\r\n  line-height: 23px;\r\n}\r\n\r\n.email-attachments ul>li a {\r\n  color: #404040;\r\n  font-weight: 500;\r\n}\r\n\r\n.email-attachments ul>li .icon {\r\n  vertical-align: middle;\r\n  color: #737373;\r\n  margin-right: 2px;\r\n}\r\n\r\n.email-attachments ul>li span {\r\n  font-weight: 400;\r\n}\r\n\r\n/*-------------------\r\n7.3 Email Compose\r\n----------------------*/\r\n\r\n.email-head-title {\r\n  padding: 25px 25px;\r\n  border-bottom: 1px solid #e6e6f2;\r\n  display: block;\r\n  font-weight: 400;\r\n  color: #3d405c;\r\n  font-size: 1.769rem;\r\n}\r\n\r\n.email-head-title .icon {\r\n  color: #696969;\r\n  margin-right: 12px;\r\n  vertical-align: middle;\r\n  line-height: 31px;\r\n  position: relative;\r\n  top: -1px;\r\n  float: left;\r\n  font-size: 1.538rem;\r\n}\r\n\r\n.email-compose-fields {\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #e6e6f2;\r\n  padding: 30px 30px 20px;\r\n}\r\n\r\n.form-group.row {\r\n  margin-bottom: 0;\r\n  padding: 12px 0;\r\n}\r\n\r\n.form-group.row label {\r\n  white-space: nowrap;\r\n}\r\n\r\n.email-compose-fields label {\r\n  padding-top: 15px;\r\n}\r\n\r\n.email.editor {\r\n  background-color: #fff;\r\n}\r\n\r\n.email.action-send {\r\n  padding: 20px 0px;\r\n}\r\n\r\n.btn-space {\r\n  margin-right: 5px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.breadcrumb {\r\n  margin: 0;\r\n  background-color: transparent;\r\n}\r\n\r\n/*-------------------\r\n7.4  Message Chat Module\r\n----------------------*/\r\n\r\n.chat-body {\r\n  overflow: hidden;\r\n}\r\n\r\n.chat-module {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  justify-content: space-between;\r\n}\r\n\r\n.chat-module {\r\n  height: calc(100vh - 105px);\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module {\r\n  /*height: 100%;*/\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module {\r\n  overflow: hidden;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.chat-module .chat-module-body {\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 55px;\r\n  height: calc(100% - 4rem);\r\n  overflow-y: scroll;\r\n  padding-right: 1.5rem;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module .chat-module-body {\r\n  width: 100%;\r\n  padding-right: 0;\r\n}\r\n\r\n.chat-module .chat-module-top {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  max-height: calc(100% - 3.5rem);\r\n  position: relative;\r\n}\r\n\r\n.avatar {\r\n  width: 2.25rem;\r\n  height: 2.25rem;\r\n  border-radius: 50%;\r\n  border: 2px solid #f7f9fa;\r\n  background: #f7f9fa;\r\n  color: #fff;\r\n}\r\n\r\n.media-attachment {\r\n  padding-left: 0.75rem;\r\n  align-items: center;\r\n  border-left: 4px solid #e9eef2;\r\n}\r\n\r\n.chat-item .media-attachment {\r\n  border-color: #dedee4;\r\n}\r\n\r\n.chat-item-author {\r\n  color: #333;\r\n}\r\n\r\n.media-attachment:not(:first-child) {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.media-attachment div.avatar {\r\n  border: none;\r\n}\r\n\r\n.avatar.bg-primary {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.avatar.bg-primary i {\r\n  font-size: 14px;\r\n}\r\n\r\n.media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.chat-item {\r\n  font-size: 0.875rem;\r\n  line-height: 1.3125rem;\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module .chat-item {\r\n  padding-bottom: 1.5rem;\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module .chat-item:not(:last-child) {\r\n  border-bottom: 1px solid #e6e6f2;\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module .chat-item .media-body {\r\n  background: none;\r\n}\r\n\r\n.chat-item>.media-body {\r\n  margin-left: 0.75rem;\r\n  border-radius: 0.5rem;\r\n  padding: 6px 1px;\r\n  background: transparent;\r\n}\r\n\r\n.media-body {\r\n  flex: 1;\r\n}\r\n\r\n.chat-item+.chat-item {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.chat-item .chat-item-title {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.master-main-wrapper .main-container {\r\n  overflow: hidden;\r\n  flex: 1;\r\n}\r\n\r\n.master-main-wrapper .content-container {\r\n  display: flex;\r\n  height: calc(100vh - 3.5625rem);\r\n}\r\n\r\n.master-main-wrapper .content-container>.chat-module .chat-item .media-body {\r\n  padding: 0;\r\n  background: none;\r\n}\r\n\r\n.media-attachment .media-body>a {\r\n  display: block;\r\n}\r\n\r\n.media-attachment .media-body {\r\n  margin-left: 0.75rem;\r\n}\r\n\r\n.chat-module .chat-module-bottom {\r\n  position: relative;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid #e9eef2;\r\n  background: #efeff6;\r\n}\r\n\r\n.chat-form {\r\n  position: relative;\r\n}\r\n\r\n.chat-module .chat-module-bottom textarea {\r\n  max-height: 9rem;\r\n}\r\n\r\n.chat-form textarea {\r\n  padding-right: 3.375rem;\r\n}\r\n\r\n.chat-form-buttons {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 0.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.chat-form-buttons button {\r\n  padding: 0;\r\n}\r\n\r\n.chat-form-buttons .custom-file-naked {\r\n  width: 1.5rem;\r\n  margin-left: 0.375rem;\r\n  top: 5px;\r\n}\r\n\r\n.custom-file-naked {\r\n  cursor: pointer;\r\n  width: auto;\r\n  height: auto;\r\n}\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: calc(2.125rem + 2px);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-naked .custom-file-input {\r\n  width: auto;\r\n  height: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.custom-file-naked .custom-file-label {\r\n  border: none;\r\n  background: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  height: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.chat-form-buttons i {\r\n  color: #6c757d;\r\n  font-size: 1.25rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.custom-file-label::after {\r\n  display: none;\r\n}\r\n\r\n.chat-sidebar {\r\n  height: 100%;\r\n  overflow: hidden;\r\n  width: 384px;\r\n  border-left: 1px solid #e6e6f2;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n}\r\n\r\n.chat-sidebar-content {\r\n  max-height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n.text-small {\r\n  font-size: 0.875rem;\r\n  line-height: 1.3125rem;\r\n}\r\n\r\n.chat-team-sidebar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.chat-team-sidebar .chat-team-sidebar-top {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.align-items-center {\r\n  align-items: center !important;\r\n}\r\n\r\n.chat-team-sidebar .nav {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.chat-team-sidebar .nav-tabs {\r\n  border-radius: 4px;\r\n  background: #eef2f5;\r\n}\r\n\r\n.chat-team-sidebar .nav-tabs .nav-item {\r\n  margin: 0.5rem;\r\n}\r\n\r\n.chat-team-sidebar .nav-tabs .nav-link:not(.active) {\r\n  color: rgba(33, 37, 41, 0.5);\r\n}\r\n\r\n.chat-team-sidebar .nav-tabs .nav-link {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border-radius: 4px;\r\n  padding: 10px;\r\n  transition: color 0.35s ease-out;\r\n}\r\n\r\n.chat-team-sidebar .chat-team-sidebar-bottom,\r\n.chat-team-sidebar .chat-team-sidebar-bottom .tab-content {\r\n  flex: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.chat-team-sidebar .chat-team-sidebar-bottom,\r\n.chat-team-sidebar .chat-team-sidebar-bottom .tab-content {\r\n  flex: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.chat-team-sidebar .tab-pane {\r\n  overflow-y: none;\r\n  -ms-overflow-style: none;\r\n  height: 100%;\r\n}\r\n\r\n.chat-team-sidebar .list .list-group-item {\r\n  width: 100%;\r\n}\r\n\r\n.sidebar form.dropzone {\r\n  padding: 0 1.5rem;\r\n}\r\n\r\nform.dropzone {\r\n  width: 100%;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.sidebar .dz-message {\r\n  background: #f7f9fa;\r\n  padding: 1rem;\r\n}\r\n\r\n.dz-message {\r\n  text-align: center;\r\n  padding: 1.5rem;\r\n  display: block;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  opacity: 1;\r\n  cursor: pointer;\r\n  border-radius: 0.5rem;\r\n  background: #fff;\r\n  border: 1px dashed #e9eef2;\r\n  transition: all 0.35s ease;\r\n  color: rgba(108, 117, 125, 0.5);\r\n}\r\n\r\n.dropzone-previews {\r\n  width: 100%;\r\n}\r\n\r\n.dz-file-representation img:not([src]) {\r\n  display: none;\r\n}\r\n\r\n.dz-file-representation img {\r\n  position: absolute;\r\n  object-fit: cover;\r\n}\r\n\r\n.dz-preview .avatars li:last-child {\r\n  transition: opacity 0.35s ease;\r\n  opacity: 0;\r\n}\r\n\r\n.dz-loading {\r\n  opacity: 1;\r\n  transition: opacity 0.35s ease;\r\n  position: absolute;\r\n  left: 1.1875rem;\r\n}\r\n\r\n.list-group-activity .avatars {\r\n  margin-right: 0.75rem;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.list-group-activity span {\r\n  margin-right: 0.25rem;\r\n}\r\n\r\n.list-group-activity .avatars>li:first-child {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.avatar {\r\n  width: 2.25rem;\r\n  height: 2.25rem;\r\n  border-radius: 50%;\r\n  border: 2px solid #f7f9fa;\r\n  background: #f7f9fa;\r\n  color: #fff;\r\n}\r\n\r\n.avatars>li {\r\n  display: inline-block;\r\n}\r\n\r\n.chat-team-sidebar .list-group-activity .avatar {\r\n  border-color: #fff;\r\n}\r\n\r\n.avatars {\r\n  padding-left: 0;\r\n  list-style: none;\r\n  margin: 0;\r\n}\r\n\r\n.avatar.bg-primary {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.avatars>li+li {\r\n  margin-left: -0.75rem;\r\n}\r\n\r\n.btn-options {\r\n  color: #6c757d;\r\n  padding: 0;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.Insurance_div_main_otr .card.Insurance_div {\r\n  border: 0px;\r\n}\r\n\r\n/* ==========================================================================\r\n9. Map\r\n========================================================================== */\r\n\r\n/*-------------------------------------------------------------------\r\nMedia Query\r\n-------------------------------------------------------------------*/\r\n\r\n/*==========  Non-Mobile First Method  ==========*/\r\n\r\n/* Large Devices, Wide Screens */\r\n\r\n@media only screen and (max-width: 1400px) {\r\n  .product-price {\r\n    position: initial;\r\n  }\r\n\r\n  .product-slider {\r\n    background-color: #fff;\r\n    border-top-left-radius: 4px;\r\n    padding: 131px 28px;\r\n  }\r\n\r\n  .influencer-profile-data .user-social-media {\r\n    padding: 16px 56px;\r\n    text-align: center;\r\n    border-right: 1px solid #e6e6f2;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1200px) {\r\n  .product-price {\r\n    position: initial;\r\n  }\r\n\r\n  .product-slider {\r\n    padding: 131px 30px;\r\n  }\r\n\r\n  /*--------- dashboard-influence -------- */\r\n  .user-social-media {\r\n    padding: 16px 45px;\r\n    text-align: center;\r\n    width: 100%;\r\n    border-bottom: 1px solid #dee2e6;\r\n    border-right: transparent !important;\r\n  }\r\n}\r\n\r\n/* Medium Devices, Desktops */\r\n\r\n@media only screen and (max-width: 992px) {\r\n\r\n  /*--------- dashboard-influence -------- */\r\n  .user-social-media {\r\n    padding: 16px 45px;\r\n    text-align: center;\r\n    width: 100%;\r\n    border-bottom: 1px solid #dee2e6;\r\n    border-right: transparent !important;\r\n  }\r\n}\r\n\r\n/* Small Devices, Tablets */\r\n\r\n@media only screen and (max-width: 991px) {\r\n\r\n  // .main-header .navbar .collapse:not(.show) {\r\n  //   display: block;\r\n  //   border: 0px;\r\n  // }\r\n  // .main-header .navbar-nav li.nav-item {\r\n  //   display: none;\r\n  // }\r\n  .main-header .navbar-toggler svg path {\r\n    fill: #fff;\r\n  }\r\n\r\n  .main-header .navbar-collapse {\r\n    position: absolute;\r\n    left: 0px;\r\n    right: 0px;\r\n    top: 60px;\r\n    background: #288366;\r\n  }\r\n\r\n  .main-header nav.navbar ul {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: left;\r\n    flex-wrap: nowrap;\r\n    padding: 15px 10px;\r\n    row-gap: 5px;\r\n  }\r\n\r\n  .main-header .navbar>.container-fluid {\r\n    justify-content: end;\r\n    column-gap: 18px;\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .main-header .navbar>.container-fluid .navbar-brand {\r\n    width: 100%;\r\n  }\r\n\r\n  .sidebar-dark.nav-left-sidebar .navbar-nav .nav-link {\r\n    flex-direction: row;\r\n    column-gap: 5px;\r\n  }\r\n\r\n  .main-content-wrapper-inner {\r\n    padding: 20px 20px 60px 20px;\r\n  }\r\n\r\n  .nav-left-sidebar .navbar a {\r\n    color: #fff;\r\n    font-size: 18px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .nav-left-sidebar .navbar {\r\n    padding: 0px;\r\n  }\r\n\r\n  .nav-left-sidebar {\r\n    width: 100%;\r\n    position: relative;\r\n    top: 0px;\r\n    right: 0px;\r\n  }\r\n\r\n  .main-content-wrapper {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .dashboard-footer {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .nav-left-sidebar .navbar-toggler {\r\n    background-color: transparent;\r\n    padding: 0px;\r\n  }\r\n\r\n  /* infulencer dahboard */\r\n  .dashboard-influence .card-footer-item {\r\n    padding: 11px 54px;\r\n  }\r\n\r\n  .influencer-profile .tab-regular .nav.nav-tabs .nav-item .nav-link,\r\n  .influencer-profile .tab-regular .nav.nav-pills .nav-item .nav-link {\r\n    display: block;\r\n    padding: 17px 13px;\r\n  }\r\n\r\n  /* Inbox */\r\n  .page-aside {\r\n    background: none repeat scroll 0 0 #ffffff;\r\n    width: 280px;\r\n    height: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border-right: 1px solid #e6e6f2;\r\n    margin-top: 0;\r\n    padding-bottom: 0px;\r\n    color: #404040;\r\n  }\r\n\r\n  /*--------- dashboard-product-single -------- */\r\n  .product-slider {\r\n    padding: 131px 30px;\r\n  }\r\n\r\n  .product-carousel .carousel-indicators {\r\n    bottom: -30px;\r\n  }\r\n\r\n  /*--------- dashboard-influence -------- */\r\n  .user-social-media {\r\n    padding: 16px 45px;\r\n    text-align: center;\r\n    width: 100%;\r\n    border-bottom: 1px solid #dee2e6;\r\n    border-right: transparent !important;\r\n  }\r\n}\r\n\r\n/* Extra Small Devices, Phones */\r\n\r\n@media only screen and (max-width: 480px) {\r\n  .main-content-wrapper-inner {\r\n    padding: 20px 20px 60px 20px;\r\n  }\r\n\r\n  .nav-left-sidebar .navbar a {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-left-sidebar .navbar-toggler {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .aside-header .navbar-toggle {\r\n    display: block;\r\n  }\r\n\r\n  .nav-left-sidebar {\r\n    width: 100%;\r\n    position: relative;\r\n    top: 0px;\r\n    right: 0px;\r\n  }\r\n\r\n  .main-content-wrapper {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .dashboard-footer {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .page-aside {\r\n    background: none repeat scroll 0 0 #fff;\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    top: 0;\r\n    left: 0px;\r\n    border-right: transparent;\r\n    margin-top: 0px;\r\n    padding-bottom: 0px;\r\n    color: #404040;\r\n    border-bottom: 1px solid #e6e6f2;\r\n  }\r\n\r\n  .aside-nav.collapse {\r\n    display: none;\r\n  }\r\n\r\n  .master-main-wrapper .main-content {\r\n    margin-left: 0px;\r\n    width: auto;\r\n  }\r\n\r\n  .aside-nav.show {\r\n    display: block;\r\n  }\r\n\r\n  /*--------- dashboard-influence -------- */\r\n  .user-social-media {\r\n    padding: 16px 45px;\r\n    text-align: center;\r\n    width: 100%;\r\n    border-bottom: 1px solid #dee2e6;\r\n    border-right: transparent !important;\r\n  }\r\n\r\n  .user-social-media:last-child {\r\n    border-bottom: transparent;\r\n    border-right: transparent !important;\r\n  }\r\n\r\n  .dashboard-influence .progress {\r\n    width: 74%;\r\n  }\r\n\r\n  .footer {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .influencer-profile-data .user-avatar {\r\n    float: initial;\r\n  }\r\n\r\n  .influencer-profile-data .user-avatar-name {\r\n    float: initial;\r\n  }\r\n\r\n  .dashboard-influence .card-footer-item {\r\n    padding: 11px 48px;\r\n  }\r\n\r\n  /*--------- dashboard-profile -------- */\r\n  .tab-regular .nav.nav-tabs .nav-item .nav-link,\r\n  .tab-regular .nav.nav-pills .nav-item .nav-link {\r\n    display: block;\r\n    padding: 17px 38px;\r\n  }\r\n\r\n  .tab-regular .nav.nav-tabs .nav-item,\r\n  .tab-regular .nav.nav-pills .nav-item {\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  /*--------- dashboard-product-single -------- */\r\n  .product-slider {\r\n    padding: 30px 10px;\r\n  }\r\n\r\n  .product-carousel .carousel-indicators {\r\n    bottom: -30px;\r\n  }\r\n\r\n  .simple-card .nav.nav-tabs .nav-item .nav-link {\r\n    padding: 17px 29px;\r\n  }\r\n}\r\n\r\n/* Custom, iPhone Retina */\r\n@media only screen and (max-width: 320px) {}\r\n\r\n/*============ NEW_CSS_START ===============*/\r\n\r\n.home_main_card_outer {\r\n  background-color: #96cc9f !important;\r\n  position: relative;\r\n  height: auto;\r\n  width: 32% !important;\r\n  z-index: 999;\r\n  position: relative;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.home_main_card_outer::after {\r\n  position: absolute;\r\n  content: '';\r\n  background-image: url(../images/active_icon.png);\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  -webkit-transform: translateX(-50%);\r\n  -moz-transform: translateX(-50%);\r\n  bottom: -16px;\r\n  width: 46px;\r\n  height: 16px;\r\n  opacity: 0;\r\n}\r\n\r\n.home_main_card_outer.active::after {\r\n  opacity: 1;\r\n}\r\n\r\n.home_main_card_outer:hover {\r\n  background-color: #a3c967 !important;\r\n}\r\n\r\n.home_main_card_outer.active {\r\n  background-color: #479573 !important;\r\n}\r\n\r\n.home_main_card_outer::before {\r\n  position: absolute;\r\n  content: '';\r\n  top: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  opacity: 0.5;\r\n  background-image: url(../images/shape-1.png);\r\n  background-position: bottom;\r\n  background-repeat: no-repeat;\r\n  width: 100%;\r\n  z-index: -1;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.home_main_card_outer.two::before {\r\n  background-image: url(../images/shape-2.png);\r\n}\r\n\r\n.home_main_card_outer :not(.active):hover::before,\r\n.home_main_card_outer:hover::before {\r\n  background-position-y: 140%;\r\n}\r\n\r\n.home_main_card_outer .card-body {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.home_main_card_outer .card-body h5 {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.Under_Management {\r\n  column-gap: 25px;\r\n}\r\n\r\n.Select_state_outer {\r\n  width: 100%;\r\n}\r\n\r\n.Select_state_outer h6 {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  margin: 0px;\r\n}\r\n\r\n.Under_Management .Under_Management_content_left p,\r\n.Under_Management .Under_Management_content_right p {\r\n  margin-bottom: 2px;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  padding: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.Under_Management .Under_Management_content_right h4 span {\r\n  font-size: 30px;\r\n}\r\n\r\n.Under_Management .Under_Management_content_right p.active {\r\n  margin-bottom: 2px;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  padding: 8px;\r\n  background-color: #225ea8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n}\r\n\r\n.Under_Management .Under_Management_content_right p:hover {\r\n  padding: 8px;\r\n  background-color: #225ea8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.Under_Management .Under_Management_content_left h4 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n  font-size: 36px;\r\n  color: #fff !important;\r\n  margin: 0px;\r\n  line-height: initial;\r\n}\r\n\r\n.Under_Management .Under_Management_content_right p {\r\n  font-size: 12px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.Under_Management .Under_Management_content_right h4 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n  font-size: 36px;\r\n  color: #fff !important;\r\n  margin: 0px;\r\n  line-height: initial;\r\n}\r\n\r\n.client_contact_recency_inner .Under_Management_content_left p {\r\n  font-size: 12px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.client_contact_recency_inner .Under_Management_content_right h4 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n  font-size: 36px;\r\n  color: #fff !important;\r\n  margin: 0px;\r\n  line-height: initial;\r\n}\r\n\r\n.Under_Management .Under_Management_content {\r\n  width: 100%;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.Under_Management .Under_Management_image {\r\n  max-width: 90px;\r\n  width: 100%;\r\n}\r\n\r\n.Under_Management .Under_Management_image img {\r\n  max-width: 90px;\r\n  width: 90px;\r\n}\r\n\r\n.Under_Management .Under_Management_content_right {\r\n  text-align: right;\r\n}\r\n\r\n.amounts_main {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.amounts_main_outer {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  column-gap: 5px;\r\n  row-gap: 5px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.amounts_main_outer .amount_box {\r\n  background-color: #f7f8fa;\r\n  padding: 13px 9px;\r\n  border-radius: 10px;\r\n  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);\r\n  transition: 0.3s ease-in-out;\r\n  -webkit-transition: 0.3s ease-in-out;\r\n  -moz-transition: 0.3s ease-in-out;\r\n}\r\n\r\n.amounts_main_outer .amount_box:hover {\r\n  background-color: #e4f8d9;\r\n  border-radius: 0px;\r\n}\r\n\r\n.amounts_main_outer .amount_box:hover p {\r\n  color: #55a080;\r\n}\r\n\r\n.amounts_main_outer .amount_box p {\r\n  margin-bottom: 0px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  color: #55a080;\r\n}\r\n\r\n.amounts_main_outer .amount_box .amount {\r\n  color: #565656;\r\n  font-weight: 700;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 24px;\r\n  line-height: initial;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 2px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.amounts_main_outer .amount_box .amount span {\r\n  color: #565656;\r\n  font-weight: 700;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  line-height: initial;\r\n}\r\n\r\n.amount_box {\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.amount_content h6 {\r\n  margin: 0px;\r\n  font-weight: 700;\r\n  font-size: 17px;\r\n  font-family: 'Roboto', sans-serif;\r\n  color: #565656 !important;\r\n  padding: 4px 5px;\r\n  border-radius: 5px;\r\n  margin-top: 5px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.amount_box .amount_title {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.amount_box .amount_title svg {\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n.amount_box:hover .amount_title svg {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.amount_box:hover .amount_content h6 {\r\n  background-color: #fff;\r\n}\r\n\r\n.market_forecast_box .box_title {\r\n  width: 100%;\r\n  grid-column: 4 span;\r\n}\r\n\r\n.market_forecast_box .market_forecast_box_outer {\r\n  grid-column: 4 span;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-row-gap: 5px;\r\n  row-gap: 5px;\r\n  grid-column-gap: 5px;\r\n  column-gap: 5px;\r\n}\r\n\r\n.market_forecast_box .box_item {\r\n  padding: 6px 2px 2px;\r\n  background: #f7f8fa;\r\n  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);\r\n  border-radius: 10px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.market_forecast_box .box_item:first-child {\r\n  grid-column: 4 span;\r\n  width: auto;\r\n  max-width: 24.5%;\r\n}\r\n\r\n.market_forecast_box .box_item span .edit {\r\n  opacity: 0;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.market_forecast_box .box_item:hover span .edit {\r\n  opacity: 1;\r\n}\r\n\r\n.market_forecast_box .box_item p.small_title {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: #55a080;\r\n  text-transform: uppercase;\r\n  margin-bottom: 2px;\r\n  padding-left: 4px;\r\n}\r\n\r\n.market_forecast_box .box_item .value_outer {\r\n  display: grid;\r\n  column-gap: 2px;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n}\r\n\r\n.market_forecast_box .box_item .value_outer .value_outer_box {\r\n  border-radius: 6px;\r\n  padding: 4px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.market_forecast_box .box_item .value_outer .value_outer_box svg {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n.market_forecast_box .box_item:hover .value_outer .value_outer_box {\r\n  background-color: #fff;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret,\r\n.market_forecast_box .box_item:hover {\r\n  background: #c7e9b4;\r\n}\r\n\r\n.market_forecast_box .box_item:hover p.small_title {\r\n  color: #55a080;\r\n}\r\n\r\n.market_forecast_box .value_outer .value_outer_box span {\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  font-family: 'Roboto', sans-serif;\r\n  color: #565656;\r\n}\r\n\r\n.market_forecast_box .value_outer .value_outer_box span.ret,\r\n.market_forecast_box .value_outer .value_outer_box span.vol,\r\n.market_forecast_box .value_outer .value_outer_box span.div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.market_forecast_box .value_outer .value_outer_box h6 {\r\n  margin: 0px;\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  font-family: 'Roboto', sans-serif;\r\n  color: #565656 !important;\r\n}\r\n\r\n.market_forecast_box .value_outer .value_outer_box h6 sup {\r\n  top: -6px;\r\n  font-size: 12px;\r\n  right: 2px;\r\n}\r\n\r\n.market_forecast .market_forecast_box {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-column-gap: 5px;\r\n  column-gap: 5px;\r\n  grid-row-gap: 5px;\r\n  row-gap: 5px;\r\n}\r\n\r\n.Dropdown_main_outer label {\r\n  color: #479573;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  line-height: 17px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.Correlations_main_outer {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 5px;\r\n  grid-column: 4 span;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item {\r\n  padding: 6px;\r\n  background: #f7f8fa;\r\n  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);\r\n  border-radius: 10px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item h5 {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item:hover {\r\n  background-color: #e4f8d9;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item h6 {\r\n  margin: 0px;\r\n  font-weight: 700;\r\n  font-size: 17px;\r\n  font-family: 'Roboto', sans-serif;\r\n  color: #565656 !important;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item .value_outer {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px;\r\n  border-radius: 5px;\r\n  justify-content: space-between;\r\n  column-gap: 5px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item:hover .value_outer {\r\n  background: #fff;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item .value_outer .edit {\r\n  opacity: 0;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  width: 15px;\r\n  height: 15px;\r\n  min-width: 15px;\r\n  max-width: 15px;\r\n  min-height: 15px;\r\n  max-height: 15px;\r\n}\r\n\r\n.Correlations_main_outer .Correlations_item:hover .value_outer .edit {\r\n  opacity: 1;\r\n}\r\n\r\n.Dropdown_main_outer {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.Correlations_title {\r\n  width: 100%;\r\n  grid-column: 4 span;\r\n}\r\n\r\n.client_type_outer {\r\n  padding: 0px 1rem;\r\n  border-right: 1px dashed rgb(0 0 0 / 50%);\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_outer {\r\n  display: none;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_ret_content span {\r\n  color: #565656;\r\n  font-weight: 600;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_ret_content {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 3px;\r\n  margin-top: 8px;\r\n  padding-left: 4px;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 3px 8px 3px 10px;\r\n  background: #fff;\r\n  height: 38px;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div,\r\n.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div input {\r\n  font-weight: 700;\r\n  color: #565656;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div .submit img {\r\n  width: 15px;\r\n}\r\n\r\n.market_forecast_box .box_item.edit_ret .value_ret_content .edit_div input {\r\n  width: 100%;\r\n  border: 0px;\r\n}\r\n\r\n.save_button {\r\n  text-align: right;\r\n}\r\n\r\n.responsive_save_button button,\r\n.save_button button,\r\n.common-button {\r\n  width: auto;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 7.5px 15px;\r\n  border: 0px;\r\n  background: #225ea8;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  text-transform: none;\r\n  margin-left: auto;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.common-button {\r\n  height: 35px;\r\n  padding: 7.5px 20px;\r\n}\r\n\r\n.secondary-button {\r\n  background: grey !important;\r\n}\r\n\r\n.select_client_outer {\r\n  margin-top: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.select_client_outer .client,\r\n.select_client_outer .plan {\r\n  width: 100%;\r\n}\r\n\r\n.select_client_outer.select_client_outer_other {\r\n  width: 50%;\r\n  margin: 0px;\r\n}\r\n\r\n.select_client_outer select {\r\n  width: auto;\r\n}\r\n\r\n.select_client_outer input {\r\n  width: 85px;\r\n  background-image: none;\r\n}\r\n\r\n.select_client_outer input .select_client_outer select {\r\n  min-height: 28px;\r\n  border-radius: 8px;\r\n  background-color: #fff;\r\n  max-height: 28px;\r\n  padding: 0px 6px;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n}\r\n\r\n.select_client_outer select {\r\n  background-image: url(../images/select_down.svg);\r\n  background-position-y: center;\r\n  background-size: 14px;\r\n  background-position-x: 95%;\r\n  padding: 0px 26px 0px 12px;\r\n  position: relative;\r\n  //background-image: url('data:image/svg+xml;utf8,<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 10.127L12 18.127L20 10.127H4Z\" fill=\"%238E8E93\"/></svg>');\r\n  background-repeat: no-repeat;\r\n  background-position-y: 50%;\r\n  background-position-x: 98%;\r\n}\r\n\r\n.select_client_outer select::before {\r\n  position: absolute;\r\n  content: '';\r\n  background-image: url(../images/search_icon.svg);\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  width: 10px;\r\n}\r\n\r\n.select_client_outer .add_client_button_group,\r\n.select_client_outer .select_client_outer_form_row {\r\n  column-gap: 5px;\r\n  opacity: 0.5;\r\n  margin-top: 10px;\r\n}\r\n\r\n.select_client_outer .select_client_outer_form_row .date_picker input.form-control {\r\n  background-color: #368156;\r\n}\r\n\r\n.select_client_outer .select_client_outer_form_row .date_picker input.form-control {\r\n  color: #fff;\r\n  border: none;\r\n}\r\n\r\n.home_main_card_outer.active .select_client_outer .add_client_button_group,\r\n.home_main_card_outer.active .select_client_outer .select_client_outer_form_row {\r\n  opacity: 1;\r\n  margin-top: 10px; // check this Tamil\r\n}\r\n\r\n.home_main_card_outer.active .select_client_outer .select_client_outer_form_row .date_picker input.form-control {\r\n  background-color: #fff;\r\n}\r\n\r\n.home_main_card_outer.active .select_client_outer .select_client_outer_form_row .date_picker input.form-control {\r\n  color: #000;\r\n}\r\n\r\n.client_contact_total_outer {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n}\r\n\r\n.client_contact_total_outer .client_contact_total p {\r\n  font-size: 10px;\r\n  color: #727272;\r\n}\r\n\r\n.client_contact_total_outer .client_contact_total.left p span {\r\n  font-weight: 800;\r\n}\r\n\r\n.client_contact_total_outer .client_contact_total.right p span {\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n}\r\n\r\n.Insurance_div {\r\n  height: 50vh !important;\r\n  overflow: auto;\r\n}\r\n\r\n.comments_notes_outer_inner textarea {\r\n  background: linear-gradient(180deg, #ffffff 0%, #efefef 87.59%);\r\n  border: 1px solid #8d8d8d;\r\n  border-radius: 5px;\r\n  width: 100%;\r\n  padding: 13px;\r\n  resize: none;\r\n  height: 133px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: #000;\r\n}\r\n\r\n.comments_notes_outer_inner textarea::placeholder {\r\n  color: #000 !important;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n}\r\n\r\n.comments_notes_outer {\r\n  height: 50vh !important;\r\n  overflow: auto;\r\n}\r\n\r\n.comments_notes_data {\r\n  row-gap: 7px;\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.comments_notes_data .comments_notes_data_box {\r\n  padding: 9px 13px 15px;\r\n  background: #eafbe8;\r\n  border-radius: 9px;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.comments_notes_data .comments_notes_data_box h6 {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.comments_notes_data .comments_notes_data_box h6,\r\n.comments_notes_data .comments_notes_data_box p {\r\n  font-weight: 500;\r\n  font-size: 10px;\r\n  color: #4a6664;\r\n}\r\n\r\n.comments_notes_data_footer {\r\n  padding: 15px;\r\n}\r\n\r\n.comments_notes_search_date .search_outer {\r\n  width: 65%;\r\n}\r\n\r\n.comments_notes_search_date .date_outer {\r\n  width: 35%;\r\n}\r\n\r\n.comments_notes_search_date .date_outer input {\r\n  background: #ffffff;\r\n  border: 1px solid #727272;\r\n  border-radius: 8px;\r\n  padding: 5px 5px 5px 26px;\r\n  font-weight: 500;\r\n  font-size: 10px;\r\n  background-image: url(../images/date_icon.svg);\r\n  background-position-y: center;\r\n  background-position-x: 5px;\r\n  background-repeat: no-repeat;\r\n  color: #000000;\r\n  line-height: initial;\r\n  height: 26px;\r\n}\r\n\r\n.comments_notes_search_date .search_outer input {\r\n  border: none;\r\n  padding: 5px 5px 5px 2px;\r\n  font-weight: 500;\r\n  font-size: 10px;\r\n  color: #000000;\r\n  line-height: initial;\r\n  height: 26px;\r\n}\r\n\r\n.comments_notes_search_date .search_outer .input-group {\r\n  border: 1px solid #727272;\r\n  background: #ffffff;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.comments_notes_search_date .search_outer .input-group button.search_icon_button {\r\n  background: transparent;\r\n  border: none;\r\n  padding-left: 20px;\r\n  background-image: url(../images/search_icon.svg);\r\n  background-repeat: no-repeat;\r\n  background-size: 15px;\r\n  background-position-x: 6px;\r\n  background-position-y: 5px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.comments_notes_search_date {\r\n  padding: 12px 0px 18px;\r\n  column-gap: 12px;\r\n}\r\n\r\n.Expenses_div_main_otr {\r\n  padding-right: 0px;\r\n}\r\n\r\n/* REPORTS_TOP_HEADER_CSS_START */\r\n.main-content-wrapper-reports {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  margin-left: 73px;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_under_tab_devices {\r\n  display: none;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab {\r\n  width: 97px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  background-color: #fff;\r\n  height: 100vh;\r\n  position: fixed;\r\n  overflow: auto;\r\n  left: 73px;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab ul {\r\n  padding: 20px 0px;\r\n  width: 100%;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab ul li {\r\n  list-style: none;\r\n  text-align: center;\r\n  padding: 5px 0px;\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab ul li:hover,\r\n.main-content-wrapper-reports .reports_pdf_nav_tab ul li.active {\r\n  background-color: #80b468;\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: #d7efd4;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #5aa266;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab .hover_icons button {\r\n  background-color: transparent;\r\n  outline: none;\r\n  border: 0px;\r\n  padding: 0px;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab .hover_icons button img {\r\n  width: 22px;\r\n  background-color: #fff;\r\n  border-radius: 50px;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab .hover_icons {\r\n  position: absolute;\r\n  bottom: -8px;\r\n  left: 50%;\r\n  width: 100%;\r\n  transform: translateX(-50%);\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li:not(.active):hover .hover_icons {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon {\r\n  position: relative;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon img {\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon img.white {\r\n  position: absolute;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon .color {\r\n  opacity: 1;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li .pdf_icon .white {\r\n  opacity: 0;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li:hover .pdf_icon .white,\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li.active .pdf_icon .white {\r\n  opacity: 1;\r\n}\r\n\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li:hover .pdf_icon .color,\r\n.main-content-wrapper-reports .reports_pdf_nav_tab li.active .pdf_icon .color {\r\n  opacity: 0;\r\n}\r\n\r\n.Reports_top_button_div {\r\n  width: 35%;\r\n}\r\n\r\n.report_name_outer {\r\n  width: 20%;\r\n  text-align: center;\r\n}\r\n\r\n.reports_top_right_div {\r\n  width: 45%;\r\n}\r\n\r\n.Reports_top_button_div ul li {\r\n  list-style: none;\r\n}\r\n\r\n.Reports_top_button_div ul {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 6px;\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.Reports_top_button_div ul li button {\r\n  font-size: 12px !important;\r\n  font-weight: 700;\r\n  font-family: 'Inter', sans-serif;\r\n  text-transform: uppercase;\r\n  height: 33px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 8px;\r\n  padding: 7px 15px !important;\r\n  background: #8f8f8f !important;\r\n  border-color: #8f8f8f !important;\r\n}\r\n\r\n.Reports_top_button_div ul li button:hover {\r\n  background: #8f8f8f !important;\r\n  border-color: #8f8f8f !important;\r\n}\r\n\r\n.Reports_top_button_div ul li button img {\r\n  width: 15px;\r\n}\r\n\r\n.report_name_outer h3 {\r\n  margin: 0px;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  opacity: 0.6;\r\n  color: #000;\r\n}\r\n\r\n.reports_top_right_div {\r\n  column-gap: 15px;\r\n  justify-content: right;\r\n}\r\n\r\n.reports_top_right_div_file_outer button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n  padding: 0px 2px;\r\n  outline: none;\r\n}\r\n\r\n.reports_generate_pdf button {\r\n  font-size: 12px !important;\r\n  font-weight: 700;\r\n  font-family: 'Inter', sans-serif;\r\n  text-transform: uppercase;\r\n  padding: 9px 11.5px !important;\r\n  background-color: #235da8;\r\n}\r\n\r\n.reports_generate_pdf button:hover {\r\n  background-color: #235da8;\r\n}\r\n\r\n.reports_pdf_outer {\r\n  background-color: #fff;\r\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);\r\n  -webkit-box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.reports_pdf_outer .reports_pdf_header_outer {\r\n  background-color: #41b6c4;\r\n  padding: 15px 30px;\r\n}\r\n\r\n.reports_pdf_header_outer .reports_pdf_financial_advisors h4 {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  margin-top: 5px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.reports_pdf_outer .reports_pdf_header_outer {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.reports_pdf_outer .reports_pdf_financial_advisors {\r\n  width: 35%;\r\n}\r\n\r\n.reports_pdf_outer .reports_client_name_outer {\r\n  width: 30%;\r\n  text-align: center;\r\n}\r\n\r\n.reports_pdf_outer .reports_advisor_name_date {\r\n  width: 35%;\r\n  text-align: right;\r\n}\r\n\r\n.reports_pdf_outer .reports_client_name_outer h1 {\r\n  color: #fff;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.reports_pdf_outer .reports_client_name_outer p {\r\n  font-size: 20px;\r\n  color: #fff;\r\n  font-weight: 700;\r\n  margin: 0px;\r\n}\r\n\r\n.reports_advisor_name_date .report_generated_by_outer {\r\n  font-size: 16px;\r\n  color: #fff;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.reports_advisor_name_date .report_generated_by_outer span {\r\n  font-weight: 600;\r\n}\r\n\r\n.reports_advisor_name_date .report_generated_by_date_outer {\r\n  font-size: 16px;\r\n  color: #fff;\r\n}\r\n\r\n.reports_advisor_name_date .report_generated_by_date_outer span {\r\n  font-weight: 600;\r\n}\r\n\r\n.reports_advisor_comments_title h4 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #479573;\r\n  text-transform: uppercase;\r\n  display: flex;\r\n}\r\n\r\n.reports_advisor_comments_title .edit_advisor_comments {\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n.reports_pdf_content_outer {\r\n  padding: 25px;\r\n  margin-bottom: 80px;\r\n  height: 100%;\r\n  min-height: 1530px;\r\n}\r\n\r\n.reports_advisor_comments_outer {\r\n  padding: 30px 30px;\r\n}\r\n\r\n.reports_advisor_comments_text_editor {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(0, 0, 0, 0.5);\r\n  box-shadow: 0px 9px 27px rgba(0, 0, 0, 0.07),\r\n    0px 3.75998px 11.28px rgba(0, 0, 0, 0.0503198),\r\n    0px 2.01027px 6.0308px rgba(0, 0, 0, 0.0417275),\r\n    0px 1.12694px 3.38082px rgba(0, 0, 0, 0.035),\r\n    0px 0.598509px 1.79553px rgba(0, 0, 0, 0.0282725),\r\n    0px 0.249053px 0.747159px rgba(0, 0, 0, 0.0196802);\r\n}\r\n\r\n.reports_advisor_comments_text_editor_tool_bar {\r\n  border-bottom: 1px solid rgba(0, 0, 0);\r\n}\r\n\r\n.reports_advisor_comments_text_editor_textarea {\r\n  display: flex;\r\n}\r\n\r\n.reports_advisor_comments_text_editor_textarea textarea {\r\n  border: 0px;\r\n  width: 100%;\r\n  height: 696px;\r\n  resize: none;\r\n  padding: 13px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: #000;\r\n}\r\n\r\n.reports_advisor_comments_text_editor_tool_bar ul {\r\n  padding: 16px 30px;\r\n  margin: 0px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 25px;\r\n}\r\n\r\n.reports_advisor_comments_text_editor_tool_bar ul li {\r\n  list-style: none;\r\n}\r\n\r\n.reports_disclaimer_outer {\r\n  // margin-top: 229px;\r\n}\r\n\r\n.reports_disclaimer_outer h4 {\r\n  text-transform: uppercase;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  color: #479573;\r\n}\r\n\r\n.reports_pdf_footer_outer {\r\n  background: #479573;\r\n  padding: 10px 17px;\r\n}\r\n\r\n.reports_pdf_footer_outer {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  color: #fff;\r\n}\r\n\r\n.reports_pdf_footer_outer .current_page_count {\r\n  background-color: #8ad184;\r\n  padding: 9px 13px;\r\n  border-radius: 4px;\r\n  min-width: 34px;\r\n  height: 34px;\r\n}\r\n\r\n.reports_pdf_page_count {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 33px;\r\n}\r\n\r\n.reports_pdf_page_count p {\r\n  color: #fff;\r\n  font-size: 11px;\r\n}\r\n\r\n.reports_pdf_page_count_inner {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n}\r\n\r\n.reports_pdf_page_count .dividers {\r\n  padding: 0px 5px;\r\n}\r\n\r\n.Reports_top_button_div .reports_search_button img {\r\n  filter: invert(1);\r\n}\r\n\r\n.reports_pdf_content_outer .card {\r\n  border: none;\r\n  -webkit-box-shadow: 1px 1px 6px rgb(0 0 0 / 25%);\r\n  -moz-box-shadow: 1px 1px 6px rgb(0 0 0 / 25%);\r\n  box-shadow: 1px 1px 6px rgb(0 0 0 / 25%);\r\n}\r\n\r\n.reports_pdf_icons button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n}\r\n\r\n.reports_pdf_icons button img {\r\n  width: 16px;\r\n}\r\n\r\n.reports_recommendations_title {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #479573;\r\n  text-transform: uppercase;\r\n  display: flex;\r\n}\r\n\r\n.reports_recommendations_title_edit {\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n.common_table table {\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 4px 4px;\r\n}\r\n\r\n.common_table table thead {\r\n  background-color: #b6d5b2;\r\n}\r\n\r\n.common_table table tr th {\r\n  color: #000;\r\n}\r\n\r\n.common_table table tr td {\r\n  color: #555;\r\n}\r\n\r\n.common_table table tr th,\r\n.common_table table tr td {\r\n  padding: 12px 8px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.common_table table tr:nth-child(odd) td {\r\n  background-color: #edffeb;\r\n}\r\n\r\n.common_table table tr:nth-child(even) td {\r\n  background-color: #d5f0d1;\r\n}\r\n\r\n.Mobile_user_client_details {\r\n  display: none;\r\n}\r\n\r\n.Mobile_user_client_details ul {\r\n  background: #3e9479;\r\n  padding: 20px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n  flex-wrap: wrap;\r\n  row-gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n.Mobile_user_client_details ul li {\r\n  list-style: none;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  text-transform: uppercase;\r\n  line-height: initial;\r\n  padding: 6px 0px;\r\n}\r\n\r\n.Mobile_user_client_details ul li span {\r\n  color: #fdf41f;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* CLIENT_PAGE_CSS_START */\r\n\r\n.client_main_right .save_button {\r\n  text-align: left;\r\n}\r\n\r\n.client_main_right .save_button button {\r\n  margin: 0px;\r\n  background-color: #225ea8;\r\n  padding: 10.5px 10px;\r\n}\r\n\r\n.client_main_right .Simulate_button_group button {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 7.5px 15px;\r\n  width: auto;\r\n  border: 0px;\r\n  background: #24948c;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  width: 135px;\r\n  text-transform: uppercase;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n  background-color: #225ea8;\r\n}\r\n\r\n.client_main_right {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n}\r\n\r\n.client_main_right .client_main_right_2 {\r\n  text-align: center;\r\n  background-color: #fff;\r\n  padding: 0px 10px;\r\n  border-radius: 6px;\r\n  width: 100%;\r\n  grid-column: 2;\r\n  grid-row: 2;\r\n}\r\n\r\n.client_main_right .client_main_right_left {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-wrap: wrap;\r\n  flex-direction: column;\r\n  row-gap: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.client_main_right .client_main_right_left .result_scroll_div {\r\n  height: 61vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.client_main_right .client_main_right_left .result_scroll_div.result_scroll_div_custom {\r\n  height: 74vh;\r\n}\r\n\r\n.client_main_right .client_main_right_left .plan_results_main_outer {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.client_left .plan_results_main_outer {\r\n  display: none;\r\n}\r\n\r\n.plan_results_main_outer .button_meter_outer {\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  background-color: #fff;\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n}\r\n\r\n.plan_results_main_outer .button_meter_outer .client_chart_inner {\r\n  border-radius: 10px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.plan_results_main_outer .button_meter_outer-alert {\r\n  width: 100%;\r\n  grid-column: 1;\r\n  grid-row: 1 / span 2;\r\n}\r\n\r\n.plan_results_main_outer .button_meter_outer-alert .client_chart_inner {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.plan_results_main_outer .chart_filter {\r\n  width: 100%;\r\n}\r\n\r\n.plan_results_main_outer {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-auto-rows: min-content;\r\n  column-gap: 8px;\r\n  row-gap: 8px;\r\n}\r\n\r\n.Plan_Results_content h4 {\r\n  margin: 0px;\r\n}\r\n\r\n.plan_results_main_outer_right {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 8px;\r\n  flex-direction: row;\r\n}\r\n\r\n.Simulate_button_group {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  column-gap: 6px;\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  background-color: #fff;\r\n  padding: 10px 0px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.Simulate_button_group button {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  margin-left: initial;\r\n  gap: 10px;\r\n  padding: 7.5px 15px;\r\n  width: auto;\r\n  border: 0px;\r\n  background: #24948c;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: normal;\r\n  justify-content: center;\r\n  text-transform: none;\r\n  transition: 0.3s ease-in-out;\r\n  -webkit-transition: 0.3s ease-in-out;\r\n  -moz-transition: 0.3s ease-in-out;\r\n  -ms-transition: 0.3s ease-in-out;\r\n  background-color: #225ea8;\r\n}\r\n\r\n.Simulate_button_group button .disabled {\r\n  background: grey !important;\r\n}\r\n\r\n.Simulate_button_group button img {\r\n  height: 18px;\r\n}\r\n\r\n.Simulate_button_group button:hover {\r\n  background: #3e9479;\r\n}\r\n\r\n.plan_results_main_outer_right h4 {\r\n  color: #225ea8;\r\n  text-transform: uppercase;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.client_main_right_2 p {\r\n  color: #225ea8;\r\n  font-size: 10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.cancel_update_btn_group {\r\n  display: flex;\r\n  column-gap: 10px;\r\n  justify-content: flex-end;\r\n  margin-top: 15px;\r\n}\r\n\r\n.cancel_update_btn_group button {\r\n  margin: 0px;\r\n}\r\n\r\n.automatic_button_group button {\r\n  padding: 7.5px 15px !important;\r\n  align-items: center;\r\n  line-height: normal;\r\n  height: auto;\r\n}\r\n\r\n.expenses_warning {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n// .client_main {\r\n//   display: flex;\r\n//   display: -webkit-flex;\r\n//   column-gap: 15px;\r\n// }\r\n// .client_main::before {\r\n//   position: absolute;\r\n//   content: '';\r\n//   height: 100%;\r\n//   width: 2px;\r\n//   background-color: #39675a;\r\n//   left: 50%;\r\n//   transform: translateX(-50%);\r\n//   -webkit-transform: translateX(-50%);\r\n//   -moz-transform: translateX(-50%);\r\n// }\r\n.client_main .client_left {\r\n  width: 100%;\r\n}\r\n\r\n.client_main .client_right {\r\n  width: 100%;\r\n}\r\n\r\n.client_main_right_2 h5 {\r\n  font-weight: 400;\r\n  margin: 0px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.client_main_right_2 h5 span {\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  color: #24948c;\r\n}\r\n\r\n.client_main_right .MuiTabs-root {\r\n  min-height: 39px;\r\n}\r\n\r\n.client_main_right .MuiTabs-flexContainer button.MuiButtonBase-root {\r\n  background-color: transparent;\r\n  border: 0px;\r\n  color: #fff;\r\n  font-weight: 300;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  padding: 10px 10px;\r\n  border-bottom: 2px solid transparent;\r\n  min-height: 39px;\r\n}\r\n\r\n.client_main_right .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {\r\n  border-bottom: 3px solid #ffc809;\r\n}\r\n\r\n.client_main_right .chrono-tabs-wrapper {\r\n  background: linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  background: -webkit-linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  box-shadow: 0px -36px 44px 0px #00000017 inset;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n  margin: 0px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.client_main_right .MuiTabs-root {\r\n  border-bottom: 2px solid #fff;\r\n}\r\n\r\n.MuiTabs-root .MuiButtonBase-root .MuiSvgIcon-root path {\r\n  fill: #fff;\r\n}\r\n\r\n.client_chart_main_div .client_chart_inner {\r\n  background-color: #fff;\r\n  border-radius: 5px;\r\n  margin-bottom: 10px;\r\n  // display: flex;\r\n  // overflow: hidden;\r\n}\r\n\r\n.client_chart_main_div .client_chart_inner table {\r\n  margin-bottom: 10px;\r\n  padding: 10px;\r\n  border: 0px;\r\n  display: block;\r\n}\r\n\r\n.client_chart_main_div .client_chart_inner:last-child {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.profile_details_outer {\r\n  margin-bottom: 10px;\r\n  background-color: #fff;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.chart_filter ul {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: center;\r\n  margin: 0px;\r\n  // background-color: #676767;\r\n  padding: 12px;\r\n  flex-direction: row;\r\n  row-gap: 25px;\r\n  background: linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  background: -webkit-linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  box-shadow: 0px -36px 44px 0px rgba(0, 0, 0, 0.0901960784) inset;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n}\r\n\r\n.chart_filter ul li {\r\n  list-style: none;\r\n  width: auto;\r\n  text-align: center;\r\n}\r\n\r\n.chart_filter ul li button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n  width: 100%;\r\n  color: #fff;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  padding: 4px 18px;\r\n  position: relative;\r\n  transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n  // max-width: 110px;\r\n  min-width: 110px;\r\n}\r\n\r\n.chart_filter ul li button::before {\r\n  position: absolute;\r\n  content: '';\r\n  background-image: url(../images/Radio.svg);\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  width: 20px;\r\n  height: 20px;\r\n  left: 5px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  -webkit-transform: translateY(-50%);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.chart_filter ul li.active button {\r\n  background-color: #fff;\r\n  color: #24948c;\r\n  font-weight: 600;\r\n  border-radius: 10px;\r\n  padding-left: 30px;\r\n}\r\n\r\n.chart_filter ul li.active button::before {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.Plan_Results_content {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 8px;\r\n  row-gap: 5px;\r\n  padding-top: 0px;\r\n}\r\n\r\n.client_left .chart_filter ul {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  flex-direction: row;\r\n  padding: 0px;\r\n  margin: 0px 0px 10px;\r\n  background-color: #676767;\r\n  border-radius: 10px;\r\n  padding: 5px;\r\n}\r\n\r\n.client_left .chart_filter ul li {\r\n  list-style: none;\r\n}\r\n\r\n.client_left .chart_filter ul li button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n  color: #fff;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  padding: 4px 18px;\r\n  position: relative;\r\n  transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n}\r\n\r\n.client_left .chart_filter ul li button::before {\r\n  position: absolute;\r\n  content: '';\r\n  background-image: url(../images/Radio.svg);\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  width: 20px;\r\n  height: 20px;\r\n  left: 5px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  -webkit-transform: translateY(-50%);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.client_left .chart_filter ul li.active button {\r\n  background-color: #fff;\r\n  color: #24948c;\r\n  font-weight: 600;\r\n  border-radius: 10px;\r\n  padding-left: 30px;\r\n}\r\n\r\n.client_left .chart_filter ul li.active button::before {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.client_left .chrono-tabs-wrapper {}\r\n\r\n/* PRODUCT_PAGE_CSS_START */\r\n\r\n.product_left .MuiTabs-flexContainer button.MuiButtonBase-root {\r\n  background-color: transparent;\r\n  border: 0px;\r\n  color: #fff;\r\n  font-weight: 300;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  padding: 8px 10px;\r\n  border-bottom: 2px solid transparent;\r\n  min-height: 39px;\r\n}\r\n\r\n.product_left .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {\r\n  border-bottom: 3px solid #ffc809;\r\n}\r\n\r\n.product_left .chrono-tabs-wrapper {\r\n  background: linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  background: -webkit-linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  box-shadow: 0px -36px 44px 0px #00000017 inset;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n}\r\n\r\n.product_left .MuiTabs-root {\r\n  border-bottom: 2px solid #fff;\r\n  min-height: 39px;\r\n}\r\n\r\n.product_left_content {\r\n  background-color: #fff;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.Choose_Risk_Appetite_outer {\r\n  column-gap: 15px;\r\n  align-items: center;\r\n}\r\n\r\n.product_left_content .title-div {\r\n  color: #71748d;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n\r\n.Current_Target_main_div table {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  min-width: 32.9%;\r\n}\r\n\r\n.Current_Target_main_div table tr {\r\n  list-style: none;\r\n  background-color: #eff9f6;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  padding: 8px 10px;\r\n  font-weight: 700;\r\n  color: #000;\r\n  font-size: 12px;\r\n  margin-bottom: 8px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.Current_Target_main_div table thead tr {\r\n  background-color: #66b192;\r\n}\r\n\r\n.Current_Target_main_div table tr td.data-value,\r\n.Current_Target_main_div table tr td.data-label {\r\n  margin: 0px;\r\n  font-weight: 400;\r\n  color: #000;\r\n  font-size: 12px;\r\n}\r\n\r\n.Current_Target_main_div table tr td.center {\r\n  font-weight: 400;\r\n}\r\n\r\n.Current_Target_main_div table tr td.center-data {\r\n  font-weight: 700;\r\n  opacity: 0.7;\r\n}\r\n\r\n.Current_Target_main_div {\r\n  margin-top: 20px;\r\n  margin-bottom: 25px;\r\n  column-gap: 6px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n}\r\n\r\n.Current_Target_main_div ul.small-width-grid {\r\n  min-width: 32.9%;\r\n}\r\n\r\n.Current_Target_main_div ul.full-width-grid {\r\n  min-width: 50%;\r\n}\r\n\r\n.Current_Target_main_div ul li p.orange_text {\r\n  color: #f58c1e;\r\n}\r\n\r\n.Current_Target_main_div ul li p.red_text {\r\n  color: #f9294e;\r\n}\r\n\r\n.Current_Target_main_div ul li p.green_text {\r\n  color: #52ba7f;\r\n}\r\n\r\n.Select_account_main_outer {\r\n  padding: 0px 0px 8px 0px;\r\n  border-bottom: 1px solid #dbdce2;\r\n}\r\n\r\n.Select_account_main_outer .Select_account_title {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.Select_account_dropdown {\r\n  // column-gap: 12px;\r\n  // align-items: center;\r\n  max-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.Select_account_dropdown button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n  padding: 0px;\r\n}\r\n.Balance_input_div .controls-select label {\r\n  margin: 0px;\r\n}\r\n\r\n.product_left_content .Balance_input_div {\r\n  width: 100%;\r\n}\r\n\r\n.product_left_content .Balance_input_div input {\r\n  // background: linear-gradient(0deg, #f2f2f2, #f2f2f2);\r\n  border: 1px solid #e0e0e0;\r\n  // background-color: #f5f5f5;\r\n  // height: 30px;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n  max-width: 100%;\r\n  height: 38px;\r\n  width: 100%;\r\n}\r\n\r\n.product_left_content input {\r\n  // background: linear-gradient(0deg, #f2f2f2, #f2f2f2);\r\n  border: 1px solid #e0e0e0;\r\n  // background-color: #f5f5f5;\r\n  height: 39px;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n  width: 100%; //change this as it is affecting balance field in investments\r\n}\r\n\r\n.product_left_content .Balance_input_div .Balance_input_div_inner.label-none label {\r\n  display: none;\r\n}\r\n\r\n.select_product_main_outer {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n}\r\n\r\n.select_product_main_outer .select_product_title {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.select_product_dropdown_outer {\r\n  width: 100%;\r\n  margin-top: 10px;\r\n}\r\n\r\n.controls-select .select-search__control {\r\n  color: #000;\r\n  background-image: none;\r\n  padding: 0px 10px;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  border: 1px solid #e0e0e0;\r\n  height: 38px;\r\n}\r\n\r\n.controls-select .select-search__single-value {\r\n  font-size: 12px;\r\n  color: #000;\r\n  background-image: none;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n.controls-select .select-search__value-container {\r\n  padding: 0px;\r\n  height: 38px;\r\n}\r\n\r\n.Remaining_Balance_main_outer {\r\n  margin-top: 30px;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 30px;\r\n  row-gap: 10px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box ul li {\r\n  list-style: none;\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 15px;\r\n  margin-bottom: 10px;\r\n  color: #000000;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box ul li span {\r\n  font-size: 12px;\r\n  color: #000;\r\n  font-weight: 600;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box ul li input {\r\n  width: 100%;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box .Remaining_Balance_box_inner:last-child::before {\r\n  border: 0px;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box_inner {\r\n  position: relative;\r\n}\r\n\r\n.Remaining_Balance_main_outer .Remaining_Balance_box_inner::before {\r\n  position: absolute;\r\n  content: '';\r\n  width: 1px;\r\n  border-right: 1px dashed #9b9b9b;\r\n  height: 100%;\r\n  right: -15px;\r\n}\r\n\r\n.client_right .tab-content {\r\n  display: none;\r\n}\r\n\r\n.client_right .tab-content.active {\r\n  display: block;\r\n}\r\n\r\n.client_chart_inner .Data_grid {\r\n  padding: 30px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  column-gap: 10px;\r\n  row-gap: 10px;\r\n}\r\n\r\n.client_chart_inner .Data_grid .Data_grid_item {\r\n  padding: 12px;\r\n  background: #eff9f6;\r\n  box-shadow: inset 0px 4px 64px rgba(78, 78, 78, 0.07);\r\n  border-radius: 10px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  text-align: center;\r\n}\r\n\r\n.client_chart_inner .Data_grid .Data_grid_item h3 {\r\n  font-weight: 700;\r\n  font-size: 28px;\r\n}\r\n\r\n.client_chart_inner .Data_grid .Data_grid_item p {\r\n  margin: 0px;\r\n  font-family: 'Roboto', sans-serif;\r\n  background: #479573;\r\n  padding: 2px 5px;\r\n  border-radius: 20px;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  color: #fff;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer {\r\n  column-gap: 15px;\r\n  row-gap: 15px;\r\n  flex-wrap: wrap;\r\n  overflow: auto;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul.full-width-table {\r\n  min-width: 65%;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul.small-width-table {\r\n  min-width: 32.333%;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li:last-child {\r\n  margin: 0px;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li {\r\n  list-style: none;\r\n  background-color: #eff9f6;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n  padding: 8px 10px;\r\n  margin-bottom: 4px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li p {\r\n  margin: 0;\r\n  font-weight: 400;\r\n  color: #000;\r\n  font-size: 12px;\r\n  word-break: break-all;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li:nth-child(odd) {\r\n  background-color: #d5f0d1;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li:nth-child(even) {\r\n  background-color: #edfeeb;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li:first-child {\r\n  background-color: #66b192;\r\n}\r\n\r\n.client_chart_inner .Table_main_outer ul li:first-child p {\r\n  font-weight: 700;\r\n}\r\n\r\n.choose_a_product_main_outer {\r\n  margin-top: 20px;\r\n}\r\n\r\n.choose_a_product_main_outer h5 {\r\n  color: #000;\r\n  text-transform: none;\r\n}\r\n\r\n.choose_a_product_table {\r\n  width: 100%;\r\n  height: auto;\r\n  padding: 13px 26px 13px 26px;\r\n  border-radius: 8px;\r\n  gap: 16px;\r\n  background-color: #eff9f6;\r\n}\r\n\r\n.choose_a_product_table table {\r\n  width: 100%;\r\n}\r\n\r\n.choose_a_product_table table th {\r\n  font-weight: 400;\r\n  color: #000;\r\n  text-transform: uppercase;\r\n  border-bottom: 1px solid #92c48e;\r\n  padding-bottom: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.choose_a_product_table table tr td {\r\n  padding: 8px 0px;\r\n  color: #000;\r\n}\r\n\r\n.choose_a_product_main_outer {\r\n  padding-bottom: 20px;\r\n  margin-bottom: 20px;\r\n  border-bottom: 1px dashed #c7c7c7;\r\n}\r\n\r\n.insured_main_outer input {\r\n  width: 100%;\r\n}\r\n\r\n.insured_main_outer .custom-input,\r\n.insured_main_outer .labelStyle,\r\n.insured_main_outer .disabled-input {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.error-text {\r\n  color: #d32f2f;\r\n  font-size: 12px;\r\n}\r\n\r\n.insured_main_outer .row {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.mobile_responsive_tab {\r\n  display: none;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.mobile_responsive_tab ul {\r\n  padding: 0px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 15px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.mobile_responsive_tab_inner {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  background: #235345;\r\n  padding: 10px 10px 0px;\r\n  justify-content: space-between;\r\n}\r\n\r\n.mobile_responsive_tab ul li {\r\n  list-style: none;\r\n}\r\n\r\n.mobile_responsive_tab ul li button {\r\n  background: #3e9479;\r\n  outline: none;\r\n  border: 0px;\r\n  padding: 12px 20px;\r\n  color: #fff;\r\n  border-bottom: 4px solid #235345;\r\n  border-radius: 10px;\r\n  position: relative;\r\n}\r\n\r\n.mobile_responsive_tab ul li button::before {\r\n  position: absolute;\r\n  content: '';\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 10px solid transparent;\r\n  border-right: 10px solid transparent;\r\n  border-top: 10px solid #fdf41f;\r\n  bottom: -13px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  opacity: 0;\r\n}\r\n\r\n.mobile_responsive_tab ul li.active button::before {\r\n  opacity: 1;\r\n}\r\n\r\n.mobile_responsive_tab ul li.active button {\r\n  border-bottom: 4px solid #fdf41f;\r\n}\r\n\r\n.mobile_responsive_tab .responsive_save_button button {\r\n  background: #225ea8;\r\n}\r\n\r\n.mobile_responsive_tab .responsive_save_button button {\r\n  margin-top: 8px;\r\n}\r\n\r\n/* CLIENT_PAGE_CS_START */\r\n\r\n.client_left_content {\r\n  background-color: #fff;\r\n  margin-top: 10px;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.client_main_left .chrono-tabs-wrapper {\r\n  background-color: #fff;\r\n}\r\n\r\n/* .client_main_left .chrono-tabs-wrapper .MuiTabs-scroller  {\r\n    border-bottom: 1px solid #fff;\r\n} */\r\n.client_main_left .chrono-tabs-wrapper .MuiTab-root {\r\n  border: 0px;\r\n  text-transform: uppercase;\r\n  font-size: 12px;\r\n  color: #005dcf;\r\n  padding: 6px 15px;\r\n  background: #fff;\r\n}\r\n\r\n.client_main_left .chrono-tabs-wrapper .MuiTab-root.Mui-selected {\r\n  border-bottom: 2px solid #ffc809;\r\n  color: #2dac00;\r\n  font-weight: 700;\r\n}\r\n\r\n.client_main_left .chrono-tabs-wrapper .chrono-sub-tab .MuiTab-root.Mui-selected {\r\n  color: #225ea8;\r\n}\r\n\r\n.client_main_left .chrono-tabs-wrapper .chrono-sub-tab .MuiTab-root.Mui-selected span {\r\n  color: #ed5500;\r\n}\r\n\r\n.client_main_left .chrono-tabs-wrapper .MuiTabs-root {}\r\n\r\n.client_left_content .input_group_main {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n  align-items: center;\r\n  row-gap: 10px;\r\n}\r\n\r\n.client_left_content .input_group_div {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n  width: 50%;\r\n}\r\n\r\n.client_left_content .input_label_div {\r\n  width: 50%;\r\n}\r\n\r\n.client_left_content .input_group_main input {\r\n  width: 100%;\r\n  height: 35px;\r\n  background-color: #f5f5f5;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 7px;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.Tax_Filing_Main {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  column-gap: 10px;\r\n}\r\n\r\n.Tax_Filing_Main p,\r\n.input_label_div label {\r\n  font-size: 12px;\r\n  color: #000000;\r\n  margin: 0px;\r\n}\r\n\r\n.input_group {\r\n  row-gap: 10px;\r\n}\r\n\r\n.Select_account_dropdown.select_client_outer button {\r\n  width: auto;\r\n}\r\n\r\n.balance_portfolio_outr .balance_portfolio_radio_group {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  column-gap: 30px;\r\n}\r\n\r\n/* input_checkbox */\r\n\r\n/* Hide the default checkbox */\r\n\r\n/* https://codepen.io/schobiwan/pen/jGLpJL */\r\n\r\n.Choose_Risk_Appetite_member label {\r\n  /* display: block; */\r\n  margin: 0px 0;\r\n  cursor: pointer;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.Choose_Risk_Appetite_member .MuiFormGroup-root {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 15px;\r\n}\r\n\r\n.Choose_Risk_Appetite_member label>input[type='checkbox'] {\r\n  display: none;\r\n}\r\n\r\n.Choose_Risk_Appetite_member input[type='checkbox']+span:before {\r\n  content: '';\r\n  display: inline-block;\r\n  margin-right: 5px;\r\n  font-family: 'FontAwesome';\r\n  font-weight: normal;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 1px solid #b0b0b0;\r\n  border-radius: 4px;\r\n  position: relative;\r\n  top: 4px;\r\n}\r\n\r\n/**--- Checked ---**/\r\n.MuiCheckbox-colorPrimary.Mui-checked {\r\n  color: #3e9479 !important;\r\n}\r\n\r\n.Choose_Risk_Appetite_member input[type='checkbox']:checked+span:before {\r\n  content: '';\r\n  color: #fff;\r\n  background-image: url(../images/checkbox_tick.svg);\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-color: #24948c;\r\n  border-color: #24948c;\r\n  animation: pop 180ms ease-in;\r\n}\r\n\r\n/**--- Disabled ---**/\r\n\r\n.Choose_Risk_Appetite_member input[type='checkbox']:disabled+span {\r\n  color: #999;\r\n}\r\n\r\n/* .Choose_Risk_Appetite_member input[type=\"checkbox\"]:disabled + span:before {\r\n    content: \"\\f0c8\";\r\n    color: #999;\r\n  } */\r\n\r\n/**--- Animation ---**/\r\n\r\n@keyframes pop {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n\r\n  90% {\r\n    transform: scale(1.4);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Radio_button_css_start */\r\n\r\n.MuiIconButton-label {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: inherit;\r\n  justify-content: inherit;\r\n}\r\n\r\n.PrivateRadioButtonIcon-root-7 {\r\n  display: flex;\r\n  position: relative;\r\n}\r\n\r\n.MuiSvgIcon-root {\r\n  fill: currentColor;\r\n  width: 1em;\r\n  height: 1em;\r\n  display: inline-block;\r\n  font-size: 1.5rem;\r\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  flex-shrink: 0;\r\n  user-select: none;\r\n}\r\n\r\n.controls-radiogroup .MuiFormControlLabel-root .MuiSvgIcon-root {\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.controls-radiogroup .MuiFormControlLabel-root .MuiSvgIcon-root {\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.PrivateRadioButtonIcon-root-7.PrivateRadioButtonIcon-checked-9 .PrivateRadioButtonIcon-layer-8 {\r\n  transform: scale(1);\r\n  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1) 0ms;\r\n}\r\n\r\n.PrivateRadioButtonIcon-layer-8 {\r\n  left: 0;\r\n  position: absolute;\r\n  transform: scale(0);\r\n  transition: transform 150ms cubic-bezier(0.4, 0, 1, 1) 0ms;\r\n  color: #fff;\r\n}\r\n\r\n.MuiRadio-root {\r\n  color: #24948c;\r\n}\r\n\r\n.MuiRadio-colorSecondary.Mui-checked {\r\n  color: #24948c !important;\r\n}\r\n\r\n/* .MuiButtonBase-root.Mui-checked .MuiSvgIcon-root {\r\n    border: 10px solid;\r\n    border-radius: 50px;\r\n}\r\n.MuiButtonBase-root.Mui-checked .MuiSvgIcon-root path {\r\n    color: #fff;\r\n} */\r\n\r\n.MuiButtonBase-root.Mui-checked .MuiSvgIcon-root.PrivateRadioButtonIcon-layer-8 {\r\n  border: 7px solid #3e9479;\r\n  border-radius: 50px;\r\n}\r\n\r\n#image-list .sub-menu {\r\n  list-style: none;\r\n  display: none;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 91px;\r\n  width: 400px;\r\n  padding: 20px;\r\n  height: 500px;\r\n  overflow-y: scroll;\r\n  margin: 0;\r\n  background-color: #fff;\r\n}\r\n\r\n#image-list .sub-menu.show-sub-menu {\r\n  display: block;\r\n}\r\n\r\n.Choose_Risk_Appetite_outer {\r\n  justify-content: space-between;\r\n}\r\n\r\n.Choose_Risk_Appetite_outer .Choose_Risk_Appetite_member {\r\n  padding-top: 10px;\r\n}\r\n\r\n.select_product_table_main_outer {\r\n  padding-top: 10px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  align-items: center;\r\n  column-gap: 20px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_column {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  align-items: center;\r\n  column-gap: 6px;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_column:nth-child(2) {\r\n  grid-template-columns: 1fr 1fr 30px;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_content {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  // width: 60%;\r\n  column-gap: 5px;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_content p {\r\n  background-color: #eff9f6;\r\n  padding: 10px 26px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-radius: 13px;\r\n  height: 43px;\r\n  width: 100%;\r\n}\r\n\r\n// .select_product_table_main_outer\r\n//   .select_product_table_inner\r\n//   .select_product_table_content\r\n//   p.value {\r\n//   width: 130px;\r\n// }\r\n// .select_product_table_main_outer\r\n//   .select_product_table_inner\r\n//   .select_product_table_amount {\r\n//   width: 39%;\r\n// }\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_amount input {\r\n  // width: 100%;\r\n  height: 43px;\r\n  border-radius: 7px;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n// .select_product_table_main_outer\r\n//   .select_product_table_inner\r\n//   .select_product_table_delete {\r\n//   width: 5%;\r\n//   text-align: center;\r\n// }\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_content p {\r\n  margin: 0px;\r\n  color: #000000;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner .select_product_table_delete button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner:last-child .select_product_table_content {\r\n  background-color: transparent;\r\n}\r\n\r\n.select_product_table_main_outer .select_product_table_inner:last-child .select_product_table_content p {\r\n  font-weight: 700;\r\n  background-color: transparent;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.client_main_right_2 svg .highcharts-credits {\r\n  display: none !important;\r\n}\r\n\r\n.client_main_right_2 svg .highcharts-label.highcharts-data-label text {\r\n  font-size: 10px !important;\r\n  display: block !important;\r\n  text-align: center !important;\r\n  fill: #479573 !important;\r\n  color: #479573 !important;\r\n  stroke: none !important;\r\n}\r\n\r\n.vHidden {\r\n  width: 0;\r\n  height: 0;\r\n  display: none;\r\n}\r\n\r\n.controls-radiogroup .MuiFormControlLabel-label label {\r\n  margin: 0px !important;\r\n}\r\n\r\n.form_group.select_date_time_outer .MuiInputBase-root.MuiInput-underline::before,\r\n.form_group.select_date_time_outer .MuiInputBase-root.MuiInput-underline::after {\r\n  display: none;\r\n}\r\n\r\n.form_group.select_date_time_outer .MuiInputBase-root.MuiInput-underline input {\r\n  height: 28px !important;\r\n}\r\n\r\n.form_group.select_time_outer .MuiInputBase-root.MuiOutlinedInput-root input {\r\n  height: 28px !important;\r\n  border: 0px solid #e0e0e0;\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n.form_group.select_time_outer .MuiInputBase-root.MuiOutlinedInput-root fieldset {\r\n  top: 0px;\r\n}\r\n\r\n.form_group.select_time_outer .MuiInputBase-root.MuiOutlinedInput-root fieldset legend {\r\n  float: left;\r\n}\r\n\r\n.crm_content h5.title-div {\r\n  color: #000;\r\n  padding-bottom: 10px;\r\n}\r\n\r\ninput:disabled::-webkit-input-placeholder {\r\n  /* WebKit browsers */\r\n  color: #b9b9b9;\r\n}\r\n\r\ninput:disabled:-moz-placeholder {\r\n  /* Mozilla Firefox 4 to 18 */\r\n  color: #b9b9b9;\r\n}\r\n\r\ninput:disabled::-moz-placeholder {\r\n  /* Mozilla Firefox 19+ */\r\n  color: #b9b9b9;\r\n}\r\n\r\ninput:disabled:-ms-input-placeholder {\r\n  /* Internet Explorer 10+ */\r\n  color: #b9b9b9;\r\n}\r\n\r\ninput[disabled] {\r\n  color: #000;\r\n  background-color: #f5f5f5;\r\n  background: linear-gradient(0deg, #f2f2f2, #f2f2f2);\r\n}\r\n\r\n.crm_content input {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n  width: 100%;\r\n}\r\n\r\n.crm_content .form_group {\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.form_group.new_notes_outer textarea {\r\n  width: 100%;\r\n  height: 150px;\r\n  padding: 5px 10px;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.form_group.new_notes_outer .Choose_Risk_Appetite_member.checkbox {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.select_report_outer .form_group select,\r\n.crm_content .form_group select {\r\n  border: 1px solid #24948c;\r\n  background-color: transparent;\r\n  height: 30px;\r\n  border-radius: 7px;\r\n  padding: 5px 10px;\r\n  width: 100%;\r\n}\r\n\r\n.meeting_history ul {\r\n  padding: 0px;\r\n  width: 100%;\r\n  margin: 0px;\r\n}\r\n\r\n.meeting_history ul li {\r\n  list-style: none;\r\n  background-color: #eff9f6;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  padding: 8px 10px;\r\n  margin-bottom: 4px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.meeting_history ul li:nth-child(odd) {\r\n  background-color: #d5f0d1;\r\n}\r\n\r\n.meeting_history ul li:first-child {\r\n  background-color: #66b192;\r\n}\r\n\r\n.meeting_history ul li p {\r\n  margin: 0px;\r\n}\r\n\r\n.crm_content_main_screen {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 30px;\r\n  row-gap: 30px;\r\n}\r\n\r\n.crm_content_main_screen .crm_content {\r\n  width: 100%;\r\n}\r\n\r\n.crm_content_main_screen .crm_content .row:first-child {\r\n  align-items: center;\r\n}\r\n\r\n.crm_all_notes_outer {\r\n  background: linear-gradient(0deg, #f2f2f2, #f2f2f2);\r\n  border: 1px solid #e0e0e0;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.crm_all_notes_outer ul {\r\n  padding: 15px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-wrap: wrap;\r\n  row-gap: 10px;\r\n  margin: 0px;\r\n  max-height: 300px;\r\n  overflow: hidden;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.crm_all_notes_outer ul li {\r\n  list-style: none;\r\n  display: block;\r\n  width: 100%;\r\n  color: #000;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.crm_all_notes_outer ul li:last-child {\r\n  border: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.Select_Report_Outer_Card {\r\n  width: 96%;\r\n}\r\n\r\n.select_meeting_edit_outer {\r\n  align-items: center;\r\n}\r\n\r\n.select_meeting_edit_outer button {\r\n  background-color: transparent;\r\n  border: 0px;\r\n}\r\n\r\n/* Search_dropdown */\r\n\r\n.controls-input input {\r\n  background: linear-gradient(180deg,\r\n      #ffffff 0%,\r\n      rgba(255, 255, 255, 0) 183.75%);\r\n  border-radius: 7px;\r\n  border: 1px solid #e0e0e0;\r\n  width: 100%;\r\n  height: 43px;\r\n}\r\n\r\n.controls-input .error-text {\r\n  color: #d32f2f;\r\n  font-size: 12px;\r\n}\r\n\r\n// .controls-select label {\r\n//   padding-bottom: 4px;\r\n//   font-size: 12px;\r\n//   display: none;\r\n// }\r\n.controls-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n  border: 1px solid #00a19a !important;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n}\r\n\r\n.controls-select .MuiSelect-outlined {\r\n  padding: 4px 0 8px;\r\n}\r\n\r\n.controls-select .MuiOutlinedInput-notchedOutline {\r\n  background: linear-gradient(180deg,\r\n      #ffffff 0%,\r\n      rgba(255, 255, 255, 0) 183.75%);\r\n  border: 1px solid #ffffff;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n}\r\n\r\n.controls-select .MuiOutlinedInput-notchedOutline legend {\r\n  display: none;\r\n}\r\n\r\n.controls-select .MuiOutlinedInput-input {\r\n  padding-left: 8px;\r\n}\r\n\r\n.controls-select .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border: 1px solid #00a19a;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n}\r\n\r\n.controls-select .MuiInputLabel-root.Mui-focused {\r\n  color: #555555;\r\n  padding-top: 5px;\r\n}\r\n\r\n.controls-select .MuiSvgIcon-root {\r\n  z-index: 1;\r\n  color: #555555;\r\n}\r\n\r\n.controls-select .MuiOutlinedInput-root.Mui-focused .MuiSvgIcon-root {\r\n  color: #00a19a;\r\n}\r\n\r\n.controls-select .MuiMenuItem-root {\r\n  font-size: 12px;\r\n}\r\n\r\n.controls-select .select-search__control--is-disabled {\r\n  background: linear-gradient(0deg, #f2f2f2, #f2f2f2) !important;\r\n}\r\n.controls-select .select-search__control {\r\n  height: 35px;\r\n  border-radius: 5px;\r\n  margin-top: 0px;\r\n  background: #fff;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.controls-select .select-search__single-value {\r\n  font-size: 14px;\r\n}\r\n\r\n.controls-select .select-search__placeholder {\r\n  font-size: 14px;\r\n}\r\n\r\n.controls-select .select-search__option {\r\n  font-size: 14px;\r\n}\r\n\r\n.controls-datepicker .MuiOutlinedInput-notchedOutline {\r\n  border-radius: 4px;\r\n  border-width: 2px;\r\n  border-color: rgba(0, 0, 0, 0.23);\r\n}\r\n\r\n.controls-datepicker .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: rgba(0, 0, 0, 0.23);\r\n}\r\n\r\n.controls-datepicker button:focus {\r\n  outline: none;\r\n}\r\n\r\n.controls-datepicker .datepicker-label {\r\n  margin-bottom: -8px;\r\n}\r\n\r\n.controls-datepicker .MuiTextField-root {\r\n  margin-top: 12px;\r\n}\r\n\r\n.controls-datepicker .MuiOutlinedInput-input {\r\n  padding: 5px 0 12px 10px;\r\n}\r\n\r\n.controls-radiogroup .MuiFormControlLabel-root .MuiSvgIcon-root {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n\r\n.controls-radiogroup .MuiFormControlLabel-label {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.controls-select .MuiFormControl-root .select-search__control .select-search__indicators svg path {\r\n  fill: #000;\r\n}\r\n\r\n/* .controls-select .MuiFormControl-root .select-search__control .select-search__indicator-separator.css-1okebmr-indicatorSeparator {\r\n  display: none;\r\n}\r\n.controls-select .MuiFormControl-root .select-search__control .select-search__indicators svg path {\r\n  fill: #24948C;\r\n} \r\n.controls-select .MuiFormControl-root .select-search__control .select-search__placeholder {\r\n  color: #24948C;\r\n} */\r\n\r\n.Plan_Results_content.select_client_outer .Horizon_div,\r\n.Plan_Results_content.select_client_outer .Display_Client {\r\n  width: 100%;\r\n}\r\n\r\n/* POP_up_css_start */\r\n\r\n.MuiDialog-scrollPaper .signup-body-container .newplan-form-grid.MuiGrid-spacing-xs-2 {\r\n  width: 100%;\r\n}\r\n\r\n.MuiDialog-scrollPaper .signup-body-container .newplan-form-grid {\r\n  margin: 0px;\r\n}\r\n\r\n.MuiDialog-scrollPaper .signup-title-container .signup-title-close-icon {\r\n  color: #24948c;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.MuiDialog-container.MuiDialog-scrollPaper .controls-input input {\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  padding: 0px 15px;\r\n}\r\n\r\n.Select_account_dropdown.select_client_outer {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  align-items: center;\r\n}\r\n\r\n.MuiSwitch-root .MuiSwitch-track {\r\n  background-color: #3e9479 !important;\r\n}\r\n\r\n.MuiSwitch-root .MuiSwitch-switchBase+.MuiSwitch-track {\r\n  background-color: #ddd !important;\r\n}\r\n\r\n.MuiSwitch-root .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track {\r\n  background-color: #3e9479 !important;\r\n}\r\n\r\n.signup-body-container .MuiFormControlLabel-root {\r\n  margin-left: 0px;\r\n}\r\n\r\n.signup-body-container .MuiTypography-root {\r\n  font-size: 14px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.select_client_outer_form_row .client.client-review-dd {\r\n  display: block;\r\n  column-gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.select_client_outer_form_row .plan.client-review-dd {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  column-gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.select_client_outer_form_row .client-review-dd .controls-select label {\r\n  display: none;\r\n}\r\n\r\n.select_client_outer_form_row .client-review-dd button {\r\n  width: 100%;\r\n}\r\n\r\n.select_client_outer_form_row.marketandasset_outer .controls-select label {\r\n  display: none;\r\n}\r\n\r\n.Table_main_outer table {\r\n  border-collapse: collapse;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.Table_main_outer table tr td,\r\n.Table_main_outer table tr th {\r\n  padding: 8px 10px;\r\n  font-size: 12px;\r\n  text-align: left;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.Table_main_outer table tr th {\r\n  background-color: #e3e3e3;\r\n  color: #000;\r\n  font-weight: 700;\r\n}\r\n\r\n.Table_main_outer table tr td {\r\n  background-color: #ffffff;\r\n  color: #000;\r\n}\r\n\r\n.client_chart_main_div.data .Table_main_outer table tr th {\r\n  border: 1px solid #e3e3e3;\r\n}\r\n\r\n.client_chart_main_div.data .center-data {\r\n  text-align: center;\r\n}\r\n\r\n.Table_main_outer table.full-width-table {\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.select_client_outer_form_row.marketandasset_outer {\r\n  margin: 0px;\r\n}\r\n\r\n.select_client_outer_form_row.marketandasset_outer p {\r\n  color: #000;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.select_client_outer_form_row.report_select_dd {\r\n  margin: 0px;\r\n  width: 35%;\r\n}\r\n\r\n.product_left .acc-list-container .MuiTabs-flexContainer button.MuiButtonBase-root {\r\n  color: #000;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  text-transform: uppercase;\r\n  padding: 10px 10px;\r\n}\r\n\r\n.product_left .acc-list-container .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {\r\n  border-bottom: none;\r\n}\r\n\r\n.product_left .plaid-container .simulate-buttons button.MuiButtonBase-root.MuiButton-textPrimary {\r\n  color: #fff !important;\r\n}\r\n\r\n.inv-list-container {\r\n  overflow: auto;\r\n\r\n  .MuiFormGroup-root {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n.Select_account_main_outer {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.Select_account_main_outer .select_account_dropdown-outer {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.Select_account_main_outer .controls-select-main-outer h5.account_dropdown_label {\r\n  width: -webkit-fill-available;\r\n  display: block;\r\n  margin: 12px 0px;\r\n  max-width: fit-content;\r\n  font-weight: bolder !important;\r\n  color: #71748d;\r\n  font-size: 14px !important;\r\n  text-transform: none !important;\r\n  line-height: 22px !important;\r\n}\r\n\r\n.Select_account_main_outer .controls-select-main-outer {\r\n  display: flex;\r\n  column-gap: 60px;\r\n  justify-content: space-between;\r\n  column-gap: 20px;\r\n}\r\n\r\n.Select_account_main_outer .controls-select-main-outer .controls-select {\r\n  width: 50%;\r\n}\r\n\r\n.Accordion_outer.faq-container-new .insured_main_outer p {\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n  color: #71748d;\r\n  font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.client_chart_main_div.data .center-data {\r\n  text-align: center;\r\n}\r\n\r\n// MuiAccordion-roo\r\n\r\n.MuiPaper-root.MuiAccordion-root {\r\n  background-color: #fff;\r\n  box-shadow: unset;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.MuiPaper-root.MuiAccordion-root.Mui-expanded {\r\n  background: #fff;\r\n}\r\n\r\n.MuiPaper-root.MuiAccordion-root:first-of-type {\r\n  border-radius: 8px;\r\n}\r\n\r\n.faq-container .faq-content-items {\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.faq-container .faq-content-items .MuiPaper-root {\r\n  box-shadow: 0 0 6px 0 #dfdfdf;\r\n}\r\n\r\n.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-content {\r\n  color: #000;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  text-align: left;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n\r\n.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root {\r\n  min-height: 30px;\r\n  flex-direction: row-reverse;\r\n  padding: 6px 10px;\r\n  column-gap: 6px;\r\n}\r\n\r\n.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root svg path {\r\n  color: #24948c;\r\n}\r\n\r\n.MuiPaper-root.MuiAccordion-root.Mui-expanded .MuiAccordionSummary-content {\r\n  color: #24948c;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.MuiButtonBase-root .MuiTabScrollButton-root {\r\n  color: #fff !important;\r\n}\r\n\r\n.MuiPaper-root.MuiDialog-paper .MuiDialogActions-root {\r\n  padding: 15px 24px 15px;\r\n  box-shadow: 0 0 11px 0 #cdcdcd;\r\n  justify-content: space-between;\r\n}\r\n.popup_button_group p.mandatory_tag {\r\n  color: #666666;\r\n  margin: 0px;\r\n}\r\n.popup_button_group p.mandatory_tag span {\r\n  color: red;\r\n}\r\n.personal_div_first_row {\r\n  justify-content: right;\r\n}\r\n\r\n.personal_div_first_row .personal_div_first_content {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 15px;\r\n}\r\n\r\n.personal_div_first_row .personal_div_first_content p {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.personal_div_first_row .personal_div_first_content input {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.personal_div_first_row {\r\n  padding: 10px 0px;\r\n}\r\n\r\n.planOuter {\r\n  position: relative;\r\n}\r\n\r\n.planOuter .select_client_outer_other {\r\n  position: absolute;\r\n  top: 10px;\r\n  z-index: 999;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 30%;\r\n}\r\n\r\n.planOuter .select_client_outer_other .client {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  column-gap: 10px;\r\n}\r\n\r\n.planOuter .select_client_outer_other .client .controls-select {\r\n  width: 100%;\r\n}\r\n\r\n.card.timeline-card .card-header {\r\n  padding: 15px 15px;\r\n}\r\n\r\n.MuiDialog-container {\r\n  justify-content: center !important;\r\n  width: 100%;\r\n}\r\n\r\n.MuiDialog-container .MuiPaper-root {\r\n  width: 100%;\r\n}\r\n\r\n.signup-body-container textarea {\r\n  width: 100%;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  padding: 15px;\r\n}\r\n\r\n.reminder_div {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 30px;\r\n}\r\n\r\n.reminder_div .form_group {\r\n  width: 100%;\r\n}\r\n\r\n.save_inline_div {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  grid-column-gap: 30px;\r\n  column-gap: 10px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n// .client_main_right_2 .highcharts-container {\r\n//   width: 100% !important;\r\n// }\r\n\r\n.mobile_card {\r\n  display: none;\r\n}\r\n\r\n.mobile_card .home_main_card_outer.active::after {\r\n  display: none;\r\n}\r\n\r\n.divider_line {\r\n  position: relative;\r\n}\r\n\r\n.divider_line::before {\r\n  position: absolute;\r\n  content: '';\r\n  height: 100%;\r\n  width: 2px;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  background-color: #39675a;\r\n}\r\n\r\n/* New */\r\n\r\n.client_main .client_left {\r\n  position: relative;\r\n}\r\n\r\n// .product_left .chrono-tabs-wrapper {\r\n//   position: absolute;\r\n//   right: 0px;\r\n//   left: 0px;\r\n// }\r\n.client_left.product_left .product_left_content {\r\n  height: calc(90vh - 96px);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  // margin-top: 90px;\r\n}\r\n\r\n.client_left.product_left.solution_action_height_full .product_left_content,\r\n.client_left.product_left.build_action_height_full .product_left_content {\r\n  height: calc(100vh - 96px);\r\n}\r\n\r\n.privacy_policy_outer {\r\n  padding: 30px;\r\n  margin: 20px 0px;\r\n  background: #fff;\r\n}\r\n\r\n.privacy_policy_outer h1,\r\n.privacy_policy_outer h2,\r\n.privacy_policy_outer h3,\r\n.privacy_policy_outer h4,\r\n.privacy_policy_outer h5,\r\n.privacy_policy_outer h6 {\r\n  color: #3e9479;\r\n  font-family: 'Futura_Bold';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  margin-top: 20px;\r\n}\r\n\r\n.privacy_policy_outer h1 {\r\n  color: #000;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.privacy_policy_outer p strong {\r\n  color: #3e9479;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n}\r\n\r\n.button-like-link {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: '14px';\r\n  text-decoration: underline;\r\n  /* Underline the text to mimic link */\r\n  padding: 0;\r\n  /* Remove default padding */\r\n  font-family: inherit;\r\n  /* Inherit font from parent */\r\n}\r\n\r\n.header_right_action_div {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.header_right_action_div .user-button {\r\n  padding: 0px;\r\n  width: auto;\r\n  min-width: auto;\r\n}\r\n\r\n.header_right_action_div .user-button svg {\r\n  font-size: 25px;\r\n}\r\n\r\n.header_right_action_div .user-button svg path {\r\n  fill: #fff;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options ul {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: column;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options ul li {\r\n  justify-content: flex-start;\r\n  padding: 5px 0px;\r\n  background: transparent;\r\n  height: auto;\r\n  min-height: auto;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options .MuiBackdrop-root.MuiBackdrop-invisible.MuiModal-backdrop .MuiPopover-root.user-button-menu-options .MuiBackdrop-root.MuiBackdrop-invisible.MuiModal-backdrop {\r\n  display: none;\r\n}\r\n\r\n// .MuiBackdrop-root {\r\n//   z-index: 1300 !important;\r\n//   /* Ensure the backdrop is above the spinner */\r\n// }\r\n\r\n// .MuiDialog-container {\r\n//   z-index: 1400 !important;\r\n//   /* Ensure dialog is above the backdrop */\r\n// }\r\n\r\n.MuiPopover-root.user-button-menu-options button {\r\n  padding: 0px;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options .MuiButton-label {\r\n  padding: 0px;\r\n  min-width: fit-content;\r\n  max-width: fit-content;\r\n  width: auto;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options .MuiIconButton-label .MuiPopover-root.user-button-menu-options .MuiIconButton-label svg path,\r\n.MuiPopover-root.user-button-menu-options .MuiButton-startIcon svg path {\r\n  fill: #000;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options button.MuiButton-text {\r\n  color: #555;\r\n  font-size: 12px;\r\n  padding: 0px 0px;\r\n  width: 100%;\r\n  text-align: left;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.MuiPopover-root.user-button-menu-options button.MuiButton-text:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n.required:after {\r\n  content: ' *';\r\n  color: red;\r\n}\r\n\r\n.mandatory:before {\r\n  content: '* ';\r\n  color: red;\r\n}\r\n\r\n.MuiDialog-container button.MuiButton-root:not(.Mui-disabled) {\r\n  background-color: rgb(34, 94, 168) !important;\r\n}\r\n\r\n.solution_expenses_outer {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.plaid_save_button_group {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.plaid_save_button_group button {\r\n  margin-left: 0px;\r\n  width: auto;\r\n}\r\n\r\n.solution_action_height_full .product_left_content {\r\n  height: 87vh;\r\n}\r\n\r\n.insight_action_height_full .product_left_content,\r\n.goals_action_height_full .product_left_content {\r\n  height: 80vh;\r\n}\r\n\r\n.simulate-buttons.cancel_update_btn_group {\r\n  text-align: right;\r\n  max-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.delete_popup_outer .MuiPaper-root {\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.report_select_dd .controls-select label {\r\n  display: none;\r\n}\r\n.controls-select .custom-input {\r\n  padding: 0px;\r\n  border: 0px;\r\n  height: auto;\r\n}\r\n.radio_button_inline .controls-radiogroup .MuiFormLabel-root {\r\n  display: none;\r\n}\r\n\r\n.radio_button_inline .controls-radiogroup .MuiFormGroup-root {\r\n  flex-direction: row;\r\n}\r\n\r\n.expenses_grid_main_outer .expenses_grid_outer {\r\n  row-gap: 15px;\r\n}\r\n\r\n.simulate-buttons.next_previous_btn_group {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.simulate-buttons.next_previous_btn_group button.next_button {\r\n  margin-left: auto;\r\n}\r\n\r\n.residence_taxFiling_outer {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  column-gap: 20px;\r\n  row-gap: 10px;\r\n  align-items: start;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer .MuiTabs-vertical {\r\n  width: 30%;\r\n  background: linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  background: -webkit-linear-gradient(270deg,\r\n      #666666 -9.03%,\r\n      #6a6a6a 39.95%,\r\n      #7e7e7e 59.81%,\r\n      #7c7c7c 245.14%);\r\n  box-shadow: 0px -36px 44px 0px rgba(0, 0, 0, 0.0901960784) inset;\r\n  overflow: hidden;\r\n  border-radius: 10px;\r\n  height: fit-content;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer .tab_content {\r\n  width: 70%;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer .tab_content .MuiBox-root {\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer .MuiFormControlLabel-root {\r\n  margin-left: 0px;\r\n  width: 100%;\r\n  gap: 8px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer .tab_content.input_tab .MuiFormControlLabel-root {\r\n  gap: 20px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer h5 {\r\n  margin-bottom: 10px;\r\n  text-transform: unset !important;\r\n  font-weight: 400 !important;\r\n  text-align: left;\r\n  font-size: 12px !important;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_box .MuiTypography-root {\r\n  font-size: 12px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_box .action-limit-width,\r\n.solution_goal_content .solution_goal_right .solution_goal_right_box .action-limit-width img {\r\n  width: 15px;\r\n  min-width: 15px;\r\n}\r\n\r\n// .solution_goal_verticaltab_main_outer button.MuiButtonBase-root {\r\n//   border-bottom: 2px solid #fff !important;\r\n// }\r\n.product_left .solution_goal_verticaltab_main_outer .MuiTabs-flexContainer button.MuiButtonBase-root {\r\n  border-bottom: 2px solid #fff;\r\n}\r\n\r\n.product_left .solution_goal_verticaltab_main_outer .MuiTabs-flexContainer button.MuiButtonBase-root.Mui-selected {\r\n  border-bottom: 3px solid #ffc809;\r\n}\r\n\r\n.solution_goal_verticaltab_main_outer {\r\n  padding: 20px 10px;\r\n}\r\n\r\n.solution_goal_content {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  margin-bottom: 30px;\r\n  padding-bottom: 30px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.solution_goal_content .solution_goal_title {\r\n  width: 22%;\r\n  border-right: 1px solid #ddd;\r\n}\r\n\r\n.solution_goal_content .solution_goal_title h4 {\r\n  font-size: 15px;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right {\r\n  width: 78%;\r\n  padding-left: 10px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_row button {\r\n  background-color: transparent;\r\n  width: fit-content;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_row {\r\n  display: grid;\r\n  grid-template-columns: 130px 1fr 1fr 1fr;\r\n  gap: 15px;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_row .solution_goal_column:first-child h5 {\r\n  padding-left: 25px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_column .green_color {\r\n  background: #3e9479;\r\n  background-color: #3e9479;\r\n  border-color: #3e9479;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_column .yellow_color {\r\n  background: #ffc809;\r\n  background-color: #ffc809;\r\n  border-color: #ffc809;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_column .red_color {\r\n  background: #f70000;\r\n  background-color: #f70000;\r\n  border-color: #f70000;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_column .orange_color {\r\n  background: #f78900;\r\n  background-color: #f78900;\r\n  border-color: #f78900;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_column .lightgreen_color {\r\n  background: #60ff60;\r\n  background-color: #60ff60;\r\n  border-color: #60ff60;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_column .grey_color {\r\n  background-color: #a1a1a1;\r\n  background: #a1a1a1;\r\n  border-color: #a1a1a1;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_row.add_btn_row {\r\n  background: transparent;\r\n  padding: 0px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_row:last-child {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .justify-content-left {\r\n  column-gap: 10px;\r\n  justify-content: left;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_box {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 10px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_box label {\r\n  margin: 0px;\r\n  font-size: 12px;\r\n}\r\n\r\n.solution_goal_content .solution_goal_right .solution_goal_right_box .Mui-disabled {\r\n  opacity: 1;\r\n  -webkit-text-fill-color: rgb(0 0 0);\r\n}\r\n\r\n.solution_goal_right .add_button {\r\n  background-color: transparent;\r\n  width: fit-content;\r\n  box-shadow: none;\r\n  padding: 0px;\r\n  width: auto;\r\n  min-width: auto;\r\n  margin-left: 60px;\r\n}\r\n\r\n.client_main_right_left .chrono-parent-tab {\r\n  display: grid;\r\n}\r\n\r\n.client_main_right_left .chrono-parent-tab .MuiTabs-root {\r\n  position: relative;\r\n  padding: 0px 40px;\r\n  display: grid;\r\n}\r\n\r\n.client_main_right_left .chrono-parent-tab .MuiTabs-root .MuiTabScrollButton-root {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  -webkit-transform: translateY(-50%);\r\n  -moz-transform: translateY(-50%);\r\n  -ms-transform: translateY(-50%);\r\n}\r\n\r\n.client_main_right_left .chrono-parent-tab .MuiTabs-root .MuiTabScrollButton-root:first-child {\r\n  left: 0px;\r\n}\r\n\r\n.client_main_right_left .chrono-parent-tab .MuiTabs-root .MuiTabScrollButton-root:last-child {\r\n  right: 0px;\r\n}\r\n\r\n// new_css\r\n.tab_main_nav {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  margin: 20px 0px 0px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.tab_main_nav button {\r\n  border: 0px;\r\n  color: #fff;\r\n  font-weight: 400;\r\n  padding: 7px 10px;\r\n  background: #225ea8;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 5px;\r\n  text-transform: none;\r\n}\r\n\r\n.tab_main_nav button:hover {\r\n  background: #3e9479;\r\n}\r\n\r\n.tab_main_nav button svg {\r\n  font-size: 18px;\r\n}\r\n\r\n.tab_main_nav.full_width_nav {\r\n  grid-column: 2 span;\r\n}\r\n\r\n.product_left_content .MuiAlert-standardInfo {\r\n  background-color: #ededed;\r\n}\r\n\r\nnav.navbar ul li.nav-item {\r\n  position: relative;\r\n}\r\n\r\n.insured_main_outer,\r\n.financial-instn-container,\r\n.Select_account_main_outer,\r\n.marketing_select_member {\r\n  grid-column: 2 span;\r\n}\r\n\r\n.markets_grid_full {\r\n  grid-column: 2 span;\r\n}\r\n\r\n.marketing_select_member,\r\n.financial-instn-container {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.Select_account_main_outer .action-button {\r\n  width: 25px !important;\r\n}\r\n\r\n.asset-mix-input-outer {\r\n  width: 100%;\r\n}\r\n\r\n.asset-mix-input {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  column-gap: 30px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.markets_grid_full .chart_filter {\r\n  margin-top: 30px;\r\n}\r\n\r\n.faq-container-new .faq-content-new {\r\n  box-shadow: 0 0 6px 0 #dfdfdf;\r\n  border-radius: 5px;\r\n  border: 1px solid #dfdfdf;\r\n  background-color: #fff;\r\n  background: #fff;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.product_left_content .tab_main_nav {\r\n  display: none !important;\r\n}\r\n\r\n.product_left_content .tab_main_nav.block {\r\n  display: flex !important;\r\n}\r\n\r\n.planner-input.long-text-input input {\r\n  height: auto !important;\r\n  min-height: 28px !important;\r\n  max-height: 28px !important;\r\n}\r\n\r\n.planner-input.long-text-input .MuiInput-underline::before,\r\n.planner-input.long-text-input .MuiInput-underline::after {\r\n  display: none;\r\n}\r\n\r\n.plaid-container .chart_filter .tab {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.Select-Update-row {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:checked,\r\n.markets-radio-buttons [type='radio']:not(:checked) {\r\n  position: absolute;\r\n  left: -9999px;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:checked+label,\r\n.markets-radio-buttons [type='radio']:not(:checked)+label {\r\n  position: relative;\r\n  padding-left: 28px;\r\n  cursor: pointer;\r\n  line-height: 20px;\r\n  display: inline-block;\r\n  color: #666;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:checked+label:before,\r\n.markets-radio-buttons [type='radio']:not(:checked)+label:before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 2px solid #828282;\r\n  border-radius: 100%;\r\n  background: #fff;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:not(:checked)+label:before {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:checked+label:before {\r\n  border: 7px solid #24948c;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:checked+label:after,\r\n.markets-radio-buttons [type='radio']:not(:checked)+label:after {\r\n  content: '';\r\n  width: 3px;\r\n  height: 3px;\r\n  background: #f87da9;\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 3px;\r\n  border-radius: 100%;\r\n  -webkit-transition: all 0.2s ease;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:not(:checked)+label:after {\r\n  opacity: 0;\r\n  -webkit-transform: scale(0);\r\n  transform: scale(0);\r\n}\r\n\r\n.markets-radio-buttons [type='radio']:checked+label:after {\r\n  opacity: 1;\r\n  -webkit-transform: scale(1);\r\n  transform: scale(1);\r\n}\r\n\r\n.markets-radio-buttons {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 20px;\r\n}\r\n\r\n.main_build_nav_item {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  column-gap: 20px;\r\n  background-color: #479573;\r\n  box-shadow: 0 0 7px 1px #c9c9c9;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  position: relative;\r\n  z-index: 9;\r\n}\r\n\r\n.main_build_nav_item::before {\r\n  position: absolute;\r\n  content: '';\r\n  top: 15px;\r\n  left: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  opacity: 0.5;\r\n  background-image: url(data:image/png;base64,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);\r\n  background-position: bottom;\r\n  background-repeat: no-repeat;\r\n  width: 100%;\r\n  z-index: -1;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -ms-transition: 0.5s ease-in-out;\r\n  background-size: contain;\r\n}\r\n\r\n.main_build_nav_item .main_build_nav_icon img {\r\n  width: 60px;\r\n  height: 60px;\r\n  object-fit: contain;\r\n}\r\n\r\n.Main_Build_nav_outer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.main_build_nav_item .main_build_nav_title h5 {\r\n  text-transform: uppercase;\r\n  margin-bottom: 0px;\r\n  color: #fff;\r\n}\r\n\r\n.Main_Build_nav_main_outer {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 20px;\r\n  position: relative;\r\n  z-index: 0;\r\n}\r\n\r\n.main_build_nav_item::after {\r\n  position: absolute;\r\n  content: '';\r\n  background-image: url(../images/active_icon_right.png);\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  bottom: auto;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  -webkit-transform: translateY(-50%);\r\n  -moz-transform: translateY(-50%);\r\n  width: 10px;\r\n  height: 25px;\r\n  opacity: 0;\r\n  right: -8px;\r\n  background-size: contain;\r\n}\r\n\r\n.main_build_nav_item.active::after {\r\n  opacity: 1;\r\n}\r\n\r\n.Main_Build_sub_nav ul {\r\n  padding: 0px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.Main_Build_sub_nav ul li {\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  background-color: #66b192;\r\n  color: #fff;\r\n  list-style: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.Main_Build_sub_nav ul li:hover {\r\n  background-color: #479573;\r\n}\r\n\r\n.product_left_content-inner {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  min-height: 100%;\r\n}\r\n\r\n.locked-text {\r\n  color: red;\r\n  margin-left: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.insured_main_outer.full-height {\r\n  height: 100%;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  justify-content: space-between;\r\n  flex-direction: column;\r\n}\r\n\r\n.client_left .Main_Build_content {\r\n  height: 100%;\r\n}\r\n\r\n.insured_radio_group.vacation_date_input .planner-input.long-text-input input {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  max-height: 100% !important;\r\n  min-height: auto !important;\r\n}\r\n\r\n.product_left_content-inner .breadcrumb ul {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  padding: 10px;\r\n  gap: 20px;\r\n  background-color: #eeeff1;\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  margin: 0px;\r\n}\r\n\r\n.product_left_content-inner .breadcrumb ul li {\r\n  list-style: none;\r\n  position: relative;\r\n  font-size: 16px;\r\n  padding: 0px 10px;\r\n  font-weight: 500;\r\n  color: #71748d;\r\n}\r\n\r\n.product_left_content-inner .breadcrumb ul li::before {\r\n  position: absolute;\r\n  content: '';\r\n  width: 10px;\r\n  height: 10px;\r\n  border-left: solid 7px #71748d;\r\n  border-bottom: solid 7px transparent;\r\n  border-top: solid 7px transparent;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  -webkit-transform: translateY(-50%);\r\n  -moz-transform: translateY(-50%);\r\n  right: -15px;\r\n}\r\n\r\n.product_left_content-inner .breadcrumb ul li:last-child {\r\n  color: #3e9479;\r\n}\r\n\r\n.product_left_content-inner .breadcrumb ul li:last-child::before {\r\n  display: none;\r\n}\r\n\r\n.Save_Simulate_button_outer .Simulate_button_group {\r\n  padding: 10px;\r\n}\r\n.Save_Simulate_button_outer .Simulate_button_group button {\r\n  width: 100%;\r\n}\r\n.delete_popup_outer .MuiDialogActions-root {\r\n  width: 100%;\r\n}\r\n\r\n.alert_text {\r\n  margin-top: 10px;\r\n}\r\n\r\n.financial-instn-container {\r\n  padding-top: 10px;\r\n}\r\n.plan.client-review-dd .controls-select .select-search__control--is-disabled {\r\n  background: #808080 !important;\r\n  color: #fff;\r\n  border: 1px solid #808080 !important;\r\n}\r\n.plan.client-review-dd .controls-select .select-search__control--is-disabled .select-search__indicator svg path {\r\n  fill: #fff;\r\n}\r\n.plan.client-review-dd .controls-select .select-search__control--is-disabled .select-search__placeholder {\r\n  color: #fff;\r\n}\r\n.plan.client-review-dd .controls-select .select-search__placeholder {\r\n  line-height: 16px;\r\n}\r\n.mandatory_div p span {\r\n  color: red;\r\n}\r\n.chrono-charts-container .ant-switch .MuiFormControlLabel-root  {\r\n  margin: 0px;\r\n  padding: 10px;\r\n}\r\n.custom_note_inner  {\r\n  padding: 20px;\r\n}\r\n.custom_note_inner p {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(0, 0, 0, 0.5);\r\n  box-shadow: 0px 9px 27px rgba(0, 0, 0, 0.07), 0px 3.75998px 11.28px rgba(0, 0, 0, 0.0503198), 0px 2.01027px 6.0308px rgba(0, 0, 0, 0.0417275), 0px 1.12694px 3.38082px rgba(0, 0, 0, 0.035), 0px 0.598509px 1.79553px rgba(0, 0, 0, 0.0282725), 0px 0.249053px 0.747159px rgba(0, 0, 0, 0.0196802);\r\n  width: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n\r\n@media (max-width: 991px) {\r\n  .mobile_card {\r\n    display: block;\r\n  }\r\n\r\n  .desktop_card {\r\n    column-gap: 20px;\r\n  }\r\n\r\n  .desktop_card .Under_Management_content {\r\n    display: none !important;\r\n  }\r\n\r\n  .desktop_card .home_main_card_outer .card-body {\r\n    text-align: center;\r\n    padding: 10px;\r\n  }\r\n\r\n  .desktop_card .Under_Management {\r\n    justify-content: center;\r\n  }\r\n\r\n  .desktop_card .select_client_outer {\r\n    display: none;\r\n  }\r\n\r\n  .desktop_card .Under_Management .Under_Management_image img {\r\n    max-width: 45px;\r\n    width: 45px;\r\n  }\r\n\r\n  .desktop_card .Under_Management .Under_Management_image {\r\n    margin: 0px auto;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .desktop_card .home_main_card_outer .card-body {}\r\n}\r\n\r\n/* Just some basic styling for demonstration */\r\n.outer {\r\n  position: relative;\r\n}\r\n\r\n// .outer .carousel-itemm {\r\n//   display: block;\r\n// }\r\n.inner {\r\n  flex: 1;\r\n  /* Equal width for both columns */\r\n}\r\n\r\n.carousel-container {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  gap: 15px;\r\n}\r\n\r\n.carousel-itemm {\r\n  // flex: 0 0 auto;\r\n  width: 50%;\r\n}\r\n\r\n/* Styling for arrows */\r\n.arrow {\r\n  display: none;\r\n  /* Hide arrows by default */\r\n}\r\n\r\n/* Media query for tablet and mobile devices */\r\n@media only screen and (max-width: 991px) {\r\n  .carousel-itemm {\r\n    width: 100%;\r\n    min-width: 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .divider_line {\r\n    display: none;\r\n  }\r\n\r\n  .outer {\r\n    flex-direction: column;\r\n    /* Stack columns on top of each other */\r\n  }\r\n\r\n  .inner {\r\n    flex: none;\r\n    /* Reset flex property */\r\n    width: auto;\r\n    /* Reset width property */\r\n  }\r\n\r\n  .carousel-container {\r\n    display: flex;\r\n    /* Display carousel */\r\n    overflow-x: hidden;\r\n    /* Add horizontal scroll for overflow */\r\n    width: 100%;\r\n    gap: 0px;\r\n  }\r\n\r\n  .arrow {\r\n    display: block;\r\n    /* Display arrows */\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 50px;\r\n    height: 50px;\r\n    background-color: rgb(62 148 121 / 65%);\r\n    color: white;\r\n    text-align: center;\r\n    line-height: 50px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .arrow.left {\r\n    left: 0;\r\n    border-top-right-radius: 25px;\r\n    border-bottom-right-radius: 25px;\r\n  }\r\n\r\n  .arrow.right {\r\n    right: 0;\r\n    border-top-left-radius: 25px;\r\n    border-bottom-left-radius: 25px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
